/**
 * String-keyed phrase dictionary — used where labels double as testid sources
 * (UserAppHeader nav) and across the ADMIN panel. Keys ARE the English strings;
 * en block is an identity map (source of truth for the backfill script).
 * Lookup: pt("Family Tree") → translated string or the English literal.
 */
import { useLang } from "@/contexts/LanguageContext";

export const PHRASES = {
    en: {
        "Home": "Home",
        "Family": "Family",
        "Family Tree": "Family Tree",
        "Add a Member": "Add a Member",
        "Invite Family": "Invite Family",
        "Family Hub · All": "Family Hub · All",
        "Family Timeline": "Family Timeline",
        "Family Calendar": "Family Calendar",
        "Services": "Services",
        "Photo Memories": "Photo Memories",
        "Audio Memories": "Audio Memories",
        "AI Family Advisor": "AI Family Advisor",
        "AI Story Generator": "AI Story Generator",
        "Video Memories": "Video Memories",
        "Digital Family Tree": "Digital Family Tree",
        "Family Hall of Fame": "Family Hall of Fame",
        "Family Hub · All Services": "Family Hub · All Services",
        "Records": "Records",
        "Blood Group Registry": "Blood Group Registry",
        "Health Repository": "Health Repository",
        "Health Score Compliance": "Health Score Compliance",
        "Emergency Contacts": "Emergency Contacts",
        "Business Directory": "Business Directory",
        "Recipe Vault": "Recipe Vault",
        "Family Statistics": "Family Statistics",
        "Legacy": "Legacy",
        "Legal Vault": "Legal Vault",
        "Document Vault": "Document Vault",
        "Story & Wisdom Vault": "Story & Wisdom Vault",
        "Family Constitution": "Family Constitution",
        "Futuristic Legacy Letter": "Futuristic Legacy Letter",
        "Digital Memorial": "Digital Memorial",
        "Account": "Account",
        "Packages & Plans": "Packages & Plans",
        "Privacy & Settings": "Privacy & Settings",
        "Download & Export": "Download & Export",
        "Profile": "Profile",
        "Search family…": "Search family…",
        "Dashboard": "Dashboard",
        "Families": "Families",
        "Users": "Users",
        "Subscriptions": "Subscriptions",
        "Packages": "Packages",
        "Exports": "Exports",
        "Content": "Content",
        "Landing Slides": "Landing Slides",
        "Site Assets": "Site Assets",
        "Family Content": "Family Content",
        "Translations": "Translations",
        "User Page Editor": "User Page Editor",
        "Analytics": "Analytics",
        "Support Tickets": "Support Tickets",
        "Broadcasts": "Broadcasts",
        "Legacy CRM": "Legacy CRM",
        "SMS Console": "SMS Console",
        "Security": "Security",
        "Settings": "Settings",
        "UI/UX Audit": "UI/UX Audit",
        "API Keys": "API Keys",
        "Admin Team": "Admin Team",
        "Content Managers": "Content Managers",
        "Overview": "Overview",
        "Members": "Members",
        "Billing": "Billing",
        "Landing & Content": "Landing & Content",
        "Insights": "Insights",
        "Support": "Support",
        "System": "System",
        "Super Admin": "Super Admin",
        "Content Admin": "Content Admin",
        "Content Manager": "Content Manager",
        "Finance Admin": "Finance Admin",
        "Support Admin": "Support Admin",
        "Security Admin": "Security Admin",
        "Admin": "Admin",
        "Admin Panel": "Admin Panel",
        "Logout": "Logout",
        "Loading dashboard…": "Loading dashboard…",
        "Platform overview at a glance.": "Platform overview at a glance.",
        "Total Families": "Total Families",
        "Total Members": "Total Members",
        "Tree Persons": "Tree Persons",
        "Storage Used": "Storage Used",
        "Marriages": "Marriages",
        "Memory Albums": "Memory Albums",
        "Wills (latest)": "Wills (latest)",
        "Audio Wills": "Audio Wills",
        "With recorded audio": "With recorded audio",
        "Across all families": "Across all families",
        "New signups — last 30 days": "New signups — last 30 days",
        "Storage breakdown": "Storage breakdown",
        "No stored files yet.": "No stored files yet.",
        "Signups": "Signups",
        "suspended": "suspended",
        "blocked": "blocked",
        "paid": "paid",
        "open tickets": "open tickets",
        "Memory photos": "Memory photos",
        "Vault documents": "Vault documents",
        "Story audio": "Story audio",
        "Member profiles & photos": "Member profiles & photos",
        "Profile details": "Profile details",
        "Story metadata": "Story metadata",
        "Memory metadata": "Memory metadata",
        "Document metadata": "Document metadata",
        "Admin (Head)": "Admin (Head)",
        "added": "added",
        "updated": "updated",
        "removed": "removed",
        "changed privacy of": "changed privacy of",
        "updated profile of": "updated profile of",
        "viewed profile of": "viewed profile of",
        "recorded": "recorded",
        "played": "played",
        "deleted story": "deleted story",
        "uploaded": "uploaded",
        "viewed": "viewed",
        "changed access of": "changed access of",
        "deleted": "deleted",
        "invited": "invited",
        "revoked an invite": "revoked an invite",
        "joined the family": "joined the family",
        "changed role of": "changed role of",
        "downloaded their data": "downloaded their data",
        "completed privacy setup": "completed privacy setup",
        "deleted account of": "deleted account of",
        "Senior mode on — simpler privacy choices.": "Senior mode on — simpler privacy choices.",
        "Senior mode off.": "Senior mode off.",
        "Saved.": "Saved.",
        "Your data export has been downloaded.": "Your data export has been downloaded.",
        "Your account and data have been deleted.": "Your account and data have been deleted.",
        "Every family tree on the platform. Suspending blocks all its members from logging in.": "Every family tree on the platform. Suspending blocks all its members from logging in.",
        "All registered members. Blocked users cannot log in or use the API.": "All registered members. Blocked users cannot log in or use the API.",
        "Manual plan control until a payment gateway is connected in Settings.": "Manual plan control until a payment gateway is connected in Settings.",
        "Growth, engagement and audience mix.": "Growth, engagement and audience mix.",
        "Users raise tickets from Settings → Help in the app.": "Users raise tickets from Settings → Help in the app.",
        "Branding, payment gateway and API keys. Secrets are stored server-side and shown masked.": "Branding, payment gateway and API keys. Secrets are stored server-side and shown masked.",
        "Packages — Feature Matrix (Demo)": "Packages — Feature Matrix (Demo)",
        "Export Center": "Export Center",
        "Download authoritative reports in CSV, Excel or PDF. Schedule auto-email exports below.": "Download authoritative reports in CSV, Excel or PDF. Schedule auto-email exports below.",
        "Send SMS or WhatsApp announcements to your users.": "Send SMS or WhatsApp announcements to your users.",
        "Content Management": "Content Management",
        "Poster templates, landing banners and testimonials curated by the super-admin.": "Poster templates, landing banners and testimonials curated by the super-admin.",
        "Platform-wide audit trail, failed logins, DPDP compliance requests, and your MFA credentials.": "Platform-wide audit trail, failed logins, DPDP compliance requests, and your MFA credentials.",
        "Manage who can sign into the admin panel and what they can access.": "Manage who can sign into the admin panel and what they can access.",
        "Family Content Moderation": "Family Content Moderation",
        "Listen": "Listen",
        "Stop": "Stop",
        "Pause": "Pause",
        "Resume": "Resume",
        "Generating…": "Generating…",
        "Signup trend — last 90 days": "Signup trend — last 90 days",
        "(or user) is expected to add all their family relationships on the": "(or user) is expected to add all their family relationships on the",
        ", which can only be opened by your password.": ", which can only be opened by your password.",
        ". Any member added there is automatically reflected here. For convenience, a few extra fields for": ". Any member added there is automatically reflected here. For convenience, a few extra fields for",
        "A family together": "A family together",
        "A premium feature for your family's future": "A premium feature for your family's future",
        "Add": "Add",
        "Add Event": "Add Event",
        "Add custom field": "Add custom field",
        "All checks": "All checks",
        "Avg age": "Avg age",
        "Back": "Back",
        "Back to Dashboard": "Back to Dashboard",
        "Change photo": "Change photo",
        "Choose the package that fits your family": "Choose the package that fits your family",
        "Classic, Premium and Elite": "Classic, Premium and Elite",
        "Countries": "Countries",
        "Current": "Current",
        "Current Location": "Current Location",
        "Current city": "Current city",
        "Current locations": "Current locations",
        "Data is encrypted in transit and at rest; every add/edit/delete is captured in the audit log.": "Data is encrypted in transit and at rest; every add/edit/delete is captured in the audit log.",
        "Date": "Date",
        "Dear customer,": "Dear customer,",
        "Delete": "Delete",
        "Distinct Cities": "Distinct Cities",
        "Family (₹999/yr)": "Family (₹999/yr)",
        "Family Head": "Family Head",
        "Family Health": "Family Health",
        "Family Members": "Family Members",
        "Family Relationships": "Family Relationships",
        "Favourite mithai": "Favourite mithai",
        "Field name": "Field name",
        "Fill with AI": "Fill with AI",
        "GPT-5.2 fills 40+ fields across all 6 modules from your surname + region · you edit before saving.": "GPT-5.2 fills 40+ fields across all 6 modules from your surname + region · you edit before saving.",
        "Gaon ka temple": "Gaon ka temple",
        "Generations": "Generations",
        "Health & Medical Repository": "Health & Medical Repository",
        "Health Score Compliance Report": "Health Score Compliance Report",
        "Health information is stored with explicit consent, only for members whose data you are authorised to record.": "Health information is stored with explicit consent, only for members whose data you are authorised to record.",
        "Help": "Help",
        "Hide details": "Hide details",
        "How complete is your family tree?": "How complete is your family tree?",
        "Informed consent — one time, per family": "Informed consent — one time, per family",
        "Kind": "Kind",
        "Legacy (₹2999/yr)": "Legacy (₹2999/yr)",
        "Linked live from your family tree.": "Linked live from your family tree.",
        "Living Cities": "Living Cities",
        "Loading events…": "Loading events…",
        "Loading packages…": "Loading packages…",
        "Loading world map…": "Loading world map…",
        "Loading…": "Loading…",
        "Lucky number": "Lucky number",
        "Member Profile": "Member Profile",
        "Most Popular": "Most Popular",
        "Native": "Native",
        "Native Place": "Native Place",
        "Native Places": "Native Places",
        "Native places": "Native places",
        "None of your family members have a mapped location yet.": "None of your family members have a mapped location yet.",
        "Not a medical diagnosis platform.": "Not a medical diagnosis platform.",
        "Not added yet": "Not added yet",
        "Notes (optional)": "Notes (optional)",
        "Place of birth": "Place of birth",
        "Preserve. Understand. Inform.": "Preserve. Understand. Inform.",
        "Privacy by design:": "Privacy by design:",
        "Records are visible to your family circle only; the Family Head controls who can add or edit.": "Records are visible to your family circle only; the Family Head controls who can add or edit.",
        "Remove": "Remove",
        "Reset": "Reset",
        "Save &amp; Continue": "Save &amp; Continue",
        "Saved ✓": "Saved ✓",
        "Saving…": "Saving…",
        "Sensitive details are hidden by default.": "Sensitive details are hidden by default.",
        "Skip the blank page — let AI suggest your family&apos;s heritage": "Skip the blank page — let AI suggest your family&apos;s heritage",
        "Tap to view": "Tap to view",
        "This is a record-keeping repository — not a diagnosis, treatment or medical-advice tool.": "This is a record-keeping repository — not a diagnosis, treatment or medical-advice tool.",
        "This repository is for private family record-keeping and health-history awareness only — it does not provide diagnosis, treatment, risk prediction or medical advice. Always consult a qualified healthcare provider.": "This repository is for private family record-keeping and health-history awareness only — it does not provide diagnosis, treatment, risk prediction or medical advice. Always consult a qualified healthcare provider.",
        "This section is private": "This section is private",
        "Timezones spread": "Timezones spread",
        "Tip": "Tip",
        "Title": "Title",
        "Tree completeness": "Tree completeness",
        "Update": "Update",
        "Update their": "Update their",
        "Value (type or tap 🎤)": "Value (type or tap 🎤)",
        "Visual Family Tree": "Visual Family Tree",
        "Voice language": "Voice language",
        "What's missing": "What's missing",
        "Where Your Family Lives — Across the World": "Where Your Family Lives — Across the World",
        "are provided in the section below —": "are provided in the section below —",
        "bank locker": "bank locker",
        "can be preserved in this section. The documents associated with these important information are required to be preserved at a different location, which is a special privilege of our": "can be preserved in this section. The documents associated with these important information are required to be preserved at a different location, which is a special privilege of our",
        "complete. Tick off the items below to grow it further.": "complete. Tick off the items below to grow it further.",
        "customers.": "customers.",
        "descriptive information": "descriptive information",
        "e.g. Dadu's Birthday": "e.g. Dadu's Birthday",
        "family-only visibility · Family Head controls writing · explicit informed consent · encrypted storage · full audit trail of every change · DPDP Act 2023 aligned. Coming next: disease timeline, maternal/paternal branch views & emergency health card.": "family-only visibility · Family Head controls writing · explicit informed consent · encrypted storage · full audit trail of every change · DPDP Act 2023 aligned. Coming next: disease timeline, maternal/paternal branch views & emergency health card.",
        "on the profile page, and they'll appear on the map instantly.": "on the profile page, and they'll appear on the map instantly.",
        "or": "or",
        "plans — preserve multi-generation medical history, hereditary conditions, allergies, vaccinations and more.": "plans — preserve multi-generation medical history, hereditary conditions, allergies, vaccinations and more.",
        "please note that you are preserving very important and vital information. Please make sure you save important information only if you want to preserve it on this platform in a highly secured manner by using a proper password. All the documents here are preserved as if they are kept in a": "please note that you are preserving very important and vital information. Please make sure you save important information only if you want to preserve it on this platform in a highly secured manner by using a proper password. All the documents here are preserved as if they are kept in a",
        "step relations, adopted relations, close relatives and extended relatives": "step relations, adopted relations, close relatives and extended relatives",
        "these will not appear on your pictorial family tree view.": "these will not appear on your pictorial family tree view.",
        "© 2026 Digital Family Tree. All rights reserved.": "© 2026 Digital Family Tree. All rights reserved.",
        "21 sections of guided wisdom — the values, lessons and stories you want to pass down.": "21 sections of guided wisdom — the values, lessons and stories you want to pass down.",
        "AI-POWERED": "AI-POWERED",
        "Aadhaar, property papers, wills and certificates — stored privately and shared only with the people you choose.": "Aadhaar, property papers, wills and certificates — stored privately and shared only with the people you choose.",
        "Achievements Wall": "Achievements Wall",
        "Ask anything about your family — heritage, relationships, memories — and get instant AI answers.": "Ask anything about your family — heritage, relationships, memories — and get instant AI answers.",
        "Audio Memories (Voice Stories)": "Audio Memories (Voice Stories)",
        "Begin your family tree journey": "Begin your family tree journey",
        "Birthdays, anniversaries and festivals happening for your family today — one tap to wish.": "Birthdays, anniversaries and festivals happening for your family today — one tap to wish.",
        "Blood groups, allergies, chronic conditions and emergency contacts — accessible when it matters most.": "Blood groups, allergies, chronic conditions and emergency contacts — accessible when it matters most.",
        "Bring parents, siblings and cousins into your private family space — everyone adds their memories, and the tree grows together.": "Bring parents, siblings and cousins into your private family space — everyone adds their memories, and the tree grows together.",
        "CULTURE & TRADITIONS": "CULTURE & TRADITIONS",
        "Capture a memory in your own voice. We'll transcribe, translate and preserve it for future generations.": "Capture a memory in your own voice. We'll transcribe, translate and preserve it for future generations.",
        "Celebrate doctors, engineers, artists and every achiever in your family — a wall of pride for generations to see.": "Celebrate doctors, engineers, artists and every achiever in your family — a wall of pride for generations to see.",
        "Choose the package that fits your family — upgrade anytime, and unlock more features as your legacy grows.": "Choose the package that fits your family — upgrade anytime, and unlock more features as your legacy grows.",
        "Complete legacy suite with AI tools": "Complete legacy suite with AI tools",
        "Connections": "Connections",
        "Culture & Rituals Archive": "Culture & Rituals Archive",
        "Demo Coming Soon": "Demo Coming Soon",
        "Demo pricing — final packages will be announced soon. Selection is saved to your account.": "Demo pricing — final packages will be announced soon. Selection is saved to your account.",
        "Digital Family Tree (Print-ready)": "Digital Family Tree (Print-ready)",
        "EMERGENCY INFO": "EMERGENCY INFO",
        "EVENTS & DATES": "EVENTS & DATES",
        "Events & Reminders": "Events & Reminders",
        "Every family member at a glance — search, filter and open any profile in one tap.": "Every family member at a glance — search, filter and open any profile in one tap.",
        "Every milestone across generations — arranged as one continuous, beautiful story.": "Every milestone across generations — arranged as one continuous, beautiful story.",
        "Every new member, photo, story and record — see everything happening in your family, as it happens.": "Every new member, photo, story and record — see everything happening in your family, as it happens.",
        "Every photo, voice note and story preserved forever — safely inside your family vault.": "Every photo, voice note and story preserved forever — safely inside your family vault.",
        "Everything, forever — one payment": "Everything, forever — one payment",
        "Expert Biography Writing": "Expert Biography Writing",
        "Export everything you've saved — members, stories, memories, records — in the format that suits you. Your data is always yours.": "Export everything you've saved — members, stories, memories, records — in the format that suits you. Your data is always yours.",
        "FAMILY STATISTICS": "FAMILY STATISTICS",
        "FAMILY TIMELINE": "FAMILY TIMELINE",
        "FAMILY WORLD MAP": "FAMILY WORLD MAP",
        "Family Activity": "Family Activity",
        "Family Calendar & Celebrations": "Family Calendar & Celebrations",
        "Family Pride": "Family Pride",
        "Family Records": "Family Records",
        "Family Tree Builder (6 generations)": "Family Tree Builder (6 generations)",
        "Family World Map": "Family World Map",
        "Gold": "Gold",
        "HEALTH & EMERGENCY": "HEALTH & EMERGENCY",
        "HEALTH REPOSITORY": "HEALTH REPOSITORY",
        "Health & Medical Repository (10 registers)": "Health & Medical Repository (10 registers)",
        "How large is your family across generations? Longevity, geography, professions and more.": "How large is your family across generations? Longevity, geography, professions and more.",
        "Keep every family member's blood group in one secure place. In an emergency, every second counts — this registry helps you instantly find the right donor within your family.": "Keep every family member's blood group in one secure place. In an emergency, every second counts — this registry helps you instantly find the right donor within your family.",
        "LEGACY & MEMORIAL": "LEGACY & MEMORIAL",
        "LEGAL & LEGACY": "LEGAL & LEGACY",
        "Legacy Lifetime": "Legacy Lifetime",
        "Legal Vault (Will & Nominee)": "Legal Vault (Will & Nominee)",
        "Let AI compose a heartfelt narrative of your family's journey from the profiles you've filled.": "Let AI compose a heartfelt narrative of your family's journey from the profiles you've filled.",
        "MEMORIES & STORIES": "MEMORIES & STORIES",
        "Marriage Records": "Marriage Records",
        "Member Profiles & Photos": "Member Profiles & Photos",
        "Memories & reminders for the whole family": "Memories & reminders for the whole family",
        "Multi-user Family Access (Invites)": "Multi-user Family Access (Invites)",
        "Never miss a birthday, anniversary or festival — smart reminders from your family tree, delivered by email, push and in-app.": "Never miss a birthday, anniversary or festival — smart reminders from your family tree, delivered by email, push and in-app.",
        "One place for every birthday, anniversary, shraddha and cultural festival — with smart nudges.": "One place for every birthday, anniversary, shraddha and cultural festival — with smart nudges.",
        "Personal Vault": "Personal Vault",
        "Prescriptions, reports and hospital records for every family member — organized and searchable.": "Prescriptions, reports and hospital records for every family member — organized and searchable.",
        "Preserve wedding dates, venues and couple details — anniversaries flow automatically into your family calendar and timeline.": "Preserve wedding dates, venues and couple details — anniversaries flow automatically into your family calendar and timeline.",
        "Priority Support": "Priority Support",
        "Rituals, recipes, dialects and heritage — everything that makes your family uniquely yours.": "Rituals, recipes, dialects and heritage — everything that makes your family uniquely yours.",
        "SHARE & CELEBRATE": "SHARE & CELEBRATE",
        "Seal messages, photos and videos to open on future birthdays, anniversaries or a chosen date.": "Seal messages, photos and videos to open on future birthdays, anniversaries or a chosen date.",
        "See every family member on a real world map. Each pin shows a current location (orange) and a native place (green), connected by a dotted line — a beautiful visual of your family's journey through geography.": "See every family member on a real world map. Each pin shows a current location (orange) and a native place (green), connected by a dotted line — a beautiful visual of your family's journey through geography.",
        "Share the gift of legacy — invite friends to build their own private family tree, free to start.": "Share the gift of legacy — invite friends to build their own private family tree, free to start.",
        "Silver": "Silver",
        "Smart Reminders (Email + Push)": "Smart Reminders (Email + Push)",
        "Starter": "Starter",
        "TIME CAPSULES": "TIME CAPSULES",
        "TODAY'S CELEBRATIONS": "TODAY'S CELEBRATIONS",
        "Turn your family tree into a beautiful shareable poster — perfect for wedding invites, festivals and print.": "Turn your family tree into a beautiful shareable poster — perfect for wedding invites, festivals and print.",
        "VOICE & STORIES": "VOICE & STORIES",
        "Watch Demo": "Watch Demo",
        "Wills, power-of-attorney, property papers and nominee details — locked and always accessible to the right people.": "Wills, power-of-attorney, property papers and nominee details — locked and always accessible to the right people.",
        "Your data, your rules — manage account preferences, visibility and every privacy declaration in one place.": "Your data, your rules — manage account preferences, visibility and every privacy declaration in one place.",
        "one-time · lifetime": "one-time · lifetime",
        "per month": "per month",
        "per year": "per year",
        "January": "January",
        "February": "February",
        "March": "March",
        "April": "April",
        "May": "May",
        "June": "June",
        "July": "July",
        "August": "August",
        "September": "September",
        "October": "October",
        "November": "November",
        "December": "December",
        "is locked": "is locked",
        "Your current package": "Your current package",
        "doesn't include this feature.": "doesn't include this feature.",
        "Included in": "Included in",
        "one-time": "one-time",
        "year": "year",
        "month": "month",
        "lifetime": "lifetime",
        "Go Back": "Go Back",
        "View Packages": "View Packages",
        "This feature": "This feature",
        "Family Legacy Dashboard": "Family Legacy Dashboard",
        "Legacy Services": "Legacy Services",
        "Life Story Vault": "Life Story Vault",
        "Video Testament Library": "Video Testament Library",
        "Family Wisdom Bank": "Family Wisdom Bank",
        "Failure Stories Archive": "Failure Stories Archive",
        "Success Stories": "Success Stories",
        "Family Decision History": "Family Decision History",
        "Family Values Repository": "Family Values Repository",
        "Family Hero Gallery": "Family Hero Gallery",
        "Unsung Heroes": "Unsung Heroes",
        "Gratitude Wall": "Gratitude Wall",
        "Tribute Pages": "Tribute Pages",
        "Love Letters Archive": "Love Letters Archive",
        "Childhood Stories Bank": "Childhood Stories Bank",
        "Language Preservation": "Language Preservation",
        "Ancestral Village": "Ancestral Village",
        "Surname History": "Surname History",
        "Family Emblem": "Family Emblem",
        "Cultural Artifacts": "Cultural Artifacts",
        "Family Songs & Bhajans": "Family Songs & Bhajans",
        "Oral History Center": "Oral History Center",
        "Biography Writing Platform": "Biography Writing Platform",
        "Memoir Writing Service": "Memoir Writing Service",
        "Personalised Gifting Service": "Personalised Gifting Service",
        "Personal Digital Identity Platform": "Personal Digital Identity Platform",
        "Add to": "Add to",
        "Choose": "Choose",
        "Compare all packages": "Compare all packages",
        "Real outputs your family gets": "Real outputs your family gets",
        "See what you actually receive": "See what you actually receive",
        "Every package delivers keepsake-quality designs — printable Family Tree posters and personalised Digital ID cards. Tap any design to view it full-size.": "Every package delivers keepsake-quality designs — printable Family Tree posters and personalised Digital ID cards. Tap any design to view it full-size.",
        "Family Tree Posters": "Family Tree Posters",
        "Digital ID Cards": "Digital ID Cards",
        "View full": "View full",
        "Sample designs shown. Your posters and cards are personalised with your family's names, photos and details.": "Sample designs shown. Your posters and cards are personalised with your family's names, photos and details.",
        "Demo pricing — packages, prices and the feature split are all editable from the admin panel.": "Demo pricing — packages, prices and the feature split are all editable from the admin panel.",
        "Feature": "Feature",
        "Five packages, one family legacy": "Five packages, one family legacy",
        "Free": "Free",
        "Life story, wisdom and biography now live in Family Legacy Dashboard": "Life story, wisdom and biography now live in Family Legacy Dashboard",
        "Open Family Legacy Dashboard": "Open Family Legacy Dashboard",
        "Packages & Pricing": "Packages & Pricing",
        "Packages temporarily unavailable. Please try again shortly.": "Packages temporarily unavailable. Please try again shortly.",
        "Start Free": "Start Free",
        "Start free, upgrade whenever your family is ready. Every feature below is compared side by side so nothing is hidden.": "Start free, upgrade whenever your family is ready. Every feature below is compared side by side so nothing is hidden.",
        "Swipe sideways on a phone — the feature column stays in place.": "Swipe sideways on a phone — the feature column stays in place.",
        "more features": "more features",
        "Namaste": "Namaste",
        "{sender} has added you to our family tree on Family Repository.": "{sender} has added you to our family tree on Family Repository.",
        "Tap to join": "Tap to join",
        "Your invite code": "Your invite code",
        "Together we will preserve our family's stories, photos and voices for the next generations.": "Together we will preserve our family's stories, photos and voices for the next generations.",
        "Your family": "Your family",
        "Invite on WhatsApp": "Invite on WhatsApp",
        "WhatsApp opened with the invite message.": "WhatsApp opened with the invite message.",
    },
    hi: {
        "Home": "होम",
        "Family": "परिवार",
        "Family Tree": "वंश वृक्ष",
        "Add a Member": "सदस्य जोड़ें",
        "Invite Family": "परिवार को आमंत्रित करें",
        "Family Hub · All": "फ़ैमिली हब · सभी",
        "Family Timeline": "परिवार टाइमलाइन",
        "Family Calendar": "परिवार कैलेंडर",
        "Services": "सेवाएँ",
        "Photo Memories": "फ़ोटो यादें",
        "Audio Memories": "ऑडियो यादें",
        "AI Family Advisor": "AI परिवार सलाहकार",
        "AI Story Generator": "AI स्टोरी जनरेटर",
        "Video Memories": "वीडियो यादें",
        "Digital Family Tree": "डिजिटल वंश वृक्ष",
        "Family Hall of Fame": "फ़ैमिली हॉल ऑफ़ फ़ेम",
        "Family Hub · All Services": "फ़ैमिली हब · सभी सेवाएँ",
        "Records": "रिकॉर्ड",
        "Blood Group Registry": "ब्लड ग्रुप रजिस्ट्रि",
        "Health Repository": "स्वास्थ्य भंडार",
        "Health Score Compliance": "स्वास्थ्य स्कोर अनुपालन",
        "Emergency Contacts": "आपातकालीन संपर्क",
        "Business Directory": "बिज़नेस निर्देशिका",
        "Recipe Vault": "रेसिपी वॉल्ट",
        "Family Statistics": "परिवार सांख्यिकी",
        "Legacy": "विरासत",
        "Legal Vault": "लीगल वॉल्ट",
        "Document Vault": "दस्तावेज़ वॉल्ट",
        "Story & Wisdom Vault": "कहानी और ज्ञान वॉल्ट",
        "Family Constitution": "परिवार संविधान",
        "Futuristic Legacy Letter": "भावी विरासत पत्र",
        "Digital Memorial": "डिजिटल स्मारक",
        "Account": "अकाउंट",
        "Packages & Plans": "पैकेज और प्लान",
        "Privacy & Settings": "प्राइवेसी और सेटिंग्स",
        "Download & Export": "डाउनलोड और एक्सपोर्ट",
        "Profile": "प्रोफ़ाइल",
        "Search family…": "परिवार खोजें…",
        "Dashboard": "डैशबोर्ड",
        "Families": "परिवार",
        "Users": "उपयोगकर्ता",
        "Subscriptions": "सदस्यताएँ",
        "Packages": "पैकेज",
        "Exports": "एक्सपोर्ट",
        "Content": "सामग्री",
        "Landing Slides": "लैंडिंग स्लाइड्स",
        "Site Assets": "साइट एसेट्स",
        "Family Content": "परिवार सामग्री",
        "Translations": "अनुवाद",
        "User Page Editor": "यूज़र पेज संपादक",
        "Analytics": "एनालिटिक्स",
        "Support Tickets": "सपोर्ट टिकट",
        "Broadcasts": "ब्रॉडकास्ट",
        "Legacy CRM": "पुराना CRM",
        "SMS Console": "SMS कंसोल",
        "Security": "सुरक्षा",
        "Settings": "सेटिंग्स",
        "UI/UX Audit": "UI/UX ऑडिट",
        "API Keys": "API कीज़",
        "Admin Team": "एडमिन टीम",
        "Content Managers": "कॉन्टेंट मैनेजर्स",
        "Overview": "संक्षिप्त विवरण",
        "Members": "सदस्य",
        "Billing": "बिलिंग",
        "Landing & Content": "लैंडिंग और कॉन्टेंट",
        "Insights": "इनसाइट्स",
        "Support": "सपोर्ट",
        "System": "सिस्टम",
        "Super Admin": "सुपर एडमिन",
        "Content Admin": "कॉन्टेंट एडमिन",
        "Content Manager": "कॉन्टेंट मैनेजर",
        "Finance Admin": "फाइनेंस एडमिन",
        "Support Admin": "सपोर्ट एडमिन",
        "Security Admin": "सिक्योरिटी एडमिन",
        "Admin": "एडमिन",
        "Admin Panel": "एडमिन पैनल",
        "Logout": "लॉगआउट",
        "Loading dashboard…": "डैशबोर्ड लोड हो रहा है…",
        "Platform overview at a glance.": "प्लैटफ़ॉर्म का एक नज़र में विवरण।",
        "Total Families": "कुल परिवार",
        "Total Members": "कुल सदस्य",
        "Tree Persons": "वृक्ष के व्यक्ति",
        "Storage Used": "प्रयोग की गई स्टोरेज",
        "Marriages": "शादियाँ",
        "Memory Albums": "स्मृति एल्बम",
        "Wills (latest)": "वसीयतें (ताज़ा)",
        "Audio Wills": "ऑडियो वसीयतें",
        "With recorded audio": "रिकॉर्ड किए गए ऑडियो सहित",
        "Across all families": "सभी परिवारों में",
        "New signups — last 30 days": "नए साइनअप — पिछले 30 दिन",
        "Storage breakdown": "स्टोरेज का ब्योरा",
        "No stored files yet.": "अभी तक कोई फ़ाइल सहेजी नहीं गई है।",
        "Signups": "साइनअप",
        "suspended": "निलंबित",
        "blocked": "अवरोधित",
        "paid": "सशुल्क",
        "open tickets": "खुले टिकट",
        "Memory photos": "स्मृति फ़ोटो",
        "Vault documents": "वॉल्ट दस्तावेज़",
        "Story audio": "कहानी ऑडियो",
        "Member profiles & photos": "सदस्य प्रोफ़ाइलें और फ़ोटो",
        "Profile details": "प्रोफ़ाइल विवरण",
        "Story metadata": "कहानी मेटाडेटा",
        "Memory metadata": "स्मृति मेटाडेटा",
        "Document metadata": "दस्तावेज़ मेटाडेटा",
        "Admin (Head)": "प्रशासक (मुखिया)",
        "added": "जोड़ा",
        "updated": "अपडेट किया",
        "removed": "हटाया",
        "changed privacy of": "की गोपनीयता बदली",
        "updated profile of": "की प्रोफ़ाइल अपडेट की",
        "viewed profile of": "की प्रोफ़ाइल देखी",
        "recorded": "रिकॉर्ड किया",
        "played": "चलाया",
        "deleted story": "कहानी हटाई",
        "uploaded": "अपलोड किया",
        "viewed": "देखा",
        "changed access of": "की पहुँच बदली",
        "deleted": "हटाया",
        "invited": "आमंत्रित किया",
        "revoked an invite": "निमंत्रण रद्द किया",
        "joined the family": "परिवार से जुड़े",
        "changed role of": "की भूमिका बदली",
        "downloaded their data": "अपना डेटा डाउनलोड किया",
        "completed privacy setup": "प्राइवेसी सेटअप पूरा किया",
        "deleted account of": "का अकाउंट हटाया",
        "Senior mode on — simpler privacy choices.": "सीनियर मोड चालू — आसान प्राइवेसी विकल्प।",
        "Senior mode off.": "सीनियर मोड बंद।",
        "Saved.": "सेव किया गया।",
        "Your data export has been downloaded.": "आपका डेटा एक्सपोर्ट डाउनलोड हो चुका है।",
        "Your account and data have been deleted.": "आपका अकाउंट और डेटा हटा दिया गया है।",
        "Every family tree on the platform. Suspending blocks all its members from logging in.": "प्लैटफ़ॉर्म पर मौजूद हर परिवार वृक्ष। निलंबन करने पर उसके सभी सदस्य लॉग‑इन नहीं कर पाएंगे।",
        "All registered members. Blocked users cannot log in or use the API.": "सभी पंजीकृत सदस्य। ब्लॉक किए गए उपयोगकर्ता न तो लॉग‑इन कर सकते हैं और न ही API का उपयोग कर सकते हैं।",
        "Manual plan control until a payment gateway is connected in Settings.": "Settings में कोई पेमेंट गेटवे जोड़ने तक प्लान को मैन्युअल रूप से नियंत्रित करें।",
        "Growth, engagement and audience mix.": "वृद्धि, सहभागिता और दर्शक‑समूह का मिश्रण।",
        "Users raise tickets from Settings → Help in the app.": "उपयोगकर्ता ऐप में Settings → Help से टिकट दर्ज करते हैं।",
        "Branding, payment gateway and API keys. Secrets are stored server-side and shown masked.": "Branding, पेमेंट गेटवे और API keys। संवेदनशील जानकारियाँ सर्वर‑साइड सुरक्षित रखी जाती हैं और छुपाकर (masked) दिखाई जाती हैं।",
        "Packages — Feature Matrix (Demo)": "Packages — Feature Matrix (Demo)",
        "Export Center": "एक्सपोर्ट सेंटर",
        "Download authoritative reports in CSV, Excel or PDF. Schedule auto-email exports below.": "CSV, Excel या PDF में प्रमाणिक रिपोर्ट डाउनलोड करें। नीचे ऑटो‑ईमेल एक्सपोर्ट की शेड्यूलिंग करें।",
        "Send SMS or WhatsApp announcements to your users.": "अपने उपयोगकर्ताओं को SMS या WhatsApp के माध्यम से घोषणाएँ भेजें।",
        "Content Management": "कंटेंट मैनेजमेंट",
        "Poster templates, landing banners and testimonials curated by the super-admin.": "पोस्टर टेम्पलेट, लैंडिंग बैनर और प्रशंसापत्र जो सुपर‑एडमिन द्वारा चुने और तैयार किए गए हों।",
        "Platform-wide audit trail, failed logins, DPDP compliance requests, and your MFA credentials.": "पूरे प्लैटफ़ॉर्म का ऑडिट ट्रेल, असफल लॉग‑इन, DPDP अनुपालन अनुरोध और आपके MFA क्रेडेंशियल्स।",
        "Manage who can sign into the admin panel and what they can access.": "यह नियंत्रित करें कि एडमिन पैनल में कौन लॉग‑इन कर सकता है और वह क्या एक्सेस कर सकता है।",
        "Family Content Moderation": "परिवार कंटेंट मॉडरेशन",
        "Listen": "सुनें",
        "Stop": "रोकें",
        "Pause": "रोकें",
        "Resume": "फिर से शुरू करें",
        "Generating…": "तैयार किया जा रहा है…",
        "Signup trend — last 90 days": "साइनअप रुझान — पिछले 90 दिनों में",
        "(or user) is expected to add all their family relationships on the": "(या उपयोगकर्ता) से अपेक्षा की जाती है कि वे अपने सभी पारिवारिक रिश्ते यहाँ जोड़ें",
        ", which can only be opened by your password.": ", जिसे केवल आपका पासवर्ड डालकर ही खोला जा सकता है।",
        ". Any member added there is automatically reflected here. For convenience, a few extra fields for": "। वहाँ जोड़ा गया कोई भी सदस्य अपने आप यहाँ दिखता है। सुविधा के लिए, कुछ अतिरिक्त फ़ील्ड",
        "A family together": "एक साथ जुड़ा परिवार",
        "A premium feature for your family's future": "आपके परिवार के भविष्य के लिए एक प्रीमियम सुविधा",
        "Add": "जोड़ें",
        "Add Event": "घटना जोड़ें",
        "Add custom field": "कस्टम फ़ील्ड जोड़ें",
        "All checks": "सभी जाँचें",
        "Avg age": "औसत आयु",
        "Back": "वापस",
        "Back to Dashboard": "डैशबोर्ड पर वापस जाएँ",
        "Change photo": "फ़ोटो बदलें",
        "Choose the package that fits your family": "अपने परिवार के लिए उपयुक्त पैकेज चुनें",
        "Classic, Premium and Elite": "क्लासिक, प्रीमियम और एलीट",
        "Countries": "देश",
        "Current": "वर्तमान",
        "Current Location": "वर्तमान स्थान",
        "Current city": "वर्तमान शहर",
        "Current locations": "वर्तमान स्थान",
        "Data is encrypted in transit and at rest; every add/edit/delete is captured in the audit log.": "डेटा यात्रा के दौरान और स्टोरेज में एन्क्रिप्टेड रहता है; हर जोड़ने/बदलने/हटाने की कार्रवाई ऑडिट लॉग में दर्ज होती है।",
        "Date": "तारीख",
        "Dear customer,": "आदरणीय ग्राहक,",
        "Delete": "हटाएँ",
        "Distinct Cities": "अलग-अलग शहर",
        "Family (₹999/yr)": "परिवार (₹999/वर्ष)",
        "Family Head": "परिवार प्रमुख",
        "Family Health": "परिवार का स्वास्थ्य",
        "Family Members": "परिवार के सदस्य",
        "Family Relationships": "परिवारिक रिश्ते",
        "Favourite mithai": "पसंदीदा मिठाई",
        "Field name": "फ़ील्ड का नाम",
        "Fill with AI": "AI से भरें",
        "GPT-5.2 fills 40+ fields across all 6 modules from your surname + region · you edit before saving.": "GPT-5.2 आपके सरनेम + क्षेत्र की जानकारी से 6ों मॉड्यूल में 40+ फ़ील्ड अपने‑आप भर देता है · सेव करने से पहले आप सब कुछ संपादित कर सकते हैं।",
        "Gaon ka temple": "गाँव का मंदिर",
        "Generations": "पीढ़ियाँ",
        "Health & Medical Repository": "स्वास्थ्य व चिकित्सा भंडार",
        "Health Score Compliance Report": "हेल्थ स्कोर अनुपालन रिपोर्ट",
        "Health information is stored with explicit consent, only for members whose data you are authorised to record.": "स्वास्थ्य संबंधी जानकारी केवल स्पष्ट सहमति के साथ, और सिर्फ़ उन्हीं सदस्यों के लिए सुरक्षित रखी जाती है जिनका डेटा दर्ज करने के लिए आप अधिकृत हैं।",
        "Help": "सहायता",
        "Hide details": "विवरण छुपाएँ",
        "How complete is your family tree?": "आपका पारिवारिक वंश-वृक्ष कितना पूरा है?",
        "Informed consent — one time, per family": "सूचित सहमति — प्रति परिवार केवल एक बार",
        "Kind": "प्रकार",
        "Legacy (₹2999/yr)": "लेगेसी (₹2999/वर्ष)",
        "Linked live from your family tree.": "आपके पारिवारिक वंश-वृक्ष से सीधे जुड़ा हुआ।",
        "Living Cities": "निवास के शहर",
        "Loading events…": "घटनाएँ लोड हो रही हैं…",
        "Loading packages…": "पैकेज लोड हो रहे हैं…",
        "Loading world map…": "विश्व मानचित्र लोड हो रहा है…",
        "Loading…": "लोड हो रहा है…",
        "Lucky number": "लकी नंबर",
        "Member Profile": "सदस्य प्रोफ़ाइल",
        "Most Popular": "सबसे लोकप्रिय",
        "Native": "मूल",
        "Native Place": "मूल स्थान",
        "Native Places": "मूल स्थान",
        "Native places": "मूल स्थान",
        "None of your family members have a mapped location yet.": "आपके किसी भी परिवार के सदस्य का स्थान अभी तक मानचित्र पर नहीं जोड़ा गया है।",
        "Not a medical diagnosis platform.": "यह कोई चिकित्सीय जाँच/निदान मंच नहीं है।",
        "Not added yet": "अभी तक नहीं जोड़ा गया",
        "Notes (optional)": "नोट्स (वैकल्पिक)",
        "Place of birth": "जन्म स्थान",
        "Preserve. Understand. Inform.": "संरक्षित करें। समझें। जानकारी दें।",
        "Privacy by design:": "डिज़ाइन से ही गोपनीयता:",
        "Records are visible to your family circle only; the Family Head controls who can add or edit.": "रिकॉर्ड केवल आपके पारिवारिक समूह को दिखाई देंगे; परिवार प्रमुख तय करेंगे कि कौन जोड़ सकता है या संपादित कर सकता है।",
        "Remove": "हटाएँ",
        "Reset": "रीसेट करें",
        "Save &amp; Continue": "सहेजें और आगे बढ़ें",
        "Saved ✓": "सहेजा गया ✓",
        "Saving…": "सहेजा जा रहा है…",
        "Sensitive details are hidden by default.": "संवेदनशील जानकारियाँ डिफ़ॉल्ट रूप से छिपी रहती हैं।",
        "Skip the blank page — let AI suggest your family&apos;s heritage": "खाली पेज छोड़ें — अपने परिवार की विरासत के सुझाव AI से लें",
        "Tap to view": "देखने के लिए टैप करें",
        "This is a record-keeping repository — not a diagnosis, treatment or medical-advice tool.": "यह केवल रिकॉर्ड रखने का संग्रह है — कोई निदान, इलाज या चिकित्सकीय सलाह देने वाला उपकरण नहीं।",
        "This repository is for private family record-keeping and health-history awareness only — it does not provide diagnosis, treatment, risk prediction or medical advice. Always consult a qualified healthcare provider.": "यह संग्रह केवल निजी पारिवारिक रिकॉर्ड रखने और स्वास्थ्य इतिहास की जानकारी के लिए है — यह निदान, इलाज, जोखिम का अनुमान या चिकित्सकीय सलाह नहीं देता। हमेशा किसी योग्य स्वास्थ्य विशेषज्ञ से परामर्श करें।",
        "This section is private": "यह अनुभाग निजी है",
        "Timezones spread": "समय क्षेत्रों का फैलाव",
        "Tip": "सुझाव",
        "Title": "शीर्षक",
        "Tree completeness": "वृक्ष की पूर्णता",
        "Update": "अपडेट करें",
        "Update their": "उनका अपडेट करें",
        "Value (type or tap 🎤)": "मान (टाइप करें या 🎤 दबाएँ)",
        "Visual Family Tree": "दृश्य परिवार वृक्ष",
        "Voice language": "आवाज़ की भाषा",
        "What's missing": "क्या कमी है",
        "Where Your Family Lives — Across the World": "आपका परिवार कहाँ रहता है — पूरी दुनिया में",
        "are provided in the section below —": "नीचे दिए गए अनुभाग में उपलब्ध हैं —",
        "bank locker": "बैंक लॉकर",
        "can be preserved in this section. The documents associated with these important information are required to be preserved at a different location, which is a special privilege of our": "को इस अनुभाग में सुरक्षित रखा जा सकता है। इन महत्वपूर्ण जानकारियों से जुड़े दस्तावेज़ों को एक अलग स्थान पर सुरक्षित रखना आवश्यक है, जो हमारे",
        "complete. Tick off the items below to grow it further.": "पूरा हो चुका है। इसे और आगे बढ़ाने के लिए नीचे दी गई वस्तुओं पर टिक लगाएँ।",
        "customers.": "ग्राहकों के लिए एक विशेष सुविधा है।",
        "descriptive information": "वर्णनात्मक जानकारी",
        "e.g. Dadu's Birthday": "जैसे, दादू का जन्मदिन",
        "family-only visibility · Family Head controls writing · explicit informed consent · encrypted storage · full audit trail of every change · DPDP Act 2023 aligned. Coming next: disease timeline, maternal/paternal branch views & emergency health card.": "सिर्फ परिवार के लिए दृश्यता · लेखन का नियंत्रण परिवार प्रमुख के पास · स्पष्ट सूचित सहमति · एन्क्रिप्टेड स्टोरेज · प्रत्येक बदलाव का पूर्ण ऑडिट ट्रेल · DPDP Act 2023 के अनुरूप। आगे आने वाला है: बीमारियों की समयरेखा, ननिहाल/ददिहाल शाखा दृश्य और आपातकालीन स्वास्थ्य कार्ड।",
        "on the profile page, and they'll appear on the map instantly.": "प्रोफ़ाइल पेज पर, और वे तुरंत मानचित्र पर दिखने लगेंगी।",
        "or": "या",
        "plans — preserve multi-generation medical history, hereditary conditions, allergies, vaccinations and more.": "प्लान — कई पीढ़ियों का मेडिकल इतिहास, अनुवांशिक बीमारियाँ, एलर्जी, टीकाकरण और बहुत कुछ सुरक्षित रखें।",
        "please note that you are preserving very important and vital information. Please make sure you save important information only if you want to preserve it on this platform in a highly secured manner by using a proper password. All the documents here are preserved as if they are kept in a": "कृपया ध्यान दें कि आप यहाँ बहुत महत्वपूर्ण और संवेदनशील जानकारी सुरक्षित रख रहे हैं। कृपया यह सुनिश्चित करें कि आप महत्वपूर्ण जानकारी तभी सहेजें, जब आप उसे एक मज़बूत पासवर्ड के साथ इस प्लेटफ़ॉर्म पर अत्यंत सुरक्षित तरीके से संरक्षित करना चाहते हों। यहाँ रखे सभी दस्तावेज़ ऐसे सुरक्षित रखे जाते हैं मानो वे किसी",
        "step relations, adopted relations, close relatives and extended relatives": "सौतेले रिश्ते, गोद लिए गए रिश्ते, नज़दीकी रिश्तेदार और दूर के रिश्तेदार",
        "these will not appear on your pictorial family tree view.": "ये आपके चित्रात्मक फैमिली ट्री दृश्य में नहीं दिखेंगे।",
        "© 2026 Digital Family Tree. All rights reserved.": "© 2026 Digital Family Tree. सर्वाधिकार सुरक्षित।",
        "21 sections of guided wisdom — the values, lessons and stories you want to pass down.": "मार्गदर्शित ज्ञान के 21 भाग — वे मूल्य, सबक और कहानियाँ जो आप आगे देना चाहते हैं।",
        "AI-POWERED": "AI-POWERED",
        "Aadhaar, property papers, wills and certificates — stored privately and shared only with the people you choose.": "आधार, संपत्ति के कागज़ात, वसीयतें और प्रमाणपत्र — सब कुछ निजी रूप से सुरक्षित, और केवल उन्हीं लोगों से साझा जिन्हें आप चुनें।",
        "Achievements Wall": "उपलब्धियों की दीवार",
        "Ask anything about your family — heritage, relationships, memories — and get instant AI answers.": "अपने परिवार के बारे में कुछ भी पूछें — विरासत, रिश्ते, यादें — और तुरंत AI से उत्तर पाएं।",
        "Audio Memories (Voice Stories)": "ऑडियो यादें (आवाज़ में कहानियाँ)",
        "Begin your family tree journey": "अपनी फैमिली ट्री की यात्रा शुरू करें",
        "Birthdays, anniversaries and festivals happening for your family today — one tap to wish.": "आज आपके परिवार में होने वाले जन्मदिन, वर्षगाँठ और त्योहार — बस एक टैप में शुभकामनाएँ भेजें।",
        "Blood groups, allergies, chronic conditions and emergency contacts — accessible when it matters most.": "ब्लड ग्रुप, एलर्जी, दीर्धकालीन बीमारियाँ और आपातकालीन संपर्क — जब सबसे ज़्यादा ज़रूरत हो तब तुरंत उपलब्ध।",
        "Bring parents, siblings and cousins into your private family space — everyone adds their memories, and the tree grows together.": "माता–पिता, भाई–बहन और कज़िन्स को अपने निजी पारिवारिक स्पेस में जोड़ें — हर कोई अपनी यादें जोड़ता है, और फैमिली ट्री साथ‑साथ बढ़ता है।",
        "CULTURE & TRADITIONS": "संस्कृति और परंपराएँ",
        "Capture a memory in your own voice. We'll transcribe, translate and preserve it for future generations.": "अपनी किसी याद को अपनी ही आवाज़ में रिकॉर्ड करें। हम उसे लिखित रूप में बदलकर, अनुवाद करके आने वाली पीढ़ियों के लिए सहेज कर रखेंगे।",
        "Celebrate doctors, engineers, artists and every achiever in your family — a wall of pride for generations to see.": "अपने परिवार के डॉक्टर, इंजीनियर, कलाकार और हर उपलब्धि हासिल करने वाले सदस्य का सम्मान करें — आने वाली पीढ़ियों के लिए गर्व की एक दीवार।",
        "Choose the package that fits your family — upgrade anytime, and unlock more features as your legacy grows.": "अपने परिवार के लिए सही पैकेज चुनें — कभी भी अपग्रेड करें, और जैसे‑जैसे आपकी विरासत बढ़े, वैसे‑वैसे और फीचर्स अनलॉक करें।",
        "Complete legacy suite with AI tools": "AI टूल्स के साथ संपूर्ण विरासत सूट",
        "Connections": "कनेक्शन्स",
        "Culture & Rituals Archive": "संस्कृति और रीति‑रिवाज़ संग्रह",
        "Demo Coming Soon": "डेमो जल्द आ रहा है",
        "Demo pricing — final packages will be announced soon. Selection is saved to your account.": "डेमो प्राइसिंग — अंतिम पैकेज जल्द ही घोषित किए जाएँगे। आपका चुनाव आपके अकाउंट में सुरक्षित रहेगा।",
        "Digital Family Tree (Print-ready)": "डिजिटल फैमिली ट्री (प्रिंट के लिए तैयार)",
        "EMERGENCY INFO": "आपातकालीन जानकारी",
        "EVENTS & DATES": "कार्यक्रम और तिथियाँ",
        "Events & Reminders": "कार्यक्रम और रिमाइंडर",
        "Every family member at a glance — search, filter and open any profile in one tap.": "हर परिवार सदस्य एक नज़र में — खोजें, फ़िल्टर करें और किसी भी प्रोफ़ाइल को एक टैप में खोलें।",
        "Every milestone across generations — arranged as one continuous, beautiful story.": "पीढ़ियों के हर महत्वपूर्ण मोड़ को — एक सतत, सुंदर कहानी की तरह सजाकर देखें।",
        "Every new member, photo, story and record — see everything happening in your family, as it happens.": "हर नया सदस्य, फोटो, कहानी और रिकॉर्ड — अपने परिवार में जो कुछ भी हो रहा है, उसे उसी समय देखें।",
        "Every photo, voice note and story preserved forever — safely inside your family vault.": "हर फोटो, वॉइस नोट और कहानी हमेशा के लिए सुरक्षित — आपके परिवार वॉल्ट के भीतर संरक्षित।",
        "Everything, forever — one payment": "सब कुछ, हमेशा के लिए — एक ही भुगतान",
        "Expert Biography Writing": "विशेषज्ञ जीवनी लेखन",
        "Export everything you've saved — members, stories, memories, records — in the format that suits you. Your data is always yours.": "जो कुछ भी आपने सहेजा है — सदस्य, कहानियाँ, यादें, रिकॉर्ड — सब कुछ अपने मनपसंद फ़ॉर्मेट में एक्सपोर्ट करें। आपका डेटा हमेशा आपका ही रहता है।",
        "FAMILY STATISTICS": "परिवार आँकड़े",
        "FAMILY TIMELINE": "परिवार टाइमलाइन",
        "FAMILY WORLD MAP": "परिवार विश्व मानचित्र",
        "Family Activity": "परिवार गतिविधि",
        "Family Calendar & Celebrations": "परिवार कैलेंडर और उत्सव",
        "Family Pride": "परिवार का गौरव",
        "Family Records": "परिवार रिकॉर्ड",
        "Family Tree Builder (6 generations)": "फैमिली ट्री बिल्डर (6 पीढ़ियाँ)",
        "Family World Map": "परिवार विश्व मानचित्र",
        "Gold": "गोल्ड",
        "HEALTH & EMERGENCY": "स्वास्थ्य व आपातकाल",
        "HEALTH REPOSITORY": "स्वास्थ्य भंडार",
        "Health & Medical Repository (10 registers)": "स्वास्थ्य व मेडिकल भंडार (10 रजिस्टर)",
        "How large is your family across generations? Longevity, geography, professions and more.": "पीढ़ियों में फैला आपका परिवार कितना बड़ा है? दीर्घायु, भौगोलिक विस्तार, पेशे और बहुत कुछ।",
        "Keep every family member's blood group in one secure place. In an emergency, every second counts — this registry helps you instantly find the right donor within your family.": "हर परिवार सदस्य का रक्त समूह एक सुरक्षित स्थान पर रखें। आपातकाल में हर पल कीमती होता है — यह रजिस्टर आपको तुरंत आपके ही परिवार से सही दाता ढूंढने में मदद करता है।",
        "LEGACY & MEMORIAL": "विरासत व स्मरण",
        "LEGAL & LEGACY": "कानूनी व विरासत",
        "Legacy Lifetime": "आजीवन विरासत",
        "Legal Vault (Will & Nominee)": "कानूनी वॉल्ट (वसीयत व नामांकित)",
        "Let AI compose a heartfelt narrative of your family's journey from the profiles you've filled.": "आपके भरे हुए प्रोफ़ाइल के आधार पर अपने परिवार की जीवन-यात्रा की भावपूर्ण कहानी AI से लिखवाएं।",
        "MEMORIES & STORIES": "यादें व किस्से",
        "Marriage Records": "विवाह अभिलेख",
        "Member Profiles & Photos": "सदस्य प्रोफ़ाइल व फ़ोटो",
        "Memories & reminders for the whole family": "पूरे परिवार के लिए यादें और रिमाइंडर",
        "Multi-user Family Access (Invites)": "एकाधिक उपयोगकर्ता पारिवारिक एक्सेस (निमंत्रण)",
        "Never miss a birthday, anniversary or festival — smart reminders from your family tree, delivered by email, push and in-app.": "अब कभी जन्मदिन, सालगिरह या त्योहार न चूकें — आपके परिवार वृक्ष से मिलने वाले स्मार्ट रिमाइंडर ईमेल, पुश और इन-ऐप के ज़रिए पहुँचेंगे।",
        "One place for every birthday, anniversary, shraddha and cultural festival — with smart nudges.": "हर जन्मदिन, सालगिरह, श्राद्ध और सांस्कृतिक त्योहार के लिए एक ही स्थान — स्मार्ट याद दिलाने के साथ।",
        "Personal Vault": "पर्सनल वॉल्ट",
        "Prescriptions, reports and hospital records for every family member — organized and searchable.": "हर परिवार सदस्य की पर्चियाँ, रिपोर्ट और अस्पताल के रिकॉर्ड — सुव्यवस्थित और आसानी से खोजने योग्य।",
        "Preserve wedding dates, venues and couple details — anniversaries flow automatically into your family calendar and timeline.": "विवाह की तारीखें, स्थान और जोड़े के विवरण सुरक्षित रखें — सालगिरहें अपने आप आपके पारिवारिक कैलेंडर और टाइमलाइन में जुड़ जाएँगी।",
        "Priority Support": "प्रायोरिटी सपोर्ट",
        "Rituals, recipes, dialects and heritage — everything that makes your family uniquely yours.": "रीत-रिवाज, व्यंजन विधियाँ, बोलियाँ और विरासत — वह सब कुछ जो आपके परिवार को सबसे अलग और अपना बनाता है।",
        "SHARE & CELEBRATE": "साझा करें और जश्न मनाएँ",
        "Seal messages, photos and videos to open on future birthdays, anniversaries or a chosen date.": "संदेश, फ़ोटो और वीडियो को सील करें ताकि वे भविष्य के जन्मदिनों, वर्षगाँठों या किसी चुनी हुई तारीख पर खुलें।",
        "See every family member on a real world map. Each pin shows a current location (orange) and a native place (green), connected by a dotted line — a beautiful visual of your family's journey through geography.": "हर परिवार सदस्य को असली दुनिया के नक्शे पर देखें। हर पिन वर्तमान स्थान (नारंगी) और मूल स्थान (हरा) दिखाता है, जो एक डॉटेड लाइन से जुड़े होते हैं — आपके परिवार की भूगोल के सफ़र की एक खूबसूरत झलक।",
        "Share the gift of legacy — invite friends to build their own private family tree, free to start.": "विरासत का उपहार बाँटें — मित्रों को आमंत्रित करें कि वे अपना निजी फैमिली ट्री बनाएँ, शुरूआत बिल्कुल मुफ़्त।",
        "Silver": "सिल्वर",
        "Smart Reminders (Email + Push)": "स्मार्ट रिमाइंडर (ईमेल + पुश)",
        "Starter": "स्टार्टर",
        "TIME CAPSULES": "टाइम कैप्सूल्स",
        "TODAY'S CELEBRATIONS": "आज के उत्सव",
        "Turn your family tree into a beautiful shareable poster — perfect for wedding invites, festivals and print.": "अपने फैमिली ट्री को एक सुंदर, सबके साथ साझा करने योग्य पोस्टर में बदलें — शादी के निमंत्रण, त्योहारों और प्रिंट के लिए एकदम उपयुक्त।",
        "VOICE & STORIES": "वॉइस और कहानियाँ",
        "Watch Demo": "डेमो देखें",
        "Wills, power-of-attorney, property papers and nominee details — locked and always accessible to the right people.": "वसीयतें, पावर-ऑफ-अटॉर्नी, ज़मीन-जायदाद के काग़ज़ात और नामांकित व्यक्ति की जानकारी — सुरक्षित ताले में और हमेशा सही लोगों के लिए सुलभ।",
        "Your data, your rules — manage account preferences, visibility and every privacy declaration in one place.": "आपका डेटा, आपके नियम — अकाउंट की पसंद, दिखाई देने वाली जानकारी और हर प्राइवेसी सहमति को एक ही जगह से नियंत्रित करें।",
        "one-time · lifetime": "एक बार · आजीवन",
        "per month": "प्रति माह",
        "per year": "प्रति वर्ष",
        "January": "जनवरी",
        "February": "फ़रवरी",
        "March": "मार्च",
        "April": "अप्रैल",
        "May": "मई",
        "June": "जून",
        "July": "जुलाई",
        "August": "अगस्त",
        "September": "सितंबर",
        "October": "अक्टूबर",
        "November": "नवंबर",
        "December": "दिसंबर",
        "is locked": "लॉक है",
        "Your current package": "आपका वर्तमान पैकेज",
        "doesn't include this feature.": "इस सुविधा को शामिल नहीं करता है।",
        "Included in": "इनमें उपलब्ध",
        "one-time": "एक बार का",
        "year": "साल",
        "month": "महीना",
        "lifetime": "आजीवन",
        "Go Back": "वापस जाएँ",
        "View Packages": "पैकेज देखें",
        "This feature": "यह सुविधा",
        "Family Legacy Dashboard": "परिवार विरासत डैशबोर्ड",
        "Legacy Services": "विरासत सेवाएँ",
        "Life Story Vault": "जीवन कहानी संग्रह",
        "Video Testament Library": "वीडियो वसीयतनामा लाइब्रेरी",
        "Family Wisdom Bank": "परिवार ज्ञान बैंक",
        "Failure Stories Archive": "विफलता कहानियों का संग्रह",
        "Success Stories": "सफलता की कहानियाँ",
        "Family Decision History": "परिवारिक निर्णय इतिहास",
        "Family Values Repository": "परिवारिक मूल्यों का भंडार",
        "Family Hero Gallery": "परिवार नायकों की गैलरी",
        "Unsung Heroes": "अनसुने नायक",
        "Gratitude Wall": "कृतज्ञता दीवार",
        "Tribute Pages": "श्रद्धांजलि पृष्ठ",
        "Love Letters Archive": "प्रेम पत्र संग्रह",
        "Childhood Stories Bank": "बचपन की कहानियों का बैंक",
        "Language Preservation": "भाषा संरक्षण",
        "Ancestral Village": "पैतृक गाँव",
        "Surname History": "उपनाम इतिहास",
        "Family Emblem": "परिवार का प्रतीक चिह्न",
        "Cultural Artifacts": "सांस्कृतिक धरोहरें",
        "Family Songs & Bhajans": "परिवारिक गीत और भजन",
        "Oral History Center": "मौखिक इतिहास केंद्र",
        "Biography Writing Platform": "जीवनी लेखन मंच",
        "Memoir Writing Service": "संस्मरण लेखन सेवा",
        "Personalised Gifting Service": "निजीकृत उपहार सेवा",
        "Personal Digital Identity Platform": "व्यक्तिगत डिजिटल पहचान मंच",
        "Add to": "में जोड़ें",
        "Choose": "चुनें",
        "Compare all packages": "सभी पैकेजों की तुलना करें",
        "Real outputs your family gets": "आपके परिवार को मिलने वाले असली आउटपुट",
        "See what you actually receive": "देखिए आपको वास्तव में क्या मिलता है",
        "Every package delivers keepsake-quality designs — printable Family Tree posters and personalised Digital ID cards. Tap any design to view it full-size.": "हर पैकेज यादगार गुणवत्ता के डिज़ाइन देता है — प्रिंट करने योग्य Family Tree पोस्टर और व्यक्तिगत Digital ID कार्ड। किसी भी डिज़ाइन को पूरे आकार में देखने के लिए टैप करें।",
        "Family Tree Posters": "Family Tree पोस्टर",
        "Digital ID Cards": "Digital ID कार्ड",
        "View full": "पूरा देखें",
        "Sample designs shown. Your posters and cards are personalised with your family's names, photos and details.": "यहाँ नमूना डिज़ाइन दिखाए गए हैं। आपके पोस्टर और कार्ड आपके परिवार के नाम, तस्वीरों और जानकारी के साथ व्यक्तिगत बनाए जाते हैं।",
        "Demo pricing — packages, prices and the feature split are all editable from the admin panel.": "डेमो प्राइसिंग — पैकेज, कीमतें और फीचर विभाजन सब कुछ एडमिन पैनल से बदला जा सकता है।",
        "Feature": "फीचर",
        "Five packages, one family legacy": "पांच पैकेज, एक पारिवारिक विरासत",
        "Free": "फ्री",
        "Life story, wisdom and biography now live in Family Legacy Dashboard": "जीवन कहानी, अनुभव और जीवनी अब Family Legacy Dashboard में उपलब्ध हैं",
        "Open Family Legacy Dashboard": "Family Legacy Dashboard खोलें",
        "Packages & Pricing": "पैकेज और प्राइसिंग",
        "Packages temporarily unavailable. Please try again shortly.": "पैकेज अस्थायी रूप से उपलब्ध नहीं हैं। कृपया थोड़ी देर बाद फिर से कोशिश करें।",
        "Start Free": "फ्री में शुरू करें",
        "Start free, upgrade whenever your family is ready. Every feature below is compared side by side so nothing is hidden.": "फ्री में शुरू करें, जब आपका परिवार तैयार हो तब अपग्रेड करें। नीचे दिए गए हर फीचर की आमने‑सामने तुलना की गई है ताकि कुछ भी छिपा न रहे।",
        "Swipe sideways on a phone — the feature column stays in place.": "फोन पर साइड में स्वाइप करें — फीचर वाला कॉलम अपनी जगह पर ही रहेगा।",
        "more features": "और फीचर",
        "Namaste": "नमस्ते",
        "{sender} has added you to our family tree on Family Repository.": "{sender} ने आपको Family Repository पर हमारे परिवार वृक्ष में जोड़ा है।",
        "Tap to join": "जुड़ने के लिए टैप करें",
        "Your invite code": "आपका आमंत्रण कोड",
        "Together we will preserve our family's stories, photos and voices for the next generations.": "हम मिलकर आने वाली पीढ़ियों के लिए अपने परिवार की कहानियाँ, तस्वीरें और आवाज़ें सुरक्षित रखेंगे।",
        "Your family": "आपका परिवार",
        "Invite on WhatsApp": "WhatsApp पर आमंत्रित करें",
        "WhatsApp opened with the invite message.": "WhatsApp आमंत्रण संदेश के साथ खुल गया।",
    },
    mr: {
        "Home": "मुख्य पान",
        "Family": "कुटुंब",
        "Family Tree": "कुटुंब वृक्ष",
        "Add a Member": "सदस्य जोडा",
        "Invite Family": "कुटुंबाला आमंत्रण पाठवा",
        "Family Hub · All": "फॅमिली हब · सर्व",
        "Family Timeline": "कुटुंब कालरेषा",
        "Family Calendar": "कुटुंब दिनदर्शिका",
        "Services": "सेवा",
        "Photo Memories": "फोटो आठवणी",
        "Audio Memories": "ऑडिओ आठवणी",
        "AI Family Advisor": "AI फॅमिली सल्लागार",
        "AI Story Generator": "AI स्टोरी जनरेटर",
        "Video Memories": "व्हिडिओ आठवणी",
        "Digital Family Tree": "डिजिटल कुटुंब वृक्ष",
        "Family Hall of Fame": "कुटुंब सन्मान भिंत",
        "Family Hub · All Services": "फॅमिली हब · सर्व सेवा",
        "Records": "नोंदी",
        "Blood Group Registry": "रक्तगट नोंदणी",
        "Health Repository": "आरोग्य संग्रह",
        "Health Score Compliance": "आरोग्य गुणपालन",
        "Emergency Contacts": "आपत्कालीन संपर्क",
        "Business Directory": "व्यवसाय निर्देशिका",
        "Recipe Vault": "रेसिपी तिजोरी",
        "Family Statistics": "कुटुंबीय सांख्यिकी",
        "Legacy": "वारसा",
        "Legal Vault": "कायदेशीर तिजोरी",
        "Document Vault": "दस्तऐवज तिजोरी",
        "Story & Wisdom Vault": "कथा व शहाणपण तिजोरी",
        "Family Constitution": "कुटुंबीय सनद",
        "Futuristic Legacy Letter": "भविष्योन्मुख वारसा पत्र",
        "Digital Memorial": "डिजिटल स्मारक",
        "Account": "खाते",
        "Packages & Plans": "पॅकेजेस व योजना",
        "Privacy & Settings": "गोपनीयता व सेटिंग्ज",
        "Download & Export": "डाउनलोड व निर्यात",
        "Profile": "प्रोफाइल",
        "Search family…": "कुटुंब शोधा…",
        "Dashboard": "डॅशबोर्ड",
        "Families": "कुटुंबे",
        "Users": "वापरकर्ते",
        "Subscriptions": "सदस्यत्वे",
        "Packages": "पॅकेजेस",
        "Exports": "निर्यात",
        "Content": "मजकूर",
        "Landing Slides": "लँडिंग स्लाइड्स",
        "Site Assets": "साइट मालमत्ता",
        "Family Content": "कुटुंबीय मजकूर",
        "Translations": "भाषांतर",
        "User Page Editor": "वापरकर्ता पृष्ठ संपादक",
        "Analytics": "विश्लेषण",
        "Support Tickets": "सपोर्ट तिकिटे",
        "Broadcasts": "प्रसारण",
        "Legacy CRM": "लीगेसी CRM",
        "SMS Console": "SMS कन्सोल",
        "Security": "सुरक्षा",
        "Settings": "सेटिंग्ज",
        "UI/UX Audit": "UI/UX ऑडिट",
        "API Keys": "API किज",
        "Admin Team": "प्रशासन संघ",
        "Content Managers": "कंटेंट व्यवस्थापक",
        "Overview": "एकूण माहिती",
        "Members": "सदस्य",
        "Billing": "बिलिंग",
        "Landing & Content": "लँडिंग आणि कंटेंट",
        "Insights": "आढावा व निरीक्षणे",
        "Support": "सपोर्ट",
        "System": "सिस्टम",
        "Super Admin": "सुपर अॅडमिन",
        "Content Admin": "कंटेंट अॅडमिन",
        "Content Manager": "कंटेंट मॅनेजर",
        "Finance Admin": "फायनान्स अॅडमिन",
        "Support Admin": "सपोर्ट अॅडमिन",
        "Security Admin": "सिक्युरिटी अॅडमिन",
        "Admin": "अॅडमिन",
        "Admin Panel": "अॅडमिन पॅनल",
        "Logout": "लॉगआउट",
        "Loading dashboard…": "डॅशबोर्ड लोड होत आहे…",
        "Platform overview at a glance.": "प्लॅटफॉर्मचा झटपट आढावा.",
        "Total Families": "एकूण कुटुंबे",
        "Total Members": "एकूण सदस्य",
        "Tree Persons": "वंशवृक्षातील व्यक्ती",
        "Storage Used": "वापरलेली स्टोरेज",
        "Marriages": "लग्न नोंदी",
        "Memory Albums": "आठवणींची अल्बम्स",
        "Wills (latest)": "इच्छापत्रे (नवीनतम)",
        "Audio Wills": "ऑडिओ इच्छापत्रे",
        "With recorded audio": "रेकॉर्ड केलेल्या ऑडिओसह",
        "Across all families": "सर्व कुटुंबांमध्ये मिळून",
        "New signups — last 30 days": "नवीन नोंदणी — मागील ३० दिवसांत",
        "Storage breakdown": "स्टोरेजचा तपशील",
        "No stored files yet.": "अजून कोणतीही फाइल साठवलेली नाही.",
        "Signups": "नोंदणी",
        "suspended": "निलंबित",
        "blocked": "अवरोधित",
        "paid": "सशुल्क",
        "open tickets": "उघडी तक्रारी",
        "Memory photos": "आठवणींचे फोटो",
        "Vault documents": "व्हॉल्टमधील कागदपत्रे",
        "Story audio": "कथांचे ऑडिओ",
        "Member profiles & photos": "सदस्य प्रोफाइल आणि फोटो",
        "Profile details": "प्रोफाइल तपशील",
        "Story metadata": "कहाणी मेटाडेटा",
        "Memory metadata": "आठवणीचे मेटाडेटा",
        "Document metadata": "दस्तऐवज मेटाडेटा",
        "Admin (Head)": "प्रशासक (मुख्य)",
        "added": "जोडले",
        "updated": "अपडेट केले",
        "removed": "काढले",
        "changed privacy of": "याची गोपनीयता बदलली",
        "updated profile of": "याचे प्रोफाइल अपडेट केले",
        "viewed profile of": "याचे प्रोफाइल पाहिले",
        "recorded": "रेकॉर्ड केले",
        "played": "प्लے केले",
        "deleted story": "कहाणी हटवली",
        "uploaded": "अपलोड केले",
        "viewed": "पाहिले",
        "changed access of": "याचा प्रवेश बदलला",
        "deleted": "हटवले",
        "invited": "आमंत्रित केले",
        "revoked an invite": "आमंत्रण रद्द केले",
        "joined the family": "कुटुंबात सहभागी झाले",
        "changed role of": "यांची भूमिका बदलली:",
        "downloaded their data": "आपला डेटा डाउनलोड केला",
        "completed privacy setup": "गोपनीयता सेटअप पूर्ण केले",
        "deleted account of": "यांचे खाते हटवले:",
        "Senior mode on — simpler privacy choices.": "ज्येष्ठ मोड सुरू — सोप्या गोपनीयता निवडी.",
        "Senior mode off.": "ज्येष्ठ मोड बंद.",
        "Saved.": "जतन केले.",
        "Your data export has been downloaded.": "आपला डेटा एक्सपोर्ट डाउनलोड झाला आहे.",
        "Your account and data have been deleted.": "आपले खाते आणि डेटा हटवले गेले आहेत.",
        "Every family tree on the platform. Suspending blocks all its members from logging in.": "प्लॅटफॉर्मवरील प्रत्येक वंशवृक्ष. निलंबन केल्यावर त्या वंशवृक्षातील सर्व सदस्यांना लॉगिन करता येत नाही.",
        "All registered members. Blocked users cannot log in or use the API.": "सर्व नोंदणीकृत सदस्य. ब्लॉक केलेल्या वापरकर्त्यांना लॉगिन करता किंवा API वापरता येत नाही.",
        "Manual plan control until a payment gateway is connected in Settings.": "Settings मध्ये पेमेंट गेटवे जोडले जाईपर्यंत प्लॅनचे नियंत्रण हाताने करा.",
        "Growth, engagement and audience mix.": "वाढ, सहभाग आणि प्रेक्षकांचा एकत्रित आढावा.",
        "Users raise tickets from Settings → Help in the app.": "वापरकर्ते अॅपमध्ये Settings → Help मधून तिकिटे नोंदवतात.",
        "Branding, payment gateway and API keys. Secrets are stored server-side and shown masked.": "Branding, पेमेंट गेटवे आणि API keys. गुप्त माहिती सर्व्हरवर साठवली जाते आणि झाकलेली (masked) स्वरूपात दाखवली जाते.",
        "Packages — Feature Matrix (Demo)": "पॅकेजेस — फीचर मॅट्रिक्स (डेमो)",
        "Export Center": "एक्सपोर्ट सेंटर",
        "Download authoritative reports in CSV, Excel or PDF. Schedule auto-email exports below.": "अधिकृत अहवाल CSV, Excel किंवा PDF स्वरूपात डाउनलोड करा. खाली स्वयंचलित ईमेल एक्सपोर्टचे वेळापत्रक ठरवा.",
        "Send SMS or WhatsApp announcements to your users.": "आपल्या वापरकर्त्यांना SMS किंवा WhatsApp द्वारे घोषणा पाठवा.",
        "Content Management": "कन्टेन्ट मॅनेजमेंट",
        "Poster templates, landing banners and testimonials curated by the super-admin.": "पोस्टर टेम्प्लेट्स, लँडिंग बॅनर्स आणि सुपर-अॅडमिनने निवडून ठेवलेले प्रमाणपत्र संदेश (टेस्टिमोनियल्स).",
        "Platform-wide audit trail, failed logins, DPDP compliance requests, and your MFA credentials.": "संपूर्ण प्लॅटफॉर्मवरील ऑडिट ट्रेल, अयशस्वी लॉगिन्स, DPDP संबंधित विनंत्या आणि आपली MFA क्रेडेन्शियल्स.",
        "Manage who can sign into the admin panel and what they can access.": "कोण अॅडमिन पॅनेलमध्ये साइन इन करू शकतो आणि काय पाहू/वापरू शकतो हे नियंत्रित करा.",
        "Family Content Moderation": "कौटुंबिक कन्टेन्ट मॉडरेशन",
        "Listen": "ऐका",
        "Stop": "थांबवा",
        "Pause": "थांबवा",
        "Resume": "पुन्हा सुरू करा",
        "Generating…": "तयार करत आहे…",
        "Signup trend — last 90 days": "साइनअपचा कल — मागील ९० दिवस",
        "(or user) is expected to add all their family relationships on the": "(किंवा वापरकर्ता) आपल्या सर्व कुटुंबीय नातेसंबंधांची नोंद येथे करण्याची अपेक्षा आहे",
        ", which can only be opened by your password.": ", जे फक्त तुमच्या पासवर्डनेच उघडता येईल.",
        ". Any member added there is automatically reflected here. For convenience, a few extra fields for": ". तिथे जोडलेला कोणताही सदस्य आपोआप इथे दिसेल. सोयीसाठी, यासाठी काही जास्तीची माहितीची क्षेत्रे दिली आहेत",
        "A family together": "कुटुंब एकत्र",
        "A premium feature for your family's future": "तुमच्या कुटुंबाच्या भविष्यासाठी एक प्रीमियम सुविधा",
        "Add": "जोडा",
        "Add Event": "घटना जोडा",
        "Add custom field": "हवे तसे नवीन क्षेत्र जोडा",
        "All checks": "सर्व तपासण्या",
        "Avg age": "सरासरी वय",
        "Back": "मागे",
        "Back to Dashboard": "डॅशबोर्डवर परत जा",
        "Change photo": "छायाचित्र बदला",
        "Choose the package that fits your family": "तुमच्या कुटुंबाला सर्वाधिक योग्य असा पॅकेज निवडा",
        "Classic, Premium and Elite": "Classic, Premium आणि Elite",
        "Countries": "देश",
        "Current": "सद्य",
        "Current Location": "सध्याचे ठिकाण",
        "Current city": "सध्याचे शहर",
        "Current locations": "सध्या राहण्याची ठिकाणे",
        "Data is encrypted in transit and at rest; every add/edit/delete is captured in the audit log.": "माहिती प्रवासात आणि स्थिर स्थितीत एन्क्रिप्ट केलेली असते; प्रत्येक add/edit/delete ऑडिट लॉगमध्ये नोंदवली जाते.",
        "Date": "दिनांक",
        "Dear customer,": "आदरणीय ग्राहक,",
        "Delete": "काढून टाका",
        "Distinct Cities": "वेगवेगळी शहरे",
        "Family (₹999/yr)": "कुटुंब (₹999/वर्ष)",
        "Family Head": "कुटुंबप्रमुख",
        "Family Health": "कुटुंबाचे आरोग्य",
        "Family Members": "कुटुंबातील सदस्य",
        "Family Relationships": "कौटुंबिक नातेसंबंध",
        "Favourite mithai": "आवडती मिठाई",
        "Field name": "फील्डचे नाव",
        "Fill with AI": "AI ने भरा",
        "GPT-5.2 fills 40+ fields across all 6 modules from your surname + region · you edit before saving.": "GPT-5.2 तुमचे आडनाव + प्रदेश यावरून सर्व 6 मॉड्युल्समधील 40+ फील्ड भरते · सेव्ह करण्यापूर्वी तुम्ही संपादित करू शकता.",
        "Gaon ka temple": "गावातील मंदिर",
        "Generations": "पिढ्या",
        "Health & Medical Repository": "आरोग्य व वैद्यकीय संग्रह",
        "Health Score Compliance Report": "हेल्थ स्कोअर अनुपालन अहवाल",
        "Health information is stored with explicit consent, only for members whose data you are authorised to record.": "आरोग्यविषयक माहिती स्पष्ट संमतीनेच जतन केली जाते, आणि फक्त त्या सदस्यांसाठी ज्यांची माहिती नोंदवण्यासाठी तुम्हाला परवानगी आहे.",
        "Help": "मदत",
        "Hide details": "तपशील लपवा",
        "How complete is your family tree?": "तुमचं वंशवृक्ष किती पूर्ण आहे?",
        "Informed consent — one time, per family": "माहितीपूर्ण संमती — प्रत्येक कुटुंबासाठी एकदाच",
        "Kind": "प्रकार",
        "Legacy (₹2999/yr)": "लेगसी (₹2999/वर्ष)",
        "Linked live from your family tree.": "तुमच्या वंशवृक्षाशी थेट जोडलेले.",
        "Living Cities": "सध्याचे राहण्याचे शहर",
        "Loading events…": "घटना लोड होत आहेत…",
        "Loading packages…": "पॅकेजेस लोड होत आहेत…",
        "Loading world map…": "जगाचा नकाशा लोड होत आहे…",
        "Loading…": "लोड होत आहे…",
        "Lucky number": "लकी नंबर",
        "Member Profile": "सदस्य प्रोफाइल",
        "Most Popular": "सर्वात लोकप्रिय",
        "Native": "मूळ",
        "Native Place": "मूळ गाव",
        "Native Places": "मूळ गावे",
        "Native places": "मूळ गावे",
        "None of your family members have a mapped location yet.": "तुमच्या कुटुंबातील कोणत्याही सदस्यासाठी अजून स्थान नकाशावर दाखवलेले नाही.",
        "Not a medical diagnosis platform.": "हे वैद्यकीय निदान करण्याचे व्यासपीठ नाही.",
        "Not added yet": "अजून जोडलेले नाही",
        "Notes (optional)": "नोंदी (ऐच्छिक)",
        "Place of birth": "जन्मस्थान",
        "Preserve. Understand. Inform.": "जतन करा. समजून घ्या. कळवा.",
        "Privacy by design:": "रचनेतूनच गोपनीयता:",
        "Records are visible to your family circle only; the Family Head controls who can add or edit.": "नोंदी फक्त आपल्या कुटुंबीयांनाच दिसतील; कोण जोडू शकतो किंवा बदल करू शकतो हे कुटुंबप्रमुख ठरवतात.",
        "Remove": "काढून टाका",
        "Reset": "रीसेट करा",
        "Save &amp; Continue": "जतन करून पुढे जा",
        "Saved ✓": "जतन केले ✓",
        "Saving…": "जतन करत आहोत…",
        "Sensitive details are hidden by default.": "संवेदनशील माहिती नेहमीच लपवलेली असते.",
        "Skip the blank page — let AI suggest your family&apos;s heritage": "रिकामी पानं टाळा — आपल्या कुटुंबाच्या वारशाबद्दल सूचना देण्यासाठी AI ला परवानगी द्या",
        "Tap to view": "पाहण्यासाठी टॅप करा",
        "This is a record-keeping repository — not a diagnosis, treatment or medical-advice tool.": "हे नोंदी ठेवण्यासाठीचे साधन आहे — निदान, उपचार किंवा वैद्यकीय सल्ला देणारे साधन नाही.",
        "This repository is for private family record-keeping and health-history awareness only — it does not provide diagnosis, treatment, risk prediction or medical advice. Always consult a qualified healthcare provider.": "हे साधन फक्त कुटुंबीयांच्या खाजगी नोंदवहीसाठी आणि आरोग्य-इतिहासाची जाणीव ठेवण्यासाठी आहे — हे निदान, उपचार, धोका-भविष्यवाणी किंवा वैद्यकीय सल्ला देत नाही. नेहमी पात्र आरोग्यसेवा तज्ज्ञांचा सल्ला घ्या.",
        "This section is private": "हा भाग खाजगी आहे",
        "Timezones spread": "वेळपट्ट्यांचा विस्तार",
        "Tip": "माहिती",
        "Title": "शीर्षक",
        "Tree completeness": "कुळवृक्षाची पूर्णता",
        "Update": "अपडेट करा",
        "Update their": "त्यांची माहिती अपडेट करा",
        "Value (type or tap 🎤)": "मूल्य (टाइप करा किंवा 🎤 वर टॅप करा)",
        "Visual Family Tree": "दृश्य कुलवृक्ष",
        "Voice language": "आवाजाची भाषा",
        "What's missing": "काय कमी आहे",
        "Where Your Family Lives — Across the World": "तुमचं कुटुंब कुठे राहतं — संपूर्ण जगभर",
        "are provided in the section below —": "खालील विभागात दिले आहेत —",
        "bank locker": "बँक लॉकर",
        "can be preserved in this section. The documents associated with these important information are required to be preserved at a different location, which is a special privilege of our": "या विभागात जतन करता येतील. या महत्त्वाच्या माहितीसोबत असलेली कागदपत्रे वेगळ्या ठिकाणी जतन करणे आवश्यक आहे आणि ही आमच्या",
        "complete. Tick off the items below to grow it further.": "पूर्ण आहे. ते अधिक समृद्ध करण्यासाठी खालील गोष्टी पूर्ण झाल्यावर त्यांना टिक करा.",
        "customers.": "ग्राहकांसाठीची विशेष सुविधा आहे.",
        "descriptive information": "तपशीलवार माहिती",
        "e.g. Dadu's Birthday": "उदा. दादूचा वाढदिवस",
        "family-only visibility · Family Head controls writing · explicit informed consent · encrypted storage · full audit trail of every change · DPDP Act 2023 aligned. Coming next: disease timeline, maternal/paternal branch views & emergency health card.": "फक्त कुटुंबीयांना दिसणारी माहिती · लिहिण्याचा अधिकार कुटुंबप्रमुखाकडे · स्पष्ट माहितीपूर्वक संमती · एन्क्रिप्टेड संचय · प्रत्येक बदलाचा संपूर्ण ऑडिट ट्रेल · DPDP Act 2023 शी सुसंगत. पुढे येत आहे: आजारपणाची कालरेषा, आईच्या/वडिलांच्या शाखांचे वेगवेगळे दृश्य आणि आपत्कालीन आरोग्य कार्ड.",
        "on the profile page, and they'll appear on the map instantly.": "प्रोफाइल पेजवर टाका, आणि ती माहिती लगेच नकाशावर दिसेल.",
        "or": "किंवा",
        "plans — preserve multi-generation medical history, hereditary conditions, allergies, vaccinations and more.": "प्लॅन्स — अनेक पिढ्यांचा वैद्यकीय इतिहास, आनुवंशिक आजार, अॅलर्जी, लसीकरण आणि आणखी बरीच माहिती जतन करा.",
        "please note that you are preserving very important and vital information. Please make sure you save important information only if you want to preserve it on this platform in a highly secured manner by using a proper password. All the documents here are preserved as if they are kept in a": "कृपया लक्षात ठेवा की आपण येथे अतिशय महत्त्वाची आणि गरजेची माहिती जतन करत आहात. ही माहिती फक्त तेव्हाच जतन करा, जेव्हा तुम्हाला ती या प्लॅटफॉर्मवर मजबूत पासवर्ड वापरून अत्यंत सुरक्षित पद्धतीने ठेवायची आहे. येथील सर्व कागदपत्रे अशी जतन केली जातात जणू ती एका",
        "step relations, adopted relations, close relatives and extended relatives": "सावत्र नाते, दत्तक नाते, जवळचे नातेवाईक आणि विस्तारित नातेवाईक",
        "these will not appear on your pictorial family tree view.": "ही नाती तुमच्या चित्रात्मक वंशावळीच्या दृश्यात दिसणार नाहीत.",
        "© 2026 Digital Family Tree. All rights reserved.": "© 2026 Digital Family Tree. सर्व हक्क सुरक्षित.",
        "21 sections of guided wisdom — the values, lessons and stories you want to pass down.": "मार्गदर्शक शहाणपणाच्या 21 विभागांमध्ये — तुम्हाला पुढच्या पिढ्यांना द्यायच्या मूल्यांचा, धड्यांचा आणि गोष्टींचा संग्रह.",
        "AI-POWERED": "AI-POWERED",
        "Aadhaar, property papers, wills and certificates — stored privately and shared only with the people you choose.": "आधार, मालमत्तेची कागदपत्रे, विलीखत आणि प्रमाणपत्रे — सुरक्षितरीत्या खाजगी ठेवलेली आणि फक्त तुम्ही निवडलेल्या लोकांसोबत शेअर केलेली.",
        "Achievements Wall": "यशभिंत",
        "Ask anything about your family — heritage, relationships, memories — and get instant AI answers.": "तुमच्या कुटुंबाबद्दल काहीही विचारा — परंपरा, नाती, आठवणी — आणि तत्काळ AI उत्तरं मिळवा.",
        "Audio Memories (Voice Stories)": "ऑडिओ आठवणी (आवाजातील गोष्टी)",
        "Begin your family tree journey": "तुमच्या कौटुंबिक वंशवृक्षाच्या प्रवासाला सुरुवात करा",
        "Birthdays, anniversaries and festivals happening for your family today — one tap to wish.": "आज तुमच्या कुटुंबात असलेले वाढदिवस, वाढदिवसाच्या आणि लग्नाच्या वाढदिवसाच्या शुभतिथी, सण — एका टॅपमध्ये शुभेच्छा पाठवा.",
        "Blood groups, allergies, chronic conditions and emergency contacts — accessible when it matters most.": "रक्तगट, अ‍ॅलर्जीज, दीर्घकालीन आजार आणि आपत्कालीन संपर्क — सर्वात जास्त गरज असताना लगेच उपलब्ध.",
        "Bring parents, siblings and cousins into your private family space — everyone adds their memories, and the tree grows together.": "आई-वडील, भाऊ-बहिणी आणि चुलत भावंडांना तुमच्या खाजगी कौटुंबिक जागेत आमंत्रित करा — सगळेजण आपापल्या आठवणी जोडतील आणि वंशवृक्ष एकत्र वाढत जाईल.",
        "CULTURE & TRADITIONS": "संस्कृती आणि परंपरा",
        "Capture a memory in your own voice. We'll transcribe, translate and preserve it for future generations.": "एखादी आठवण तुमच्या स्वतःच्या आवाजात रेकॉर्ड करा. आम्ही ती लिहून काढू, अनुवाद करू आणि पुढच्या पिढ्यांसाठी जतन करून ठेवू.",
        "Celebrate doctors, engineers, artists and every achiever in your family — a wall of pride for generations to see.": "तुमच्या कुटुंबातील डॉक्टर, अभियंते, कलाकार आणि प्रत्येक यशस्वी व्यक्तीचा सन्मान करा — पुढच्या पिढ्यांसाठी अभिमानाची भिंत तयार करा.",
        "Choose the package that fits your family — upgrade anytime, and unlock more features as your legacy grows.": "तुमच्या कुटुंबासाठी योग्य असा पॅकेज निवडा — कधीही अपग्रेड करा आणि तुमची परंपरा वाढत जाईल तसे आणखी सुविधा अनलॉक करा.",
        "Complete legacy suite with AI tools": "AI साधनांसह संपूर्ण वारसा-संच",
        "Connections": "नातीगोती",
        "Culture & Rituals Archive": "संस्कृती आणि संस्कारांचे संग्रहालय",
        "Demo Coming Soon": "डेमो लवकरच येत आहे",
        "Demo pricing — final packages will be announced soon. Selection is saved to your account.": "डेमो किंमती — अंतिम पॅकेजेस लवकरच जाहीर केली जातील. तुम्ही केलेली निवड तुमच्या खात्यात जतन केली जाईल.",
        "Digital Family Tree (Print-ready)": "डिजिटल कौटुंबिक वंशवृक्ष (प्रिंटसाठी तयार)",
        "EMERGENCY INFO": "आपत्कालीन माहिती",
        "EVENTS & DATES": "कार्यक्रम आणि दिनांक",
        "Events & Reminders": "कार्यक्रम आणि स्मरणपत्रे",
        "Every family member at a glance — search, filter and open any profile in one tap.": "प्रत्येक कुटुंबातील सदस्य एकाच दृष्टीक्षेपात — शोधा, फिल्टर करा आणि कोणताही प्रोफाइल एका टॅपमध्ये उघडा.",
        "Every milestone across generations — arranged as one continuous, beautiful story.": "पिढ्यान्‌पिढ्यांचे प्रत्येक महत्त्वाचे टप्पे — एका सलग, सुंदर गोष्टीसारखे मांडलेले.",
        "Every new member, photo, story and record — see everything happening in your family, as it happens.": "प्रत्येक नवा सदस्य, फोटो, गोष्ट आणि नोंद — आपल्या कुटुंबात जे घडत आहे ते सर्व, तसेच्या तसे पहा.",
        "Every photo, voice note and story preserved forever — safely inside your family vault.": "प्रत्येक फोटो, आवाजाची नोंद आणि गोष्ट कायमची जपलेली — सुरक्षितपणे आपल्या फॅमिली व्हॉल्टमध्ये.",
        "Everything, forever — one payment": "सगळं, कायमचं — एकदाच पेमेंट",
        "Expert Biography Writing": "तज्ञांकडून चरित्र लेखन",
        "Export everything you've saved — members, stories, memories, records — in the format that suits you. Your data is always yours.": "आपण जतन केलेलं सर्व — सदस्य, गोष्टी, आठवणी, नोंदी — आपल्या सोयीच्या फॉरमॅटमध्ये एक्सपोर्ट करा. आपला डेटा नेहमी आपलाच राहील.",
        "FAMILY STATISTICS": "कुटुंब सांख्यिकी",
        "FAMILY TIMELINE": "कुटुंब टाइमलाइन",
        "FAMILY WORLD MAP": "कुटुंब जागतिक नकाशा",
        "Family Activity": "कुटुंबातील घडामोडी",
        "Family Calendar & Celebrations": "कुटुंब दिनदर्शिका आणि साजरे प्रसंग",
        "Family Pride": "कुटुंबाचा अभिमान",
        "Family Records": "कुटुंब नोंदी",
        "Family Tree Builder (6 generations)": "कुटुंब वृक्ष तयार करणारे साधन (६ पिढ्या)",
        "Family World Map": "कुटुंब जागतिक नकाशा",
        "Gold": "Gold",
        "HEALTH & EMERGENCY": "आरोग्य आणि आपत्कालीन सेवा",
        "HEALTH REPOSITORY": "आरोग्य नोंद संग्रह",
        "Health & Medical Repository (10 registers)": "आरोग्य आणि वैद्यकीय नोंद संग्रह (१० नोंदवही)",
        "How large is your family across generations? Longevity, geography, professions and more.": "पिढ्यान्‌पिढ्या तुमचे कुटुंब किती मोठे आहे? दीर्घायुष्य, भौगोलिक पसर, व्यवसाय आणि बरंच काही जाणून घ्या.",
        "Keep every family member's blood group in one secure place. In an emergency, every second counts — this registry helps you instantly find the right donor within your family.": "कुटुंबातील प्रत्येक सदस्याचा रक्तगट एका सुरक्षित ठिकाणी नोंदवा. आपत्कालीन वेळी प्रत्येक सेकंद महत्त्वाचा असतो — ही नोंदणी तुम्हाला तुमच्या कुटुंबातला योग्य रक्तदाता लगेच शोधायला मदत करते.",
        "LEGACY & MEMORIAL": "वारसा आणि स्मरण",
        "LEGAL & LEGACY": "कायदेशीर बाबी आणि वारसा",
        "Legacy Lifetime": "आयुष्यभराचा वारसा",
        "Legal Vault (Will & Nominee)": "कायदेशीर तिजोरी (वसीयत आणि नामनिर्देशित व्यक्ती)",
        "Let AI compose a heartfelt narrative of your family's journey from the profiles you've filled.": "तुम्ही भरलेल्या प्रोफाइलच्या आधारावर, AI कडून तुमच्या कुटुंबाच्या प्रवासाची मनाला भिडणारी कहाणी तयार करून घ्या.",
        "MEMORIES & STORIES": "आठवणी आणि गोष्टी",
        "Marriage Records": "लग्न नोंदी",
        "Member Profiles & Photos": "सदस्यांची प्रोफाइल आणि छायाचित्रे",
        "Memories & reminders for the whole family": "संपूर्ण कुटुंबासाठी आठवणी आणि सूचना",
        "Multi-user Family Access (Invites)": "अनेक सदस्यांसाठी कुटुंब प्रवेश (निमंत्रणे)",
        "Never miss a birthday, anniversary or festival — smart reminders from your family tree, delivered by email, push and in-app.": "कधीही वाढदिवस, लग्नाचा वाढदिवस किंवा सण चुकणार नाही — तुमच्या कौटुंबिक वृक्षातून मिळणाऱ्या स्मार्ट सुचनांचे ईमेल, पुश आणि इन-अॅप द्वारे वितरण.",
        "One place for every birthday, anniversary, shraddha and cultural festival — with smart nudges.": "प्रत्येक वाढदिवस, लग्नाचा वाढदिवस, श्राद्ध आणि सांस्कृतिक सण नोंदवण्यासाठी एकच ठिकाण — स्मार्ट सूचनाांसह.",
        "Personal Vault": "वैयक्तिक तिजोरी",
        "Prescriptions, reports and hospital records for every family member — organized and searchable.": "प्रत्येक कुटुंब सदस्यासाठी चिठ्ठ्या, अहवाल आणि दवाखान्याच्या नोंदी — व्यवस्थित वर्गीकृत आणि सहज शोधता येण्यासारख्या.",
        "Preserve wedding dates, venues and couple details — anniversaries flow automatically into your family calendar and timeline.": "लग्नाच्या तारखा, ठिकाणे आणि जोडप्याची माहिती जतन करा — लग्नाच्या वाढदिवसांच्या नोंदी आपोआप तुमच्या कौटुंबिक दिनदर्शिकेत आणि टाइमलाइनमध्ये दिसतील.",
        "Priority Support": "प्राधान्य सहाय्य",
        "Rituals, recipes, dialects and heritage — everything that makes your family uniquely yours.": "रीतीरिवाज, पाककृती, बोलीभाषा आणि वारसा — तुमचे कुटुंब वेगळे आणि खास बनवणाऱ्या सगळ्या गोष्टी.",
        "SHARE & CELEBRATE": "SHARE & CELEBRATE",
        "Seal messages, photos and videos to open on future birthdays, anniversaries or a chosen date.": "संदेश, फोटो आणि व्हिडिओ भविष्यातील वाढदिवस, वाढदिवसांच्या वाढदिवसांवर किंवा निवडलेल्या तारखेला उघडण्यासाठी सुरक्षितपणे जतन करून ठेवा.",
        "See every family member on a real world map. Each pin shows a current location (orange) and a native place (green), connected by a dotted line — a beautiful visual of your family's journey through geography.": "प्रत्यक्ष नकाशावर तुमच्या कुटुंबातील प्रत्येक सदस्याला पहा. प्रत्येक पिनमध्ये सद्य ठिकाण (केशरी) आणि मूळ गाव (हिरवे) दाखवलेले असते आणि त्यांना बिंदरेषेने जोडलेले असते — भूगोलातून तुमच्या कुटुंबाच्या प्रवासाचे सुंदर चित्रण.",
        "Share the gift of legacy — invite friends to build their own private family tree, free to start.": "वारशाची भेट पुढे द्या — मित्रांना त्यांचे स्वतःचे खाजगी कौटुंबिक वंशवृक्ष तयार करण्यासाठी आमंत्रित करा, सुरूवात मोफत.",
        "Silver": "सिल्व्हर",
        "Smart Reminders (Email + Push)": "स्मार्ट स्मरणपत्रे (ईमेल + पुश)",
        "Starter": "स्टार्टर",
        "TIME CAPSULES": "TIME CAPSULES",
        "TODAY'S CELEBRATIONS": "TODAY'S CELEBRATIONS",
        "Turn your family tree into a beautiful shareable poster — perfect for wedding invites, festivals and print.": "तुमच्या कौटुंबिक वंशवृक्षाला सुंदर आणि शेअर करता येण्याजोग्या पोस्टरमध्ये रूपांतरित करा — लग्नाच्या निमंत्रणासाठी, सणांसाठी आणि छपाईसाठी अगदी योग्य.",
        "VOICE & STORIES": "VOICE & STORIES",
        "Watch Demo": "डेमो पाहा",
        "Wills, power-of-attorney, property papers and nominee details — locked and always accessible to the right people.": "वसीयत, पावर ऑफ अटर्नी, मालमत्तेची कागदपत्रे आणि नामनिर्देशितांची माहिती — सुरक्षितपणे जतन केलेली आणि नेहमी योग्य व्यक्तींनाच उपलब्ध.",
        "Your data, your rules — manage account preferences, visibility and every privacy declaration in one place.": "तुमची माहिती, तुमचे नियम — खाते प्राधान्यक्रम, दिसणारे तपशील आणि सर्व गोपनीयता निवेदने एका ठिकाणाहून सांभाळा.",
        "one-time · lifetime": "एकदाच · आजीवन",
        "per month": "दर महिना",
        "per year": "दर वर्षी",
        "January": "जानेवारी",
        "February": "फेब्रुवारी",
        "March": "मार्च",
        "April": "एप्रिल",
        "May": "मे",
        "June": "जून",
        "July": "जुलै",
        "August": "ऑगस्ट",
        "September": "सप्टेंबर",
        "October": "ऑक्टोबर",
        "November": "नोव्हेंबर",
        "December": "डिसेंबर",
        "is locked": "लॉक आहे",
        "Your current package": "आपला सध्याचा पॅकेज",
        "doesn't include this feature.": "यामध्ये ही सुविधा समाविष्ट नाही.",
        "Included in": "यामध्ये समाविष्ट",
        "one-time": "एकदाच",
        "year": "वर्ष",
        "month": "महिना",
        "lifetime": "आयुष्यभर",
        "Go Back": "मागे जा",
        "View Packages": "पॅकेज पहा",
        "This feature": "ही सुविधा",
        "Family Legacy Dashboard": "कुटुंब वारसा डॅशबोर्ड",
        "Legacy Services": "वारसा सेवा",
        "Life Story Vault": "जीवनकथा संग्रह",
        "Video Testament Library": "व्हिडिओ वसीयत लायब्ररी",
        "Family Wisdom Bank": "कौटुंबिक शहाणपण बँक",
        "Failure Stories Archive": "अपयशकथा संग्रह",
        "Success Stories": "यशकथा",
        "Family Decision History": "कौटुंबिक निर्णयांचा इतिहास",
        "Family Values Repository": "कौटुंबिक मूल्यांचा संग्रह",
        "Family Hero Gallery": "कुटुंबातील हिरोंची गॅलरी",
        "Unsung Heroes": "अनामिक हिरो",
        "Gratitude Wall": "कृतज्ञता भिंत",
        "Tribute Pages": "श्रद्धांजली पृष्ठे",
        "Love Letters Archive": "प्रेमपत्रांचा संग्रह",
        "Childhood Stories Bank": "बालपणीच्या गोष्टींचा संग्रह",
        "Language Preservation": "भाषा जतन",
        "Ancestral Village": "पितृपूर्वजांचे गाव",
        "Surname History": "आडनावाचा इतिहास",
        "Family Emblem": "कौटुंबिक प्रतीक",
        "Cultural Artifacts": "सांस्कृतिक वस्तू",
        "Family Songs & Bhajans": "कुटुंबीय गीते व भजने",
        "Oral History Center": "मौखिक इतिहास केंद्र",
        "Biography Writing Platform": "चरित्रलेखन व्यासपीठ",
        "Memoir Writing Service": "आत्मकथन लेखन सेवा",
        "Personalised Gifting Service": "वैयक्तिकृत भेटवस्तू सेवा",
        "Personal Digital Identity Platform": "वैयक्तिक डिजिटल ओळख व्यासपीठ",
        "Add to": "यात जोडा",
        "Choose": "निवडा",
        "Compare all packages": "सर्व पॅकेजेसची तुलना करा",
        "Real outputs your family gets": "तुमच्या कुटुंबाला मिळणारे खरे आउटपुट",
        "See what you actually receive": "तुम्हाला प्रत्यक्षात काय मिळते ते पाहा",
        "Every package delivers keepsake-quality designs — printable Family Tree posters and personalised Digital ID cards. Tap any design to view it full-size.": "प्रत्येक पॅकेज जपून ठेवण्याजोग्या दर्जाचे डिझाइन देते — प्रिंट करता येणारे Family Tree पोस्टर आणि वैयक्तिक Digital ID कार्ड. कोणतेही डिझाइन पूर्ण आकारात पाहण्यासाठी टॅप करा.",
        "Family Tree Posters": "Family Tree पोस्टर",
        "Digital ID Cards": "Digital ID कार्ड",
        "View full": "पूर्ण पाहा",
        "Sample designs shown. Your posters and cards are personalised with your family's names, photos and details.": "इथे नमुना डिझाइन दाखवले आहेत. तुमचे पोस्टर आणि कार्ड तुमच्या कुटुंबाची नावे, फोटो आणि माहितीसह वैयक्तिक बनवले जातात.",
        "Demo pricing — packages, prices and the feature split are all editable from the admin panel.": "डेमो pricing — पॅकेजेस, किंमती आणि फीचरचे विभाजन हे सर्व admin panel मधून बदलता येते.",
        "Feature": "फीचर",
        "Five packages, one family legacy": "पाच पॅकेजेस, एक कौटुंबिक वारसा",
        "Free": "फ्री",
        "Life story, wisdom and biography now live in Family Legacy Dashboard": "आपली जीवनकथा, अनुभव आणि चरित्र आता Family Legacy Dashboard मध्ये जतन होत आहे",
        "Open Family Legacy Dashboard": "Family Legacy Dashboard उघडा",
        "Packages & Pricing": "पॅकेजेस आणि Pricing",
        "Packages temporarily unavailable. Please try again shortly.": "पॅकेजेस तात्पुरते उपलब्ध नाहीत. कृपया थोड्या वेळाने पुन्हा प्रयत्न करा.",
        "Start Free": "फ्रीमध्ये सुरू करा",
        "Start free, upgrade whenever your family is ready. Every feature below is compared side by side so nothing is hidden.": "फ्रीमध्ये सुरू करा, तुमचे कुटुंब तयार झाल्यावर कधीही upgrade करा. खालील प्रत्येक फीचरची बाजूबाजूने तुलना दिली आहे, काहीही लपवलेले नाही.",
        "Swipe sideways on a phone — the feature column stays in place.": "फोनवर बाजूला swipe करा — फीचरचा कॉलम तिथेच स्थिर राहील.",
        "more features": "अजून फीचर्स",
        "Namaste": "नमस्ते",
        "{sender} has added you to our family tree on Family Repository.": "{sender} यांनी तुमची नोंद आमच्या Family Repository वरील घराण्याच्या वंशवृक्षात केली आहे.",
        "Tap to join": "सामील होण्यासाठी टॅप करा",
        "Your invite code": "आपला आमंत्रण कोड",
        "Together we will preserve our family's stories, photos and voices for the next generations.": "आपण मिळून आपल्या कुटुंबाच्या गोष्टी, फोटो आणि आवाज पुढच्या पिढ्यांसाठी जतन करू.",
        "Your family": "आपले कुटुंब",
        "Invite on WhatsApp": "WhatsApp वर आमंत्रण पाठवा",
        "WhatsApp opened with the invite message.": "आमंत्रण संदेशासह WhatsApp उघडले गेले.",
    },
    ta: {
        "Home": "முகப்பு",
        "Family": "குடும்பம்",
        "Family Tree": "குடும்ப வம்சவழி மரம்",
        "Add a Member": "ஒரு உறுப்பினரைச் சேர்க்கவும்",
        "Invite Family": "குடும்பத்தினரை அழைக்கவும்",
        "Family Hub · All": "குடும்ப மையம் · அனைத்தும்",
        "Family Timeline": "குடும்ப காலவரிசை",
        "Family Calendar": "குடும்ப நாள்காட்டி",
        "Services": "சேவைகள்",
        "Photo Memories": "புகைப்பட நினைவுகள்",
        "Audio Memories": "ஒலி நினைவுகள்",
        "AI Family Advisor": "AI குடும்ப ஆலோசகர்",
        "AI Story Generator": "AI கதை உருவாக்கி",
        "Video Memories": "வீடியோ நினைவுகள்",
        "Digital Family Tree": "டிஜிட்டல் குடும்ப வம்சவழி மரம்",
        "Family Hall of Fame": "குடும்ப பெருமை மண்டபம்",
        "Family Hub · All Services": "குடும்ப மையம் · அனைத்து சேவைகள்",
        "Records": "பதிவுகள்",
        "Blood Group Registry": "இரத்தக் குழு பதிவேடு",
        "Health Repository": "சுகாதார களஞ்சியம்",
        "Health Score Compliance": "சுகாதார மதிப்பெண் இணக்கம்",
        "Emergency Contacts": "அவசரநிலை தொடர்புகள்",
        "Business Directory": "வணிக அடைவு",
        "Recipe Vault": "சமையல் குறிப்புகள் பொக்கிஷம்",
        "Family Statistics": "குடும்ப புள்ளிவிவரங்கள்",
        "Legacy": "பாரம்பரியம்",
        "Legal Vault": "சட்டப் பொக்கிஷம்",
        "Document Vault": "ஆவணப் பொக்கிஷம்",
        "Story & Wisdom Vault": "கதைகள் மற்றும் ஞானப் பொக்கிஷம்",
        "Family Constitution": "குடும்ப அரசியல் / ஒப்பந்தம்",
        "Futuristic Legacy Letter": "எதிர்காலப் பாரம்பரியக் கடிதம்",
        "Digital Memorial": "மின்னணு நினைவுத் தளம்",
        "Account": "கணக்கு",
        "Packages & Plans": "பொதுப்பெட்டிகள் மற்றும் திட்டங்கள்",
        "Privacy & Settings": "தனியுரிமை மற்றும் அமைப்புகள்",
        "Download & Export": "பதிவிறக்கம் மற்றும் ஏற்றுமதி",
        "Profile": "சுயவிவரம்",
        "Search family…": "குடும்பத்தைத் தேடவும்…",
        "Dashboard": "டாஷ்போர்டு",
        "Families": "குடும்பங்கள்",
        "Users": "பயனர்கள்",
        "Subscriptions": "சந்தாக்கள்",
        "Packages": "பேக்கேஜ்கள்",
        "Exports": "ஏற்றுமதிகள்",
        "Content": "உள்ளடக்கம்",
        "Landing Slides": "லாண்டிங் ஸ்லைடுகள்",
        "Site Assets": "தள வளங்கள்",
        "Family Content": "குடும்ப உள்ளடக்கம்",
        "Translations": "மொழிபெயர்ப்புகள்",
        "User Page Editor": "பயனர் பக்கத் தொகுப்பி",
        "Analytics": "ஆய்வறிக்கை (Analytics)",
        "Support Tickets": "உதவி டிக்கெட்டுகள்",
        "Broadcasts": "ஒளிபரப்புகள்",
        "Legacy CRM": "பழைய CRM",
        "SMS Console": "SMS கன்சோல்",
        "Security": "பாதுகாப்பு",
        "Settings": "அமைப்புகள்",
        "UI/UX Audit": "UI/UX ஆய்வு",
        "API Keys": "API விசைகள்",
        "Admin Team": "நிர்வாக அணி",
        "Content Managers": "உள்ளடக்க மேலாளர்கள்",
        "Overview": "மேல்நோக்கு",
        "Members": "உறுப்பினர்கள்",
        "Billing": "பிலிங்",
        "Landing & Content": "லாண்டிங் & உள்ளடக்கம்",
        "Insights": "உள்ளடக்க நுண்ணறிவுகள்",
        "Support": "உதவி",
        "System": "கணினி அமைப்பு",
        "Super Admin": "சூப்பர் நிர்வாகி",
        "Content Admin": "உள்ளடக்க நிர்வாகி",
        "Content Manager": "உள்ளடக்க மேலாளர்",
        "Finance Admin": "நிதி நிர்வாகி",
        "Support Admin": "உதவி நிர்வாகி",
        "Security Admin": "பாதுகாப்பு நிர்வாகி",
        "Admin": "நிர்வாகி",
        "Admin Panel": "நிர்வாக பலகை",
        "Logout": "வெளியேறு",
        "Loading dashboard…": "டாஷ்போர்டு ஏற்றப்படுகிறது…",
        "Platform overview at a glance.": "இந்த தளத்தின் நிலை ஒரு பார்வையில்.",
        "Total Families": "மொத்த குடும்பங்கள்",
        "Total Members": "மொத்த உறுப்பினர்கள்",
        "Tree Persons": "குடும்ப மரத்தில் உள்ளவர்கள்",
        "Storage Used": "பயன்படுத்திய சேமிப்பு",
        "Marriages": "திருமணங்கள்",
        "Memory Albums": "நினைவுப் ஆல்பங்கள்",
        "Wills (latest)": "உயில் ஆவணங்கள் (சமீபத்திய)",
        "Audio Wills": "ஒலி வடிவ உயில்கள்",
        "With recorded audio": "பதிவு செய்யப்பட்ட ஒலியுடன்",
        "Across all families": "அனைத்து குடும்பங்களிலும்",
        "New signups — last 30 days": "புதிய பதிவு செய்தவர்கள் — கடந்த 30 நாட்கள்",
        "Storage breakdown": "சேமிப்பு பகிர்வு",
        "No stored files yet.": "இன்னும் எந்தக் கோப்பும் சேமிக்கப்படவில்லை.",
        "Signups": "பதிவு செய்தவர்கள்",
        "suspended": "இடைநிறுத்தப்பட்ட",
        "blocked": "தடைசெய்யப்பட்ட",
        "paid": "கட்டணம் செலுத்திய",
        "open tickets": "திறந்த புகார் பதிவு",
        "Memory photos": "நினைவு புகைப்படங்கள்",
        "Vault documents": "பாதுகாப்புக் காப்பக ஆவணங்கள்",
        "Story audio": "கதை ஒலி பதிவுகள்",
        "Member profiles & photos": "உறுப்பினர் சுயவிவரங்கள் & புகைப்படங்கள்",
        "Profile details": "சுயவிவர விவரங்கள்",
        "Story metadata": "கதை தொடர்பு தகவல்",
        "Memory metadata": "நினைவு தொடர்பு தகவல்",
        "Document metadata": "ஆவண தொடர்பு தகவல்",
        "Admin (Head)": "நிர்வாகி (முகாமையாளர்)",
        "added": "சேர்த்தார்",
        "updated": "புதுப்பித்தார்",
        "removed": "அகற்றினார்",
        "changed privacy of": "தனியுரிமை அமைப்பை மாற்றினார்",
        "updated profile of": "சுயவிவரத்தை புதுப்பித்தார்",
        "viewed profile of": "சுயவிவரத்தை பார்த்தார்",
        "recorded": "பதிவு செய்தார்",
        "played": "ஓட்டிப் பார்த்தார்",
        "deleted story": "கதையை நீக்கினார்",
        "uploaded": "பதிவேற்றினார்",
        "viewed": "பார்த்தார்",
        "changed access of": "அணுகலை மாற்றினார்",
        "deleted": "நீக்கினார்",
        "invited": "அழைத்தார்",
        "revoked an invite": "ஒரு அழைப்பை ரத்து செய்தார்",
        "joined the family": "குடும்பத்தில் இணைந்தார்",
        "changed role of": "பாத்திரத்தை மாற்றினார்",
        "downloaded their data": "தங்களது தரவை பதிவிறக்கம் செய்தார்",
        "completed privacy setup": "தனியுரிமை அமைப்பை முடித்தார்",
        "deleted account of": "கணக்கை நீக்கினார்",
        "Senior mode on — simpler privacy choices.": "மூத்தோர் முறை இயக்கப்பட்டது — எளிய தனியுரிமை தெரிவுகள்.",
        "Senior mode off.": "மூத்தோர் முறை நிறுத்தப்பட்டது.",
        "Saved.": "சேமிக்கப்பட்டது.",
        "Your data export has been downloaded.": "உங்கள் தரவு ஏற்றுமதி பதிவிறக்கம் செய்யப்பட்டது.",
        "Your account and data have been deleted.": "உங்கள் கணக்கு மற்றும் தரவு நீக்கப்பட்டுவிட்டது.",
        "Every family tree on the platform. Suspending blocks all its members from logging in.": "தளத்தில் உள்ள ஒவ்வொரு குடும்ப மரமும். அதை நிறுத்தினால் அதன் அனைத்து உறுப்பினர்களும் உள்நுழைய முடியாது.",
        "All registered members. Blocked users cannot log in or use the API.": "அனைத்து பதிவு செய்யப்பட்ட உறுப்பினர்களும். தடைக்கப்பட்ட பயனர்கள் உள்நுழையவும் API-யைப் பயன்படுத்தவும் முடியாது.",
        "Manual plan control until a payment gateway is connected in Settings.": "அமைப்புகளில் கட்டண நுழைவாயில் (payment gateway) இணைக்கப்படும் வரை திட்டத்தை கையால் நிர்வகிக்கலாம்.",
        "Growth, engagement and audience mix.": "வளர்ச்சி, ஈடுபாடு மற்றும் பார்வையாளர் அமைவு.",
        "Users raise tickets from Settings → Help in the app.": "பயனர்கள் செயலியில் அமைப்புகள் → உதவி பகுதியில் இருந்து டிக்கெட்களை எழுப்புகிறார்கள்.",
        "Branding, payment gateway and API keys. Secrets are stored server-side and shown masked.": "பிராண்டிங், payment gateway மற்றும் API சாவிகள். ரகசியத் தகவல்கள் சேவையகத்தில் சேமிக்கப்பட்டு மறைக்கப்பட்ட நிலையில் மட்டும் காட்டப்படும்.",
        "Packages — Feature Matrix (Demo)": "பொதுப்பெட்டிகள் — அம்ச அட்டவணை (டெமோ)",
        "Export Center": "ஏற்றுமதி மையம்",
        "Download authoritative reports in CSV, Excel or PDF. Schedule auto-email exports below.": "அதிகாரப்பூர்வ அறிக்கைகளை CSV, Excel அல்லது PDF வடிவில் பதிவிறக்கவும். கீழே தானாக மின்னஞ்சல் அனுப்பும் ஏற்றுமதி அட்டவணையை அமைக்கவும்.",
        "Send SMS or WhatsApp announcements to your users.": "உங்கள் பயனர்களுக்கு SMS அல்லது WhatsApp அறிவிப்புகளை அனுப்புங்கள்.",
        "Content Management": "உள்ளடக்க மேலாண்மை",
        "Poster templates, landing banners and testimonials curated by the super-admin.": "போஸ்டர் வார்ப்புருக்கள், லாண்டிங் பேனர்கள் மற்றும் பாராட்டுக் குறிப்புகள் super-admin மூலம் தொகுக்கப்பட்டவை.",
        "Platform-wide audit trail, failed logins, DPDP compliance requests, and your MFA credentials.": "முழு தளத்திற்குமான ஆடிட் பதிவுகள், தோல்வியடைந்த உள்நுழைவுகள், DPDP இணக்கம் கோரிக்கைகள் மற்றும் உங்கள் MFA சான்றுகள்.",
        "Manage who can sign into the admin panel and what they can access.": "யார் admin panel-இல் உள்நுழையலாம், அவர்கள் என்னைக் காணலாம் என்பதை நீங்கள் கட்டுப்படுத்தலாம்.",
        "Family Content Moderation": "குடும்ப உள்ளடக்க கட்டுப்பாடு",
        "Listen": "கேட்க",
        "Stop": "நிறுத்து",
        "Pause": "இடைநிறுத்து",
        "Resume": "மீண்டும் தொடங்கு",
        "Generating…": "உருவாக்குகிறது…",
        "Signup trend — last 90 days": "கடந்த 90 நாட்களில் சேர்க்கை போக்கு",
        "(or user) is expected to add all their family relationships on the": "(அல்லது பயனர்) தங்கள் அனைத்து குடும்ப உறவுகளையும் சேர்ப்பது எதிர்பார்க்கப்படுகிறது",
        ", which can only be opened by your password.": ", அதை உங்கள் கடவுச்சொல்லால் மட்டுமே திறக்க முடியும்.",
        ". Any member added there is automatically reflected here. For convenience, a few extra fields for": ". அங்கே சேர்க்கப்படும் எந்த உறுப்பினரும் தானாகவே இங்கே பிரதிபலிக்கப்படுவார். உங்களுக்கு வசதிக்காக, சில கூடுதல் புலங்கள்",
        "A family together": "ஒருங்கிணைந்த குடும்பம்",
        "A premium feature for your family's future": "உங்கள் குடும்பத்தின் எதிர்காலத்திற்கான ஒரு சிறப்பு பிரீமியம் வசதி",
        "Add": "சேர்க்கவும்",
        "Add Event": "நிகழ்ச்சியைச் சேர்க்கவும்",
        "Add custom field": "தனிப்பயன் புலத்தைச் சேர்க்கவும்",
        "All checks": "அனைத்து சரிபார்ப்புகளும்",
        "Avg age": "சராசரி வயது",
        "Back": "திரும்ப",
        "Back to Dashboard": "டாஷ்போர்டுக்குத் திரும்ப",
        "Change photo": "புகைப்படத்தை மாற்றவும்",
        "Choose the package that fits your family": "உங்கள் குடும்பத்துக்கு ஏற்ற தொகுப்பைத் தேர்வு செய்யவும்",
        "Classic, Premium and Elite": "கிளாசிக், பிரீமியம் மற்றும் எலீட்",
        "Countries": "நாடுகள்",
        "Current": "நடப்பு",
        "Current Location": "தற்போதைய இருப்பிடம்",
        "Current city": "தற்போதைய நகரம்",
        "Current locations": "தற்போதைய இருப்பிடங்கள்",
        "Data is encrypted in transit and at rest; every add/edit/delete is captured in the audit log.": "தரவு பரிமாற்றத்தின்போதும் சேமிப்பிடத்திலும் குறியாக்கமாக (encrypted) பாதுகாக்கப்படுகிறது; ஒவ்வொரு சேர்ப்பு/திருத்தம்/அழிப்பு செயலும் audit log-ல் பதிவு செய்யப்படுகிறது.",
        "Date": "தேதி",
        "Dear customer,": "அன்புள்ள வாடிக்கையாளர்,",
        "Delete": "அழிக்கவும்",
        "Distinct Cities": "ஒவ்வொரு தனித்த நகரங்கள்",
        "Family (₹999/yr)": "குடும்பம் (₹999/வருடம்)",
        "Family Head": "குடும்பத் தலைவர்",
        "Family Health": "குடும்ப ஆரோக்கியம்",
        "Family Members": "குடும்ப உறுப்பினர்கள்",
        "Family Relationships": "குடும்ப உறவுகள்",
        "Favourite mithai": "பிடித்த மிதாய்",
        "Field name": "புலத்தின் பெயர்",
        "Fill with AI": "AI மூலம் நிரப்பவும்",
        "GPT-5.2 fills 40+ fields across all 6 modules from your surname + region · you edit before saving.": "GPT-5.2 உங்கள் குடும்பப் பெயர் + பகுதியை அடிப்படையாகக் கொண்டு 6 தொகுதிகளில் உள்ள 40+ புலங்களை நிரப்பும் · சேமிக்கும் முன் நீங்கள் திருத்திக் கொள்ளலாம்.",
        "Gaon ka temple": "கிராமத்து கோவில்",
        "Generations": "தலைமுறைகள்",
        "Health & Medical Repository": "உடல்நலம் மற்றும் மருத்துவத் தரவகை (ரெப்போசிட்டரி)",
        "Health Score Compliance Report": "ஆரோக்கிய மதிப்பெண் இணக்கம் அறிக்கை",
        "Health information is stored with explicit consent, only for members whose data you are authorised to record.": "நீங்கள் பதிவு செய்ய அனுமதி பெற்றிருக்கும் உறுப்பினர்களுக்கான உடல்நலத் தகவல்கள் மட்டும், அவர்களுடைய வெளிப்படையான சம்மதத்துடன் சேமிக்கப்படும்.",
        "Help": "உதவி",
        "Hide details": "விவரங்களை மறைக்கவும்",
        "How complete is your family tree?": "உங்கள் குடும்ப வம்சவரலாறு எவ்வளவு முழுமையானது?",
        "Informed consent — one time, per family": "தகவலறிந்த சம்மதம் — ஒவ்வொரு குடும்பத்திற்கும் ஒரு முறை",
        "Kind": "வகை",
        "Legacy (₹2999/yr)": "லெகசி (₹2999/வருடம்)",
        "Linked live from your family tree.": "உங்கள் குடும்ப வம்சவரலாற்றில் இருந்து நேரடியாக இணைக்கப்பட்டுள்ளது.",
        "Living Cities": "வசிக்கும் நகரங்கள்",
        "Loading events…": "நிகழ்வுகள் ஏற்றப்படுகிறது…",
        "Loading packages…": "பேக்கேஜ்கள் ஏற்றப்படுகிறது…",
        "Loading world map…": "உலக வரைபடம் ஏற்றப்படுகிறது…",
        "Loading…": "ஏற்றப்படுகிறது…",
        "Lucky number": "அதிர்ஷ்ட எண்",
        "Member Profile": "உறுப்பினர் சுயவிவரம்",
        "Most Popular": "அதிகம் பயன்படுத்தப்படும்",
        "Native": "இலக்கம்",
        "Native Place": "சொந்த ஊர்",
        "Native Places": "சொந்த ஊர்கள்",
        "Native places": "சொந்த ஊர்கள்",
        "None of your family members have a mapped location yet.": "உங்கள் குடும்ப உறுப்பினர்களில் யாருக்கும் இன்னும் இடம் வரைபடத்தில் குறிக்கப்படவில்லை.",
        "Not a medical diagnosis platform.": "இது மருத்துவர் நோயறிதல் செய்யும் தளம் அல்ல.",
        "Not added yet": "இன்னும் சேர்க்கப்படவில்லை",
        "Notes (optional)": "குறிப்புகள் (விருப்பம்)",
        "Place of birth": "பிறந்த இடம்",
        "Preserve. Understand. Inform.": "பாதுகாப்போம். புரிந்துகொள்வோம். பகிர்வோம்.",
        "Privacy by design:": "தொடக்கம் முதலே தனியுரிமை:",
        "Records are visible to your family circle only; the Family Head controls who can add or edit.": "பதிவுகளை உங்கள் குடும்ப வட்டாரமே மட்டும் பார்க்க முடியும்; யார் சேர்க்கலாம், திருத்தலாம் என்பதைக் குடும்பத்தின் தலைவர் கட்டுப்படுத்துவார்.",
        "Remove": "அகற்று",
        "Reset": "மீட்டமை",
        "Save &amp; Continue": "சேமித்து தொடரவும்",
        "Saved ✓": "சேமிக்கப்பட்டது ✓",
        "Saving…": "சேமிக்கிறது…",
        "Sensitive details are hidden by default.": "முக்கியமான (அதிக நுணுக்கமான) விவரங்கள் இயல்பாக மறைக்கப்பட்டிருக்கும்.",
        "Skip the blank page — let AI suggest your family&apos;s heritage": "வெற்று பக்கத்தைத் தாவிக்கொள்ளுங்கள் — உங்கள் குடும்ப பாரம்பரியத்தை AI பரிந்துரைக்க அனுமதியுங்கள்",
        "Tap to view": "காண தட்டவும்",
        "This is a record-keeping repository — not a diagnosis, treatment or medical-advice tool.": "இது பதிவுகளை பாதுகாக்க உருவாக்கப்பட்ட தொகுப்பு — இது நோய்நிலை கண்டறிதல், சிகிச்சை அல்லது மருத்துவ ஆலோசனைக்கான கருவி அல்ல.",
        "This repository is for private family record-keeping and health-history awareness only — it does not provide diagnosis, treatment, risk prediction or medical advice. Always consult a qualified healthcare provider.": "இந்த தொகுப்பு உங்கள் குடும்பத்தின் தனிப்பட்ட பதிவுகள் மற்றும் உடல்நிலை வரலாறு பற்றிய விழிப்புணர்விற்காக மட்டுமே — இது நோய்நிலை கண்டறிதல், சிகிச்சை, ஆபத்து கணிப்பு அல்லது மருத்துவ ஆலோசனையை வழங்காது. எப்போதும் தகுதியான மருத்துவ நிபுணரை அணுகுங்கள்.",
        "This section is private": "இந்த பகுதி தனிப்பட்டதாகும்",
        "Timezones spread": "நேர மண்டலங்களின் பரவல்",
        "Tip": "சிறு குறிப்புரை",
        "Title": "தலைப்பு",
        "Tree completeness": "குடும்ப மரம் நிறைவு",
        "Update": "புதுப்பிக்கவும்",
        "Update their": "அவர்களின் தகவலைப் புதுப்பிக்கவும்",
        "Value (type or tap 🎤)": "மதிப்பு (டைப் செய்யவும் அல்லது 🎤 தட்டவும்)",
        "Visual Family Tree": "காட்சி குடும்ப மரம்",
        "Voice language": "குரல் மொழி",
        "What's missing": "இன்னும் எது சேர்க்கப்படவில்லை",
        "Where Your Family Lives — Across the World": "உங்கள் குடும்பம் எங்கு வாழ்கிறது — உலகம் முழுவதும்",
        "are provided in the section below —": "கீழே உள்ள பிரிவில் வழங்கப்பட்டுள்ளன —",
        "bank locker": "வங்கிக் குடோன்",
        "can be preserved in this section. The documents associated with these important information are required to be preserved at a different location, which is a special privilege of our": "இந்தப் பகுதியில் பாதுகாக்கலாம். இந்த முக்கியமான தகவல்களுடன் தொடர்புடைய ஆவணங்கள் வேறு இடத்தில் பாதுகாக்கப்பட வேண்டும்; இது எங்கள்",
        "complete. Tick off the items below to grow it further.": "முழுமையானது. அதை மேலும் வளர்த்துக் கொள்ள கீழே உள்ள உருப்படிகளை குறி போடுங்கள்.",
        "customers.": "வாடிக்கையாளர்களுக்குக் கிடைக்கும் ஒரு சிறப்பு சலுகை.",
        "descriptive information": "விளக்கமான தகவல்",
        "e.g. Dadu's Birthday": "உதா. தாதுவின் பிறந்தநாள்",
        "family-only visibility · Family Head controls writing · explicit informed consent · encrypted storage · full audit trail of every change · DPDP Act 2023 aligned. Coming next: disease timeline, maternal/paternal branch views & emergency health card.": "குடும்பத்தினர் மட்டுமே பார்க்கலாம் · எழுதுதலை குடும்பத் தலைவர் கட்டுப்படுத்துவார் · வெளிப்படையான, உணர்த்தப்பட்ட சம்மதம் · குறியாக்கப்பட்ட சேமிப்பு · ஒவ்வொரு மாற்றத்திற்கும் முழு கண்காணிப்பு பதிவேடு · DPDP Act 2023 உடன் இணக்கம். அடுத்ததாக வருவது: நோய்களின் காலவரிசை, தாய்தந்தை வழி கிளை காட்சிகள் & அவசர சுகாதார அட்டை.",
        "on the profile page, and they'll appear on the map instantly.": "சுயவிவரப் பக்கத்தில், அவை உடனே வரைபடத்தில் தோன்றும்.",
        "or": "அல்லது",
        "plans — preserve multi-generation medical history, hereditary conditions, allergies, vaccinations and more.": "திட்டங்கள் — பல தலைமுறை மருத்துவ வரலாறு, மரபணு நோய்கள், ஒவ்வாமைகள், தடுப்பூசிகள் மற்றும் பலவற்றை பாதுகாக்கலாம்.",
        "please note that you are preserving very important and vital information. Please make sure you save important information only if you want to preserve it on this platform in a highly secured manner by using a proper password. All the documents here are preserved as if they are kept in a": "நீங்கள் மிகவும் முக்கியமான மற்றும் அத்தியாவசியமான தகவலை பாதுகாக்கிறீர்கள் என்பதை கவனத்தில் கொள்ளுங்கள். இந்த தளத்தில், சரியான கடவுச்சொல்லைப் பயன்படுத்தி, மிகுந்த பாதுகாப்புடன் நிரந்தரமாக வைத்துக் கொள்ள வேண்டும் என்று நீங்கள் உறுதியாக நினைக்கும் தகவல்களை மட்டுமே சேமிக்கவும். இங்கு உள்ள அனைத்து ஆவணங்களும் ஒரு",
        "step relations, adopted relations, close relatives and extended relatives": "படிகுடும்ப உறவுகள், தத்தெடுத்த உறவுகள், நெருங்கிய உறவினர்கள் மற்றும் தூரத்து உறவினர்கள்",
        "these will not appear on your pictorial family tree view.": "இவை உங்கள் படக்காட்சிப் குடும்ப வம்ச விரிதிரை (family tree) பார்வையில் தோன்றாது.",
        "© 2026 Digital Family Tree. All rights reserved.": "© 2026 Digital Family Tree. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
        "21 sections of guided wisdom — the values, lessons and stories you want to pass down.": "21 பகுதிகளாக வழிகாட்டும் ஞானம் — நீங்கள் அடுத்த தலைமுறைக்கு அளிக்க விரும்பும் மதிப்புகள், பாடங்கள் மற்றும் கதைகள்.",
        "AI-POWERED": "AI-POWERED",
        "Aadhaar, property papers, wills and certificates — stored privately and shared only with the people you choose.": "ஆதார், சொத்து ஆவணங்கள், விலைகள் மற்றும் சான்றிதழ்கள் — தனிப்பட்ட முறையில் பாதுகாக்கப்பட்டு, நீங்கள் தேர்வு செய்கிறவர்களுடன் மட்டுமே பகிரப்படும்.",
        "Achievements Wall": "சாதனைச் சுவர்",
        "Ask anything about your family — heritage, relationships, memories — and get instant AI answers.": "உங்கள் குடும்பத்தைப் பற்றி எதை வேண்டுமானாலும் கேளுங்கள் — பாரம்பரியம், உறவுகள், நினைவுகள் — உடனடி AI பதில்களைப் பெறுங்கள்.",
        "Audio Memories (Voice Stories)": "ஒலி நினைவுகள் (குரல் கதைகள்)",
        "Begin your family tree journey": "உங்கள் குடும்ப மரப் பயணத்தை தொடங்குங்கள்",
        "Birthdays, anniversaries and festivals happening for your family today — one tap to wish.": "இன்று உங்கள் குடும்பத்தில் நடைபெறும் பிறந்தநாள், ஆண்டு விழா, திருவிழாக்கள் — ஒரே தொடுதலில் வாழ்த்துங்கள்.",
        "Blood groups, allergies, chronic conditions and emergency contacts — accessible when it matters most.": "இரத்தக் குழுக்கள், அலர்ஜிகள், நீடித்த உடல் நிலைகள் மற்றும் அவசர தொடர்புகள் — மிகவும் அவசியமான நேரத்தில் எளிதில் கிடைக்கும்.",
        "Bring parents, siblings and cousins into your private family space — everyone adds their memories, and the tree grows together.": "உங்கள் பெற்றோர், சகோதரர்/சகோதரி மற்றும் சித்திகள்/மருமக்களை உங்கள் தனிப்பட்ட குடும்ப வட்டத்துக்குள் அழைக்கவும் — ஒவ்வொருவரும் தங்கள் நினைவுகளைச் சேர்த்துக் கொண்டால், குடும்ப மரம் ஒன்றாக வளர்கிறது.",
        "CULTURE & TRADITIONS": "கலாச்சாரம் & மரபுகள்",
        "Capture a memory in your own voice. We'll transcribe, translate and preserve it for future generations.": "ஒரு நினைவை உங்கள் சொந்த குரலில் பதிவு செய்யுங்கள். அதை நாங்கள் எழுத்தாக்கி, மொழிபெயர்த்து, எதிர்கால தலைமுறைகளுக்காக பாதுகாப்போம்.",
        "Celebrate doctors, engineers, artists and every achiever in your family — a wall of pride for generations to see.": "உங்கள் குடும்பத்தில் உள்ள மருத்துவர்கள், பொறியாளர்கள், கலைஞர்கள் மற்றும் அனைத்து சாதனையாளர்களையும் கொண்டாடுங்கள் — பல தலைமுறைகள் பார்ப்பதற்கான பெருமைச் சுவர்.",
        "Choose the package that fits your family — upgrade anytime, and unlock more features as your legacy grows.": "உங்கள் குடும்பத்துக்கு பொருத்தமான தொகுப்பைத் தேர்ந்தெடுக்கவும் — எப்போது வேண்டுமானாலும் மேம்படுத்தி, உங்கள் பாரம்பரியம் வளரும்போது மேலும் பல அம்சங்களைத் திறக்கவும்.",
        "Complete legacy suite with AI tools": "AI கருவிகளுடன் கூடிய முழுமையான பாரம்பரியத் தொகுப்பு",
        "Connections": "இணைப்புகள்",
        "Culture & Rituals Archive": "கலாச்சாரம் & சடங்குகள் காப்பகம்",
        "Demo Coming Soon": "டெமோ விரைவில் வருகிறது",
        "Demo pricing — final packages will be announced soon. Selection is saved to your account.": "டெமோ விலை நிர்ணயம் — இறுதி தொகுப்புகள் விரைவில் அறிவிக்கப்படும். உங்கள் தேர்வு உங்கள் கணக்கில் சேமிக்கப்பட்டுள்ளது.",
        "Digital Family Tree (Print-ready)": "டிஜிட்டல் குடும்ப மரம் (அச்சிடத் தயாராக)",
        "EMERGENCY INFO": "அவசரத் தகவல்",
        "EVENTS & DATES": "நிகழ்வுகள் & தேதிகள்",
        "Events & Reminders": "நிகழ்வுகள் & நினைவூட்டல்கள்",
        "Every family member at a glance — search, filter and open any profile in one tap.": "குடும்பத்தின் ஒவ்வொருவரையும் ஒரே பார்வையில் — தேடவும், வடிகட்டவும், ஒரு தொட்டிலேயே அவர்களின் சுயவிவரத்தைத் திறக்கவும்.",
        "Every milestone across generations — arranged as one continuous, beautiful story.": "பல தலைமுறைகள் முழுவதும் உள்ள ஒவ்வொரு முக்கிய தருணமும் — ஒன்றாக இணைந்த அழகான வாழ்க்கைக் கதையாக ஒழுங்குபடுத்தப்பட்டுள்ளது.",
        "Every new member, photo, story and record — see everything happening in your family, as it happens.": "ஒவ்வொரு புதிய உறுப்பினரும், படம், கதை, பதிவும் — உங்கள் குடும்பத்தில் நடப்பதை அது நடக்கும் தருணத்திலேயே பார்க்கலாம்.",
        "Every photo, voice note and story preserved forever — safely inside your family vault.": "ஒவ்வொரு படமும், குரல் குறிப்பும், கதையும் — உங்கள் குடும்பத்திற்கான பாதுகாப்பான புதையல் பெட்டியில் என்றென்றும் பாதுகாப்பாகச் சேமிக்கப்படும்.",
        "Everything, forever — one payment": "எல்லாம், எப்போதும் — ஒரே முறை கட்டணம்",
        "Expert Biography Writing": "நிபுணத்துவ வாழ்க்கை வரலாறு எழுதுதல்",
        "Export everything you've saved — members, stories, memories, records — in the format that suits you. Your data is always yours.": "நீங்கள் சேமித்துள்ள உறுப்பினர்கள், கதைகள், நினைவுகள், பதிவுகள் ஆகிய அனைத்தையும் — உங்களுக்கு விருப்பமான வடிவில் ஏற்றுமதி செய்யலாம். உங்கள் தரவு எப்போதும் உங்கள்தே.",
        "FAMILY STATISTICS": "குடும்ப புள்ளிவிவரங்கள்",
        "FAMILY TIMELINE": "குடும்ப காலவரிசை",
        "FAMILY WORLD MAP": "குடும்ப உலக வரைபடம்",
        "Family Activity": "குடும்ப நிகழ்வுகள்",
        "Family Calendar & Celebrations": "குடும்ப நாட்காட்டி & கொண்டாடல்கள்",
        "Family Pride": "குடும்பப் பெருமை",
        "Family Records": "குடும்பப் பதிவுகள்",
        "Family Tree Builder (6 generations)": "குடும்ப மரம் உருவாக்கி (6 தலைமுறைகள்)",
        "Family World Map": "குடும்ப உலக வரைபடம்",
        "Gold": "Gold",
        "HEALTH & EMERGENCY": "நலம் & அவசரநிலை",
        "HEALTH REPOSITORY": "நலத் தகவல் சேமிப்பு",
        "Health & Medical Repository (10 registers)": "நலம் & மருத்துவத் தகவல் சேமிப்பு (10 பதிவுகள்)",
        "How large is your family across generations? Longevity, geography, professions and more.": "தலைமுறைகள் முழுவதும் உங்கள் குடும்பம் எவ்வளவு பெரியது? ஆயுட்காலம், புவியியல், தொழில்கள் மற்றும் இன்னும் பல.",
        "Keep every family member's blood group in one secure place. In an emergency, every second counts — this registry helps you instantly find the right donor within your family.": "ஒவ்வொரு குடும்ப உறுப்பினரின் இரத்த வகையையும் ஒரு பாதுகாப்பான இடத்தில் சேமித்து வையுங்கள். அவசரநிலையில் ஒரு நொடிக்கும் அர்த்தம் உண்டு — இந்த பதிவேடு உங்கள் குடும்பத்திலிருந்தே உடனே சரியான தானதாரியை கண்டுபிடிக்க உதவும்.",
        "LEGACY & MEMORIAL": "இருப்பு & நினைவஞ்சலி",
        "LEGAL & LEGACY": "சட்டம் & இருப்பு",
        "Legacy Lifetime": "இருப்பு — வாழ்நாள் முழுவதும்",
        "Legal Vault (Will & Nominee)": "சட்டப் பாதுகாப்புக் கூடம் (இறுதிச்சொத்து ஆவணம் & நியமனவர்)",
        "Let AI compose a heartfelt narrative of your family's journey from the profiles you've filled.": "நீங்கள் நிரப்பிய சுயவிவரங்களை அடிப்படையாகக் கொண்டு, உங்கள் குடும்பத்தின் பயணத்தை பற்றிய மனம் தொறும் கதையைக் AI உருவாக்க அனுமதிக்கவும்.",
        "MEMORIES & STORIES": "நினைவுகள் & கதைகள்",
        "Marriage Records": "திருமணப் பதிவுகள்",
        "Member Profiles & Photos": "உறுப்பினர் சுயவிவரங்கள் & படங்கள்",
        "Memories & reminders for the whole family": "முழு குடும்பத்திற்குமான நினைவுகள் & நினைவூட்டல்கள்",
        "Multi-user Family Access (Invites)": "பலர் பயன்படுத்தும் குடும்ப அணுகல் (அழைப்புகள்)",
        "Never miss a birthday, anniversary or festival — smart reminders from your family tree, delivered by email, push and in-app.": "பிறந்தநாள், திருமண நாள் அல்லது திருவிழாவை இனி ஒருபோதும் தவறவிடாதீர்கள் — உங்கள் குடும்ப மரத்திலிருந்து மின்னஞ்சல், புஷ் மற்றும் செயலிக்குள் வரும் புத்திசாலித்தனமான நினைவூட்டல்கள்.",
        "One place for every birthday, anniversary, shraddha and cultural festival — with smart nudges.": "ஒவ்வொரு பிறந்தநாள், திருமண நாள், ஸ்ராத்தம் மற்றும் கலாசாரத் திருவிழாவுக்கும் — புத்திசாலித்தனமான நினைவூட்டல்களுடன் — ஒரே இடம்.",
        "Personal Vault": "தனிப்பட்ட பாதுகாப்புக் கூடம்",
        "Prescriptions, reports and hospital records for every family member — organized and searchable.": "ஒவ்வொரு குடும்ப உறுப்பினரின் மருந்துச் சீட்டுகள், அறிக்கைகள் மற்றும் மருத்துவமனைப் பதிவுகள் — ஒழுங்காக சேமிக்கப்பட்டு, எளிதில் தேடக்கூடிய முறையில்.",
        "Preserve wedding dates, venues and couple details — anniversaries flow automatically into your family calendar and timeline.": "திருமண தேதிகள், இடங்கள் மற்றும் தம்பதியரின் விவரங்களைப் பாதுகாத்து வையுங்கள் — திருமண நாள்கள் தானாகவே உங்கள் குடும்ப நாட்காட்டி மற்றும் காலவரிசையில் சேர்க்கப்படும்.",
        "Priority Support": "முன்னுரிமை உதவி",
        "Rituals, recipes, dialects and heritage — everything that makes your family uniquely yours.": "சடங்குகள், சமையல் குறிப்புகள், வழக்குப் பேச்சு மற்றும் பாரம்பரியம் — உங்களின் குடும்பத்தை தனித்துவமாக்கும் அனைத்தும்.",
        "SHARE & CELEBRATE": "பகிர்ந்து மகிழுங்கள்",
        "Seal messages, photos and videos to open on future birthdays, anniversaries or a chosen date.": "செய்திகள், புகைப்படங்கள் மற்றும் வீடியோக்களை எதிர்கால பிறந்தநாள், ஆண்டு விழா அல்லது நீங்கள் தேர்ந்தெடுக்கும் தேதியில் திறக்கக்கூடிய வகையில் பாதுகாப்பாக சேமித்து வையுங்கள்.",
        "See every family member on a real world map. Each pin shows a current location (orange) and a native place (green), connected by a dotted line — a beautiful visual of your family's journey through geography.": "ஒவ்வொரு குடும்ப உறுப்பினரையும் உண்மையான உலக வரைபடத்தில் பாருங்கள். ஒவ்வொரு முள் குறியீடும் நிகழ்கால இருப்பிடம் (செம்மஞ்சள்) மற்றும் சொந்த ஊர் (பச்சை) ஆகியவற்றை காட்டும்; அவை புள்ளியிட்ட கோடால் இணைக்கப்பட்டிருக்கும் — உங்கள் குடும்பத்தின் புவியியல் பயணத்தை அழகாகக் காட்சிப்படுத்தும் ஒரு வரைபடம்.",
        "Share the gift of legacy — invite friends to build their own private family tree, free to start.": "வரலாற்றின் அற்புதப் பரிசை பகிருங்கள் — உங்கள் நண்பர்களை, தங்களுக்கான தனிப்பட்ட குடும்ப மரத்தை (family tree) உருவாக்க அழைக்குங்கள்; தொடக்கம் இலவசம்.",
        "Silver": "சில்வர்",
        "Smart Reminders (Email + Push)": "ஸ்மார்ட் நினைவூட்டல்கள் (Email + Push)",
        "Starter": "ஸ்டார்டர்",
        "TIME CAPSULES": "நேரக் காப்பகங்கள்",
        "TODAY'S CELEBRATIONS": "இன்றைய விழாக்கள்",
        "Turn your family tree into a beautiful shareable poster — perfect for wedding invites, festivals and print.": "உங்கள் குடும்ப மரத்தை அழகான, பகிரக்கூடிய போஸ்டராக மாற்றுங்கள் — திருமண அழைப்பிதழ்கள், திருவிழாக்கள் மற்றும் அச்சிடுதல்களுக்கு மிகச் சிறந்தது.",
        "VOICE & STORIES": "குரலும் கதைகளும்",
        "Watch Demo": "காட்சி விளக்கத்தைப் பாருங்கள்",
        "Wills, power-of-attorney, property papers and nominee details — locked and always accessible to the right people.": "வசியாண்மை, பதில்-அரசாணை (power-of-attorney), சொத்து ஆவணங்கள் மற்றும் நியமனப் பயனாளரின் விவரங்கள் — பாதுகாப்பாக பூட்டப்பட்டு, உரிய أش أشخاص-க்கு எப்போதும் அணுகக்கூடியவையாக இருக்கும்.",
        "Your data, your rules — manage account preferences, visibility and every privacy declaration in one place.": "உங்கள் தரவு, உங்கள் விதிமுறைகள் — கணக்கு விருப்பங்கள், யாருக்கு காண வேண்டும் என்ற கட்டுப்பாடு மற்றும் அனைத்து தனியுரிமை உடன்படிக்கைகளையும் ஒரே இடத்தில் நிர்வகிக்கலாம்.",
        "one-time · lifetime": "ஒருமுறை · ஆயுள் முழுவதும்",
        "per month": "ஒரு மாதத்திற்கு",
        "per year": "ஒரு ஆண்டுக்கு",
        "January": "ஜனவரி",
        "February": "பிப்ரவரி",
        "March": "மார்ச்",
        "April": "ஏப்ரல்",
        "May": "மே",
        "June": "ஜூன்",
        "July": "ஜூலை",
        "August": "ஆகஸ்ட்",
        "September": "செப்டம்பர்",
        "October": "அக்டோபர்",
        "November": "நவம்பர்",
        "December": "டிசம்பர்",
        "is locked": "பூட்டப்பட்டுள்ளது",
        "Your current package": "உங்களின் தற்போதைய திட்டம்",
        "doesn't include this feature.": "இந்த வசதி இதில் சேர்க்கப்படவில்லை.",
        "Included in": "இவற்றில் கிடைக்கும்",
        "one-time": "ஒருமுறை",
        "year": "ஆண்டு",
        "month": "மாதம்",
        "lifetime": "ஆயுள் முழுவதும்",
        "Go Back": "திரும்பிச் செல்லவும்",
        "View Packages": "திட்டங்களைப் பார்க்க",
        "This feature": "இந்த வசதி",
        "Family Legacy Dashboard": "குடும்ப மரபு கட்டுப்பாட்டு பலகை",
        "Legacy Services": "மரபு சேவைகள்",
        "Life Story Vault": "வாழ்க்கைக் கதைகள்த் தேக்கம்",
        "Video Testament Library": "காணொலி وصیت நூலகம்",
        "Family Wisdom Bank": "குடும்ப ஞான வங்கி",
        "Failure Stories Archive": "தோல்விக் கதைகள் காப்பகம்",
        "Success Stories": "வெற்றிக் கதைகள்",
        "Family Decision History": "குடும்ப முடிவுகள் வரலாறு",
        "Family Values Repository": "குடும்ப மதிப்புகள் களஞ்சியம்",
        "Family Hero Gallery": "குடும்ப வீரர்கள் அரங்கம்",
        "Unsung Heroes": "புகழ் பெறாத வீரர்கள்",
        "Gratitude Wall": "நன்றியின்சுவர்",
        "Tribute Pages": "மரியாதை அஞ்சலி பக்கங்கள்",
        "Love Letters Archive": "காதல் கடிதங்கள் காப்பகம்",
        "Childhood Stories Bank": "குழந்தைப் பருவக் கதைகள் வங்கி",
        "Language Preservation": "மொழி பாதுகாப்பு",
        "Ancestral Village": "பூர்வீக ஊர்",
        "Surname History": "குடும்பப் பெயர் வரலாறு",
        "Family Emblem": "குடும்பச் சின்னம்",
        "Cultural Artifacts": "கலை – கலாச்சாரப் பொருட்கள்",
        "Family Songs & Bhajans": "குடும்பப் பாடல்கள் & பஜனைகள்",
        "Oral History Center": "வாய் வழி வரலாறு மையம்",
        "Biography Writing Platform": "சுயசரிதை எழுதும் தளம்",
        "Memoir Writing Service": "நினைவுக் குறிப்புகள் எழுதும் சேவை",
        "Personalised Gifting Service": "தனிப்பட்ட பரிசளிப்பு சேவை",
        "Personal Digital Identity Platform": "தனிப்பட்ட டிஜிட்டல் அடையாள தளம்",
        "Add to": "சேர்க்க",
        "Choose": "தேர்வு செய்யவும்",
        "Compare all packages": "அனைத்து தொகுப்புகளையும் ஒப்பிடவும்",
        "Demo pricing — packages, prices and the feature split are all editable from the admin panel.": "டெமோ விலை — தொகுப்புகள், விலைகள் மற்றும் அம்சப் பிரிப்பு அனைத்தையும் நிர்வாகப் பலகையில் இருந்து மாற்றலாம்.",
        "Feature": "அம்சம்",
        "Five packages, one family legacy": "ஐந்து தொகுப்புகள், ஒரு குடும்ப பாரம்பரியம்",
        "Free": "இலவசம்",
        "Life story, wisdom and biography now live in Family Legacy Dashboard": "உங்கள் வாழ்க்கைக் கதை, அறிவு மற்றும் சுயசரிதை இப்போது Family Legacy Dashboard-இல் வாழ்கிறது",
        "Open Family Legacy Dashboard": "Family Legacy Dashboard-ஐ திறக்கவும்",
        "Packages & Pricing": "தொகுப்புகள் & விலை விவரம்",
        "Packages temporarily unavailable. Please try again shortly.": "தொகுப்புகள் தற்காலிகமாக கிடைக்கவில்லை. தயவுசெய்து சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்.",
        "Start Free": "இலவசமாக தொடங்கவும்",
        "Start free, upgrade whenever your family is ready. Every feature below is compared side by side so nothing is hidden.": "இலவசமாக தொடங்குங்கள், உங்கள் குடும்பம் தயாராக இருக்கும் போது எப்போது வேண்டுமானாலும் மேம்படுத்தலாம். கீழே உள்ள ஒவ்வொரு அம்சமும் அடுத்தடுத்து ஒப்பிடப்பட்டுள்ளதால் எதுவும் மறைக்கப்படவில்லை.",
        "Swipe sideways on a phone — the feature column stays in place.": "தொலைபேசியில் பக்கவாட்டில் ஸ்வைப் செய்யவும் — அம்சம் காட்டும் நிரல் தனது இடத்தில் நிலையாக இருக்கும்.",
        "more features": "மேலும் அம்சங்கள்",
        "Namaste": "வணக்கம்",
        "{sender} has added you to our family tree on Family Repository.": "{sender} அவர்கள் உங்களை எங்கள் குடும்ப மரத்தில் Family Repository-ல் சேர்த்துள்ளார்கள்.",
        "Tap to join": "சேர முடிய இங்கே தொட்டு திறக்கவும்",
        "Your invite code": "உங்கள் அழைப்புக் குறியீடு",
        "Together we will preserve our family's stories, photos and voices for the next generations.": "நாம் சேர்ந்து எங்கள் குடும்பத்தின் கதைகள், படங்கள் மற்றும் குரல்களை அடுத்த தலைமுறைகளுக்காக பாதுகாப்போம்.",
        "Your family": "உங்கள் குடும்பம்",
        "Invite on WhatsApp": "WhatsApp-ல் அழைக்கவும்",
        "WhatsApp opened with the invite message.": "அழைப்புக் குறிப்புடன் WhatsApp திறக்கப்பட்டது.",
    },
    bn: {
        "Home": "বাড়ি",
        "Family": "পরিবার",
        "Family Tree": "বংশবৃক্ষ",
        "Add a Member": "একজন সদস্য যোগ করুন",
        "Invite Family": "পরিবারকে আমন্ত্রণ জানান",
        "Family Hub · All": "ফ্যামিলি হাব · সব",
        "Family Timeline": "পারিবারিক সময়রেখা",
        "Family Calendar": "পারিবারিক ক্যালেন্ডার",
        "Services": "সেবা",
        "Photo Memories": "ছবির স্মৃতি",
        "Audio Memories": "অডিও স্মৃতি",
        "AI Family Advisor": "AI পারিবারিক পরামর্শদাতা",
        "AI Story Generator": "AI গল্প তৈরির টুল",
        "Video Memories": "ভিডিও স্মৃতি",
        "Digital Family Tree": "ডিজিটাল বংশবৃক্ষ",
        "Family Hall of Fame": "পারিবারিক হল অফ ফেম",
        "Family Hub · All Services": "ফ্যামিলি হাব · সব সেবা",
        "Records": "রেকর্ড",
        "Blood Group Registry": "রক্তের গ্রুপ নিবন্ধন",
        "Health Repository": "স্বাস্থ্য সঞ্চয়শালা",
        "Health Score Compliance": "স্বাস্থ্য স্কোর সম্মতি",
        "Emergency Contacts": "জরুরি যোগাযোগ",
        "Business Directory": "ব্যবসায়িক ডিরেক্টরি",
        "Recipe Vault": "রেসিপি ভল্ট",
        "Family Statistics": "পরিবারের পরিসংখ্যান",
        "Legacy": "ঐতিহ্য",
        "Legal Vault": "লিগ্যাল ভল্ট",
        "Document Vault": "ডকুমেন্ট ভল্ট",
        "Story & Wisdom Vault": "কথা ও প্রজ্ঞার ভল্ট",
        "Family Constitution": "পারিবারিক সংবিধান",
        "Futuristic Legacy Letter": "ভবিষ্যতমুখী ঐতিহ্যপত্র",
        "Digital Memorial": "ডিজিটাল স্মারক",
        "Account": "অ্যাকাউন্ট",
        "Packages & Plans": "প্যাকেজ ও প্ল্যান",
        "Privacy & Settings": "গোপনীয়তা ও সেটিংস",
        "Download & Export": "ডাউনলোড ও এক্সপোর্ট",
        "Profile": "প্রোফাইল",
        "Search family…": "পরিবার খুঁজুন…",
        "Dashboard": "ড্যাশবোর্ড",
        "Families": "পরিবারসমূহ",
        "Users": "ব্যবহারকারীরা",
        "Subscriptions": "সাবস্ক্রিপশন",
        "Packages": "প্যাকেজ",
        "Exports": "এক্সপোর্ট",
        "Content": "কনটেন্ট",
        "Landing Slides": "ল্যান্ডিং স্লাইড",
        "Site Assets": "সাইট অ্যাসেট",
        "Family Content": "পারিবারিক কনটেন্ট",
        "Translations": "অনুবাদ",
        "User Page Editor": "ইউজার পেজ এডিটর",
        "Analytics": "অ্যানালিটিক্স",
        "Support Tickets": "সাপোর্ট টিকিট",
        "Broadcasts": "ব্রডকাস্ট",
        "Legacy CRM": "লিগেসি CRM",
        "SMS Console": "SMS কনসোল",
        "Security": "নিরাপত্তা",
        "Settings": "সেটিংস",
        "UI/UX Audit": "UI/UX অডিট",
        "API Keys": "API কী",
        "Admin Team": "অ্যাডমিন টিম",
        "Content Managers": "কনটেন্ট ম্যানেজাররা",
        "Overview": "সংক্ষিপ্ত বিবরণ",
        "Members": "সদস্যরা",
        "Billing": "বিলিং",
        "Landing & Content": "ল্যান্ডিং ও কনটেন্ট",
        "Insights": "ইনসাইটস",
        "Support": "সাপোর্ট",
        "System": "সিস্টেম",
        "Super Admin": "সুপার অ্যাডমিন",
        "Content Admin": "কনটেন্ট অ্যাডমিন",
        "Content Manager": "কনটেন্ট ম্যানেজার",
        "Finance Admin": "ফাইন্যান্স অ্যাডমিন",
        "Support Admin": "সাপোর্ট অ্যাডমিন",
        "Security Admin": "সিকিউরিটি অ্যাডমিন",
        "Admin": "অ্যাডমিন",
        "Admin Panel": "অ্যাডমিন প্যানেল",
        "Logout": "লগআউট",
        "Loading dashboard…": "ড্যাশবোর্ড লোড হচ্ছে…",
        "Platform overview at a glance.": "এক নজরে প্ল্যাটফর্মের সারসংক্ষেপ।",
        "Total Families": "মোট পরিবার",
        "Total Members": "মোট সদস্য",
        "Tree Persons": "বৃক্ষের অন্তর্ভুক্ত ব্যক্তি",
        "Storage Used": "ব্যবহৃত স্টোরেজ",
        "Marriages": "বিবাহ",
        "Memory Albums": "স্মৃতি অ্যালবাম",
        "Wills (latest)": "উইল (সর্বশেষ)",
        "Audio Wills": "অডিও উইল",
        "With recorded audio": "রেকর্ড করা অডিওসহ",
        "Across all families": "সব পরিবারের হিসাব মিলিয়ে",
        "New signups — last 30 days": "নতুন সাইনআপ — শেষ ৩০ দিনে",
        "Storage breakdown": "স্টোরেজের বিশদ",
        "No stored files yet.": "এখনও কোনও ফাইল সংরক্ষণ করা হয়নি।",
        "Signups": "সাইনআপ",
        "suspended": "সাসপেন্ড করা",
        "blocked": "ব্লক করা",
        "paid": "পেইড",
        "open tickets": "খোলা টিকিট",
        "Memory photos": "স্মৃতির ছবি",
        "Vault documents": "ভল্ট ডকুমেন্ট",
        "Story audio": "গল্পের অডিও",
        "Member profiles & photos": "সদস্য প্রোফাইল ও ছবি",
        "Profile details": "প্রোফাইলের বিস্তারিত",
        "Story metadata": "গল্পের মেটাডাটা",
        "Memory metadata": "স্মৃতির মেটাডাটা",
        "Document metadata": "ডকুমেন্টের মেটাডাটা",
        "Admin (Head)": "অ্যাডমিন (প্রধান)",
        "added": "যোগ করেছেন",
        "updated": "আপডেট করেছেন",
        "removed": "সরিয়ে দিয়েছেন",
        "changed privacy of": "এর গোপনীয়তা বদলেছেন",
        "updated profile of": "এর প্রোফাইল আপডেট করেছেন",
        "viewed profile of": "এর প্রোফাইল দেখেছেন",
        "recorded": "রেকর্ড করেছেন",
        "played": "প্লে করেছেন",
        "deleted story": "গল্প মুছে দিয়েছেন",
        "uploaded": "আপলোড করেছেন",
        "viewed": "দেখেছেন",
        "changed access of": "এর অ্যাক্সেস বদলেছেন",
        "deleted": "মুছে দিয়েছেন",
        "invited": "নিমন্ত্রণ পাঠিয়েছেন",
        "revoked an invite": "একটি আমন্ত্রণ বাতিল করেছেন",
        "joined the family": "পরিবারে যোগ দিয়েছেন",
        "changed role of": "এর ভূমিকা পরিবর্তন করেছেন",
        "downloaded their data": "তাদের ডেটা ডাউনলোড করেছেন",
        "completed privacy setup": "গোপনীয়তা সেটআপ সম্পূর্ণ করেছেন",
        "deleted account of": "এর অ্যাকাউন্ট মুছে দিয়েছেন",
        "Senior mode on — simpler privacy choices.": "জ্যেষ্ঠ মোড চালু — গোপনীয়তার সহজ বিকল্প।",
        "Senior mode off.": "জ্যেষ্ঠ মোড বন্ধ।",
        "Saved.": "সেভ করা হয়েছে।",
        "Your data export has been downloaded.": "আপনার ডেটা এক্সপোর্ট ডাউনলোড হয়ে গেছে।",
        "Your account and data have been deleted.": "আপনার অ্যাকাউন্ট এবং ডেটা মুছে ফেলা হয়েছে।",
        "Every family tree on the platform. Suspending blocks all its members from logging in.": "প্ল্যাটফর্মের প্রতিটি বংশবৃক্ষ। স্থগিত করলে এর সব সদস্য লগইন করতে পারবেন না।",
        "All registered members. Blocked users cannot log in or use the API.": "সব নিবন্ধিত সদস্য। ব্লক করা ব্যবহারকারীরা লগইন করতে বা API ব্যবহার করতে পারবেন না।",
        "Manual plan control until a payment gateway is connected in Settings.": "Settings-এ কোনো পেমেন্ট গেটওয়ে যুক্ত হওয়া পর্যন্ত ম্যানুয়াল প্ল্যান নিয়ন্ত্রণ।",
        "Growth, engagement and audience mix.": "বৃদ্ধি, সম্পৃক্ততা এবং শ্রোতা/দর্শকের মিশ্রণ।",
        "Users raise tickets from Settings → Help in the app.": "ব্যবহারকারীরা অ্যাপে Settings → Help থেকে টিকিট তোলেন।",
        "Branding, payment gateway and API keys. Secrets are stored server-side and shown masked.": "ব্র্যান্ডিং, পেমেন্ট গেটওয়ে এবং API key। গোপন তথ্য সার্ভার-সাইডে সংরক্ষিত থাকে এবং আড়াল করা অবস্থায় দেখানো হয়।",
        "Packages — Feature Matrix (Demo)": "Packages — Feature Matrix (ডেমো)",
        "Export Center": "Export Center",
        "Download authoritative reports in CSV, Excel or PDF. Schedule auto-email exports below.": "CSV, Excel বা PDF-এ প্রামাণ্য রিপোর্ট ডাউনলোড করুন। নিচে অটো-ইমেল এক্সপোর্টের সময়সূচি সেট করুন।",
        "Send SMS or WhatsApp announcements to your users.": "আপনার ব্যবহারকারীদের SMS বা WhatsApp-এ ঘোষণা পাঠান।",
        "Content Management": "Content Management",
        "Poster templates, landing banners and testimonials curated by the super-admin.": "পোস্টার টেমপ্লেট, ল্যান্ডিং ব্যানার এবং টেস্টিমোনিয়াল সুপার-অ্যাডমিন দ্বারা নির্বাচিত।",
        "Platform-wide audit trail, failed logins, DPDP compliance requests, and your MFA credentials.": "পুরো প্ল্যাটফর্ম জুড়ে অডিট ট্রেল, ব্যর্থ লগইন, DPDP কমপ্লায়েন্স রিকোয়েস্ট এবং আপনার MFA ক্রেডেনশিয়াল।",
        "Manage who can sign into the admin panel and what they can access.": "কারা অ্যাডমিন প্যানেলে সাইন ইন করতে পারবেন এবং কী কী অ্যাক্সেস করতে পারবেন তা নিয়ন্ত্রণ করুন।",
        "Family Content Moderation": "পরিবারের কনটেন্ট মডারেশন",
        "Listen": "শুনুন",
        "Stop": "থামান",
        "Pause": "থামিয়ে রাখুন",
        "Resume": "আবার শুরু করুন",
        "Generating…": "তৈরি হচ্ছে…",
        "Signup trend — last 90 days": "সাইনআপের প্রবণতা — শেষ ৯০ দিন",
        "(or user) is expected to add all their family relationships on the": "(বা ব্যবহারকারী) আশা করা হয় যে তিনি তার সব পারিবারিক সম্পর্ক যোগ করবেন",
        ", which can only be opened by your password.": ", যা কেবল আপনার পাসওয়ার্ড দিয়েই খোলা যাবে।",
        ". Any member added there is automatically reflected here. For convenience, a few extra fields for": "। সেখানে যেকোনো সদস্য যোগ করলে তা এখানে নিজে থেকেই দেখা যাবে। সুবিধার জন্য, অতিরিক্ত কয়েকটি ঘর রাখা হয়েছে",
        "A family together": "একসঙ্গে একটি পরিবার",
        "A premium feature for your family's future": "আপনার পরিবারের ভবিষ্যতের জন্য একটি প্রিমিয়াম সুবিধা",
        "Add": "যোগ করুন",
        "Add Event": "ঘটনা যোগ করুন",
        "Add custom field": "নিজস্ব ঘর যোগ করুন",
        "All checks": "সব যাচাই",
        "Avg age": "গড় বয়স",
        "Back": "ফিরে যান",
        "Back to Dashboard": "ড্যাশবোর্ডে ফিরে যান",
        "Change photo": "ছবি বদলান",
        "Choose the package that fits your family": "আপনার পরিবারের উপযোগী প্যাকেজটি বেছে নিন",
        "Classic, Premium and Elite": "Classic, Premium এবং Elite",
        "Countries": "দেশ",
        "Current": "বর্তমান",
        "Current Location": "বর্তমান অবস্থান",
        "Current city": "বর্তমান শহর",
        "Current locations": "বর্তমান অবস্থানসমূহ",
        "Data is encrypted in transit and at rest; every add/edit/delete is captured in the audit log.": "ডেটা ট্রানজিট এবং রেস্ট অবস্থায় এনক্রিপ্ট করা থাকে; প্রতিটি যোগ/সম্পাদনা/মুছার কাজ অডিট লগে রেকর্ড হয়।",
        "Date": "তারিখ",
        "Dear customer,": "প্রিয় গ্রাহক,",
        "Delete": "ডিলিট",
        "Distinct Cities": "স্বতন্ত্র শহর",
        "Family (₹999/yr)": "ফ্যামিলি (₹৯৯৯/বছর)",
        "Family Head": "পরিবারের কর্তা",
        "Family Health": "পারিবারিক স্বাস্থ্য",
        "Family Members": "পরিবারের সদস্যরা",
        "Family Relationships": "পারিবারিক সম্পর্ক",
        "Favourite mithai": "পছন্দের মিঠাই",
        "Field name": "ফিল্ডের নাম",
        "Fill with AI": "AI দিয়ে পূরণ করুন",
        "GPT-5.2 fills 40+ fields across all 6 modules from your surname + region · you edit before saving.": "GPT-5.2 আপনার পদবি + অঞ্চল থেকে ৬টি মডিউলের মধ্যে ৪০টিরও বেশি ফিল্ড পূরণ করে দেয় · আপনি সেভ করার আগে সবকিছু এডিট করতে পারবেন।",
        "Gaon ka temple": "গ্রামের মন্দির",
        "Generations": "প্রজন্ম",
        "Health & Medical Repository": "স্বাস্থ্য ও চিকিৎসা ভান্ডার",
        "Health Score Compliance Report": "হেলথ স্কোর কমপ্লায়েন্স রিপোর্ট",
        "Health information is stored with explicit consent, only for members whose data you are authorised to record.": "স্বাস্থ্য-সংক্রান্ত তথ্য কেবলমাত্র স্পষ্ট সম্মতির ভিত্তিতে, এবং যেসব সদস্যের তথ্য নথিবদ্ধ করার জন্য আপনি অনুমোদিত, শুধুমাত্র তাদের ক্ষেত্রেই সংরক্ষণ করা হয়।",
        "Help": "সাহায্য",
        "Hide details": "বিস্তারিত লুকান",
        "How complete is your family tree?": "আপনার পারিবারিক বংশতালিকা কতটা সম্পূর্ণ?",
        "Informed consent — one time, per family": "ইনফর্মড সম্মতি — প্রতি পরিবারে একবারই",
        "Kind": "ধরন",
        "Legacy (₹2999/yr)": "লেগেসি (₹২৯৯৯/বছর)",
        "Linked live from your family tree.": "আপনার পারিবারিক বংশতালিকা থেকে সরাসরি যুক্ত।",
        "Living Cities": "বর্তমান বসবাসের শহরসমূহ",
        "Loading events…": "ইভেন্ট লোড হচ্ছে…",
        "Loading packages…": "প্যাকেজ লোড হচ্ছে…",
        "Loading world map…": "বিশ্ব মানচিত্র লোড হচ্ছে…",
        "Loading…": "লোড হচ্ছে…",
        "Lucky number": "শুভ সংখ্যা",
        "Member Profile": "সদস্যের প্রোফাইল",
        "Most Popular": "সবচেয়ে জনপ্রিয়",
        "Native": "পৈতৃক",
        "Native Place": "পৈতৃক স্থান",
        "Native Places": "পৈতৃক স্থানসমূহ",
        "Native places": "পৈতৃক স্থানসমূহ",
        "None of your family members have a mapped location yet.": "আপনার পরিবারের কোনো সদস্যের অবস্থান এখনো মানচিত্রে চিহ্নিত হয়নি।",
        "Not a medical diagnosis platform.": "এটি কোনো চিকিৎসা-নির্ণয় প্ল্যাটফর্ম নয়।",
        "Not added yet": "এখনও যোগ করা হয়নি",
        "Notes (optional)": "নোট (ঐচ্ছিক)",
        "Place of birth": "জন্মস্থান",
        "Preserve. Understand. Inform.": "সংরক্ষণ করুন। বুঝুন। জানিয়ে দিন।",
        "Privacy by design:": "গোপনীয়তা নকশাতেই অর্ন্তভুক্ত:",
        "Records are visible to your family circle only; the Family Head controls who can add or edit.": "রেকর্ড শুধুমাত্র আপনার পরিবারের সদস্যদের জন্য দৃশ্যমান; কে যোগ বা সম্পাদনা করতে পারবেন, তা পরিবারপ্রধান নিয়ন্ত্রণ করেন।",
        "Remove": "মুছে দিন",
        "Reset": "রিসেট",
        "Save &amp; Continue": "সংরক্ষণ করুন ও এগিয়ে যান",
        "Saved ✓": "সংরক্ষণ হয়েছে ✓",
        "Saving…": "সংরক্ষণ করা হচ্ছে…",
        "Sensitive details are hidden by default.": "সংবেদনশীল তথ্য ডিফল্টভাবে আড়াল করা থাকে।",
        "Skip the blank page — let AI suggest your family&apos;s heritage": "ফাঁকা পাতা এড়িয়ে যান — আপনার পরিবারের ঐতিহ্য সম্পর্কে প্রস্তাব দিতে AI-কে ব্যবহার করুন",
        "Tap to view": "দেখতে ট্যাপ করুন",
        "This is a record-keeping repository — not a diagnosis, treatment or medical-advice tool.": "এটি একটি রেকর্ড সংরক্ষণের ভান্ডার — কোনো নির্ণয়, চিকিৎসা বা চিকিৎসা-সংক্রান্ত পরামর্শের উপকরণ নয়।",
        "This repository is for private family record-keeping and health-history awareness only — it does not provide diagnosis, treatment, risk prediction or medical advice. Always consult a qualified healthcare provider.": "এই ভান্ডারটি শুধুমাত্র ব্যক্তিগত পারিবারিক রেকর্ড সংরক্ষণ ও স্বাস্থ্য-ইতিহাস সম্পর্কে সচেতনতার জন্য — এটি নির্ণয়, চিকিৎসা, ঝুঁকি পূর্বাভাস বা চিকিৎসা-সংক্রান্ত পরামর্শ প্রদান করে না। সব সময় যোগ্য স্বাস্থ্যসেবা প্রদানকারীর সঙ্গে পরামর্শ করুন।",
        "This section is private": "এই অংশটি ব্যক্তিগত",
        "Timezones spread": "সময়ের অঞ্চলগুলির বিস্তৃতি",
        "Tip": "পরামর্শ",
        "Title": "শিরোনাম",
        "Tree completeness": "গাছের সম্পূর্ণতা",
        "Update": "আপডেট",
        "Update their": "তাদের আপডেট করুন",
        "Value (type or tap 🎤)": "মান (টাইপ করুন বা 🎤 ট্যাপ করুন)",
        "Visual Family Tree": "ভিজ্যুয়াল ফ্যামিলি ট্রি",
        "Voice language": "কণ্ঠের ভাষা",
        "What's missing": "কি অসম্পূর্ণ আছে",
        "Where Your Family Lives — Across the World": "আপনার পরিবার কোথায় থাকে — সারা বিশ্ব জুড়ে",
        "are provided in the section below —": "নিচের অংশে দেওয়া আছে —",
        "bank locker": "ব্যাংক লকার",
        "can be preserved in this section. The documents associated with these important information are required to be preserved at a different location, which is a special privilege of our": "এই অংশে সংরক্ষণ করা যেতে পারে। এই গুরুত্বপূর্ণ তথ্যগুলোর সঙ্গে যুক্ত নথিগুলো অন্য একটি জায়গায় সংরক্ষণ করা প্রয়োজন, যা আমাদের",
        "complete. Tick off the items below to grow it further.": "সম্পূর্ণ। আরও বাড়াতে নিচের বিষয়গুলো টিক করে দিন।",
        "customers.": "গ্রাহকদের বিশেষ সুবিধা।",
        "descriptive information": "বর্ণনামূলক তথ্য",
        "e.g. Dadu's Birthday": "যেমন, দাদুর জন্মদিন",
        "family-only visibility · Family Head controls writing · explicit informed consent · encrypted storage · full audit trail of every change · DPDP Act 2023 aligned. Coming next: disease timeline, maternal/paternal branch views & emergency health card.": "শুধু পরিবার-সীমিত দেখা যাবে · লেখার নিয়ন্ত্রণ থাকছে পরিবার প্রধানের হাতে · স্পষ্ট অবহিত সম্মতি · এনক্রিপ্টেড স্টোরেজ · প্রতিটি পরিবর্তনের সম্পূর্ণ অডিট ট্রেইল · DPDP Act 2023 অনুযায়ী। আসছে শিগগিরই: রোগের সময়রেখা, মাতৃকুল/পিতৃকুল শাখার ভিউ এবং ইমার্জেন্সি স্বাস্থ্য কার্ড।",
        "on the profile page, and they'll appear on the map instantly.": "প্রোফাইল পাতায়, আর সেগুলো সঙ্গে সঙ্গে মানচিত্রে দেখা যাবে।",
        "or": "অথবা",
        "plans — preserve multi-generation medical history, hereditary conditions, allergies, vaccinations and more.": "প্ল্যান — বহু প্রজন্মের চিকিৎসার ইতিহাস, বংশগত রোগ, অ্যালার্জি, টিকাদান এবং আরও অনেক কিছু সংরক্ষণ করুন।",
        "please note that you are preserving very important and vital information. Please make sure you save important information only if you want to preserve it on this platform in a highly secured manner by using a proper password. All the documents here are preserved as if they are kept in a": "অনুগ্রহ করে মনে রাখবেন, আপনি এখানে অত্যন্ত গুরুত্বপূর্ণ এবং সংবেদনশীল তথ্য সংরক্ষণ করছেন। কেবলমাত্র তখনই এই গুরুত্বপূর্ণ তথ্যগুলো সংরক্ষণ করুন, যখন আপনি যথাযথ পাসওয়ার্ড ব্যবহার করে এই প্ল্যাটফর্মে সেগুলো অত্যন্ত সুরক্ষিতভাবে রেখে দিতে চান। এখানে থাকা সব নথি এমনভাবে সংরক্ষিত থাকে যেন সেগুলো রাখা আছে একটি",
        "step relations, adopted relations, close relatives and extended relatives": "সৎ আত্মীয়, দত্তক আত্মীয়, নিকট আত্মীয় এবং দূরসম্পর্কের আত্মীয়",
        "these will not appear on your pictorial family tree view.": "এগুলো আপনার ছবিযুক্ত পারিবারিক বংশতালিকা ভিউ‑তে দেখা যাবে না।",
        "© 2026 Digital Family Tree. All rights reserved.": "© ২০২৬ Digital Family Tree. সর্বস্বত্ব সংরক্ষিত।",
        "21 sections of guided wisdom — the values, lessons and stories you want to pass down.": "নির্দেশিত প্রজ্ঞার ২১টি অংশ — যে মূল্যবোধ, শিক্ষা আর গল্পগুলো আপনি পরের প্রজন্মের কাছে পৌঁছে দিতে চান।",
        "AI-POWERED": "AI-POWERED",
        "Aadhaar, property papers, wills and certificates — stored privately and shared only with the people you choose.": "আধার, জমিজমার কাগজপত্র, উইল আর সার্টিফিকেট — নিরাপদে গোপনে রাখা থাকবে এবং শুধু যাদের আপনি বাছবেন, তাদের সঙ্গেই ভাগ হবে।",
        "Achievements Wall": "সাফল্যের দেওয়াল",
        "Ask anything about your family — heritage, relationships, memories — and get instant AI answers.": "আপনার পরিবারের সম্পর্কে যেকোনো কিছু জিজ্ঞাসা করুন — ঐতিহ্য, সম্পর্ক, স্মৃতি — আর সঙ্গে সঙ্গেই AI থেকে উত্তর পান।",
        "Audio Memories (Voice Stories)": "অডিও স্মৃতি (কণ্ঠের গল্প)",
        "Begin your family tree journey": "আপনার ফ্যামিলি ট্রি যাত্রা শুরু করুন",
        "Birthdays, anniversaries and festivals happening for your family today — one tap to wish.": "আজ আপনার পরিবারের কার কার জন্মদিন, বিবাহবার্ষিকী আর কী কী উৎসব — এক ট্যাপেই শুভেচ্ছা পাঠিয়ে দিন।",
        "Blood groups, allergies, chronic conditions and emergency contacts — accessible when it matters most.": "রক্তের গ্রুপ, অ্যালার্জি, দীর্ঘস্থায়ী অসুখ আর জরুরি সময়ে যাদের ফোন করবেন — সবকিছুই যখন দরকার তখন হাতের কাছেই থাকবে।",
        "Bring parents, siblings and cousins into your private family space — everyone adds their memories, and the tree grows together.": "মা–বাবা, ভাই–বোন আর কাজিনদের আপনার ব্যক্তিগত ফ্যামিলি স্পেসে আমন্ত্রণ করুন — সবাই নিজের স্মৃতি যোগ করবে, আর ফ্যামিলি ট্রি একসাথে বড় হবে।",
        "CULTURE & TRADITIONS": "সংস্কৃতি ও ঐতিহ্য",
        "Capture a memory in your own voice. We'll transcribe, translate and preserve it for future generations.": "একটি স্মৃতি নিজের কণ্ঠে ধরে রাখুন। আমরা তা লিখে রাখব, অনুবাদ করব এবং ভবিষ্যৎ প্রজন্মের জন্য সযত্নে রেখে দেব।",
        "Celebrate doctors, engineers, artists and every achiever in your family — a wall of pride for generations to see.": "আপনার পরিবারের সব ডাক্তার, ইঞ্জিনিয়ার, শিল্পী আর প্রতিটি কৃতী মানুষকে উদযাপন করুন — প্রজন্মের পর প্রজন্ম দেখার মতো একটি গর্বের দেওয়াল।",
        "Choose the package that fits your family — upgrade anytime, and unlock more features as your legacy grows.": "আপনার পরিবারের জন্য উপযুক্ত প্যাকেজটি বেছে নিন — যেকোনো সময় আপগ্রেড করুন, আর আপনার উত্তরাধিকার যত বাড়বে, তত নতুন সুবিধা খুলে যাবে।",
        "Complete legacy suite with AI tools": "AI টুলসহ সম্পূর্ণ লিগেসি সেট",
        "Connections": "সম্পর্ক",
        "Culture & Rituals Archive": "সংস্কৃতি ও আচার–অনুষ্ঠানের আর্কাইভ",
        "Demo Coming Soon": "ডেমো খুব শিগগিরই আসছে",
        "Demo pricing — final packages will be announced soon. Selection is saved to your account.": "ডেমো মূল্য তালিকা — চূড়ান্ত প্যাকেজ খুব শিগগিরই জানানো হবে। আপনার পছন্দটি আপনার অ্যাকাউন্টে সংরক্ষণ করা হয়েছে।",
        "Digital Family Tree (Print-ready)": "ডিজিটাল ফ্যামিলি ট্রি (প্রিন্টের জন্য প্রস্তুত)",
        "EMERGENCY INFO": "জরুরি তথ্য",
        "EVENTS & DATES": "ইভেন্ট ও তারিখ",
        "Events & Reminders": "ইভেন্ট ও রিমাইন্ডার",
        "Every family member at a glance — search, filter and open any profile in one tap.": "সব পরিবার-সদস্য এক নজরে — খুঁজুন, ফিল্টার করুন, আর এক ট্যাপেই যে কোনো প্রোফাইল খুলুন।",
        "Every milestone across generations — arranged as one continuous, beautiful story.": "প্রজন্মের পর প্রজন্মের সব মাইলস্টোন — গুছিয়ে সাজানো একটানা, সুন্দর গল্পের মতো।",
        "Every new member, photo, story and record — see everything happening in your family, as it happens.": "নতুন সদস্য, ছবি, গল্প আর রেকর্ড — আপনার পরিবারে যা কিছু ঘটছে, সব দেখুন, ঠিক যেভাবে ঘটছে।",
        "Every photo, voice note and story preserved forever — safely inside your family vault.": "প্রতিটি ছবি, ভয়েস নোট আর গল্প চিরদিনের জন্য সংরক্ষিত — নিরাপদে আপনার ফ্যামিলি ভল্টের ভেতরে।",
        "Everything, forever — one payment": "সবকিছু, সবসময়ের জন্য — মাত্র একবারের পেমেন্ট",
        "Expert Biography Writing": "বিশেষজ্ঞ জীবনী লেখার পরিষেবা",
        "Export everything you've saved — members, stories, memories, records — in the format that suits you. Your data is always yours.": "যা কিছু আপনি সংরক্ষণ করেছেন — সদস্য, গল্প, স্মৃতি, রেকর্ড — সবকিছু আপনার পছন্দের ফরম্যাটে এক্সপোর্ট করুন। আপনার ডেটা সবসময়ই আপনারই সম্পত্তি।",
        "FAMILY STATISTICS": "ফ্যামিলি পরিসংখ্যান",
        "FAMILY TIMELINE": "ফ্যামিলি টাইমলাইন",
        "FAMILY WORLD MAP": "ফ্যামিলি ওয়ার্ল্ড ম্যাপ",
        "Family Activity": "ফ্যামিলি কার্যকলাপ",
        "Family Calendar & Celebrations": "ফ্যামিলি ক্যালেন্ডার ও উদযাপন",
        "Family Pride": "পরিবারের গর্ব",
        "Family Records": "ফ্যামিলি রেকর্ড",
        "Family Tree Builder (6 generations)": "ফ্যামিলি ট্রি বিল্ডার (৬ প্রজন্ম)",
        "Family World Map": "ফ্যামিলি ওয়ার্ল্ড ম্যাপ",
        "Gold": "গোল্ড",
        "HEALTH & EMERGENCY": "স্বাস্থ্য ও জরুরি অবস্থা",
        "HEALTH REPOSITORY": "স্বাস্থ্য ভাণ্ডার",
        "Health & Medical Repository (10 registers)": "স্বাস্থ্য ও চিকিৎসা ভাণ্ডার (১০টি রেজিস্টার)",
        "How large is your family across generations? Longevity, geography, professions and more.": "প্রজন্ম ধরে আপনার পরিবার কত বড়? দীর্ঘায়ু, ভৌগোলিক বিস্তার, পেশা আর আরও অনেক কিছু।",
        "Keep every family member's blood group in one secure place. In an emergency, every second counts — this registry helps you instantly find the right donor within your family.": "পরিবারের সবার রক্তের গ্রুপ এক নিরাপদ জায়গায় সংরক্ষণ করুন। জরুরি অবস্থায় প্রতিটি সেকেন্ড মূল্যবান — এই নিবন্ধন আপনাকে মুহূর্তের মধ্যে আপনার পরিবারের মধ্যেই সঠিক দাতা খুঁজে পেতে সাহায্য করবে।",
        "LEGACY & MEMORIAL": "ঐতিহ্য ও স্মৃতিচারণ",
        "LEGAL & LEGACY": "আইনগত নথি ও ঐতিহ্য",
        "Legacy Lifetime": "আজীবন ঐতিহ্য",
        "Legal Vault (Will & Nominee)": "আইনগত ভল্ট (উইল ও নমিনি)",
        "Let AI compose a heartfelt narrative of your family's journey from the profiles you've filled.": "আপনি যে প্রোফাইলগুলো পূরণ করেছেন, সেগুলোর ভিত্তিতে আপনার পরিবারের যাত্রার এক আন্তরিক গল্প AI‑কে লিখতে দিন।",
        "MEMORIES & STORIES": "স্মৃতি ও গল্প",
        "Marriage Records": "বিবাহ সংক্রান্ত নথি",
        "Member Profiles & Photos": "সদস্যদের প্রোফাইল ও ছবি",
        "Memories & reminders for the whole family": "পুরো পরিবারের জন্য স্মৃতি ও রিমাইন্ডার",
        "Multi-user Family Access (Invites)": "একাধিক ব্যবহারকারীর পরিবার–অ্যাক্সেস (আমন্ত্রণ)",
        "Never miss a birthday, anniversary or festival — smart reminders from your family tree, delivered by email, push and in-app.": "কখনও যেন জন্মদিন, বিবাহবার্ষিকী বা উৎসব বাদ না পড়ে — আপনার ফ্যামিলি ট্রি থেকে ইমেল, পুশ এবং ইন‑অ্যাপ স্মার্ট রিমাইন্ডার পাবেন।",
        "One place for every birthday, anniversary, shraddha and cultural festival — with smart nudges.": "প্রতিটি জন্মদিন, বিবাহবার্ষিকী, শ্রাদ্ধ ও সাংস্কৃতিক উৎসবের জন্য এক জায়গায় সবকিছু — স্মার্ট নাজার সহ।",
        "Personal Vault": "পার্সোনাল ভল্ট",
        "Prescriptions, reports and hospital records for every family member — organized and searchable.": "পরিবারের প্রতিটি সদস্যের প্রেসক্রিপশন, রিপোর্ট ও হাসপাতালের নথি — সাজানো ও সহজে খুঁজে পাওয়ার মতোভাবে সংরক্ষিত।",
        "Preserve wedding dates, venues and couple details — anniversaries flow automatically into your family calendar and timeline.": "বিয়ে’র তারিখ, স্থান ও দম্পতির তথ্য সংরক্ষণ করুন — এসব থেকে বিবাহবার্ষিকী আপনার ফ্যামিলি ক্যালেন্ডার ও টাইমলাইনে স্বয়ংক্রিয়ভাবে যুক্ত হয়ে যাবে।",
        "Priority Support": "প্রায়োরিটি সাপোর্ট",
        "Rituals, recipes, dialects and heritage — everything that makes your family uniquely yours.": "অনুষ্ঠান, রান্নার রেসিপি, উপভাষা আর ঐতিহ্য — যা যা মিলিয়ে আপনার পরিবারকে একেবারে আলাদা করে তোলে।",
        "SHARE & CELEBRATE": "শেয়ার করুন ও উদযাপন করুন",
        "Seal messages, photos and videos to open on future birthdays, anniversaries or a chosen date.": "বার্তা, ছবি ও ভিডিও ভবিষ্যতের জন্মদিন, বিবাহবার্ষিকী বা আপনার পছন্দের কোনও তারিখে খোলার জন্য সিল করে রাখুন।",
        "See every family member on a real world map. Each pin shows a current location (orange) and a native place (green), connected by a dotted line — a beautiful visual of your family's journey through geography.": "বাস্তব মানচিত্রে আপনার পরিবারের প্রতিটি সদস্যকে দেখুন। প্রতিটি পিনে দেখা যাবে বর্তমান ঠিকানা (কমলা) ও নিজ এলাকা (সবুজ); দুটিকে একটি ডটেড লাইনে যুক্ত করা থাকবে — ভূগোলের ভিতর দিয়ে আপনার পরিবারের যাত্রার এক সুন্দর ছবি।",
        "Share the gift of legacy — invite friends to build their own private family tree, free to start.": "ঐতিহ্যের অনন্য উপহার দিন — বন্ধুদের আমন্ত্রণ করুন যাতে তারা নিজেদের ব্যক্তিগত ফ্যামিলি ট্রি বানাতে পারে, শুরুটা একদম বিনামূল্যে।",
        "Silver": "সিলভার",
        "Smart Reminders (Email + Push)": "স্মার্ট রিমাইন্ডার (ইমেল + পুশ)",
        "Starter": "স্টার्टर",
        "TIME CAPSULES": "টাইম ক্যাপসুল",
        "TODAY'S CELEBRATIONS": "আজকের উদযাপন",
        "Turn your family tree into a beautiful shareable poster — perfect for wedding invites, festivals and print.": "আপনার ফ্যামিলি ট্রিকে সুন্দর একটি শেয়ারযোগ্য পোস্টারে বদলে নিন — বিয়ের নিমন্ত্রণ, উৎসব আর প্রিন্ট করার জন্য একদম উপযুক্ত।",
        "VOICE & STORIES": "ভয়েস ও গল্প",
        "Watch Demo": "ডেমো দেখুন",
        "Wills, power-of-attorney, property papers and nominee details — locked and always accessible to the right people.": "উইল, পাওয়ার অফ অ্যাটর্নি, সম্পত্তির কাগজপত্র এবং নমিনির সমস্ত তথ্য — সুরক্ষিতভাবে লক করা, তবু সবসময় সঠিক মানুষদের জন্য সহজে পাওয়া যাবে।",
        "Your data, your rules — manage account preferences, visibility and every privacy declaration in one place.": "আপনার তথ্য, আপনার নিয়ম — এক জায়গা থেকেই অ্যাকাউন্টের পছন্দ, দৃশ্যমানতা আর সব ধরনের প্রাইভেসি সেটিংস নিয়ন্ত্রণ করুন।",
        "one-time · lifetime": "একবারই · সারাজীবনের জন্য",
        "per month": "প্রতি মাসে",
        "per year": "প্রতি বছরে",
        "January": "জানুয়ারি",
        "February": "ফেব্রুয়ারি",
        "March": "মার্চ",
        "April": "এপ্রিল",
        "May": "মে",
        "June": "জুন",
        "July": "জুলাই",
        "August": "আগস্ট",
        "September": "সেপ্টেম্বর",
        "October": "অক্টোবর",
        "November": "নভেম্বর",
        "December": "ডিসেম্বর",
        "is locked": "লক করা আছে",
        "Your current package": "আপনার বর্তমান প্যাকেজ",
        "doesn't include this feature.": "এই সুবিধাটি অন্তর্ভুক্ত নেই।",
        "Included in": "অন্তর্ভুক্ত আছে",
        "one-time": "একবারের",
        "year": "বছর",
        "month": "মাস",
        "lifetime": "আজীবন",
        "Go Back": "পেছনে যান",
        "View Packages": "প্যাকেজগুলো দেখুন",
        "This feature": "এই সুবিধাটি",
        "Family Legacy Dashboard": "পারিবারিক উত্তরাধিকার ড্যাশবোর্ড",
        "Legacy Services": "উত্তরাধিকার সেবা",
        "Life Story Vault": "জীবনকথা ভল্ট",
        "Video Testament Library": "ভিডিও উইল লাইব্রেরি",
        "Family Wisdom Bank": "পারিবারিক প্রজ্ঞা ব্যাংক",
        "Failure Stories Archive": "ব্যর্থতার গল্পের আর্কাইভ",
        "Success Stories": "সাফল্যের গল্প",
        "Family Decision History": "পারিবারিক সিদ্ধান্তের ইতিহাস",
        "Family Values Repository": "পারিবারিক মূল্যবোধ ভাণ্ডার",
        "Family Hero Gallery": "পারিবারিক বীরদের গ্যালারি",
        "Unsung Heroes": "অজ্ঞাত বীরেরা",
        "Gratitude Wall": "কৃতজ্ঞতার প্রাচীর",
        "Tribute Pages": "শ্রদ্ধা নিবেদনের পেজ",
        "Love Letters Archive": "ভালোবাসার চিঠির আর্কাইভ",
        "Childhood Stories Bank": "শৈশবের গল্পের ভাণ্ডার",
        "Language Preservation": "ভাষা সংরক্ষণ",
        "Ancestral Village": "পূর্বপুরুষের গ্রাম",
        "Surname History": "বংশনামের ইতিহাস",
        "Family Emblem": "পারিবারিক প্রতীক",
        "Cultural Artifacts": "সাংস্কৃতিক নিদর্শন",
        "Family Songs & Bhajans": "পারিবারিক গান ও ভজন",
        "Oral History Center": "মৌখিক ইতিহাস কেন্দ্র",
        "Biography Writing Platform": "জীবনী লেখার প্ল্যাটফর্ম",
        "Memoir Writing Service": "স্মৃতিকথা লেখার পরিষেবা",
        "Personalised Gifting Service": "ব্যক্তিগতকৃত উপহার পরিষেবা",
        "Personal Digital Identity Platform": "ব্যক্তিগত ডিজিটাল পরিচয় প্ল্যাটফর্ম",
        "Add to": "যোগ করুন",
        "Choose": "পছন্দ করুন",
        "Compare all packages": "সব প্যাকেজ তুলনা করুন",
        "Demo pricing — packages, prices and the feature split are all editable from the admin panel.": "ডেমো প্রাইসিং — প্যাকেজ, দাম এবং ফিচার ভাগ সবই অ্যাডমিন প্যানেল থেকে বদলানো যাবে।",
        "Feature": "ফিচার",
        "Five packages, one family legacy": "পাঁচটি প্যাকেজ, একটাই পারিবারিক উত্তরাধিকার",
        "Free": "ফ্রি",
        "Life story, wisdom and biography now live in Family Legacy Dashboard": "জীবনের গল্প, প্রজ্ঞা ও জীবনী এখন Family Legacy Dashboard-এ সংরক্ষিত",
        "Open Family Legacy Dashboard": "Family Legacy Dashboard খুলুন",
        "Packages & Pricing": "প্যাকেজ ও প্রাইসিং",
        "Packages temporarily unavailable. Please try again shortly.": "প্যাকেজগুলো সাময়িকভাবে পাওয়া যাচ্ছে না। কিছুক্ষণ পরে আবার চেষ্টা করুন।",
        "Start Free": "ফ্রি শুরু করুন",
        "Start free, upgrade whenever your family is ready. Every feature below is compared side by side so nothing is hidden.": "ফ্রি দিয়ে শুরু করুন, পরিবার প্রস্তুত হলে যেকোনও সময় আপগ্রেড করুন। নিচের প্রতিটি ফিচার পাশাপাশি দেখানো হয়েছে, কিছুই লুকোনো নেই।",
        "Swipe sideways on a phone — the feature column stays in place.": "ফোনে আড়াআড়ি সোয়াইপ করুন — ফিচারের কলাম একই জায়গায় থাকবে।",
        "more features": "আরও ফিচার",
        "Namaste": "নমস্তে",
        "{sender} has added you to our family tree on Family Repository.": "{sender} আপনাকে Family Repository-তে আমাদের পারিবারিক বংশতালিকায় যুক্ত করেছেন।",
        "Tap to join": "যোগ দিতে ট্যাপ করুন",
        "Your invite code": "আপনার আমন্ত্রণ কোড",
        "Together we will preserve our family's stories, photos and voices for the next generations.": "একসঙ্গে আমরা আমাদের পরিবারের গল্প, ছবি এবং কণ্ঠ ভবিষ্যৎ প্রজন্মের জন্য সংরক্ষণ করব।",
        "Your family": "আপনার পরিবার",
        "Invite on WhatsApp": "WhatsApp-এ আমন্ত্রণ জানান",
        "WhatsApp opened with the invite message.": "আমন্ত্রণ বার্তাসহ WhatsApp খোলা হয়েছে।",
    },
    gu: {
        "Home": "હોમ",
        "Family": "પરિવાર",
        "Family Tree": "વંશવૃક્ષ",
        "Add a Member": "સભ્ય ઉમેરો",
        "Invite Family": "પરિવારને આમંત્રિત કરો",
        "Family Hub · All": "ફેમિલી હબ · બધા",
        "Family Timeline": "પરિવાર ટાઈમલાઈન",
        "Family Calendar": "પરિવાર કેલેન્ડર",
        "Services": "સેવાઓ",
        "Photo Memories": "ફોટો યાદો",
        "Audio Memories": "ઓડિયો યાદો",
        "AI Family Advisor": "AI ફેમિલી સલાહકાર",
        "AI Story Generator": "AI સ્ટોરી જનરેટર",
        "Video Memories": "વિડિયો યાદો",
        "Digital Family Tree": "ડિજિટલ વંશવૃક્ષ",
        "Family Hall of Fame": "પરિવાર હોલ ઓફ ફેમ",
        "Family Hub · All Services": "ફેમિલી હબ · બધી સેવાઓ",
        "Records": "રેકોર્ડ્સ",
        "Blood Group Registry": "બ્લડ ગ્રુપ રજિસ્ટ્રી",
        "Health Repository": "હેલ્થ રેપોઝિટરી",
        "Health Score Compliance": "આરોગ્ય સ્કોર અનુસરણ",
        "Emergency Contacts": "તાત્કાલિક સંપર્કો",
        "Business Directory": "વ્યવસાય નિર્દેશિકા",
        "Recipe Vault": "રસોઈની રેસીપી તિજોરી",
        "Family Statistics": "કુટુંબ આંકડા",
        "Legacy": "વારસો",
        "Legal Vault": "કાનૂની દસ્તાવેજોની તિજોરી",
        "Document Vault": "દસ્તાવેજોની તિજોરી",
        "Story & Wisdom Vault": "વાર્તા અને જ્ઞાન તિજોરી",
        "Family Constitution": "કુટુંબ બંધારણ",
        "Futuristic Legacy Letter": "ભવિષ્યમુખી વારસાની ચીઠ્ઠી",
        "Digital Memorial": "ડિજિટલ સ્મારક",
        "Account": "ખાતું",
        "Packages & Plans": "પેકેજ અને યોજનાઓ",
        "Privacy & Settings": "ગોપનીયતા અને સેટિંગ્સ",
        "Download & Export": "ડાઉનલોડ અને નિકાસ",
        "Profile": "પ્રોફાઇલ",
        "Search family…": "કુટુંબ શોધો…",
        "Dashboard": "ડેશબોર્ડ",
        "Families": "કુટુંબો",
        "Users": "વપરાશકર્તાઓ",
        "Subscriptions": "સબ્સ્ક્રિપ્શન",
        "Packages": "પેકેજો",
        "Exports": "નિકાસ",
        "Content": "સમગ્રી",
        "Landing Slides": "લૅન્ડિંગ સ્લાઇડ્સ",
        "Site Assets": "સાઇટ એસેટ્સ",
        "Family Content": "પરિવારની સામગ્રી",
        "Translations": "અનુવાદો",
        "User Page Editor": "વપરાશકર્તા પેજ સંપાદક",
        "Analytics": "એનલિટિક્સ",
        "Support Tickets": "સપોર્ટ ટિકિટો",
        "Broadcasts": "પ્રસારણ",
        "Legacy CRM": "લેગસી CRM",
        "SMS Console": "SMS કન્સોલ",
        "Security": "સુરક્ષા",
        "Settings": "સેટિંગ્સ",
        "UI/UX Audit": "UI/UX ઑડિટ",
        "API Keys": "API કીઓ",
        "Admin Team": "એડમિન ટીમ",
        "Content Managers": "સમગ્રી મેનેજરો",
        "Overview": "સારાંશ",
        "Members": "સભ્યો",
        "Billing": "બિલિંગ",
        "Landing & Content": "લૅન્ડિંગ અને સામગ્રી",
        "Insights": "અંતર્દૃષ્ટિ",
        "Support": "સપોર્ટ",
        "System": "સિસ્ટમ",
        "Super Admin": "સુપર એડમિન",
        "Content Admin": "સામગ્રી એડમિન",
        "Content Manager": "સામગ્રી મેનેજર",
        "Finance Admin": "વિત્ત એડમિન",
        "Support Admin": "સપોર્ટ એડમિન",
        "Security Admin": "સિક્યોરિટી એડમિન",
        "Admin": "એડમિન",
        "Admin Panel": "એડમિન પેનલ",
        "Logout": "લૉગઆઉટ",
        "Loading dashboard…": "ડૅશબોર્ડ લોડ થઈ રહ્યું છે…",
        "Platform overview at a glance.": "પ્લેટફોર્મનો સરવાળો એક નજરમાં.",
        "Total Families": "કુલ પરિવારો",
        "Total Members": "કુલ સભ્યો",
        "Tree Persons": "વૃક્ષમાં લોકો",
        "Storage Used": "વપરાયેલ સ્ટોરેજ",
        "Marriages": "લગ્નો",
        "Memory Albums": "યાદોના આલ્બમ",
        "Wills (latest)": "વસીયતો (નવીનતમ)",
        "Audio Wills": "ઑડિયો વસીયતો",
        "With recorded audio": "રેકોર્ડેડ ઑડિયો સાથે",
        "Across all families": "બધા પરિવારોમાં મળી ને",
        "New signups — last 30 days": "નવા સાઇનઅપ — છેલ્લા 30 દિવસમાં",
        "Storage breakdown": "સ્ટોરેજનું વિગતવાર વિભાજન",
        "No stored files yet.": "હજુ સુધી કોઈ ફાઇલો સેવ નથી.",
        "Signups": "સાઇનઅપ્સ",
        "suspended": "થોડા સમય માટે બંધ",
        "blocked": "અટકાવેલ",
        "paid": "ચૂકવેલ",
        "open tickets": "ખુલ્લા ટિકિટ",
        "Memory photos": "યાદોની તસવીરો",
        "Vault documents": "વૉલ્ટ દસ્તાવેજો",
        "Story audio": "કથાનો ઑડિયો",
        "Member profiles & photos": "સભ્યોની પ્રોફાઇલ અને ફોટા",
        "Profile details": "પ્રોફાઇલની વિગતો",
        "Story metadata": "સ્ટોરી મેટાડેટા",
        "Memory metadata": "મેમરી મેટાડેટા",
        "Document metadata": "દસ્તાવેજ મેટાડેટા",
        "Admin (Head)": "એડમિન (મુખિયા)",
        "added": "ઉમેર્યું",
        "updated": "સુધાર્યું",
        "removed": "દૂર કર્યું",
        "changed privacy of": "ની પ્રાઈવસી બદલી",
        "updated profile of": "ની પ્રોફાઇલ સુધારી",
        "viewed profile of": "ની પ્રોફાઇલ જોઈ",
        "recorded": "રેકોર્ડ કર્યું",
        "played": "પ્લે કર્યું",
        "deleted story": "સ્ટોરી કાઢી",
        "uploaded": "અપલોડ કર્યું",
        "viewed": "જોઈ",
        "changed access of": "નો ઍક્સેસ બદલીયો",
        "deleted": "કાઢી નાખ્યું",
        "invited": "આમંત્રણ આપ્યું",
        "revoked an invite": "આમંત્રણ રદ કર્યું",
        "joined the family": "પરિવારમાં જોડાયા",
        "changed role of": "ની ભૂમિકા બદલી",
        "downloaded their data": "તેમનો ડેટા ડાઉનલોડ કર્યો",
        "completed privacy setup": "ગોપનીયતા સેટઅપ પૂરો કર્યો",
        "deleted account of": "નુ એકાઉન્ટ કાઢી નાંખ્યું",
        "Senior mode on — simpler privacy choices.": "વરિષ્ઠ મોડ ચાલુ — સરળ ગોપનીયતા વિકલ્પો.",
        "Senior mode off.": "વરિષ્ઠ મોડ બંધ.",
        "Saved.": "સાચવાયું.",
        "Your data export has been downloaded.": "તમારો ડેટા એક્સપોર્ટ ડાઉનલોડ થઈ ગયો છે.",
        "Your account and data have been deleted.": "તમારું એકાઉન્ટ અને ડેટા કાઢી નાંખવામાં આવ્યા છે.",
        "Every family tree on the platform. Suspending blocks all its members from logging in.": "પ્લેટફોર્મ પરની દરેક વંશાવળી. તેને સસ્પેન્ડ કરવાથી તેના બધા સભ્યો માટે લૉગિન પર પ્રતિબંધ થાય છે.",
        "All registered members. Blocked users cannot log in or use the API.": "બધા નોંધાયેલ સભ્યો. બ્લોક કરાયેલા યૂઝર્સ લૉગિન કરી શકતા નથી અથવા APIનો ઉપયોગ કરી શકતા નથી.",
        "Manual plan control until a payment gateway is connected in Settings.": "Settings માં payment gateway જોડાય ત્યાં સુધી પ્લાનનું મેન્યુઅલ કન્ટ્રોલ રહેશે.",
        "Growth, engagement and audience mix.": "વિકાસ, જોડાણ અને પ્રેક્ષક મિશ્રણ.",
        "Users raise tickets from Settings → Help in the app.": "યૂઝર્સ એપમાં Settings → Help માંથી ટિકિટ ઉઠાવે છે.",
        "Branding, payment gateway and API keys. Secrets are stored server-side and shown masked.": "Branding, payment gateway અને API keys. સિક્રેટ્સ સર્વર-સાઈડ સંગ્રહિત રહે છે અને છુપાવેલા રૂપમાં બતાવવામાં આવે છે.",
        "Packages — Feature Matrix (Demo)": "Packages — Feature Matrix (Demo)",
        "Export Center": "Export Center",
        "Download authoritative reports in CSV, Excel or PDF. Schedule auto-email exports below.": "CSV, Excel અથવા PDF માં વિશ્વસનીય રિપોર્ટ્સ ડાઉનલોડ કરો. નીચે auto-email exports શેડ્યૂલ કરો.",
        "Send SMS or WhatsApp announcements to your users.": "તમારા યૂઝર્સને SMS અથવા WhatsApp દ્વારા ઘોષણાઓ મોકલો.",
        "Content Management": "Content Management",
        "Poster templates, landing banners and testimonials curated by the super-admin.": "સુપર-એડમિન દ્વારા પસંદ કરેલી પોસ્ટર ટેમ્પ્લેટ્સ, લેન્ડિંગ બેનર્સ અને ટેસ્ટીમોનિયલ્સ.",
        "Platform-wide audit trail, failed logins, DPDP compliance requests, and your MFA credentials.": "પ્લેટફોર્મ-સ્તરની audit trail, નિષ્ફળ લૉગિન, DPDP compliance વિનંતીઓ અને તમારા MFA ક્રેડેન્શિયલ્સ.",
        "Manage who can sign into the admin panel and what they can access.": "કોણ એડમિન પેનલમાં સાઇન ઇન કરી શકે અને તેઓ શું ઍક્સેસ કરી શકે તે મેનેજ કરો.",
        "Family Content Moderation": "પરિવારનું કન્ટેન્ટ Moderation",
        "Listen": "સાંભળો",
        "Stop": "બંધ કરો",
        "Pause": "રોકો",
        "Resume": "ફરી શરૂ કરો",
        "Generating…": "બનાવી રહ્યા છીએ…",
        "Signup trend — last 90 days": "છેલ્લા 90 દિવસોની સાઇનઅપની પ્રવૃતિ",
        "(or user) is expected to add all their family relationships on the": "(અથવા યુઝર) તેમની બધી કુટુંબી સંબંધોની માહિતી તેમાં ઉમેરે એવો ધાર્ય છે",
        ", which can only be opened by your password.": ", જેને માત્ર તમારા પાસવર્ડથી જ ખોલી શકાય છે.",
        ". Any member added there is automatically reflected here. For convenience, a few extra fields for": ". ત્યાં ઉમેરાયેલો કોઈપણ સભ્ય આપમેળે અહીં દેખાશે. સરળતા માટે, થોડા વધારાના ફીલ્ડ્સ",
        "A family together": "એક કુટુંબ સાથે",
        "A premium feature for your family's future": "તમારા પરિવારના ભવિષ્ય માટેની એક પ્રીમિયમ સુવિધા",
        "Add": "ઉમેરો",
        "Add Event": "ઇવેન્ટ ઉમેરો",
        "Add custom field": "કસ્ટમ ફીલ્ડ ઉમેરો",
        "All checks": "બધા ચેક",
        "Avg age": "સરેરાશ ઉંમર",
        "Back": "પાછા",
        "Back to Dashboard": "ડેશબોર્ડ પર પાછા જાઓ",
        "Change photo": "ફોટો બદલો",
        "Choose the package that fits your family": "તમારા પરિવારને યોગ્ય આવતું પેકેજ પસંદ કરો",
        "Classic, Premium and Elite": "ક્લાસિક, પ્રીમિયમ અને એલાઇટ",
        "Countries": "દેશો",
        "Current": "હાલનું",
        "Current Location": "હાલનું સ્થાન",
        "Current city": "હાલનું શહેર",
        "Current locations": "હાલના સ્થળો",
        "Data is encrypted in transit and at rest; every add/edit/delete is captured in the audit log.": "માહિતી ટ્રાન્સિટ અને સ્ટોરેજ બન્ને વખતે એન્ક્રિપ્ટેડ રહે છે; દરેક add/edit/delete audit log માં નોંધાય છે.",
        "Date": "તારીખ",
        "Dear customer,": "આદરનીય ગ્રાહક,",
        "Delete": "કાઢી નાખો",
        "Distinct Cities": "અલગ અલગ શહેરો",
        "Family (₹999/yr)": "કુટુંબ (₹999/વર્ષ)",
        "Family Head": "કુટુંબ પ્રમુખ",
        "Family Health": "કુટુંબ આરોગ્ય",
        "Family Members": "કુટુંબના સભ્યો",
        "Family Relationships": "કુટુંબીય સંબંધો",
        "Favourite mithai": "મનપસંદ મીઠાઈ",
        "Field name": "ફીલ્ડનું નામ",
        "Fill with AI": "AI થી ભરો",
        "GPT-5.2 fills 40+ fields across all 6 modules from your surname + region · you edit before saving.": "GPT-5.2 તમારા અટક અને વિસ્તારના આધારે 6ેય મોડ્યુલમાં 40થી વધુ ફીલ્ડ્સ ભરી આપે છે · તમે સેવ કરતાં પહેલાં તેમાં ફેરફાર કરી શકો છો.",
        "Gaon ka temple": "ગામનું મંદિર",
        "Generations": "પેઢીઓ",
        "Health & Medical Repository": "હેલ્થ અને મેડિકલ રેપોઝિટરી",
        "Health Score Compliance Report": "હેલ્થ સ્કોર કમ્પ્લાયન્સ રિપોર્ટ",
        "Health information is stored with explicit consent, only for members whose data you are authorised to record.": "આરોગ્ય સંબંધિત માહિતી સ્પષ્ટ સંમતિ સાથે, ફક્ત તે સભ્યો માટે જ સંગ્રહવામાં આવે છે જેઓની માહિતી નોંધવાનો તમને અધિકાર છે.",
        "Help": "મદદ",
        "Hide details": "વિગતો છુપાવો",
        "How complete is your family tree?": "તમારું કુટુંબ વૃક્ષ કેટલું સંપૂર્ણ છે?",
        "Informed consent — one time, per family": "માહિતગાર સંમતિ — દરેક પરિવાર માટે એક જ વાર",
        "Kind": "પ્રકાર",
        "Legacy (₹2999/yr)": "લેગસી (₹2999/વર્ષ)",
        "Linked live from your family tree.": "તમારા કુટુંબ વૃક્ષમાંથી લાઈવ જોડાયેલ.",
        "Living Cities": "રહેઠાણવાળા શહેરો",
        "Loading events…": "ઘટનાઓ લોડ થઈ રહી છે…",
        "Loading packages…": "પેકેજિસ લોડ થઈ રહ્યા છે…",
        "Loading world map…": "વર્લ્ડ મેપ લોડ થઈ રહ્યો છે…",
        "Loading…": "લોડ થઈ રહ્યું છે…",
        "Lucky number": "લક્કી નંબર",
        "Member Profile": "સભ્યની પ્રોફાઇલ",
        "Most Popular": "સૌથી લોકપ્રિય",
        "Native": "મૂળ",
        "Native Place": "મૂળ ગામ/શહેર",
        "Native Places": "મૂળ ગામો/શહેરો",
        "Native places": "મૂળ ગામો/શહેરો",
        "None of your family members have a mapped location yet.": "તમારા કોઈપણ પરિવારજનોનું સ્થાને હજી નકશામાં દર્શાવવામાં આવ્યું નથી.",
        "Not a medical diagnosis platform.": "આ તબીબી નિદાન માટેનું પ્લેટફોર્મ નથી.",
        "Not added yet": "હજુ સુધી ઉમેરાયું નથી",
        "Notes (optional)": "નોંધો (વૈકલ્પિક)",
        "Place of birth": "જન્મસ્થળ",
        "Preserve. Understand. Inform.": "સાચવો. સમજો. માહિતગાર કરો.",
        "Privacy by design:": "ડિઝાઇનથી જ ગોપનીયતા:",
        "Records are visible to your family circle only; the Family Head controls who can add or edit.": "નોંધો ફક્ત તમારા કુટુંબના પરિધિમાં જ દેખાય છે; કોણ ઉમેરશે કે ફેરફાર કરશે તેનું નિયંત્રણ કુટુંબ-મુખિયા પાસે છે.",
        "Remove": "કાઢી નાંખો",
        "Reset": "રીસેટ",
        "Save &amp; Continue": "સાચવો અને આગળ વધો",
        "Saved ✓": "સાચવાઈ ગયું ✓",
        "Saving…": "સાચવી રહ્યા છીએ…",
        "Sensitive details are hidden by default.": "સંવેદનશીલ વિગતો મૂળભૂત રીતે છુપાવવામાં આવે છે.",
        "Skip the blank page — let AI suggest your family&apos;s heritage": "ખાલી પાનું છોડો — તમારા કુટુંબની વારસત AI સૂચવે તેવી મંજુરી આપો",
        "Tap to view": "જોવા માટે ટેપ કરો",
        "This is a record-keeping repository — not a diagnosis, treatment or medical-advice tool.": "આ ફક્ત નોંધો સાચવવાનું ભંડાર છે — નિદાન, સારવાર અથવા તબીબી સલાહ આપતું સાધન નથી.",
        "This repository is for private family record-keeping and health-history awareness only — it does not provide diagnosis, treatment, risk prediction or medical advice. Always consult a qualified healthcare provider.": "આ ભંડાર ફક્ત ખાનગી કુટુંબ-નોંધો અને આરોગ્ય ઇતિહાસ વિશે જાગૃતિ માટે છે — તે કોઈપણ પ્રકારનું નિદાન, સારવાર, જોખમનું ભાખાણું કે તબીબી સલાહ આપતું નથી. હંમેશા લાયકાત ધરાવતા આરોગ્ય-સેવા પ્રદાતા સાથે પરામર્શ કરો.",
        "This section is private": "આ વિભાગ ખાનગી છે",
        "Timezones spread": "ટાઈમઝોનનો વ્યાપ",
        "Tip": "સૂચન",
        "Title": "શીર્ષક",
        "Tree completeness": "કુટુંબ વૃક્ષની પૂર્ણતા",
        "Update": "અપડેટ કરો",
        "Update their": "તેમનું અપડેટ કરો",
        "Value (type or tap 🎤)": "કિંમત (ટાઇપ કરો અથવા 🎤 પર ટેપ કરો)",
        "Visual Family Tree": "જુઓ યોગ્ય કુટુંબ વૃક્ષ",
        "Voice language": "વાણીની ભાષા",
        "What's missing": "શું ખૂટે છે",
        "Where Your Family Lives — Across the World": "તમારું કુટુંબ ક્યાં રહે છે — આખી દુનિયામાં",
        "are provided in the section below —": "નીચેના વિભાગમાં આપવામાં આવ્યા છે —",
        "bank locker": "બેન્ક લોકર",
        "can be preserved in this section. The documents associated with these important information are required to be preserved at a different location, which is a special privilege of our": "આ વિભાગમાં સુરક્ષિત રીતે સાચવી શકાય છે. આ મહત્વપૂર્ણ માહિતી સંબંધિત દસ્તાવેજો અલગ સ્થળે સાચવવાના જરૂરી છે, જે અમારા",
        "complete. Tick off the items below to grow it further.": "પૂર્ણ છે. તેને વધુ વિકસાવવા નીચેની વસ્તુઓમાં ટીક કરો.",
        "customers.": "ગ્રાહકો માટેનું વિશેષ સુલભ સુવિધા છે.",
        "descriptive information": "વર્ણનાત્મક માહિતી",
        "e.g. Dadu's Birthday": "ઉદાહરણ તરીકે, દાદુનો જન્મદિવસ",
        "family-only visibility · Family Head controls writing · explicit informed consent · encrypted storage · full audit trail of every change · DPDP Act 2023 aligned. Coming next: disease timeline, maternal/paternal branch views & emergency health card.": "માત્ર કુટુંબ માટે દેખાય તેવી સુવિધા · લેખનનું નિયંત્રણ કુટુંબમુખિયાને · સ્પષ્ટ અને માહિતગાર સંમતિ · એન્ક્રિપ્ટેડ સંગ્રહ · દરેક બદલાવનો સંપૂર્ણ ઓડિટ રેકોર્ડ · DPDP Act 2023 મુજબ. આગળ આવતું: રોગ ઇતિહાસનો સમયગાળો, માતૃક/પિતૃક શાખાના દૃશ્યો અને ઇમરજન્સી હેલ્થ કાર્ડ.",
        "on the profile page, and they'll appear on the map instantly.": "પ્રોફાઇલ પેજ પર, અને તે તરત જ નકશામાં દેખાશે.",
        "or": "અથવા",
        "plans — preserve multi-generation medical history, hereditary conditions, allergies, vaccinations and more.": "પ્લાન્સ — અનેક પેઢીઓનો તબીબી ઇતિહાસ, વંશાનુગત બીમારીઓ, એલર્જી, રસીકરણ અને વધુને સાચવો.",
        "please note that you are preserving very important and vital information. Please make sure you save important information only if you want to preserve it on this platform in a highly secured manner by using a proper password. All the documents here are preserved as if they are kept in a": "કૃપા કરીને નોંધ કરો કે તમે અત્યંત મહત્વપૂર્ણ અને અનિવાર્ય માહિતી સાચવી રહ્યા છો. કૃપા કરીને ખાતરી કરો કે તમે આવી મહત્વની માહિતી ત્યારે જ સાચવો જ્યારે તમે તેને આ પ્લેટફોર્મ પર યોગ્ય પાસવર્ડથી ખૂબ સુરક્ષિત રીતે રાખવા ઇચ્છો. અહીંના બધા દસ્તાવેજો એવી રીતે સાચવવામાં આવે છે જેમ કે તેઓ એક",
        "step relations, adopted relations, close relatives and extended relatives": "સાવકા સંબંધ, દત્તક લીધેલા સંબંધ, નજીકના સગા અને દૂરના સગા",
        "these will not appear on your pictorial family tree view.": "આ તમારા ચિત્રાત્મક કુટુંબ વૃક્ષના દર્શનમાં દેખાશે નહીં.",
        "© 2026 Digital Family Tree. All rights reserved.": "© 2026 Digital Family Tree. સર્વ હકો સુરક્ષિત.",
        "21 sections of guided wisdom — the values, lessons and stories you want to pass down.": "માર્ગદર્શિત જ્ઞાનના 21 વિભાગો — તે મૂલ્યો, પાઠો અને વાર્તાઓ જેને તમે આવનારી પેઢીઓને આપવાના ઈચ્છો છો.",
        "AI-POWERED": "AI-POWERED",
        "Aadhaar, property papers, wills and certificates — stored privately and shared only with the people you choose.": "આધાર, મિલકતના કાગળો, વસીયત અને સર્ટિફિકેટ — ખાનગી રીતે સંગ્રહિત, અને ફક્ત તમે પસંદ કરેલા લોકોને જ શેર થાય છે.",
        "Achievements Wall": "સફળતાઓની દિવાલ",
        "Ask anything about your family — heritage, relationships, memories — and get instant AI answers.": "તમારા પરિવાર વિશે કંઈપણ પૂછો — વારસો, સંબંધો, યાદો — અને તરત જ AI જવાબ મેળવો.",
        "Audio Memories (Voice Stories)": "ઑડિયો યાદો (આવાજની વાર્તાઓ)",
        "Begin your family tree journey": "તમારા પરિવાર વૃક્ષની સફર શરૂ કરો",
        "Birthdays, anniversaries and festivals happening for your family today — one tap to wish.": "આજે તમારા પરિવારનાં જન્મદિવસ, વર્ષગાંઠ અને તહેવાર — શુભેચ્છા મોકલવા માટે એક જ ટૅપ.",
        "Blood groups, allergies, chronic conditions and emergency contacts — accessible when it matters most.": "બ્લડ ગ્રુપ, એલર્જી, દીર્ઘકાળીન બીમારીઓ અને ઇમરજન્સી સંપર્ક — જ્યારે સૌથી વધુ જરૂર હોય ત્યારે તરત ઉપલબ્ધ.",
        "Bring parents, siblings and cousins into your private family space — everyone adds their memories, and the tree grows together.": "માતા-પિતા, ભાઈ-બહેનો અને કઝિન્સને તમારા ખાનગી પરિવાર સ્પેસમાં આમંત્રો — દરેક પોતપોતાની યાદો ઉમેરે, અને પરિવાર વૃક્ષ સાથે મળી વધી રહ્યું હોય.",
        "CULTURE & TRADITIONS": "સંસ્કૃતિ અને પરંપરાઓ",
        "Capture a memory in your own voice. We'll transcribe, translate and preserve it for future generations.": "તમારી પોતાની અવાજમાં કોઈ યાદને કેદ કરો. અમે તેને લખીશું, ભાષાંતર કરીશું અને આવનારી પેઢીઓ માટે જાળવી રાખીશું.",
        "Celebrate doctors, engineers, artists and every achiever in your family — a wall of pride for generations to see.": "તમારા પરિવારના ડોક્ટર, ઇજનેર, કલાકાર અને દરેક સફળ વ્યક્તિને ઉજવો — પેઢીઓ સુધી ગૌરવ અનુભવાય એવી દિવાલ.",
        "Choose the package that fits your family — upgrade anytime, and unlock more features as your legacy grows.": "તમારા પરિવારને યોગ્ય એવું પેકેજ પસંદ કરો — ક્યારે પણ અપગ્રેડ કરો, અને જેમ જેમ તમારો વારસો વધે તેમ વધુ સુવિધાઓ ખોલો.",
        "Complete legacy suite with AI tools": "AI સાધનો સાથે સંપૂર્ણ વારસા સુઇટ",
        "Connections": "સંબંધો",
        "Culture & Rituals Archive": "સંસ્કૃતિ અને વિધિઓનો સંચય",
        "Demo Coming Soon": "ડેમો ટૂંક સમયમાં આવી રહ્યું છે",
        "Demo pricing — final packages will be announced soon. Selection is saved to your account.": "ડેમો પ્રાઇસિંગ — અંતિમ પેકેજો ટૂંક સમયમાં જાહેર થશે. તમારો પસંદ કરેલો વિકલ્પ તમારા એકાઉન્ટમાં સંગ્રહિત રહેશે.",
        "Digital Family Tree (Print-ready)": "ડિજિટલ પરિવાર વૃક્ષ (છાપવા માટે તૈયાર)",
        "EMERGENCY INFO": "આકસ્મિક માહિતી",
        "EVENTS & DATES": "ઘટનાઓ અને તારીખો",
        "Events & Reminders": "પ્રવિર્તિઓ અને યાદીપત્રો",
        "Every family member at a glance — search, filter and open any profile in one tap.": "દરેક પરિવાર સભ્યને એક નજરમાં જુઓ — શોધો, ગાળી કરો અને ફક્ત એક ટૅપથી કોઈ પણ પ્રોફાઇલ ખોલો.",
        "Every milestone across generations — arranged as one continuous, beautiful story.": "પેઢી દર પેઢીના દરેક મહત્વના પ્રસંગને — એક સતત, સુંદર વાર્તા તરીકે ગોઠવાયેલું.",
        "Every new member, photo, story and record — see everything happening in your family, as it happens.": "દરેક નવા સભ્ય, ફોટો, વાત અને રેકોર્ડ — તમારા પરિવારમાં શું શું થઈ રહ્યું છે તે બધું, જેમજેમ થાય તેમ જુઓ.",
        "Every photo, voice note and story preserved forever — safely inside your family vault.": "દરેક ફોટો, અવાજ નોંધ અને વાર્તા હંમેશ માટે જાળવેલી — સુરક્ષિત રીતે તમારા પરિવાર વોલ્ટમાં.",
        "Everything, forever — one payment": "બધું, હંમેશ માટે — એક જ ચુકવણી",
        "Expert Biography Writing": "નિષ્ણાત જીવનવૃત્ત લેખન",
        "Export everything you've saved — members, stories, memories, records — in the format that suits you. Your data is always yours.": "તમે સાચવી રાખેલું બધું — સભ્યો, વાર્તાઓ, યાદો, રેકોર્ડ — તમારી સુવિધા મુજબના સ્વરૂપમાં નિકાસ કરો. તમારો ડેટા હંમેશા તમારો જ રહેશે.",
        "FAMILY STATISTICS": "પરિવારની આંકડાકીય માહિતી",
        "FAMILY TIMELINE": "પરિવાર સમયરેખા",
        "FAMILY WORLD MAP": "પરિવાર વિશ્વ નકશો",
        "Family Activity": "પરિવાર પ્રવૃત્તિ",
        "Family Calendar & Celebrations": "પરિવાર કેલેન્ડર અને ઉજવણીઓ",
        "Family Pride": "પરિવાર ગૌરવ",
        "Family Records": "પરિવારના રેકોર્ડ્સ",
        "Family Tree Builder (6 generations)": "પરિવાર વૃક્ષ નિર્માતા (6 પેઢીઓ)",
        "Family World Map": "પરિવાર વિશ્વ નકશો",
        "Gold": "ગોલ્ડ",
        "HEALTH & EMERGENCY": "HEALTH & EMERGENCY",
        "HEALTH REPOSITORY": "હેલ્થ રિપોઝિટરી",
        "Health & Medical Repository (10 registers)": "હેલ્થ અને મેડિકલ રિપોઝિટરી (10 રજિસ્ટર)",
        "How large is your family across generations? Longevity, geography, professions and more.": "તમારો પરિવાર પેઢીઓમાં મળીને કેટલો મોટો છે? આયુષ્ય, ભૌગોલિક વિસ્તારો, વ્યવસાયો અને ઘણું વધુ.",
        "Keep every family member's blood group in one secure place. In an emergency, every second counts — this registry helps you instantly find the right donor within your family.": "દરેક પરિવારજના બ્લડ ગ્રુપને એક જ સુરક્ષિત જગ્યાએ રાખો. ઈમરજન્સીમાં દરેક સેકન્ડ મહત્વનો છે — આ રજિસ્ટ્રી તમને તમારા જ પરિવારમાંથી તરત યોગ્ય ડોનર શોધવામાં મદદ કરે છે.",
        "LEGACY & MEMORIAL": "લેગસી અને સ્મૃતિ સ્મારક",
        "LEGAL & LEGACY": "લીગલ અને લેગસી",
        "Legacy Lifetime": "લેગસી લાઇફટાઇમ",
        "Legal Vault (Will & Nominee)": "લીગલ વોલ્ટ (વસીયત અને નોમિની)",
        "Let AI compose a heartfelt narrative of your family's journey from the profiles you've filled.": "તમે ભરીેલા પ્રોફાઇલ પરથી તમારા પરિવરની સફરની હૃદયસ્પર્શી વાર્તા AI દ્વારા લખાવાવો.",
        "MEMORIES & STORIES": "યાદો અને વાર્તાઓ",
        "Marriage Records": "લગ્નના રેકોર્ડ",
        "Member Profiles & Photos": "સભ્યોના પ્રોફાઇલ અને ફોટા",
        "Memories & reminders for the whole family": "સંપૂર્ણ પરિવારો માટે યાદો અને રીમાઇન્ડર",
        "Multi-user Family Access (Invites)": "મલ્ટી-યુઝર ફેમિલી એક્સેસ (આમંત્રણો)",
        "Never miss a birthday, anniversary or festival — smart reminders from your family tree, delivered by email, push and in-app.": "ક્યારેય જન્મદિવસ, ઍનિવર્સરી અથવા તહેવાર ભૂલશો નહીં — તમારા ફેમિલી ટ્રીમાંથી સ્માર્ટ રીમાઇન્ડર ઈમેઈલ, પુષ અને ઇન-ઍપ દ્વારા મળશે.",
        "One place for every birthday, anniversary, shraddha and cultural festival — with smart nudges.": "દરેક જન્મદિવસ, ઍનિવર્સરી, શ્રદ્ધાંજલિ પ્રસંગ અને સાંસ્કૃતિક તહેવાર માટે એક જ જગ્યાએ — સ્માર્ટ યાદ અપાવણીઓ સાથે.",
        "Personal Vault": "પર્સનલ વોલ્ટ",
        "Prescriptions, reports and hospital records for every family member — organized and searchable.": "દરેક પરિવારજના પ્રિસ્ક્રિપ્શન, રિપોર્ટ્સ અને હોસ્પિટલ રેકોર્ડ — ગોઠવેલા અને સરળતાથી શોધી શકાય તેવા.",
        "Preserve wedding dates, venues and couple details — anniversaries flow automatically into your family calendar and timeline.": "લગ્નની તારીખો, સ્થળો અને દંપતીની વિગતો નોંધાઈ રાખો — ઍનિવર્સરીઓ આપમેળે તમારા ફેમિલી કેલેન્ડર અને ટાઇમલાઇનમાં ઉમેરાતી રહેશે.",
        "Priority Support": "પ્રાથમિક સહાય",
        "Rituals, recipes, dialects and heritage — everything that makes your family uniquely yours.": "વિધિઓ, વાનગીઓ, બોલીઓ અને વારસા — બધી જ એવી વસ્તુઓ જે તમારા પરિવારને અનોખો બનાવે છે.",
        "SHARE & CELEBRATE": "શેર કરો અને ઉજવો",
        "Seal messages, photos and videos to open on future birthdays, anniversaries or a chosen date.": "સંદેશાઓ, ફોટા અને વિડિઓને સીલ કરીને રાખો, જેથી તેઓ આગલા જન્મદિવસ, વર્ષગાંઠ અથવા પસંદ કરેલી તારીખે ખોલી શકાય.",
        "See every family member on a real world map. Each pin shows a current location (orange) and a native place (green), connected by a dotted line — a beautiful visual of your family's journey through geography.": "વાસ્તવિક નકશા પર દરેક પરિવાર સભ્યને જુઓ. દરેક પિન હાલનું સ્થાન (નારંગી) અને મૂળ વતન (લીલું) બતાવે છે, જે તૂટેલી લાઇનથી જોડાયેલા હોય છે — તમારા પરિવારની ભૂગોળમય સફરનું સુંદર દર્શન.",
        "Share the gift of legacy — invite friends to build their own private family tree, free to start.": "વારસાની ભેટ વહેંચો — મિત્રો ને આમંત્રિત કરો કે તેઓ પોતાનું ખાનગી ફેમિલી ટ્રી બનાવે, શરૂઆત સંપૂર્ણપણે મફત.",
        "Silver": "સિલ્વર",
        "Smart Reminders (Email + Push)": "સ્માર્ટ રીમાઈન્ડર્સ (Email + Push)",
        "Starter": "સ્ટાર્ટર",
        "TIME CAPSULES": "સમય કેપ્સ્યુલ્સ",
        "TODAY'S CELEBRATIONS": "આજની ઉજવણીઓ",
        "Turn your family tree into a beautiful shareable poster — perfect for wedding invites, festivals and print.": "તમારા ફેમિલી ટ્રીને એક સુંદર, શેર કરી શકાય તેવી પોસ્ટરમાં બદલો — લગ્ન આમંત્રણ, તહેવારો અને પ્રિન્ટ માટે એકદમ યોગ્ય.",
        "VOICE & STORIES": "આવાજ અને વાર્તાઓ",
        "Watch Demo": "ડેમો જુઓ",
        "Wills, power-of-attorney, property papers and nominee details — locked and always accessible to the right people.": "વસીયતો, પાવર-ઑફ-અટર્ની, મિલકતના દસ્તાવેજો અને નામાંકિત વ્યક્તિની વિગતો — સુરક્ષિત લોકમાં અને હંમેશા યોગ્ય લોકો માટે ઉપલબ્ધ.",
        "Your data, your rules — manage account preferences, visibility and every privacy declaration in one place.": "તમારું ડેટા, તમારા નિયમો — એક જ જગ્યાએ એકાઉન્ટ પસંદગીઓ, દેખાવ (વિઝિબિલિટી) અને દરેક પ્રાઈવસી ડીક્લેરેશન સંભાળો.",
        "one-time · lifetime": "એક વખત · આખું જીવન",
        "per month": "દર મહિને",
        "per year": "દર વર્ષે",
        "January": "જાન્યુઆરી",
        "February": "ફેબ્રુઆરી",
        "March": "માર્ચ",
        "April": "એપ્રિલ",
        "May": "મે",
        "June": "જૂન",
        "July": "જુલાઈ",
        "August": "ઓગસ્ટ",
        "September": "સપ્ટેમ્બર",
        "October": "ઓક્ટોબર",
        "November": "નવેમ્બર",
        "December": "ડિસેમ્બર",
        "is locked": "તાળાબંધ છે",
        "Your current package": "તમારું હાલનું પેકેજ",
        "doesn't include this feature.": "આ સુવિધા શામેલ નથી.",
        "Included in": "આમાં શામેલ",
        "one-time": "એક વખત",
        "year": "વર્ષ",
        "month": "મહિનો",
        "lifetime": "આજીવન",
        "Go Back": "પાછા જાઓ",
        "View Packages": "પેકેજ જુઓ",
        "This feature": "આ સુવિધા",
        "Family Legacy Dashboard": "ફેમિલી લેગેસી ડેશબોર્ડ",
        "Legacy Services": "લેગેસી સેવાઓ",
        "Life Story Vault": "જીવનકથા ભંડાર",
        "Video Testament Library": "વિડિયો વસીયત લાયબ્રેરી",
        "Family Wisdom Bank": "કુટુંબ જ્ઞાન બેંક",
        "Failure Stories Archive": "અસફળતાની કથાઓ સંગ્રહ",
        "Success Stories": "સફળતાની કથાઓ",
        "Family Decision History": "કુટુંબના નિર્ણયોનો ઈતિહાસ",
        "Family Values Repository": "કુટુંબ મૂલ્યો ભંડાર",
        "Family Hero Gallery": "પરિવારના હીરો ગેલેરી",
        "Unsung Heroes": "અનગાતા હીરો",
        "Gratitude Wall": "કૃતજ્નતા દિવાલ",
        "Tribute Pages": "શ્રદ્ધાંજલિ પૃષ્ઠો",
        "Love Letters Archive": "પ્રેમ પત્રો સંગ્રહ",
        "Childhood Stories Bank": "બાળપણની કથાઓ બેંક",
        "Language Preservation": "ભાષા સંરક્ષણ",
        "Ancestral Village": "પૂર્વજનું ગામ",
        "Surname History": "અટકનો ઈતિહાસ",
        "Family Emblem": "પરિવારનો પ્રતીક",
        "Cultural Artifacts": "સાંસ્કૃતિક વારસાની વસ્તુઓ",
        "Family Songs & Bhajans": "પરિવારના ગીતો અને ભજનો",
        "Oral History Center": "મૌખિક ઇતિહાસ કેન્દ્ર",
        "Biography Writing Platform": "જીવનવૃત્ત લેખન પ્લેટફોર્મ",
        "Memoir Writing Service": "સ્મૃતિલેખ લખાવવાની સેવા",
        "Personalised Gifting Service": "વ્યક્તિગત ભેટ આપવાની સેવા",
        "Personal Digital Identity Platform": "વ્યક્તિગત ડિજિટલ ઓળખ પ્લેટફોર્મ",
        "Add to": "ઉમેરો",
        "Choose": "પસંદ કરો",
        "Compare all packages": "બધી પેકેજોની તુલના કરો",
        "Demo pricing — packages, prices and the feature split are all editable from the admin panel.": "ડેમો પ્રાઇસિંગ — પેકેજો, કિંમતો અને ફીચર વિતરણ બધું એડમિન પેનલમાંથી બદલી શકાય છે.",
        "Feature": "ફીચર",
        "Five packages, one family legacy": "પાંચ પેકેજ, એક કુટુંબ વારસો",
        "Free": "મફત",
        "Life story, wisdom and biography now live in Family Legacy Dashboard": "જીવનકથા, જીવન અનુભવ અને જીવનચરિત્ર હવે Family Legacy Dashboard માં સંગ્રહિત છે",
        "Open Family Legacy Dashboard": "Family Legacy Dashboard ખોલો",
        "Packages & Pricing": "પેકેજો અને પ્રાઈસિંગ",
        "Packages temporarily unavailable. Please try again shortly.": "પેકેજો હાલ થોડા સમય માટે ઉપલબ્ધ નથી. કૃપા કરીને થોડા સમયે ફરી પ્રયાસ કરો.",
        "Start Free": "મફતમાં શરૂ કરો",
        "Start free, upgrade whenever your family is ready. Every feature below is compared side by side so nothing is hidden.": "મફતમાં શરૂ કરો, જ્યારે તમારા પરિવાર માટે યોગ્ય લાગે ત્યારે અપગ્રેડ કરો. નીચેના દરેક ફીચરની બાજુ-બાજુ તુલના દેખાય છે જેથી કંઈપણ છુપાયેલું ન રહે.",
        "Swipe sideways on a phone — the feature column stays in place.": "ફોન પર બાજુ તરફ સ્વાઇપ કરો — ફીચર વાળો કૉલમ એ જ જગ્યાએ રહેશે.",
        "more features": "વધુ ફીચરો",
        "Namaste": "નમસ્તે",
        "{sender} has added you to our family tree on Family Repository.": "{sender} એ તમને Family Repository પર અમારા પરિવાર વૃક્ષમાં ઉમેર્યા છે.",
        "Tap to join": "જોડાવવા માટે ટૅપ કરો",
        "Your invite code": "તમારો આમંત્રણ કોડ",
        "Together we will preserve our family's stories, photos and voices for the next generations.": "સાથે મળીને આપણે આપણા પરિવારની કહાણીઓ, ફોટાઓ અને અવાજોને આવતી પેઢીઓ માટે સાચવીશું.",
        "Your family": "તમારો પરિવાર",
        "Invite on WhatsApp": "WhatsApp પર આમંત્રણ મોકલો",
        "WhatsApp opened with the invite message.": "આમંત્રણ સંદેશ સાથે WhatsApp ખુલ્યું છે.",
    },
    te: {
        "Home": "మొదటి పేజి",
        "Family": "కుటుంబం",
        "Family Tree": "కుటుంబ వృక్షం",
        "Add a Member": "ఒక సభ్యుడిని చేర్చండి",
        "Invite Family": "కుటుంబాన్ని ఆహ్వానించండి",
        "Family Hub · All": "ఫ్యామిలీ హబ్ · అన్నీ",
        "Family Timeline": "కుటుంబ కాలరేఖ",
        "Family Calendar": "కుటుంబ క్యాలెండర్",
        "Services": "సేవలు",
        "Photo Memories": "ఫోటో జ్ఞాపకాలు",
        "Audio Memories": "ఆడియో జ్ఞాపకాలు",
        "AI Family Advisor": "AI ఫ్యామిలీ సలహాదారు",
        "AI Story Generator": "AI కథల సృష్టికర్త",
        "Video Memories": "వీడియో జ్ఞాపకాలు",
        "Digital Family Tree": "డిజిటల్ కుటుంబ వృక్షం",
        "Family Hall of Fame": "కుటుంబ గౌరవ ఫలకం",
        "Family Hub · All Services": "ఫ్యామిలీ హబ్ · అన్ని సేవలు",
        "Records": "రికార్డులు",
        "Blood Group Registry": "రక్తగుంపు నమోదు",
        "Health Repository": "ఆరోగ్య భాండాగారం",
        "Health Score Compliance": "ఆరోగ్య స్కోర్ అనుసరణ",
        "Emergency Contacts": "అత్యవసర సంప్రదింపులు",
        "Business Directory": "వ్యాపార డైరెక్టరీ",
        "Recipe Vault": "వంట రచనల నిల్వ",
        "Family Statistics": "కుటుంబ గణాంకాలు",
        "Legacy": "వారసత్వం",
        "Legal Vault": "న్యాయ పత్రాల నిల్వ",
        "Document Vault": "పత్రాల నిల్వ",
        "Story & Wisdom Vault": "కథలు & జ్ఞాన నిల్వ",
        "Family Constitution": "కుటుంబ రాజ్యాంగం",
        "Futuristic Legacy Letter": "భవిష్యత్ వారసత్వ లేఖ",
        "Digital Memorial": "డిజిటల్ స్మారకం",
        "Account": "ఖాతా",
        "Packages & Plans": "ప్యాకేజీలు & ప్లాన్‌లు",
        "Privacy & Settings": "గోప్యత & సెట్టింగ్‌లు",
        "Download & Export": "డౌన్‌లోడ్ & ఎగుమతి",
        "Profile": "ప్రొఫైల్",
        "Search family…": "కుటుంబాన్ని వెతకండి…",
        "Dashboard": "డాష్‌బోర్డ్",
        "Families": "కుటుంబాలు",
        "Users": "వినియోగదారులు",
        "Subscriptions": "చందాలు",
        "Packages": "ప్యాకేజీలు",
        "Exports": "ఎగుమతులు",
        "Content": "కంటెంట్",
        "Landing Slides": "ల్యాండింగ్ స్లైడ్లు",
        "Site Assets": "సైట్ ఆస్తులు",
        "Family Content": "కుటుంబ కంటెంట్",
        "Translations": "అనువాదాలు",
        "User Page Editor": "వినియోగదారు పేజీ ఎడిటర్",
        "Analytics": "విశ్లేషణలు",
        "Support Tickets": "సపోర్ట్ టికెట్లు",
        "Broadcasts": "ప్రసారాలు",
        "Legacy CRM": "పాత CRM",
        "SMS Console": "SMS కన్సోల్",
        "Security": "భద్రత",
        "Settings": "సెట్టింగ్‌లు",
        "UI/UX Audit": "UI/UX ఆడిట్",
        "API Keys": "API కీలు",
        "Admin Team": "అడ్మిన్ బృందం",
        "Content Managers": "కంటెంట్ మేనేజర్లు",
        "Overview": "సారాంశం",
        "Members": "సభ్యులు",
        "Billing": "బిల్లింగ్",
        "Landing & Content": "ల్యాండింగ్ & కంటెంట్",
        "Insights": "అవలోకనాలు",
        "Support": "సహాయం",
        "System": "వ్యవస్థ",
        "Super Admin": "సూపర్ అడ్మిన్",
        "Content Admin": "కంటెంట్ అడ్మిన్",
        "Content Manager": "కంటెంట్ మేనేజర్",
        "Finance Admin": "ఫైనాన్స్ అడ్మిన్",
        "Support Admin": "సపోర్ట్ అడ్మిన్",
        "Security Admin": "సెక్యూరిటీ అడ్మిన్",
        "Admin": "అడ్మిన్",
        "Admin Panel": "అడ్మిన్ ప్యానెల్",
        "Logout": "లాగ్ అవుట్",
        "Loading dashboard…": "డ్యాష్‌బోర్డ్ లోడ్ అవుతోంది…",
        "Platform overview at a glance.": "వేదిక యొక్క సమగ్ర దృశ్యం ఒక చూపులో.",
        "Total Families": "మొత్తం కుటుంబాలు",
        "Total Members": "మొత్తం సభ్యులు",
        "Tree Persons": "వంశవృక్షంలోని వ్యక్తులు",
        "Storage Used": "ఉപయోగించిన స్టోరేజ్",
        "Marriages": "వివాహాలు",
        "Memory Albums": "స్మృతి ఆల్బమ్‌లు",
        "Wills (latest)": "ఇచ్చిన విల్‌లు (తాజా)",
        "Audio Wills": "ఆడియో విల్‌లు",
        "With recorded audio": "రికార్డు చేసిన ఆడియోతో",
        "Across all families": "అన్ని కుటుంబాల్లో కలిపి",
        "New signups — last 30 days": "కొత్త సైన్‌అప్స్ — గత 30 రోజుల్లో",
        "Storage breakdown": "స్టోరేజ్ వివరాలు",
        "No stored files yet.": "ఇంకా ఏ ఫైళ్లు భద్రపరచలేదు.",
        "Signups": "సైన్‌అప్స్",
        "suspended": "తాత్కాలికంగా నిలిపివేశారు",
        "blocked": "నిరోధించారు",
        "paid": "చెల్లించిన",
        "open tickets": "తెరిచి ఉన్న టికెట్లు",
        "Memory photos": "స్మృతి ఫోటోలు",
        "Vault documents": "వాల్ట్ పత్రాలు",
        "Story audio": "కథ ఆడియో",
        "Member profiles & photos": "సభ్యుల వివరాలు & ఫోటోలు",
        "Profile details": "ప్రొఫైల్ వివరాలు",
        "Story metadata": "కథకు సంబంధించిన మెటాడేటా",
        "Memory metadata": "జ్ఞాపకానికి సంబంధించిన మెటాడేటా",
        "Document metadata": "పత్రానికి సంబంధించిన మెటాడేటా",
        "Admin (Head)": "అడ్మిన్ (ముఖ్యులు)",
        "added": "చేర్చారు",
        "updated": "నవీకరించారు",
        "removed": "తొలగించారు",
        "changed privacy of": "గోప్యతను మార్చారు",
        "updated profile of": "ప్రొఫైల్‌ను నవీకరించారు",
        "viewed profile of": "ప్రొఫైల్‌ను చూశారు",
        "recorded": "రికార్డు చేశారు",
        "played": "ప్లే చేశారు",
        "deleted story": "కథను తొలగించారు",
        "uploaded": "అప్‌లోడ్ చేశారు",
        "viewed": "చూశారు",
        "changed access of": "యాక్సెస్‌ను మార్చారు",
        "deleted": "తొలగించారు",
        "invited": "ఆహ్వానించారు",
        "revoked an invite": "ఆహ్వానాన్ని రద్దు చేశారు",
        "joined the family": "కుటుంబంలో చేరారు",
        "changed role of": "వారి పాత్రను మార్చారు",
        "downloaded their data": "వారి డేటాను డౌన్‌లోడ్ చేశారు",
        "completed privacy setup": "గోప్యత అమరికలను పూర్తి చేశారు",
        "deleted account of": "ఖాతాను తొలగించారు",
        "Senior mode on — simpler privacy choices.": "సీనియర్ మోడ్ ఆన్ — సులభమైన గోప్యత ఎంపికలు.",
        "Senior mode off.": "సీనియర్ మోడ్ ఆఫ్.",
        "Saved.": "భద్రపరచబడింది.",
        "Your data export has been downloaded.": "మీ డేటా ఎగుమతి డౌన్‌లోడ్ చేయబడింది.",
        "Your account and data have been deleted.": "మీ ఖాతా మరియు డేటా తొలగించబడింది.",
        "Every family tree on the platform. Suspending blocks all its members from logging in.": "వేదికపై ఉన్న ప్రతి కుటుంబ వృక్షం. దాన్ని నిలిపివేస్తే, అందులోని సభ్యులందరూ లాగిన్ కాకుండా ఆటోమేటిక్‌గా నిలిపివేయబడతారు.",
        "All registered members. Blocked users cannot log in or use the API.": "అన్ని నమోదు చేసిన సభ్యులు. బ్లాక్ చేసిన వినియోగదారులు లాగిన్ కావడం లేదా API ఉపయోగించడం చేయలేరు.",
        "Manual plan control until a payment gateway is connected in Settings.": "సెట్టింగ్స్‌లో పేమెంట్ గేట్‌వే కనెక్ట్ చేసే వరకు ప్లాన్‌ను మాన్యువల్‌గా నియంత్రించండి.",
        "Growth, engagement and audience mix.": "వృద్ధి, భాగస్వామ్యం మరియు ప్రేక్షకుల మిశ్రమం.",
        "Users raise tickets from Settings → Help in the app.": "యాప్‌లో సెట్టింగ్స్ → Help ద్వారా వినియోగదారులు టికెట్లు పంపిస్తారు.",
        "Branding, payment gateway and API keys. Secrets are stored server-side and shown masked.": "బ్రాండింగ్, పేమెంట్ గేట్‌వే మరియు API keys. సీక్రెట్లు సర్వర్ సైడ్‌లో భద్రపరచబడి, దాచిన రూపంలో మాత్రమే చూపబడతాయి.",
        "Packages — Feature Matrix (Demo)": "ప్యాకేజీలు — ఫీచర్ మ్యాట్రిక్స్ (డెమో)",
        "Export Center": "ఎక్స్‌పోర్ట్ సెంటర్",
        "Download authoritative reports in CSV, Excel or PDF. Schedule auto-email exports below.": "అధికారిక రిపోర్టులను CSV, Excel లేదా PDF రూపంలో డౌన్‌లోడ్ చేసుకోండి. క్రింద ఆటో-ఈమెయిల్ ఎక్స్‌పోర్ట్‌లను షెడ్యూల్ చేయండి.",
        "Send SMS or WhatsApp announcements to your users.": "మీ వినియోగదారులకు SMS లేదా WhatsApp ద్వారా ప్రకటనలు పంపండి.",
        "Content Management": "కంటెంట్ మేనేజ్‌మెంట్",
        "Poster templates, landing banners and testimonials curated by the super-admin.": "సూపర్ అడ్మిన్ ఎంపిక చేసిన పోస్టర్ టెంప్లేట్‌లు, ల్యాండింగ్ బ్యానర్‌లు మరియు టెస్టిమోనియల్స్.",
        "Platform-wide audit trail, failed logins, DPDP compliance requests, and your MFA credentials.": "మొత్తం వేదికకు సంబంధించిన ఆడిట్ ట్రెయిల్, విఫలమైన లాగిన్‌లు, DPDP కంప్లయన్స్ అభ్యర్థనలు మరియు మీ MFA క్రెడెన్షియల్స్.",
        "Manage who can sign into the admin panel and what they can access.": "ఎవరు అడ్మిన్ ప్యానెల్‌లోకి సైన్ ఇన్ కావాలి, వారు ఏమి యాక్సెస్ చేయగలరో మీరు నిర్వహించండి.",
        "Family Content Moderation": "కుటుంబ కంటెంట్ మోడరేషన్",
        "Listen": "వినండి",
        "Stop": "ఆపండి",
        "Pause": "విరామం",
        "Resume": "మళ్లీ ప్రారంభించండి",
        "Generating…": "సృష్టిస్తున్నాము…",
        "Signup trend — last 90 days": "గత 90 రోజుల సైన్‌అప్ ప్రవణత",
        "(or user) is expected to add all their family relationships on the": "(లేదా వినియోగదారు) తమ కుటుంబంలోని అన్ని బంధాలను జోడించాల్సిన పేజీ",
        ", which can only be opened by your password.": ", దీనిని మీ పాస్‌వర్డ్‌తో మాత్రమే తెరవగలరు.",
        ". Any member added there is automatically reflected here. For convenience, a few extra fields for": ". అక్కడ జోడించిన ఏ సభ్యుడైనా స్వయంగా ఇక్కడ కనిపిస్తారు. సౌలభ్యం కోసం, కొంత అదనపు సమాచారం కోసం",
        "A family together": "ఒకటిగా ఉన్న కుటుంబం",
        "A premium feature for your family's future": "మీ కుటుంబ భవిష్యత్తు కోసం ప్రీమియమ్ సౌకర్యం",
        "Add": "జోడించండి",
        "Add Event": "ఈవెంట్ జోడించండి",
        "Add custom field": "కస్టమ్ ఫీల్డ్ జోడించండి",
        "All checks": "అన్ని నిర్ధారణలు",
        "Avg age": "సగటు వయస్సు",
        "Back": "వెనక్కి",
        "Back to Dashboard": "డ్యాష్‌బోర్డ్‌కి తిరిగి వెళ్ళండి",
        "Change photo": "ఫోటో మార్చండి",
        "Choose the package that fits your family": "మీ కుటుంబానికి సరిపోయే ప్యాకేజీని ఎంచుకోండి",
        "Classic, Premium and Elite": "క్లాసిక్, ప్రీమియమ్ మరియు ఎలైట్",
        "Countries": "దేశాలు",
        "Current": "ప్రస్తుత",
        "Current Location": "ప్రస్తుత స్థానం",
        "Current city": "ప్రస్తుత నగరం",
        "Current locations": "ప్రస్తుత స్థానాలు",
        "Data is encrypted in transit and at rest; every add/edit/delete is captured in the audit log.": "డేటా ప్రయాణంలోనూ, నిల్వలోనూ ఎన్క్రిప్ట్ చేయబడుతుంది; ప్రతి add/edit/delete చర్య ఆడిట్ లాగ్‌లో నమోదవుతుంది.",
        "Date": "తేదీ",
        "Dear customer,": "ఆదరణీయ కస్టమర్ గారికి,",
        "Delete": "తొలగించండి",
        "Distinct Cities": "వేరువేరు నగరాలు",
        "Family (₹999/yr)": "ఫ్యామిలీ (₹999/సంవత్సరం)",
        "Family Head": "కుటుంబ ప్రధానులు",
        "Family Health": "కుటుంబ ఆరోగ్యం",
        "Family Members": "కుటుంబ సభ్యులు",
        "Family Relationships": "కుటుంబ బంధాలు",
        "Favourite mithai": "ఇష్టమైన మిఠాయి",
        "Field name": "ఫీల్డ్ పేరు",
        "Fill with AI": "AI తో నింపండి",
        "GPT-5.2 fills 40+ fields across all 6 modules from your surname + region · you edit before saving.": "GPT-5.2 మీ ఇంటిపేరు + ప్రాంతం ఆధారంగా 6 మాడ్యూల్స్‌లో 40+ ఫీల్డ్స్‌ను నింపుతుంది · సేవ్ చేయడానికి ముందు మీరు మార్పులు చేయవచ్చు.",
        "Gaon ka temple": "గ్రామంలోని దేవాలయం",
        "Generations": "తరాలు",
        "Health & Medical Repository": "ఆరోగ్య & వైద్య సమాచార భాండాగారం",
        "Health Score Compliance Report": "హెల్త్ స్కోర్ కంప్లయెన్స్ రిపోర్ట్",
        "Health information is stored with explicit consent, only for members whose data you are authorised to record.": "ఆరోగ్య సమాచారం స్పష్టమైన అనుమతితో మాత్రమే, మీరు నమోదు చేయడానికి అధికారం ఉన్న సభ్యుల కోసం భద్రపరచబడుతుంది.",
        "Help": "సహాయం",
        "Hide details": "వివరాలను దాచు",
        "How complete is your family tree?": "మీ వంశవృక్షం ఎంత పూర్తిగా ఉంది?",
        "Informed consent — one time, per family": "అవగాహనతో ఇచ్చే సమ్మతి — ఒక్కసారి, ఒక్క కుటుంబానికి",
        "Kind": "రకం",
        "Legacy (₹2999/yr)": "లెగసీ (₹2999/సంవత్సరం)",
        "Linked live from your family tree.": "మీ వంశవృక్షం నుండి ప్రత్యక్షంగా అనుసంధానించబడింది.",
        "Living Cities": "ప్రస్తుతం నివసిస్తున్న నగరాలు",
        "Loading events…": "కార్యక్రమాలను లోడ్ చేస్తున్నాం…",
        "Loading packages…": "ప్యాకేజీలను లోడ్ చేస్తున్నాం…",
        "Loading world map…": "ప్రపంచ పటాన్ని లోడ్ చేస్తున్నాం…",
        "Loading…": "లోడ్ చేస్తున్నాం…",
        "Lucky number": "అదృష్ట సంఖ్య",
        "Member Profile": "సభ్యుని ప్రొఫైల్",
        "Most Popular": "అత్యంత ప్రాచుర్యం పొందినవి",
        "Native": "సొంత ఊరు",
        "Native Place": "సొంత ఊరు",
        "Native Places": "సొంత ఊర్లు",
        "Native places": "సొంత ఊర్లు",
        "None of your family members have a mapped location yet.": "మీ కుటుంబ సభ్యుల్లో ఎవరికీ ఇంకా మ్యాప్‌లో స్థానం ఇవ్వలేదు.",
        "Not a medical diagnosis platform.": "ఇది వైద్య నిర్ధారణ వేదిక కాదు.",
        "Not added yet": "ఇంకా చేర్చలేదు",
        "Notes (optional)": "గమనికలు (ఐచ్చికం)",
        "Place of birth": "జన్మస్థలం",
        "Preserve. Understand. Inform.": "సంరక్షించండి. అర్థం చేసుకోండి. తెలియజేయండి.",
        "Privacy by design:": "నిర్మాణంలో నుంచే గోప్యత:",
        "Records are visible to your family circle only; the Family Head controls who can add or edit.": "రికార్డులు మీ కుటుంబ వలయానికే మాత్రమే కనిపిస్తాయి; ఎవరు చేర్చాలి, సవరించాలి అనే నియంత్రణ కుటుంబ ప్రధానుడి వద్ద ఉంటుంది.",
        "Remove": "తొలగించండి",
        "Reset": "రీసెట్ చేయండి",
        "Save &amp; Continue": "సేవ్ చేసి కొనసాగించండి",
        "Saved ✓": "సేవ్ అయింది ✓",
        "Saving…": "సేవ్ అవుతోంది…",
        "Sensitive details are hidden by default.": "సెట్టింగ్ ప్రకారం సున్నితమైన వివరాలు దాచబడ్డాయి.",
        "Skip the blank page — let AI suggest your family&apos;s heritage": "ఖాళీ పేజీని దాటేయండి — మీ కుటుంబ వారసత్వాన్ని AI సూచించనివ్వండి",
        "Tap to view": "చూడటానికి ట్యాప్ చేయండి",
        "This is a record-keeping repository — not a diagnosis, treatment or medical-advice tool.": "ఇది రికార్డులను నిల్వ చేసుకునే నిల్వ కేంద్రం — ఇది నిర్ధారణ, చికిత్స లేదా వైద్య సలహా ఇచ్చే సాధనం కాదు.",
        "This repository is for private family record-keeping and health-history awareness only — it does not provide diagnosis, treatment, risk prediction or medical advice. Always consult a qualified healthcare provider.": "ఈ నిల్వ కేంద్రం మీ వ్యక్తిగత కుటుంబ రికార్డుల నిర్వహణకు, ఆరోగ్య చరిత్రపై అవగాహన కోసం మాత్రమే — ఇది నిర్ధారణ, చికిత్స, ప్రమాద అంచనా లేదా వైద్య సలహా అందించదు. ఎప్పుడూ అర్హత కలిగిన ఆరోగ్య సేవాదారుని సంప్రదించండి.",
        "This section is private": "ఈ విభాగం వ్యక్తిగతం",
        "Timezones spread": "సమయ మండలాల వ్యాప్తి",
        "Tip": "సూచన",
        "Title": "పదవి/శీర్షిక",
        "Tree completeness": "వంశవృక్షం పూర్తితనం",
        "Update": "అప్డేట్ చేయండి",
        "Update their": "వారి వివరాలు అప్డేట్ చేయండి",
        "Value (type or tap 🎤)": "విలువ (టైప్ చేయండి లేదా 🎤 నొక్కండి)",
        "Visual Family Tree": "చిత్రరూప కుటుంబ వృక్షం",
        "Voice language": "వాయిస్ భాష",
        "What's missing": "ఏం మిగిలి ఉంది",
        "Where Your Family Lives — Across the World": "మీ కుటుంబం ఎక్కడ ఉంది — ప్రపంచవ్యాప్తంగా",
        "are provided in the section below —": "క్రింద ఉన్న విభాగంలో ఇవ్వబడ్డాయి —",
        "bank locker": "బ్యాంకు లాకర్",
        "can be preserved in this section. The documents associated with these important information are required to be preserved at a different location, which is a special privilege of our": "ఈ విభాగంలో భద్రపరచవచ్చు. ఈ ముఖ్యమైన సమాచారానికి సంబంధించిన పత్రాలను వేరే ప్రదేశంలో భద్రపరచాలి; ఇది మా",
        "complete. Tick off the items below to grow it further.": "పూర్తైంది. దాన్ని ఇంకా పెంచడానికి క్రింది అంశాలకు టిక్ పెట్టండి.",
        "customers.": "గ్రాహులకు లభించే ప్రత్యేక సదుపాయం.",
        "descriptive information": "వివరణాత్మక సమాచారం",
        "e.g. Dadu's Birthday": "ఉదా: తాతగారి పుట్టినరోజు",
        "family-only visibility · Family Head controls writing · explicit informed consent · encrypted storage · full audit trail of every change · DPDP Act 2023 aligned. Coming next: disease timeline, maternal/paternal branch views & emergency health card.": "కేవలం కుటుంబ సభ్యులకు మాత్రమే కనిపించేలా · వ్రాయడంపై నియంత్రణ కుటుంబ అధిపతికి · స్పష్టమైన అవగాహనతో ఇచ్చిన సమ్మతి · గూఢీకరించిన నిల్వ (ఎన్క్రిప్టెడ్ స్టోరేజ్) · ప్రతి మార్పుకూ పూర్తి ఆడిట్ ట్రైల్ · DPDP Act 2023 కు అనుగుణంగా. తరువాత రాబోయేవి: వ్యాధి టైమ్‌లైన్, తల్లిదండ్రుల (మాతృ/పితృ) శాఖల వీక్షణ, అత్యవసర ఆరోగ్య కార్డు.",
        "on the profile page, and they'll appear on the map instantly.": "ప్రొఫైల్ పేజీలో, అప్పుడు అవి వెంటనే మ్యాప్‌లో కనిపిస్తాయి.",
        "or": "లేదా",
        "plans — preserve multi-generation medical history, hereditary conditions, allergies, vaccinations and more.": "ప్యాన్‌లు — అనేక తరాల వైద్య చరిత్ర, వారసత్వ వ్యాధులు, అలర్జీలు, టీకాలు మరియు మరిన్ని భద్రపరచండి.",
        "please note that you are preserving very important and vital information. Please make sure you save important information only if you want to preserve it on this platform in a highly secured manner by using a proper password. All the documents here are preserved as if they are kept in a": "దయచేసి గమనించండి, మీరు చాలా ముఖ్యం మరియు అత్యంత సంరక్షణ అవసరమైన సమాచారాన్ని భద్రపరుస్తున్నారు. దాన్ని ఈ ప్లాట్‌ఫారమ్‌లో అత్యంత భద్రంగా ఉంచాలని మీరు నిజంగా అనుకుంటే మాత్రమే, సరైన పాస్‌వర్డ్‌ ఉపయోగించి ఈ ముఖ్యమైన సమాచారాన్ని సేవ్ చేయండి. ఇక్కడ ఉన్న అన్ని పత్రాలు, అవి ఒక",
        "step relations, adopted relations, close relatives and extended relatives": "అత్తిగామలు, దత్తత సంబంధాలు, సన్నిహిత బంధువులు మరియు విస్తృత బంధువులు",
        "these will not appear on your pictorial family tree view.": "ఇవి మీ కుటుంబ వృక్షం చిత్ర రూపంలో చూపించే వీక్షణలో కనిపించవు.",
        "© 2026 Digital Family Tree. All rights reserved.": "© 2026 Digital Family Tree. అన్ని హక్కులు సంక్రమించబడినవి.",
        "21 sections of guided wisdom — the values, lessons and stories you want to pass down.": "మార్గదర్శక జ్ఞానంతో కూడిన 21 విభాగాలు — మీరు తర్వాతి తరాలకు అందించాలనుకునే విలువలు, పాఠాలు, కథలు.",
        "AI-POWERED": "AI-POWERED",
        "Aadhaar, property papers, wills and certificates — stored privately and shared only with the people you choose.": "ఆధార్, ఆస్తి పత్రాలు, విల్‌లు, సర్టిఫికెట్‌లు — భద్రంగా వ్యక్తిగతంగా నిల్వ చేసి, మీరు అనుమతించిన వారికే పంచబడతాయి.",
        "Achievements Wall": "సాధనల గోడ",
        "Ask anything about your family — heritage, relationships, memories — and get instant AI answers.": "మీ కుటుంబం గురించి ఏదైనా అడగండి — వారసత్వం, సంబంధాలు, గుర్తులు — వెంటనే AI సమాధానాలు పొందండి.",
        "Audio Memories (Voice Stories)": "ఆడియో స్మృతులు (వాయిస్ కథలు)",
        "Begin your family tree journey": "మీ కుటుంబ వృక్ష ప్రయాణాన్ని ప్రారంభించండి",
        "Birthdays, anniversaries and festivals happening for your family today — one tap to wish.": "మీ కుటుంబంలో ఈ రోజు ఉన్న పుట్టినరోజులు, వార్షికోత్సవాలు, పండుగలు — ఒక్క ట్యాప్‌తో శుభాకాంక్షలు పంపండి.",
        "Blood groups, allergies, chronic conditions and emergency contacts — accessible when it matters most.": "రక్త గ్రూపులు, అలర్జీలు, దీర్ఘకాలిక వ్యాధులు, అత్యవసర సంప్రదింపు వివరాలు — అత్యవసర సమయంలో వెంటనే అందుబాటులో.",
        "Bring parents, siblings and cousins into your private family space — everyone adds their memories, and the tree grows together.": "తల్లిదండ్రులు, తోబుట్టువులు, బంధువులను మీ ప్రైవేట్ కుటుంబ స్థలంలోకి ఆహ్వానించండి — ప్రతి ఒక్కరూ తమ జ్ఞాపకాలను చేరుస్తారు, కుటుంబ వృక్షం కలిసి పెరుగుతుంది.",
        "CULTURE & TRADITIONS": "సంస్కృతి & సంప్రదాయాలు",
        "Capture a memory in your own voice. We'll transcribe, translate and preserve it for future generations.": "మీ స్వరంతో మీ జ్ఞాపకాలను రికార్డ్ చేయండి. మేము వాటిని వ్రాతరూపంలోకి మార్చి, అనువదించి, తర్వాతి తరాల కోసం సంరక్షిస్తాము.",
        "Celebrate doctors, engineers, artists and every achiever in your family — a wall of pride for generations to see.": "మీ కుటుంబంలోని డాక్టర్లు, ఇంజనీర్లు, కళాకారులు, ప్రతి సాధకుడిని గౌరవించండి — తరతరాలు చూసే గర్వదీప్తి గోడ.",
        "Choose the package that fits your family — upgrade anytime, and unlock more features as your legacy grows.": "మీ కుటుంబానికి సరిపోయే ప్యాకేజీని ఎంచుకోండి — ఎప్పుడైనా అప్‌గ్రేడ్ చేసి, మీ వారసత్వం పెరిగే కొద్దీ మరిన్ని సౌకర్యాలను తెరవండి.",
        "Complete legacy suite with AI tools": "AI సాధనాలతో కూడిన సంపూర్ణ వారసత్వ సూట్",
        "Connections": "సంబంధాలు",
        "Culture & Rituals Archive": "సంస్కృతి & సంప్రదాయాల భాండాగారం",
        "Demo Coming Soon": "డెమో త్వరలో అందుబాటులో",
        "Demo pricing — final packages will be announced soon. Selection is saved to your account.": "డెమో ధరలు — తుది ప్యాకేజీలు త్వరలో ప్రకటించబడతాయి. మీరు ఎంచుకున్నవి మీ ఖాతాలో నమోదు చేయబడతాయి.",
        "Digital Family Tree (Print-ready)": "డిజిటల్ కుటుంబ వృక్షం (ముద్రణకు సిద్ధం)",
        "EMERGENCY INFO": "అత్యవసర సమాచారం",
        "EVENTS & DATES": "కార్యక్రమాలు & తేదీలు",
        "Events & Reminders": "కార్యక్రమాలు & గుర్తుచూపులు",
        "Every family member at a glance — search, filter and open any profile in one tap.": "మీ కుటుంబంలోని ప్రతి సభ్యుడిని ఒక చూపులోనే చూడండి — వెతకండి, వడపోసుకోండి, ఏ ప్రొఫైల్‌నైనా ఒక్క ట్యాప్‌తో తెరవండి.",
        "Every milestone across generations — arranged as one continuous, beautiful story.": "తరతరాలుగా జరిగిన ప్రతి ముఖ్య ఘట్టం — ఒకటిగా కలిపిన, అందమైన నిరంతర కథలా అమర్చబడుతుంది.",
        "Every new member, photo, story and record — see everything happening in your family, as it happens.": "ప్రతి కొత్త సభ్యుడు, ఫోటో, కథ, రికార్డు — మీ కుటుంబంలో జరుగుతున్న ప్రతిదీ, జరుగుతున్న వెంటనే చూడండి.",
        "Every photo, voice note and story preserved forever — safely inside your family vault.": "ప్రతి ఫోటో, వాయిస్ నోట్, కథ — అన్నీ శాశ్వతంగా మీ కుటుంబ వాల్ట్‌లో సురక్షితంగా నిల్వ ఉంటాయి.",
        "Everything, forever — one payment": "అన్నీ, ఎప్పటికీ — ఒక్కసారి చెల్లింపు",
        "Expert Biography Writing": "నిపుణుల జీవితచరిత్ర రచన",
        "Export everything you've saved — members, stories, memories, records — in the format that suits you. Your data is always yours.": "మీరు సేవ్ చేసిన సభ్యులు, కథలు, జ్ఞాపకాలు, రికార్డులు — ఇవన్నీ మీకు నచ్చిన ఫార్మాట్‌లో ఎగుమతి చేసుకోండి. మీ డేటా ఎల్లప్పుడూ మీదే.",
        "FAMILY STATISTICS": "కుటుంబ గణాంకాలు",
        "FAMILY TIMELINE": "కుటుంబ టైమ్‌లైన్",
        "FAMILY WORLD MAP": "కుటుంబ ప్రపంచ పటం",
        "Family Activity": "కుటుంబ కార్యకలాపాలు",
        "Family Calendar & Celebrations": "కుటుంబ క్యాలెండర్ & వేడుకలు",
        "Family Pride": "కుటుంబ గౌరవం",
        "Family Records": "కుటుంబ రికార్డులు",
        "Family Tree Builder (6 generations)": "కుటుంబ వృక్ష నిర్మాణం (6 తరాలు)",
        "Family World Map": "కుటుంబ ప్రపంచ పటం",
        "Gold": "గోల్డ్",
        "HEALTH & EMERGENCY": "ఆరోగ్యం & అత్యవసర పరిస్థితులు",
        "HEALTH REPOSITORY": "ఆరోగ్య భణ్డారం",
        "Health & Medical Repository (10 registers)": "ఆరోగ్య & వైద్య భణ్డారం (10 రిజిస్టర్‌లు)",
        "How large is your family across generations? Longevity, geography, professions and more.": "మీ కుటుంబం తరతరాలుగా ఎంత విస్తరించింది? ఆయుర్దాయం, ప్రాంతాలు, వృత్తులు మరియు మరెన్నో.",
        "Keep every family member's blood group in one secure place. In an emergency, every second counts — this registry helps you instantly find the right donor within your family.": "ప్రతి కుటుంబ సభ్యుడి రక్తగుంపు వివరాలను ఒకే భద్రమైన చోట ఉంచండి. అత్యవసర సమయంలో ప్రతి సెకను విలువైనది — ఈ రిజిస్ట్రీ మీ కుటుంబంలోనే సరైన రక్తదాతను వెంటనే గుర్తించడానికి సహాయపడుతుంది.",
        "LEGACY & MEMORIAL": "వారసత్వం & స్మరణ",
        "LEGAL & LEGACY": "చట్టబద్ధం & వారసత్వం",
        "Legacy Lifetime": "వారసత్వ జీవితకాలం",
        "Legal Vault (Will & Nominee)": "చట్టబద్ధ వాల్ట్ (విల్ & నామినీ)",
        "Let AI compose a heartfelt narrative of your family's journey from the profiles you've filled.": "మీరు భర్తీ చేసిన ప్రొఫైల్‌ల ఆధారంగా, మీ కుటుంబ ప్రయాణాన్ని హృదయానికి హత్తుకునే కథలా AI వర్ణించనివ్వండి.",
        "MEMORIES & STORIES": "స్మృతులు & కథలు",
        "Marriage Records": "వివాహ రికార్డ్‌లు",
        "Member Profiles & Photos": "సభ్యుల ప్రొఫైల్‌లు & ఫోటోలు",
        "Memories & reminders for the whole family": "అంతా కుటుంబానికి సంబంధించిన స్మృతులు & రిమైండర్‌లు",
        "Multi-user Family Access (Invites)": "బహు-వినియోగదారుల కుటుంబ ప్రవేశం (ఆహ్వానాలు)",
        "Never miss a birthday, anniversary or festival — smart reminders from your family tree, delivered by email, push and in-app.": "పుట్టినరోజు, వివాహ వార్షికోత్సవం లేదా పండుగ — ఏది మిస్ కాకుండా ఉండండి. మీ ఫ్యామిలీ ట్రీ నుంచే ఈమెయిల్, పుష్ నోటిఫికేషన్ మరియు యాప్‌లో స్మార్ట్ రిమైండర్‌లు వస్తాయి.",
        "One place for every birthday, anniversary, shraddha and cultural festival — with smart nudges.": "ప్రతి పుట్టినరోజు, వార్షికోత్సవం, శ్రద్ధ మరియు సాంస్కృతిక పండుగ కోసం — స్మార్ట్ రిమైండర్‌లతో ఒకే చోట.",
        "Personal Vault": "వ్యక్తిగత వాల్ట్",
        "Prescriptions, reports and hospital records for every family member — organized and searchable.": "ప్రతి కుటుంబ సభ్యుడికి సంబంధించిన ప్రిస్క్రిప్షన్‌లు, రిపోర్ట్‌లు, ఆసుపత్రి రికార్డ్‌లు — సక్రమంగా అమర్చబడి, సులభంగా వెతుకుకోగలిగేట్టుగా.",
        "Preserve wedding dates, venues and couple details — anniversaries flow automatically into your family calendar and timeline.": "వివాహ తేదీలు, వేదికలు, దంపతుల వివరాలను భద్రపరచండి — వార్షికోత్సవాలు ఆటోమేటిక్‌గా మీ కుటుంబ క్యాలెండర్ మరియు టైమ్‌లైన్‌లో చేరిపోతాయి.",
        "Priority Support": "ప్రాధాన్య సహాయం",
        "Rituals, recipes, dialects and heritage — everything that makes your family uniquely yours.": "సంస్కారాలు, వంటకాలు, స్థానిక భాషలు, వారసత్వం — మీ కుటుంబాన్ని ప్రత్యేకంగా చేసే ప్రతి విషయం.",
        "SHARE & CELEBRATE": "పంచుకోండి & సంబరించండి",
        "Seal messages, photos and videos to open on future birthdays, anniversaries or a chosen date.": "సందేశాలు, ఫోటోలు, వీడియోలను భవిష్యత్తు పుట్టినరోజులు, వార్షికోత్సవాలు లేదా మీకు నచ్చిన తేదీన తెరవడానికి ఇప్పుడే మూసివేసి భద్రపరచండి.",
        "See every family member on a real world map. Each pin shows a current location (orange) and a native place (green), connected by a dotted line — a beautiful visual of your family's journey through geography.": "మీ కుటుంబంలోని ప్రతి సభ్యుని నిజ జీవిత మ్యాప్‌పై చూడండి. ప్రతి పిన్ ఒక ప్రస్తుత స్థానం (నారింజ రంగు), ఒక మాతృస్థలం (ఆకుపచ్చ రంగు)ను చూపుతుంది; రెండు చుక్కల గీతతో కలిపి — మీ కుటుంబ ప్రయాణాన్ని అద్భుతంగా చూపించే రూపంలో ఉంటుంది.",
        "Share the gift of legacy — invite friends to build their own private family tree, free to start.": "వారసత్వం అనే బహుమతిని పంచుకోండి — మీ స్నేహితులను వారి సొంత ప్రైవేట్ ఫ్యామిలీ ట్రీని నిర్మించమని ఆహ్వానించండి, ప్రారంభం పూర్తిగా ఉచితం.",
        "Silver": "సిల్వర్",
        "Smart Reminders (Email + Push)": "స్మార్ట్ రిమైండర్లు (Email + Push)",
        "Starter": "స్టార్టర్",
        "TIME CAPSULES": "టైమ్ క్యాప్సూల్స్",
        "TODAY'S CELEBRATIONS": "ఈరోజు జ‌రుపుకునే వేడుకలు",
        "Turn your family tree into a beautiful shareable poster — perfect for wedding invites, festivals and print.": "మీ ఫ్యామిలీ ట్రీని అందంగా పంచుకోగల పోస్టర్‌గా మార్చండి — పెళ్లి ఆహ్వానాలు, పండుగలు, ప్రింట్ కోసం అద్భుతంగా సరిపోతుంది.",
        "VOICE & STORIES": "వాయిస్ & కథలు",
        "Watch Demo": "డెమో చూడండి",
        "Wills, power-of-attorney, property papers and nominee details — locked and always accessible to the right people.": "విల్లు పత్రాలు, పవర్ ఆఫ్ అటార్నీ, ఆస్తి పత్రాలు, నామినీ వివరాలు — భద్రంగా లాక్ చేసి, సరైన కుటుంబ సభ్యులకు ఎప్పుడూ అందుబాటులో ఉండేలా.",
        "Your data, your rules — manage account preferences, visibility and every privacy declaration in one place.": "మీ డేటా, మీ నిబంధనలు — ఖాతా అభిరుచులు, కనిపించే విధానం, ప్రతి ప్రైవసీ సెట్టింగ్‌ను ఒకే చోట సులభంగా నియంత్రించండి.",
        "one-time · lifetime": "ఒక్కసారి · జీవితకాలం",
        "per month": "నెలకు",
        "per year": "ఏటా",
        "January": "జనవరి",
        "February": "ఫిబ్రవరి",
        "March": "మార్చి",
        "April": "ఏప్రిల్",
        "May": "మే",
        "June": "జూన్",
        "July": "జూలై",
        "August": "ఆగస్టు",
        "September": "సెప్టెంబర్",
        "October": "అక్టోబర్",
        "November": "నవంబర్",
        "December": "డిసెంబర్",
        "is locked": "లాక్ చేయబడి ఉంది",
        "Your current package": "మీ ప్రస్తుత ప్యాకేజ్",
        "doesn't include this feature.": "ఈ ఫీచర్ ఇందులో లేదు.",
        "Included in": "దీనిలో పొందుపరచబడింది",
        "one-time": "ఒక్కసారి",
        "year": "సంవత్సరం",
        "month": "నెల",
        "lifetime": "ఆజీవం",
        "Go Back": "వెనక్కి వెళ్ళండి",
        "View Packages": "ప్యాకేజీలను చూడండి",
        "This feature": "ఈ ఫీచర్",
        "Family Legacy Dashboard": "కుటుంబ వారసత్వ డాష్‌బోర్డు",
        "Legacy Services": "వారసత్వ సేవలు",
        "Life Story Vault": "జీవిత కథల భద్రగారము",
        "Video Testament Library": "వీడియో ఇష్టలేఖల గ్రంథాలయం",
        "Family Wisdom Bank": "కుటుంబ జ్ఞాన భాండాగారం",
        "Failure Stories Archive": "విఫలత కథల సంగ్రహం",
        "Success Stories": "విజయ కథలు",
        "Family Decision History": "కుటుంబ నిర్ణయాల చరిత్ర",
        "Family Values Repository": "కుటుంబ విలువల భాండాగారం",
        "Family Hero Gallery": "కుటుంబ వీరుల గ్యాలరీ",
        "Unsung Heroes": "పేరులేని వీరులు",
        "Gratitude Wall": "కృతజ్ఞత గోడ",
        "Tribute Pages": "స్మారక పేజీలు",
        "Love Letters Archive": "ప్రేమలేఖల సంగ్రహం",
        "Childhood Stories Bank": "బాల్యకాల కథల భాండాగారం",
        "Language Preservation": "భాష సంరక్షణ",
        "Ancestral Village": "పూర్వీకుల ఊరు",
        "Surname History": "ఇంటి పేర్ల చరిత్ర",
        "Family Emblem": "కుటుంబ చిహ్నం",
        "Cultural Artifacts": "సాంస్కృతిక అవశేషాలు",
        "Family Songs & Bhajans": "కుటుంబ పాటలు & భజనలు",
        "Oral History Center": "మౌఖిక చరిత్ర కేంద్రం",
        "Biography Writing Platform": "జీవిత చరిత్ర రచనా వేదిక",
        "Memoir Writing Service": "స్మృతిచిత్ర రచనా సేవ",
        "Personalised Gifting Service": "వ్యక్తిగతీకరించిన బహుమతుల సేవ",
        "Personal Digital Identity Platform": "వ్యక్తిగత డిజిటల్ గుర్తింపు వేదిక",
        "Add to": "దీనికి జోడించండి",
        "Choose": "ఎంచుకోండి",
        "Compare all packages": "అన్ని ప్యాకేజీలను పోల్చండి",
        "Demo pricing — packages, prices and the feature split are all editable from the admin panel.": "డెమో ధరలు — ప్యాకేజీలు, ధరలు మరియు ఫీచర్ విభజన అన్నింటినీ అడ్మిన్ ప్యానెల్ నుండి మార్చుకోవచ్చు.",
        "Feature": "ఫీచర్",
        "Five packages, one family legacy": "ఐదు ప్యాకేజీలు, ఒక కుటుంబ వారసత్వం",
        "Free": "ఉచితం",
        "Life story, wisdom and biography now live in Family Legacy Dashboard": "జీవితకథ, జ్ఞానం మరియు జీవిత చరిత్ర ఇప్పుడు Family Legacy Dashboard లో అందుబాటులో ఉన్నాయి",
        "Open Family Legacy Dashboard": "Family Legacy Dashboard తెరవండి",
        "Packages & Pricing": "ప్యాకేజీలు & ధరలు",
        "Packages temporarily unavailable. Please try again shortly.": "ప్యాకేజీలు తాత్కాలికంగా అందుబాటులో లేవు. కొద్దిసేపటి తర్వాత మళ్లీ ప్రయత్నించండి.",
        "Start Free": "ఉచితంగా మొదలు పెట్టండి",
        "Start free, upgrade whenever your family is ready. Every feature below is compared side by side so nothing is hidden.": "మొదట ఉచితంగా ప్రారంభించి, మీ కుటుంబం సిద్ధమైనప్పుడు ఎప్పుడైనా అప్గ్రేడ్ చేసుకోండి. క్రింద ఉన్న ప్రతీ ఫీచర్‌ను పక్కపక్కన చూపించి పోల్చాం, ఏదీ దాచలేదు.",
        "Swipe sideways on a phone — the feature column stays in place.": "ఫోన్‌లో పక్కకు స్వైప్ చేయండి — ఫీచర్ కాలమ్ స్థిరంగా ఉంటుంది.",
        "more features": "ఇంకా ఫీచర్లు",
        "Namaste": "నమస్తే",
        "{sender} has added you to our family tree on Family Repository.": "{sender} గారు Family Repositoryలో మా కుటుంబ వృక్షంలో మిమ్మల్ని చేర్చారు.",
        "Tap to join": "చేరడానికి ట్యాప్ చేయండి",
        "Your invite code": "మీ ఆహ్వాన కోడ్",
        "Together we will preserve our family's stories, photos and voices for the next generations.": "మన కుటుంబ కథలు, ఫోటోలు, స్వరాలను కలిసి వచ్చే తరాల కోసం సంరక్షించుకుందాం.",
        "Your family": "మీ కుటుంబం",
        "Invite on WhatsApp": "WhatsApp ద్వారా ఆహ్వానించండి",
        "WhatsApp opened with the invite message.": "ఆహ్వాన సందేశంతో WhatsApp తెరవబడింది.",
    },
    kn: {
        "Home": "ಮುಖಪುಟ",
        "Family": "ಕುಟುಂಬ",
        "Family Tree": "ಕುಟುಂಬ ವೃಕ್ಷ",
        "Add a Member": "ಸದಸ್ಯರನ್ನು ಸೇರಿಸಿ",
        "Invite Family": "ಕುಟುಂಬವನ್ನು ಆಹ್ವಾನಿಸಿ",
        "Family Hub · All": "ಕುಟುಂಬ ಹಬ್ · ಎಲ್ಲಾ",
        "Family Timeline": "ಕುಟುಂಬದ ಕಾಲರೇಖೆ",
        "Family Calendar": "ಕುಟುಂಬ ಕ್ಯಾಲೆಂಡರ್",
        "Services": "ಸೇವೆಗಳು",
        "Photo Memories": "ಫೋಟೋ ನೆನಪುಗಳು",
        "Audio Memories": "ಆಡಿಯೋ ನೆನಪುಗಳು",
        "AI Family Advisor": "AI ಕುಟುಂಬ ಸಲಹೆಗಾರ",
        "AI Story Generator": "AI ಕಥೆ ನಿರ್ಮಾಪಕ",
        "Video Memories": "ವೀಡಿಯೋ ನೆನಪುಗಳು",
        "Digital Family Tree": "ಡಿಜಿಟಲ್ ಕುಟುಂಬ ವೃಕ್ಷ",
        "Family Hall of Fame": "ಕುಟುಂಬ ಗೌರವ ಗೃಹ",
        "Family Hub · All Services": "ಕುಟುಂಬ ಹಬ್ · ಎಲ್ಲಾ ಸೇವೆಗಳು",
        "Records": "ದಾಖಲೆಗಳು",
        "Blood Group Registry": "ರಕ್ತಗುಂಪು ನೋಂದಣಿ",
        "Health Repository": "ಆರೋಗ್ಯ ಭಂಡಾರ",
        "Health Score Compliance": "ಆರೋಗ್ಯ ಅಂಕ ಪಾಲನೆಯ ಸ್ಥಿತಿ",
        "Emergency Contacts": "ತುರ್ತು ಸಂಪರ್ಕಗಳು",
        "Business Directory": "ವ್ಯಾಪಾರ ಸೂಚಿಪತ್ರಿಕೆ",
        "Recipe Vault": "ಪದಾರ್ಥಗಳ ಭಂಡಾರ",
        "Family Statistics": "ಕುಟುಂಬದ ಅಂಕಿಅಂಶಗಳು",
        "Legacy": "ಪಾರಂಪರ್ಯ",
        "Legal Vault": "ಕಾನೂನು ದಾಖಲೆ ಭಂಡಾರ",
        "Document Vault": "ದಾಖಲೆ ಭಂಡಾರ",
        "Story & Wisdom Vault": "ಕಥೆ ಮತ್ತು ಜ್ಞಾನ ಭಂಡಾರ",
        "Family Constitution": "ಕುಟುಂಬ ಸಂವಿಧಾನ",
        "Futuristic Legacy Letter": "ಭವಿಷ್ಯಮುಖಿ ಪಾರಂಪರ್ಯ ಪತ್ರ",
        "Digital Memorial": "ಡಿಜಿಟಲ್ ಸ್ಮಾರಕ",
        "Account": "ಖಾತೆ",
        "Packages & Plans": "ಪ್ಯಾಕೇಜುಗಳು ಮತ್ತು ಯೋಜನೆಗಳು",
        "Privacy & Settings": "ಗೌಪ್ಯತೆ ಮತ್ತು ಸಂಯೋಜನೆಗಳು",
        "Download & Export": "ಡೌನ್‌ಲೋಡ್ ಮತ್ತು ರಫ್ತು",
        "Profile": "ಪ್ರೊಫೈಲ್",
        "Search family…": "ಕುಟುಂಬವನ್ನು ಹುಡುಕಿ…",
        "Dashboard": "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
        "Families": "ಕುಟುಂಬಗಳು",
        "Users": "ಬಳಕೆದಾರರು",
        "Subscriptions": "ಚಂದಾದಾರಿಕೆಗಳು",
        "Packages": "ಪ್ಯಾಕೇಜುಗಳು",
        "Exports": "ರಫ್ತುಗಳು",
        "Content": "ವಿಷಯ",
        "Landing Slides": "ಲ್ಯಾಂಡಿಂಗ್ ಸ್ಲೈಡ್‌ಗಳು",
        "Site Assets": "ಸೈಟ್ ಆಸ್ತಿಗಳು",
        "Family Content": "ಕುಟುಂಬ ವಿಷಯ",
        "Translations": "ಅನುವಾದಗಳು",
        "User Page Editor": "ಬಳಕೆದಾರರ ಪುಟ ಸಂಪಾದಕ",
        "Analytics": "ವಿಶ್ಲೇಷಣೆ",
        "Support Tickets": "ಸಹಾಯ ಟಿಕೆಟ್‌ಗಳು",
        "Broadcasts": "ಪ್ರಸಾರಗಳು",
        "Legacy CRM": "ಲೆಗಸಿ CRM",
        "SMS Console": "SMS ಕನ್‌ಸೋಲ್",
        "Security": "ಭದ್ರತೆ",
        "Settings": "ಹೊಂದಿಕೆಗಳು",
        "UI/UX Audit": "UI/UX ಆಡಿಟ್",
        "API Keys": "API ಕೀಗಳು",
        "Admin Team": "ನಿರ್ವಾಹಕ ತಂಡ",
        "Content Managers": "ವಿಷಯ ನಿರ್ವಹಕರು",
        "Overview": "ಸಮಗ್ರ ನೋಟ",
        "Members": "ಸದಸ್ಯರು",
        "Billing": "ಬಿಲ್ಲಿಂಗ್",
        "Landing & Content": "ಲ್ಯಾಂಡಿಂಗ್ ಮತ್ತು ವಿಷಯ",
        "Insights": "ಅಳಿವು-ಪಳಿವು (ಇನ್‌ಸೈಟ್ಸ್)",
        "Support": "ಸಹಾಯ",
        "System": "ವ್ಯವಸ್ಥೆ",
        "Super Admin": "ಸೂಪರ್ ಅಡ್ಮಿನ್",
        "Content Admin": "ವಿಷಯ ಅಡ್ಮಿನ್",
        "Content Manager": "ವಿಷಯ ನಿರ್ವಹಕ",
        "Finance Admin": "ಹಣಕಾಸು ಅಡ್ಮಿನ್",
        "Support Admin": "ಸಹಾಯ ಅಡ್ಮಿನ್",
        "Security Admin": "ಸುರಕ್ಷತಾ ಅಡ್ಮಿನ್",
        "Admin": "ಅಡ್ಮಿನ್",
        "Admin Panel": "ಅಡ್ಮಿನ್ ಪ್ಯಾನೆಲ್",
        "Logout": "ಲಾಗ್‌ಔಟ್",
        "Loading dashboard…": "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
        "Platform overview at a glance.": "ವೇದಿಕೆಯ ಒಮ್ಮೆಲೆ ಕಾಣುವ ಸಮಗ್ರ ನೋಟ.",
        "Total Families": "ಒಟ್ಟು ಕುಟುಂಬಗಳು",
        "Total Members": "ಒಟ್ಟು ಸದಸ್ಯರು",
        "Tree Persons": "ಕುಟುಂಬ ವೃಕ್ಷದ ವ್ಯಕ್ತಿಗಳು",
        "Storage Used": "ಬಳಸಿದ ಸಂಗ್ರಹಣಾ ಜಾಗ",
        "Marriages": "ವಿವಾಹಗಳು",
        "Memory Albums": "ಸ್ಮರಣಿಕೆ ಆಲ್ಬಮ್‌ಗಳು",
        "Wills (latest)": "ವಸತುಪತ್ರಗಳು (ಇತ್ತೀಚಿನ)",
        "Audio Wills": "ಆಡಿಯೋ ವಸತುಪತ್ರಗಳು",
        "With recorded audio": "ದಾಖಲಿಸಿದ ಆಡಿಯೋ ಸಹಿತ",
        "Across all families": "ಎಲ್ಲಾ ಕುಟುಂಬಗಳ ಮಟ್ಟಿಗೆ",
        "New signups — last 30 days": "ಹೊಸ ನೋಂದಣಿಗಳು — ಕಳೆದ 30 ದಿನಗಳು",
        "Storage breakdown": "ಸಂಗ್ರಹಣಾ ಬಳಕೆ ವಿವರ",
        "No stored files yet.": "ಇನ್ನೂ ಯಾವುದೇ ಕಡತಗಳನ್ನು ಸಂಗ್ರಹಿಸಲಾಗಿಲ್ಲ.",
        "Signups": "ನೋಂದಣಿಗಳು",
        "suspended": "ತಾತ್ಕಾಲಿಕ ಸ್ಥಗಿತಗೊಳಿಸಲಾಗಿದೆ",
        "blocked": "ತಡೆಹಿಡಿಯಲಾಗಿದೆ",
        "paid": "ಪಾವತಿಸಿದ",
        "open tickets": "ಮುಕ್ತ ಟಿಕೆಟ್‌ಗಳು",
        "Memory photos": "ಸ್ಮರಣಿಕೆ ಫೋಟೋಗಳು",
        "Vault documents": "ಕೋಶದ ದಾಖಲೆಗಳು",
        "Story audio": "ಕತೆಯ ಆಡಿಯೋ",
        "Member profiles & photos": "ಸದಸ್ಯರ ಪ್ರೊಫೈಲ್‌ಗಳು ಮತ್ತು ಫೋಟೋಗಳು",
        "Profile details": "ಪ್ರೊಫೈಲ್ ವಿವರಗಳು",
        "Story metadata": "ಕಥೆಯ ಮೆಟಾಡೇಟಾ",
        "Memory metadata": "ಸ್ಮರಣೆಯ ಮೆಟಾಡೇಟಾ",
        "Document metadata": "ದಾಖಲೆಯ ಮೆಟಾಡೇಟಾ",
        "Admin (Head)": "ನಿರ್ವಾಹಕರು (ಮುಖ್ಯಸ್ಥರು)",
        "added": "ಸೇರಿಸಿದ್ದಾರೆ",
        "updated": "ನವೀಕರಿಸಿದ್ದಾರೆ",
        "removed": "ತೆಗೆದುಹಾಕಿದ್ದಾರೆ",
        "changed privacy of": "ಗೌಪ್ಯತಾ ಸೆಟ್ಟಿಂಗ್‌ ಅನ್ನು ಬದಲಿಸಿದ್ದಾರೆ",
        "updated profile of": "ಪ್ರೊಫೈಲ್‌ನ್ನು ನವೀಕರಿಸಿದ್ದಾರೆ",
        "viewed profile of": "ಪ್ರೊಫೈಲ್‌ನ್ನು ನೋಡಿದ್ದಾರೆ",
        "recorded": "ದಾಖಲಿಸಿದ್ದಾರೆ",
        "played": "ಪ್ಲೇ ಮಾಡಿದ್ದಾರೆ",
        "deleted story": "ಕಥೆಯನ್ನು ಅಳಿಸಿದ್ದಾರೆ",
        "uploaded": "ಅಪ್ಲೋಡ್ ಮಾಡಿದ್ದಾರೆ",
        "viewed": "ನೋಡಿದ್ದಾರೆ",
        "changed access of": "ಪ್ರವೇಶ ಹಕ್ಕನ್ನು ಬದಲಿಸಿದ್ದಾರೆ",
        "deleted": "ಅಳಿಸಿದ್ದಾರೆ",
        "invited": "ಆಹ್ವಾನಿಸಿದ್ದಾರೆ",
        "revoked an invite": "ಆಮಂತ್ರಣವನ್ನು ರದ್ದು ಮಾಡಿದರು",
        "joined the family": "ಕುಟುಂಬಕ್ಕೆ ಸೇರಿದರು",
        "changed role of": "ಪಾತ್ರವನ್ನು ಬದಲಿಸಿದರು",
        "downloaded their data": "ತಮ್ಮ ಮಾಹಿತಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿಕೊಂಡರು",
        "completed privacy setup": "ಗೌಪ್ಯತಾ ಸೆಟ್ಟಪ್ ಪೂರ್ಣಗೊಳಿಸಿದರು",
        "deleted account of": "ಖಾತೆಯನ್ನು ಅಳಿಸಿದರು",
        "Senior mode on — simpler privacy choices.": "ಜ್ಯೇಷ್ಟರ ಮೋಡ್ ಆನ್ — ಸುಲಭವಾದ ಗೌಪ್ಯತಾ ಆಯ್ಕೆಗಳು.",
        "Senior mode off.": "ಜ್ಯೇಷ್ಟರ ಮೋಡ್ ಆಫ್.",
        "Saved.": "ಸೇಫ್ ಮಾಡಲಾಗಿದೆ.",
        "Your data export has been downloaded.": "ನಿಮ್ಮ ಡೇಟಾ ಎಕ್ಸ್‌ಪೋರ್ಟ್ ಡೌನ್‌ಲೋಡ್ ಆಗಿದೆ.",
        "Your account and data have been deleted.": "ನಿಮ್ಮ ಖಾತೆ ಮತ್ತು ಮಾಹಿತಿಯನ್ನು ಅಳಿಸಲಾಗಿದೆ.",
        "Every family tree on the platform. Suspending blocks all its members from logging in.": "ವೇದಿಕೆಯಲ್ಲಿರುವ ಪ್ರತಿಯೊಂದು ಕುಟುಂಬ ವೃಕ್ಷ. ಇದನ್ನು ಸ್ಥಗಿತಗೊಳಿಸಿದರೆ ಅದರ ಎಲ್ಲ ಸದಸ್ಯರಿಗೂ ಲಾಗಿನ್ ಮಾಡಲು ಅವಕಾಶ ಇರುವುದಿಲ್ಲ.",
        "All registered members. Blocked users cannot log in or use the API.": "ಎಲ್ಲಾ ನೋಂದಾಯಿತ ಸದಸ್ಯರು. ತಡೆಯಲ್ಪಟ್ಟ ಬಳಕೆದಾರರು ಲಾಗಿನ್ ಆಗಲಾರರು ಅಥವಾ API ಬಳಸಲಾರರು.",
        "Manual plan control until a payment gateway is connected in Settings.": "Settings ನಲ್ಲಿ ಪೇಮೆಂಟ್ ಗೇಟ್‌ವೇ ಅನ್ನು ಸಂಪರ್ಕಿಸುವವರೆಗೆ ಯೋಜನೆಯನ್ನು ಕೈಯಾರೆ ನಿಯಂತ್ರಿಸಬಹುದು.",
        "Growth, engagement and audience mix.": "ವೃದ್ಧಿ, ತೊಡಗು ಹಾಗೂ ಪ್ರೇಕ್ಷಕರ ಸಂಯೋಜನೆ.",
        "Users raise tickets from Settings → Help in the app.": "ಬಳಕೆದಾರರು ಆಪ್‌ನ Settings → Help ಮೂಲಕ ಟಿಕೆಟ್‌ಗಳನ್ನು ರೈಸ್ಮಾಡುತ್ತಾರೆ.",
        "Branding, payment gateway and API keys. Secrets are stored server-side and shown masked.": "ಬ್ರ್ಯಾಂಡಿಂಗ್, ಪೇಮೆಂಟ್ ಗೇಟ್‌ವೇ ಮತ್ತು API ಕೀಗಳು. ರಹಸ್ಯ ಮಾಹಿತಿಯನ್ನು ಸರ್ವರ್ ಬದಿಯಲ್ಲಿ ಸಂಗ್ರಹಿಸಿ ಮಸ್ಕ್ ಮಾಡಿ ತೋರಿಸಲಾಗುತ್ತದೆ.",
        "Packages — Feature Matrix (Demo)": "ಪ್ಯಾಕೇಜುಗಳು — ವೈಶಿಷ್ಟ್ಯ ಮ್ಯಾಟ್ರಿಕ್ಸ್ (ಡೆಮೊ)",
        "Export Center": "ಎಕ್ಸ್‌ಪೋರ್ಟ್ ಸೆಂಟರ್",
        "Download authoritative reports in CSV, Excel or PDF. Schedule auto-email exports below.": "ಪ್ರಮುಖ ವರದಿಗಳನ್ನು CSV, Excel ಅಥವಾ PDF ರೂಪದಲ್ಲಿ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ. ಕೆಳಗೆ ಸ್ವಯಂಚಾಲಿತ ಇಮೇಲ್ ಎಕ್ಸ್‌ಪೋರ್ಟ್‌ಗಳ ವೇಳಾಪಟ್ಟಿ ನಿಗದಿಪಡಿಸಿ.",
        "Send SMS or WhatsApp announcements to your users.": "ನಿಮ್ಮ ಬಳಕೆದಾರರಿಗೆ SMS ಅಥವಾ WhatsApp ಘೋಷಣೆಗಳನ್ನು ಕಳುಹಿಸಿ.",
        "Content Management": "ವಿಷಯ ನಿರ್ವಹಣೆ",
        "Poster templates, landing banners and testimonials curated by the super-admin.": "ಪೋಸ್ಟರ್ ಟೆಂಪ್ಲೇಟ್‌ಗಳು, ಲ್ಯಾಂಡಿಂಗ್ ಬ್ಯಾನರ್‌ಗಳು ಮತ್ತು ಟೆಸ್ಟಿಮೋನಿಯಲ್‌ಗಳನ್ನು ಸೂಪರ್-ಅಡ್ಮಿನ್ ಆಯ್ಕೆಮಾಡಿ ಸಂಗ್ರಹಿಸುತ್ತಾರೆ.",
        "Platform-wide audit trail, failed logins, DPDP compliance requests, and your MFA credentials.": "ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಮಟ್ಟದ ಆಡಿಟ್ ಟ್ರೇಲ್, ವಿಫಲವಾದ ಲಾಗಿನ್‌ಗಳು, DPDP ಅನುಸರಣೆಯ ವಿನಂತಿಗಳು ಮತ್ತು ನಿಮ್ಮ MFA ರಹಸ್ಯ ವಿವರಗಳು.",
        "Manage who can sign into the admin panel and what they can access.": "ಯಾರು ಅಡ್ಮಿನ್ ಪ್ಯಾನೆಲ್‌ಗೆ ಸೈನ್ ಇನ್ ಮಾಡಬಹುದು ಮತ್ತು ಅವರು ಏನು ಪ್ರವೇಶಿಸಬಹುದು ಎಂಬುದನ್ನು ನಿರ್ವಹಿಸಿ.",
        "Family Content Moderation": "ಕುಟುಂಬ ವಿಷಯ ಪರಿಶೀಲನೆ",
        "Listen": "ಕೇಳಿ",
        "Stop": "ನಿಲ್ಲಿಸಿ",
        "Pause": "ವಿರಾಮ",
        "Resume": "ಮತ್ತೆ ಪ್ರಾರಂಭಿಸಿ",
        "Generating…": "ರಚಿಸಲಾಗುತ್ತಿದೆ…",
        "Signup trend — last 90 days": "ಸೈನ್‌ಅಪ್ ಪ್ರವೃತ್ತಿ — ಕಳೆದ 90 ದಿನಗಳು",
        "(or user) is expected to add all their family relationships on the": "(ಅಥವಾ ಬಳಕೆದಾರರು) ತಮ್ಮ ಎಲ್ಲಾ ಕುಟುಂಬ ಸಂಬಂಧಗಳನ್ನು ಸೇರಿಸುವುದಾಗಿ ನಿರೀಕ್ಷಿಸಲಾಗಿದೆ",
        ", which can only be opened by your password.": ", ಇದನ್ನು ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್‌ನಿಂದ ಮಾತ್ರ ತೆರೆಯಬಹುದು.",
        ". Any member added there is automatically reflected here. For convenience, a few extra fields for": ". ಅಲ್ಲಿ ಸೇರಿಸಿರುವ ಯಾವುದೇ ಸದಸ್ಯರು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಇಲ್ಲಿ ತೋರಿಸಲ್ಪಡುತ್ತಾರೆ. ಅನುಕೂಲಕ್ಕಾಗಿ, ಕೆಲವು ಹೆಚ್ಚುವರಿ ವಿವರಗಳನ್ನು",
        "A family together": "ಒಟ್ಟುಗೂಡಿದ ಒಂದು ಕುಟುಂಬ",
        "A premium feature for your family's future": "ನಿಮ್ಮ ಕುಟುಂಬದ ಭವಿಷ್ಯದಿಗಾಗಿ ಒಂದು ಪ್ರೀಮಿಯಂ ಸೌಲಭ್ಯ",
        "Add": "ಸೇರಿಸಿ",
        "Add Event": "ಕಾರ್ಯಕ್ರಮವನ್ನು ಸೇರಿಸಿ",
        "Add custom field": "ಹೆಚ್ಚುವರಿ ಕ್ಷೇತ್ರವನ್ನು ಸೇರಿಸಿ",
        "All checks": "ಎಲ್ಲಾ ಪರಿಶೀಲನೆಗಳು",
        "Avg age": "ಸರಾಸರಿ ವಯಸ್ಸು",
        "Back": "ಹಿಂದೆ",
        "Back to Dashboard": "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗೆ ಹಿಂದಿರುಗಿ",
        "Change photo": "ಫೋಟೋ ಬದಲಾಯಿಸಿ",
        "Choose the package that fits your family": "ನಿಮ್ಮ ಕುಟುಂಬಕ್ಕೆ ತಕ್ಕ ಪ್ಯಾಕೇಜ್‌ನ್ನು ಆಯ್ಕೆಮಾಡಿ",
        "Classic, Premium and Elite": "ಕ್ಲಾಸಿಕ್, ಪ್ರೀಮಿಯಂ ಮತ್ತು ಎಲೈಟ್",
        "Countries": "ದೇಶಗಳು",
        "Current": "ಪ್ರಸ್ತುತ",
        "Current Location": "ಪ್ರಸ್ತುತ ಸ್ಥಳ",
        "Current city": "ಪ್ರಸ್ತುತ ನಗರ",
        "Current locations": "ಪ್ರಸ್ತುತ ಸ್ಥಳಗಳು",
        "Data is encrypted in transit and at rest; every add/edit/delete is captured in the audit log.": "ಡೇಟಾ ಪ್ರಯಾಣಿಸುವಾಗಲೂ ಹಾಗು ಸಂಗ್ರಹವಾಗಿರುವಾಗಲೂ ಎನ್ಕ್ರಿಪ್ಟ್ ಆಗಿರುತ್ತದೆ; ಪ್ರತಿ add/edit/delete ಕ್ರಿಯೆಯೂ audit log ನಲ್ಲಿ ದಾಖಲೆಯಾಗುತ್ತದೆ.",
        "Date": "ದಿನಾಂಕ",
        "Dear customer,": "ಆದರಣೀಯ ಗ್ರಾಹಕರೇ,",
        "Delete": "ಅಳಿಸಿ",
        "Distinct Cities": "ವೈವಿಧ್ಯಮಯ ನಗರಗಳು",
        "Family (₹999/yr)": "ಕುಟುಂಬ (₹999/ವರ್ಷ)",
        "Family Head": "ಕುಟುಂಬದ ಮುಖಂಡ",
        "Family Health": "ಕುಟುಂಬದ ಆರೋಗ್ಯ",
        "Family Members": "ಕುಟುಂಬದ ಸದಸ್ಯರು",
        "Family Relationships": "ಕುಟುಂಬದ ಸಂಬಂಧಗಳು",
        "Favourite mithai": "ಮೆಚ್ಚಿನ ಮಿಠಾಯಿ",
        "Field name": "ಕ್ಷೇತ್ರದ ಹೆಸರು",
        "Fill with AI": "AI ಬಳಸಿ ಭರ್ತಿ ಮಾಡಿ",
        "GPT-5.2 fills 40+ fields across all 6 modules from your surname + region · you edit before saving.": "GPT-5.2 ನಿಮ್ಮ ಒಡೆಯ ಹೆಸರು + ಪ್ರದೇಶದ ಆಧಾರದಿಂದ 6 ಮಾಡ್ಯೂಲ್‌ಗಳಲ್ಲಿನ 40+ ಕ್ಷೇತ್ರಗಳನ್ನು ತುಂಬುತ್ತದೆ · ನೀವು ಸೇವ್ ಮಾಡುವ ಮೊದಲು ತಿದ್ದುಗಳನ್ನು ಮಾಡಬಹುದು.",
        "Gaon ka temple": "ಗ್ರಾಮದ ದೇವಾಲಯ",
        "Generations": "ತಲೆಮಾರುಗಳು",
        "Health & Medical Repository": "ಆರೋಗ್ಯ ಮತ್ತು ವೈದ್ಯಕೀಯ ಸಂಗ್ರಹಣೆ",
        "Health Score Compliance Report": "ಆರೋಗ್ಯ ಅಂಕೆಗಳ ಅನುಸರಣಾ ವರದಿ",
        "Health information is stored with explicit consent, only for members whose data you are authorised to record.": "ನೀವು ಮಾಹಿತಿ ದಾಖಲಿಸಲು ಅಧಿಕೃತರಾಗಿರುವ ಸದಸ್ಯರಿಗಾಗಿ ಮಾತ್ರ, ಅವರ ಸ್ಪಷ್ಟ ಅನುಮತಿಯೊಂದಿಗೆ ಆರೋಗ್ಯ ಸಂಬಂಧಿತ ಮಾಹಿತಿಯನ್ನು ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆ.",
        "Help": "ಸಹಾಯ",
        "Hide details": "ವಿವರಗಳನ್ನು ಮರೆಮಾಡಿ",
        "How complete is your family tree?": "ನಿಮ್ಮ ಕುಟುಂಬ ವಂಶವೃಕ್ಷ ಎಷ್ಟು ಸಂಪೂರ್ಣವಾಗಿದೆ?",
        "Informed consent — one time, per family": "ಸೂಚಿತ ಒಪ್ಪಿಗೆ — ಒಂದು ಬಾರಿ, ಒಂದು ಕುಟುಂಬಕ್ಕೆ",
        "Kind": "ಪ್ರಕಾರ",
        "Legacy (₹2999/yr)": "ಲೆಗಸಿ (₹2999/ವರ್ಷ)",
        "Linked live from your family tree.": "ನಿಮ್ಮ ಕುಟುಂಬ ವಂಶವೃಕ್ಷದಿಂದ ನೇರವಾಗಿ ಜೋಡಿಸಲಾಗಿದೆ.",
        "Living Cities": "ರಹವಾಸ ನಗರಗಳು",
        "Loading events…": "ಕಾರ್ಯಕ್ರಮಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ…",
        "Loading packages…": "ಪ್ಯಾಕೇಜ್‌ಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ…",
        "Loading world map…": "ವಿಶ್ವ ನಕ್ಷೆಯನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ…",
        "Loading…": "ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ…",
        "Lucky number": "ಅದೃಷ್ಟ ಸಂಖ್ಯೆ",
        "Member Profile": "ಸದಸ್ಯರ ಪ್ರೊಫೈಲ್",
        "Most Popular": "ಅತ್ಯಂತ ಜನಪ್ರಿಯ",
        "Native": "ಮೂಲದ",
        "Native Place": "ಮೂಲ ಊರು",
        "Native Places": "ಮೂಲ ಊರುಗಳು",
        "Native places": "ಮೂಲ ಊರುಗಳು",
        "None of your family members have a mapped location yet.": "ನಿಮ್ಮ ಕುಟುಂಬದ ಯಾರಿಗೂ ಇನ್ನೂ ನಕ್ಷೆಯಲ್ಲಿ ಸ್ಥಳವನ್ನು ಹೊಂದಿಸಲಾಗಿಲ್ಲ.",
        "Not a medical diagnosis platform.": "ಇದು ವೈದ್ಯಕೀಯ ರೋಗನಿರ್ಣಯ ವೇದಿಕೆ ಅಲ್ಲ.",
        "Not added yet": "ಇನ್ನೂ ಸೇರಿಸಲಾಗಿಲ್ಲ",
        "Notes (optional)": "ಟಿಪ್ಪಣಿಗಳು (ಐಚ್ಛಿಕ)",
        "Place of birth": "ಹುಟ್ಟು ಸ್ಥಳ",
        "Preserve. Understand. Inform.": "ಸಂಗ್ರಹಿಸಿ. ಅರ್ಥಮಾಡಿ. ತಿಳಿಸಿ.",
        "Privacy by design:": "ಆರಂಭದಿಂದಲೂ ಗೌಪ್ಯತೆ:",
        "Records are visible to your family circle only; the Family Head controls who can add or edit.": "ದಾಖಲೆಗಳು ನಿಮ್ಮ ಕುಟುಂಬ ವಲಯಕ್ಕೆ ಮಾತ್ರ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತವೆ; ಯಾರು ಸೇರಿಸಬೇಕು ಅಥವಾ ಬದಲಾಯಿಸಬೇಕು ಎಂಬುದನ್ನು ಕುಟುಂಬ ಮುಖ್ಯಸ್ಥರು ನಿಯಂತ್ರಿಸುತ್ತಾರೆ.",
        "Remove": "ತೆಗೆದುಹಾಕಿ",
        "Reset": "ಮರುಹೊಂದಿಸಿ",
        "Save &amp; Continue": "ಉಳಿಸಿ &amp; ಮುಂದುವರಿಸಿ",
        "Saved ✓": "ಉಳಿಸಲಾಗಿದೆ ✓",
        "Saving…": "ಉಳಿಸಲಾಗುತ್ತಿದೆ…",
        "Sensitive details are hidden by default.": "ಸಾಧಾರಣವಾಗಿ ಸಂವೇದನಾಶೀಲ ವಿವರಗಳನ್ನು ಮರೆಮಾಡಲಾಗಿದೆ.",
        "Skip the blank page — let AI suggest your family&apos;s heritage": "ಖಾಲಿ ಪುಟವನ್ನು ಬಿಟ್ಟುಬಿಡಿ — ನಿಮ್ಮ ಕುಟುಂಬದ ಪರಂಪರೆಯನ್ನು AI ಸೂಚಿಸಲು ಬಿಡಿ",
        "Tap to view": "ನೋಡಲು ತಟ್ಟಿರಿ",
        "This is a record-keeping repository — not a diagnosis, treatment or medical-advice tool.": "ಇದು ದಾಖಲೆಗಳನ್ನು ಇಟ್ಟುಕೊಳ್ಳುವ ಸಂಗ್ರಹಣೆ — ನಿರ್ಣಯ, ಚಿಕಿತ್ಸೆ ಅಥವಾ ವೈದ್ಯಕೀಯ ಸಲಹೆ ನೀಡುವ ಸಾಧನವಲ್ಲ.",
        "This repository is for private family record-keeping and health-history awareness only — it does not provide diagnosis, treatment, risk prediction or medical advice. Always consult a qualified healthcare provider.": "ಈ ಸಂಗ್ರಹಣೆಯನ್ನು ಖಾಸಗಿ ಕುಟುಂಬದ ದಾಖಲೆ ನಿರ್ವಹಣೆ ಮತ್ತು ಆರೋಗ್ಯ ಇತಿಹಾಸದ ಅರಿವುಗಾಗಿ ಮಾತ್ರ ಬಳಸಬೇಕು — ಇದು ಯಾವುದೇ ನಿರ್ಣಯ, ಚಿಕಿತ್ಸೆ, ಅಪಾಯ ಅಂದಾಜು ಅಥವಾ ವೈದ್ಯಕೀಯ ಸಲಹೆ ನೀಡುವುದಿಲ್ಲ. ಯಾವಾಗಲೂ ಅರ್ಹ ವೈದ್ಯಕೀಯ ತಜ್ಞರನ್ನು ಸಂಪರ್ಕಿಸಿ.",
        "This section is private": "ಈ ವಿಭಾಗ ಖಾಸಗಿ ಆಗಿದೆ",
        "Timezones spread": "ಸಮಯ ವಲಯಗಳ ವ್ಯಾಪ್ತಿ",
        "Tip": "ಸಲಹೆ",
        "Title": "ಹುದ್ದೆ/ಪದವಿ",
        "Tree completeness": "ವಂಶವೃಕ್ಷದ ಸಂಪೂರ್ಣತೆ",
        "Update": "ನವೀಕರಿಸಿ",
        "Update their": "ಅವರದನ್ನು ನವೀಕರಿಸಿ",
        "Value (type or tap 🎤)": "ಮೌಲ್ಯ (ಟೈಪ್ ಮಾಡಿ ಅಥವಾ 🎤 ಒತ್ತಿ)",
        "Visual Family Tree": "ದೃಶ್ಯ ವಂಶವೃಕ್ಷ",
        "Voice language": "ಧ್ವನಿ ಭಾಷೆ",
        "What's missing": "ಏನು ಬಾಕಿಯಿದೆ",
        "Where Your Family Lives — Across the World": "ನಿಮ್ಮ ಕುಟುಂಬ ಎಲ್ಲಿದೆ — ವಿಶ್ವದಾದ್ಯಂತ",
        "are provided in the section below —": "ಕೆಳಗಿನ ವಿಭಾಗದಲ್ಲಿ ಒದಗಿಸಲಾಗಿದೆ —",
        "bank locker": "ಬ್ಯಾಂಕ್ ಲಾಕರ್",
        "can be preserved in this section. The documents associated with these important information are required to be preserved at a different location, which is a special privilege of our": "ಈ ವಿಭಾಗದಲ್ಲಿ ಸಂರಕ್ಷಿಸಬಹುದು. ಈ ಮಹತ್ವದ ಮಾಹಿತಿಗೆ ಸಂಬಂಧಿಸಿದ ದಾಖಲೆಗಳನ್ನು ಬೇರೆ ಸ್ಥಳದಲ್ಲಿ ಸಂರಕ್ಷಿಸಿ ಇರಿಸುವುದು ಅಗತ್ಯ, ಇದೊಂದು ನಮ್ಮ",
        "complete. Tick off the items below to grow it further.": "ಸಂಪೂರ್ಣವಾಗಿದೆ. ಇದನ್ನು ಇನ್ನಷ್ಟು ಬೆಳೆಸಲು ಕೆಳಗಿನ ಅಂಶಗಳನ್ನು ಗುರುತು ಹಾಕಿ.",
        "customers.": "ಗ್ರಾಹಕರಿಗೆ ಲಭ್ಯವಿರುವ ವಿಶೇಷ ಸೌಲಭ್ಯವಾಗಿದೆ.",
        "descriptive information": "ವಿವರಣಾತ್ಮಕ ಮಾಹಿತಿ",
        "e.g. Dadu's Birthday": "ಉದಾ. ದಾದು ಅವರ ಹುಟ್ಟುಹಬ್ಬ",
        "family-only visibility · Family Head controls writing · explicit informed consent · encrypted storage · full audit trail of every change · DPDP Act 2023 aligned. Coming next: disease timeline, maternal/paternal branch views & emergency health card.": "ಕುಟುಂಬ ಸದಸ್ಯರಿಗೆ ಮಾತ್ರ ಗೋಚರಿಕೆ · ಬರಹದ ನಿಯಂತ್ರಣ ಕುಟುಂಬ ಮುಖ್ಯಸ್ಥರ ಬಳಿ · ಸ್ಪಷ್ಟ ಹಾಗೂ ತಿಳಿದಿರುವ ಒಪ್ಪಿಗೆ · ಎನ್ಕ್ರಿಪ್ಟ್ ಮಾಡಿದ ಸಂಗ್ರಹಣೆ · ಪ್ರತಿಯೊಂದು ಬದಲಾವಣೆಯ ಸಂಪೂರ್ಣ ದಾಖಲೆ · DPDP Act 2023 ಗೆ ಹೊಂದಿಕೆಯಾಗಿರುವುದು. ಮುಂದೇನು: ರೋಗದ ಸಮಯರೇಖೆ, ಮಾತೃ/ಪಿತೃ ಶಾಖೆಗಳ ನೋಟಗಳು ಮತ್ತು ತುರ್ತು ಆರೋಗ್ಯ ಕಾರ್ಡ್.",
        "on the profile page, and they'll appear on the map instantly.": "ಪ್ರೊಫೈಲ್ ಪುಟದಲ್ಲಿ, ಅಲ್ಲಿ ನಮೂದಿಸಿದ ಕೂಡಲೆ ಅವು ನಕ್ಷೆಯಲ್ಲಿ ಕಾಣಿಸುತ್ತವೆ.",
        "or": "ಅಥವಾ",
        "plans — preserve multi-generation medical history, hereditary conditions, allergies, vaccinations and more.": "ಯೋಜನೆಗಳಲ್ಲಿ — ಅನೇಕ ಪೀಳಿಗೆಯ ವೈದ್ಯಕೀಯ ಇತಿಹಾಸ, ವಂಶಪಾರಂಪರ್ಯ ಕಾಯಿಲೆಗಳು, ಅಲರ್ಜಿಗಳು, ಲಸಿಕೆಗಳು ಮತ್ತು ಇನ್ನಷ್ಟು ಮಾಹಿತಿಗಳನ್ನು ಸಂರಕ್ಷಿಸಿ.",
        "please note that you are preserving very important and vital information. Please make sure you save important information only if you want to preserve it on this platform in a highly secured manner by using a proper password. All the documents here are preserved as if they are kept in a": "ದಯವಿಟ್ಟು ಗಮನಿಸಿ, ನೀವು ಇಲ್ಲಿ ಅತ್ಯಂತ ಮಹತ್ವದ ಮತ್ತು ಅಪರೂಪದ ಮಾಹಿತಿಯನ್ನು ಸಂರಕ್ಷಿಸುತ್ತಿದ್ದೀರಿ. ಈ ವೇದಿಕೆಯಲ್ಲಿ ನೀವು ನಿಜವಾಗಿಯೂ ಸಂರಕ್ಷಿಸಲು ಬಯಸುವ ಮಹತ್ವದ ಮಾಹಿತಿಯನ್ನು ಮಾತ್ರ, ಸರಿಯಾದ ಗುಪ್ತಪದವನ್ನು ಬಳಸಿ, ಅತ್ಯಂತ ಸುರಕ್ಷಿತ ರೀತಿಯಲ್ಲಿ ಉಳಿಸಿ. ಇಲ್ಲಿ ಇರುವ ಎಲ್ಲಾ ದಾಖಲೆಗಳನ್ನು, ಅವುಗಳನ್ನು ಒಂದೇ ಒಂದು",
        "step relations, adopted relations, close relatives and extended relatives": "ಸವೊಂದಿನ ಸಂಬಂಧಗಳು, ದತ್ತಕ ಸಂಬಂಧಗಳು, ಹತ್ತಿರದ ಬಂಧುಗಳು ಮತ್ತು ದೂರದ ಬಂಧುಗಳು",
        "these will not appear on your pictorial family tree view.": "ಇವು ನಿಮ್ಮ ಚಿತ್ರಾತ್ಮಕ ವಂಶವೃಕ್ಷ ದೃಶ್ಯದಲ್ಲಿ ಕಾಣಿಸುವುದಿಲ್ಲ.",
        "© 2026 Digital Family Tree. All rights reserved.": "© 2026 Digital Family Tree. ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
        "21 sections of guided wisdom — the values, lessons and stories you want to pass down.": "ಮಾರ್ಗದರ್ಶಕ ಜ್ಞಾನದಿಂದ ಕೂಡಿದ 21 ವಿಭಾಗಗಳು — ನೀವು ಮುಂದಿನ ತಲೆಮಾರಿಗೆ ಹಂಚಲು ಬಯಸುವ ಮೌಲ್ಯಗಳು, ಪಾಠಗಳು ಮತ್ತು ಕಥೆಗಳು.",
        "AI-POWERED": "AI-POWERED",
        "Aadhaar, property papers, wills and certificates — stored privately and shared only with the people you choose.": "ಆಧಾರ್, ಆಸ್ತಿ ದಾಖಲೆಗಳು, ವಿಲ್‌ಗಳು ಮತ್ತು ಪ್ರಮಾಣಪತ್ರಗಳು — ಖಾಸಗಿಯಾಗಿ ಸಂಗ್ರಹಿಸಿ, ನೀವು ಆಯ್ಕೆ ಮಾಡುವವರೊಡನೆ ಮಾತ್ರ ಹಂಚಿಕೊಳ್ಳಿ.",
        "Achievements Wall": "ಸಾಧನೆಗಳ ಗೋಡೆ",
        "Ask anything about your family — heritage, relationships, memories — and get instant AI answers.": "ನಿಮ್ಮ ಕುಟುಂಬದ ಬಗ್ಗೆ ಏನು ಬೇಕಾದರೂ ಕೇಳಿ — ಪರಂಪರೆ, ಸಂಬಂಧಗಳು, ನೆನಪುಗಳು — ಮತ್ತು ತಕ್ಷಣ AI ಉತ್ತರಗಳನ್ನು ಪಡೆಯಿರಿ.",
        "Audio Memories (Voice Stories)": "ಧ್ವನಿ ನೆನಪುಗಳು (ವಾಯ್ಸ್ ಸ್ಟೋರೀಸ್)",
        "Begin your family tree journey": "ನಿಮ್ಮ ಕುಟುಂಬ ವೃಕ್ಷದ ಪ್ರಯಾಣವನ್ನು ಪ್ರಾರಂಭಿಸಿ",
        "Birthdays, anniversaries and festivals happening for your family today — one tap to wish.": "ಇಂದು ನಿಮ್ಮ ಕುಟುಂಬದಲ್ಲಿ ಇರುವ ಹುಟ್ಟುಹಬ್ಬಗಳು, ವಾರ್ಷಿಕೋತ್ಸವಗಳು ಮತ್ತು ಹಬ್ಬಗಳು — ಒಂದು ಟ್ಯಾಪ್‌ನಲ್ಲೇ ಶುಭಾಶಯ ಕಳುಹಿಸಿ.",
        "Blood groups, allergies, chronic conditions and emergency contacts — accessible when it matters most.": "ರಕ್ತ ಗುಂಪುಗಳು, ಅಲರ್ಜಿಗಳು, ದೀರ್ಘಕಾಲದ ಆರೋಗ್ಯ ಸ್ಥಿತಿಗಳು ಮತ್ತು ತುರ್ತು ಸಂಪರ್ಕ ವಿವರಗಳು — ಅತ್ಯಂತ ಅಗತ್ಯವಾಗುವಾಗ ಎಲ್ಲವೂ ಲಭ್ಯ.",
        "Bring parents, siblings and cousins into your private family space — everyone adds their memories, and the tree grows together.": "ತಾಯಿ-ತಂದೆ, ಸಹೋದರ-ಸಹೋದರಿಯರು ಮತ್ತು ಸಂಬಂಧಿಕರನ್ನು ನಿಮ್ಮ ಖಾಸಗಿ ಕುಟುಂಬ ಪ್ರದೇಶಕ್ಕೆ ಆಹ್ವಾನಿಸಿ — ಪ್ರತಿಯೊಬ್ಬರೂ ತಮ್ಮ ನೆನಪುಗಳನ್ನು ಸೇರಿಸಿ, ಕುಟುಂಬ ವೃಕ್ಷವು ಒಟ್ಟಾಗಿ ಬೆಳೆಯುತ್ತದೆ.",
        "CULTURE & TRADITIONS": "ಸಂಸ್ಕೃತಿ ಮತ್ತು ಸಂಪ್ರದಾಯಗಳು",
        "Capture a memory in your own voice. We'll transcribe, translate and preserve it for future generations.": "ಒಂದು ನೆನಪನ್ನು ನಿಮ್ಮ ಸ್ವಂತ ಧ್ವನಿಯಲ್ಲಿ ದಾಖಲಿಸಿ. ನಾವು ಅದನ್ನು ಬರಹಕ್ಕೆ ಇಳಿಸಿ, ಭಾಷಾಂತರಿಸಿ, ಮುಂದಿನ ತಲೆಮಾರುಗಳಿಗೆ ಉಳಿಸಿಡುತ್ತೇವೆ.",
        "Celebrate doctors, engineers, artists and every achiever in your family — a wall of pride for generations to see.": "ನಿಮ್ಮ ಕುಟುಂಬದ ವೈದ್ಯರು, ಇಂಜಿನಿಯರ್‌ಗಳು, ಕಲಾವಿದರು ಮತ್ತು ಪ್ರತಿಯೊಬ್ಬ ಸಾಧಕರನ್ನು ಸಂಭ್ರಮಿಸಿ — ತಲೆಮಾರುಗಳು ಹೆಮ್ಮೆಪಡುವ ಸಾಧನೆಗಳ ಗೋಡೆ.",
        "Choose the package that fits your family — upgrade anytime, and unlock more features as your legacy grows.": "ನಿಮ್ಮ ಕುಟುಂಬಕ್ಕೆ ಸೂಕ್ತವಾದ ಪ್ಯಾಕೇಜ್‌ನ್ನು ಆಯ್ಕೆಮಾಡಿ — ಯಾವಾಗ ಬೇಕಾದರೂ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ, ನಿಮ್ಮ ಪರಂಪರೆ ವಿಸ್ತರಿಸಿದಂತೆ ಹೆಚ್ಚು ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ಅನ್ಲಾಕ್ ಮಾಡಿ.",
        "Complete legacy suite with AI tools": "AI ಸಾಧನಗಳೊಡನೆ ಸಂಪೂರ್ಣ ಲೆಗಸಿ ಪ್ಯಾಕೇಜ್",
        "Connections": "ಸಂಪರ್ಕಗಳು",
        "Culture & Rituals Archive": "ಸಂಸ್ಕೃತಿ ಮತ್ತು ಆಚರಣೆಗಳ ಭಂಡಾರ",
        "Demo Coming Soon": "ಡೆಮೊ ಅತ್ಯಂತ ಶೀಘ್ರದಲ್ಲೇ ಲಭ್ಯ",
        "Demo pricing — final packages will be announced soon. Selection is saved to your account.": "ಡೆಮೊ ಬೆಲೆಗಳು — ಅಂತಿಮ ಪ್ಯಾಕೇಜ್‌ಗಳನ್ನು ಬೇಗನೆ ಪ್ರಕಟಿಸಲಾಗುತ್ತದೆ. ನೀವು ಮಾಡಿದ ಆಯ್ಕೆ ನಿಮ್ಮ ಖಾತೆಯಲ್ಲಿ ಉಳಿಯುತ್ತದೆ.",
        "Digital Family Tree (Print-ready)": "ಡಿಜಿಟಲ್ ಕುಟುಂಬ ವೃಕ್ಷ (ಮುದ್ರಣಕ್ಕೆ ಸಿದ್ಧ)",
        "EMERGENCY INFO": "ತುರ್ತು ಮಾಹಿತಿ",
        "EVENTS & DATES": "ಕಾರ್ಯಕ್ರಮಗಳು ಮತ್ತು ದಿನಾಂಕಗಳು",
        "Events & Reminders": "ಕಾರ್ಯಕ್ರಮಗಳು ಮತ್ತು ನೆನಪಿನ ಸೂಚನೆಗಳು",
        "Every family member at a glance — search, filter and open any profile in one tap.": "ಒಮ್ಮೆ ನೋಡುತ್ತಿದ್ದಂತೆಯೇ ಪ್ರತಿಯೊಬ್ಬ ಕುಟುಂಬ ಸದಸ್ಯರನ್ನೂ ಹುಡುಕಿ, ಫಿಲ್ಟರ್ ಮಾಡಿ, ಒಂದು ಸ್ಪರ್ಶದಲ್ಲಿ ಯಾವುದೇ ಪ್ರೊಫೈಲ್ ತೆರೆಯಿರಿ.",
        "Every milestone across generations — arranged as one continuous, beautiful story.": "ಪೀಳಿಗೆಗಳ ಪಯಣದಲ್ಲಿ ನಡೆದ ಎಲ್ಲ ಮಹತ್ವದ ಘಟ್ಟಗಳು — ಒಂದೇ ಹಿರಿಮೆಯ, ನಿರಂತರ ಕಥೆಯಾಗಿ ಅಂದವಾಗಿ ಜೋಡಣೆಗೊಂಡಿವೆ.",
        "Every new member, photo, story and record — see everything happening in your family, as it happens.": "ಪ್ರತಿ ಹೊಸ ಸದಸ್ಯ, ಫೋಟೋ, ಕಥೆ ಮತ್ತು ದಾಖಲೆ — ನಿಮ್ಮ ಕುಟುಂಬದಲ್ಲಿ ಏನಾಗುತ್ತಿದೆ ಎಂಬುದನ್ನೆಲ್ಲ 그것ೇ ನಡೆಯುವ ಹೊತ್ತಿನಲ್ಲೇ ನೋಡಿ.",
        "Every photo, voice note and story preserved forever — safely inside your family vault.": "ಪ್ರತಿ ಫೋಟೋ, ಧ್ವನಿ ಟಿಪ್ಪಣಿ ಮತ್ತು ಕಥೆಯನ್ನು ಶಾಶ್ವತವಾಗಿ — ಸುರಕ್ಷಿತವಾಗಿ ನಿಮ್ಮ ಕುಟುಂಬದ ಸಂಗ್ರಹದಲ್ಲೇ ಕಾಯ್ದಿರಿಸಿ.",
        "Everything, forever — one payment": "ಎಲ್ಲವೂ, ಯಾವತ್ತಿಗೂ — ಒಂದು ಬಾರಿ ಪಾವತಿ",
        "Expert Biography Writing": "ಪಂಡಿತರಿಂದ ಜೀವನಚರಿತ್ರೆ ಬರೆಯಿಸುವ ಸೇವೆ",
        "Export everything you've saved — members, stories, memories, records — in the format that suits you. Your data is always yours.": "ನೀವು ಉಳಿಸಿರುವ ಎಲ್ಲಾ — ಸದಸ್ಯರು, ಕಥೆಗಳು, ನೆನಪುಗಳು, ದಾಖಲೆಗಳು — ನಿಮಗೆ ಅನುಕೂಲವಾದ ರೂಪದಲ್ಲಿ ಹೊರತೆಗೆದುಕೊಳ್ಳಿ. ನಿಮ್ಮ ಡೇಟಾ ಯಾವಾಗಲೂ ನಿಮ್ಮದೇ.",
        "FAMILY STATISTICS": "ಕುಟುಂಬದ ಅಂಕಿಅಂಶಗಳು",
        "FAMILY TIMELINE": "ಕುಟುಂಬದ ಕಾಲರೇಖೆ",
        "FAMILY WORLD MAP": "ಕುಟುಂಬ ವಿಶ್ವ ನಕ್ಷೆ",
        "Family Activity": "ಕುಟುಂಬ ಚಟುವಟಿಕೆ",
        "Family Calendar & Celebrations": "ಕುಟುಂಬ ಕ್ಯಾಲೆಂಡರ್ ಮತ್ತು ಸಂಭ್ರಮಗಳು",
        "Family Pride": "ಕುಟುಂಬದ ಹೆಮ್ಮೆ",
        "Family Records": "ಕುಟುಂಬದ ದಾಖಲೆಗಳು",
        "Family Tree Builder (6 generations)": "ಕುಟುಂಬ ವಂಶವೃಕ್ಷ ನಿರ್ಮಾಣ (6 ಪೀಳಿಗೆಗಳು)",
        "Family World Map": "ಕುಟುಂಬ ವಿಶ್ವ ನಕ್ಷೆ",
        "Gold": "ಗೋಲ್ಡ್",
        "HEALTH & EMERGENCY": "ಆರೋಗ್ಯ ಮತ್ತು ತುರ್ತುಸೇವೆ",
        "HEALTH REPOSITORY": "ಆರೋಗ್ಯ ಸಂಗ್ರಹ",
        "Health & Medical Repository (10 registers)": "ಆರೋಗ್ಯ ಮತ್ತು ವೈದ್ಯಕೀಯ ಸಂಗ್ರಹ (10 ದಾಖಲೆಗಳು)",
        "How large is your family across generations? Longevity, geography, professions and more.": "ಪೀಳಿಗೆಗಳ ತುಂಬ ನಿಮ್ಮ ಕುಟುಂಬ ಎಷ್ಟು ದೊಡ್ಡದು? ದೀರ್ಘಾಯುಷ್ಯ, ವಾಸಸ್ಥಳ, ವೃತ್ತಿಗಳು ಮತ್ತು ಇನ್ನಷ್ಟು.",
        "Keep every family member's blood group in one secure place. In an emergency, every second counts — this registry helps you instantly find the right donor within your family.": "ಪ್ರತಿ ಕುಟುಂಬ ಸದಸ್ಯರ ರಕ್ತದ ಗುಂಪನ್ನು ಒಂದು ಸುರಕ್ಷಿತ ಸ್ಥಳದಲ್ಲಿ ಇಟ್ಟುಕೊಳ್ಳಿ. ತುರ್ತು ಸಂದರ್ಭಗಳಲ್ಲಿ ಪ್ರತಿ ಕ್ಷಣವೂ ಮುಖ್ಯ — ಈ ನೋಂದಣಿ ನಿಮ್ಮ ಕುಟುಂಬದಲ್ಲೇ ತಕ್ಷಣ ಸೂಕ್ತ ದಾತರನ್ನು ಹುಡುಕಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ.",
        "LEGACY & MEMORIAL": "ಪಾರಂಪರ್ಯ ಮತ್ತು ಸ್ಮಾರಕ",
        "LEGAL & LEGACY": "ಕಾನೂನು ಮತ್ತು ಪಾರಂಪರ್ಯ",
        "Legacy Lifetime": "ಪಾರಂಪರ್ಯ ಜೀವನಕಾಲ",
        "Legal Vault (Will & Nominee)": "ಕಾನೂನು ಸಂಗ್ರಹ (ವಿಲ್ ಮತ್ತು ನಾಮನಿರ್ದೇಶಿತ)",
        "Let AI compose a heartfelt narrative of your family's journey from the profiles you've filled.": "ನೀವು ತುಂಬಿರುವ ವೈಯಕ್ತಿಕ ವಿವರಗಳಿಂದ ನಿಮ್ಮ ಕುಟುಂಬದ ಪ್ರಯಾಣದ ಹೃತ್ಪೂರ್ವಕ ಕಥನವನ್ನು AI ಮೂಲಕ ರಚಿಸಿಕೊಳ್ಳಿ.",
        "MEMORIES & STORIES": "ಸ್ಮೃತಿಗಳು ಮತ್ತು ಕಥೆಗಳು",
        "Marriage Records": "ವಿವಾಹ ದಾಖಲೆಗಳು",
        "Member Profiles & Photos": "ಸದಸ್ಯರ ಪ್ರೊಫೈಲ್‌ಗಳು ಮತ್ತು ಫೋಟೋಗಳು",
        "Memories & reminders for the whole family": "ಮುಕ್ತಾಯ ಕುಟುಂಬದ ಸ್ಮೃತಿಗಳು ಮತ್ತು ನೆನಪು ಸೂಚನೆಗಳು",
        "Multi-user Family Access (Invites)": "ಬಹು-ಬಳಕೆದಾರ ಕುಟುಂಬ ಪ್ರವೇಶ (ಆಹ್ವಾನಗಳು)",
        "Never miss a birthday, anniversary or festival — smart reminders from your family tree, delivered by email, push and in-app.": "ಹುಟ್ಟುಹಬ್ಬ, ವಾರ್ಷಿಕೋತ್ಸವ ಅಥವಾ ಹಬ್ಬವನ್ನು ಎಂದಿಗೂ ಮಿಸ್ ಮಾಡಿಕೊಳ್ಳಬೇಡಿ — ಇಮೇಲ್, ಪುಷ್ ಮತ್ತು ಆಪ್‌ನ ಮೂಲಕ ನಿಮ್ಮ ಕುಟುಂಬ ವೃಕ್ಷದಿಂದ ಬರುವ ಚತುರ ನೆನಪು ಸೂಚನೆಗಳು.",
        "One place for every birthday, anniversary, shraddha and cultural festival — with smart nudges.": "ಪ್ರತಿ ಹುಟ್ಟುಹಬ್ಬ, ವಾರ್ಷಿಕೋತ್ಸವ, ಶ್ರಾದ್ಧ ಮತ್ತು ಸಾಂಸ್ಕೃತಿಕ ಹಬ್ಬಕ್ಕಾಗಿ ಒಂದೇ ಸ್ಥಳ — ಚತುರ ಸೂಚನೆಗಳೊಂದಿಗೆ.",
        "Personal Vault": "ವೈಯಕ್ತಿಕ ಸಂಗ್ರಹ",
        "Prescriptions, reports and hospital records for every family member — organized and searchable.": "ಪ್ರತಿ ಕುಟುಂಬ ಸದಸ್ಯರ ಔಷಧ ಪತ್ರಿಕೆಗಳು, ವರದಿಗಳು ಮತ್ತು ಆಸ್ಪತ್ರೆ ದಾಖಲೆಗಳು — ಸರಿಯಾಗಿ ಜೋಡಿಸಿ, ಸುಲಭವಾಗಿ ಹುಡುಕಬಹುದು.",
        "Preserve wedding dates, venues and couple details — anniversaries flow automatically into your family calendar and timeline.": "ವಿವಾಹದ ದಿನಾಂಕಗಳು, ಸ್ಥಳಗಳು ಮತ್ತು ದಂಪತಿಯ ವಿವರಗಳನ್ನು ಉಳಿಸಿ — ವಾರ್ಷಿಕೋತ್ಸವಗಳು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ನಿಮ್ಮ ಕುಟುಂಬ ಕ್ಯಾಲೆಂಡರ್ ಮತ್ತು ಟೈಮ್ಲೈನ್‌ಗೆ ಸೇರುತ್ತವೆ.",
        "Priority Support": "ಪ್ರಾಥಮಿಕ ಸಹಾಯ",
        "Rituals, recipes, dialects and heritage — everything that makes your family uniquely yours.": "ವಿಧಿವಿಧಾನಗಳು, ಪಾಕವಿಧಾನಗಳು, ಉಪಭಾಷೆಗಳು ಮತ್ತು ಪರಂಪರೆ — ನಿಮ್ಮ ಕುಟುಂಬವನ್ನು ವಿಶಿಷ್ಟವಾಗಿಸುವ ಪ್ರತಿಯೊಂದು ಸಂಗತಿ.",
        "SHARE & CELEBRATE": "ಹಂಚಿಕೊಳ್ಳಿ ಮತ್ತು ಆಚರಿಸಿ",
        "Seal messages, photos and videos to open on future birthdays, anniversaries or a chosen date.": "ಭವಿಷ್ಯದ ಜನ್ಮದಿನಗಳು, ವಾರ್ಷಿಕೋತ್ಸವಗಳು ಅಥವಾ ನೀವು ಆರಿಸಿದ ದಿನಕ್ಕೆ ತೆರೆಯುವಂತೆ ಸಂದೇಶಗಳು, ಫೋಟೋಗಳು ಮತ್ತು ವೀಡಿಯೊಗಳನ್ನು ಮುಚ್ಚಿಟ್ಟು ಉಳಿಸಿಕೊಳ್ಳಿ.",
        "See every family member on a real world map. Each pin shows a current location (orange) and a native place (green), connected by a dotted line — a beautiful visual of your family's journey through geography.": "ನಿಜಜಗತ್ತಿನ نقಶೆಯಲ್ಲಿ ಪ್ರತಿಯೊಬ್ಬ ಕುಟುಂಬ ಸದಸ್ಯನನ್ನೂ ನೋಡಿ. ಪ್ರತಿ ಪಿನ್ ಒಂದೊಂದು ಪ್ರಸ್ತುತ ಸ್ಥಳವನ್ನು (ಕಿತ್ತಳೆ ಬಣ್ಣ) ಮತ್ತು ಮೂಲಸ್ಥಳವನ್ನು (ಹಸಿರು) ತೋರಿಸುತ್ತದೆ; ಇವು ಚುಕ್ಕೆಗೀತ ರೇಖೆಯಿಂದ ಸಂಪರ್ಕಗೊಂಡಿರುತ್ತವೆ — ನಿಮ್ಮ ಕುಟುಂಬದ ಭೌಗೋಳಿಕ ಪ್ರಯಾಣದ ಸುಂದರ ದೃಶ್ಯ.",
        "Share the gift of legacy — invite friends to build their own private family tree, free to start.": "ಪರಂಪರೆಯ ಉಡುಗೊರೆಯನ್ನು ಹಂಚಿಕೊಳ್ಳಿ — ಸ್ನೇಹಿತರನ್ನು ತಮ್ಮದೇ ಖಾಸಗಿ ಕುಟುಂಬ ವಂಶವೃಕ್ಷವನ್ನು ನಿರ್ಮಿಸಲು ಆಹ್ವಾನಿಸಿ; ಆರಂಭಿಸಲು ಉಚಿತ.",
        "Silver": "ಸಿಲ್ವರ್",
        "Smart Reminders (Email + Push)": "ಸ್ಮಾರ್ಟ್ ರಿಮೈಂಡರ್‌ಗಳು (ಇಮೇಲ್ + ಪುಷ್)",
        "Starter": "ಸ್ಟಾರ್ಟರ್",
        "TIME CAPSULES": "ಟೈಮ್ ಕ್ಯಾಪ್ಸ್ಯೂಲುಗಳು",
        "TODAY'S CELEBRATIONS": "ಇಂದಿನ ಆಚರಣೆಗಳು",
        "Turn your family tree into a beautiful shareable poster — perfect for wedding invites, festivals and print.": "ನಿಮ್ಮ ಕುಟುಂಬ ವಂಶವೃಕ್ಷವನ್ನು ಹಂಚಿಕೊಳ್ಳಲು ಸೂಕ್ತವಾದ ಸುಂದರ ಪೋಸ್ಟರ್ ಆಗಿ ರೂಪಿಸಿ — ಮದುವೆಯ ಆಹ್ವಾನ ಪತ್ರಿಕೆಗಳು, ಹಬ್ಬಗಳು ಮತ್ತು ಮುದ್ರಣಕ್ಕೆ ಅಚ್ಚುಮೆಚ್ಚು.",
        "VOICE & STORIES": "ಸ್ವರ ಮತ್ತು ಕಥೆಗಳು",
        "Watch Demo": "ಡೆಮೊ ವೀಕ್ಷಿಸಿ",
        "Wills, power-of-attorney, property papers and nominee details — locked and always accessible to the right people.": "ವಸಿಯತ್ತುಗಳು, ಪವರ್‌ ಆಫ್‌ ಅಟಾರ್ನಿ, ಆಸ್ತಿ ಪತ್ರಗಳು ಮತ್ತು ನಾಮಿನಿ ವಿವರಗಳು — ಸಂರಕ್ಷಿತವಾಗಿದ್ದು, ಸದಾ ಸರಿಯಾದ ವ್ಯಕ್ತಿಗಳಿಗೆ ಮಾತ್ರ ಲಭ್ಯವಾಗುವಂತೆ ಇರಿ.",
        "Your data, your rules — manage account preferences, visibility and every privacy declaration in one place.": "ನಿಮ್ಮ ಡೇಟಾ, ನಿಮ್ಮ ನಿಯಮಗಳು — ಖಾತೆಯ ಆಯ್ಕೆಗಳು, ಕಾಣಿಕೆ (ವಿಸಿಬಿಲಿಟಿ) ಮತ್ತು ಎಲ್ಲ ಗೌಪ್ಯತಾ ಘೋಷಣೆಗಳನ್ನು ಒಂದೇ ಜಾಗದಲ್ಲಿ ನಿರ್ವಹಿಸಿ.",
        "one-time · lifetime": "ಒಮ್ಮೆ · ಜೀವನಪೂರ್ತಿ",
        "per month": "ಪ್ರತಿ ತಿಂಗಳು",
        "per year": "ಪ್ರತಿ ವರ್ಷ",
        "January": "ಜನವರಿ",
        "February": "ಫೆಬ್ರವರಿ",
        "March": "ಮಾರ್ಚ್",
        "April": "ಏಪ್ರಿಲ್",
        "May": "ಮೇ",
        "June": "ಜೂನ್",
        "July": "ಜುಲೈ",
        "August": "ಆಗಸ್ಟ್",
        "September": "ಸೆಪ್ಟೆಂಬರ್",
        "October": "ಅಕ್ಟೋಬರ್",
        "November": "ನವೆಂಬರ್",
        "December": "ಡಿಸೆಂಬರ್",
        "is locked": "ಲಾಕ್ ಮಾಡಲಾಗಿದೆ",
        "Your current package": "ನಿಮ್ಮ ಪ್ರಸ್ತುತ ಪ್ಯಾಕೇಜ್",
        "doesn't include this feature.": "ಈ ಸೌಕರ್ಯವನ್ನು ಒಳಗೊಂಡಿಲ್ಲ.",
        "Included in": "ಇವುಗಳಲ್ಲಿ ಸೇರಿಸಲಾಗಿದೆ",
        "one-time": "ಒಮ್ಮೆ ಮಾತ್ರ",
        "year": "ವರ್ಷ",
        "month": "ತಿಂಗಳು",
        "lifetime": "ಆಜೀವ",
        "Go Back": "ಹಿಂದಕ್ಕೆ ಹೋಗಿ",
        "View Packages": "ಪ್ಯಾಕೇಜ್‌ಗಳನ್ನು ನೋಡಿ",
        "This feature": "ಈ ಸೌಕರ್ಯ",
        "Family Legacy Dashboard": "ಕುಟುಂಬ ಪರಂಪರೆ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
        "Legacy Services": "ಪರಂಪರೆ ಸೇವೆಗಳು",
        "Life Story Vault": "ಜೀವನಕಥೆ ಭಂಡಾರ",
        "Video Testament Library": "ವೀಡಿಯೊ ವಸಿಯತ್ ಗ್ರಂಥಾಲಯ",
        "Family Wisdom Bank": "ಕುಟುಂಬ ಜ್ಞಾನ ಬ್ಯಾಂಕ್",
        "Failure Stories Archive": "ವೈಫಲ್ಯ ಕಥೆಗಳ ಸಂಗ್ರಹ",
        "Success Stories": "ಯಶಸ್ಸಿನ ಕಥೆಗಳು",
        "Family Decision History": "ಕುಟುಂಬ ತೀರ್ಮಾನಗಳ ಇತಿಹಾಸ",
        "Family Values Repository": "ಕುಟುಂಬ ಮೌಲ್ಯಗಳ ಭಂಡಾರ",
        "Family Hero Gallery": "ಕುಟುಂಬ ವೀರರ ಗ್ಯಾಲರಿ",
        "Unsung Heroes": "ಗುರುತಿಸದ ವೀರರು",
        "Gratitude Wall": "ಕೃತಜ್ಞತಾ ಗೋಡೆ",
        "Tribute Pages": "ಸ್ಮರಣಾ ಪುಟಗಳು",
        "Love Letters Archive": "ಪ್ರೀತಿ ಪತ್ರಗಳ ಸಂಗ್ರಹ",
        "Childhood Stories Bank": "ಬಾಲ್ಯದ ಕಥೆಗಳ ಬ್ಯಾಂಕ್",
        "Language Preservation": "ಭಾಷಾ ಸಂರಕ್ಷಣೆ",
        "Ancestral Village": "ಪೂರ್ವಜರ ಗ್ರಾಮ",
        "Surname History": "ಕುಲಹೆಸರಿನ ಇತಿಹಾಸ",
        "Family Emblem": "ಕುಟುಂಬ ಚಿಹ್ನೆ",
        "Cultural Artifacts": "ಸಾಂಸ್ಕೃತಿಕ ವಸ್ತುಗಳು",
        "Family Songs & Bhajans": "ಕುಟುಂಬ ಹಾಡುಗಳು ಮತ್ತು ಭಜನೆಗಳು",
        "Oral History Center": "ಮೌಖಿಕ ಇತಿಹಾಸ ಕೇಂದ್ರ",
        "Biography Writing Platform": "ಚರಿತ್ರೆ ಬರೆಯುವ ವೇದಿಕೆ",
        "Memoir Writing Service": "ಸ್ಮರಣಿಕೆ ಬರವಣಿಗೆ ಸೇವೆ",
        "Personalised Gifting Service": "ವೈಯಕ್ತಿಕೃತ ಉಡುಗೊರೆ ಸೇವೆ",
        "Personal Digital Identity Platform": "ವೈಯಕ್ತಿಕ ಡಿಜಿಟಲ್ ಗುರುತು ವೇದಿಕೆ",
        "Add to": "ಇದಕ್ಕೆ ಸೇರಿಸಿ",
        "Choose": "ಆಯ್ಕೆಮಾಡಿ",
        "Compare all packages": "ಎಲ್ಲಾ ಪ್ಯಾಕೇಜ್‌ಗಳನ್ನು ಹೋಲಿಸಿ",
        "Demo pricing — packages, prices and the feature split are all editable from the admin panel.": "ಡೆಮೊ ಬೆಲೆ — ಪ್ಯಾಕೇಜ್‌ಗಳು, ಬೆಲೆಗಳು ಮತ್ತು ಫೀಚರ್ ಹಂಚಿಕೆ ಇವೆಲ್ಲವನ್ನು ಆಡ್ಮಿನ್ ಪ್ಯಾನಲ್‌ನಲ್ಲಿ ಬದಲಾಯಿಸಬಹುದು.",
        "Feature": "ಫೀಚರ್",
        "Five packages, one family legacy": "ಐದು ಪ್ಯಾಕೇಜ್‌ಗಳು, ಒಂದು ಕುಟುಂಬ ಪರಂಪರೆ",
        "Free": "ಉಚಿತ",
        "Life story, wisdom and biography now live in Family Legacy Dashboard": "ನಿಮ್ಮ ಜೀವನಕತೆ, ಜ್ಞಾನ ಮತ್ತು ಜೀವನಚರಿತ್ರೆ ಈಗ Family Legacy Dashboard ನಲ್ಲಿ ಲಭ್ಯವಿದೆ",
        "Open Family Legacy Dashboard": "Family Legacy Dashboard ತೆರೆಯಿರಿ",
        "Packages & Pricing": "ಪ್ಯಾಕೇಜ್‌ಗಳು ಮತ್ತು ಬೆಲೆ",
        "Packages temporarily unavailable. Please try again shortly.": "ಪ್ಯಾಕೇಜ್‌ಗಳು ತಾತ್ಕಾಲಿಕವಾಗಿ ಲಭ್ಯವಿಲ್ಲ. ದಯವಿಟ್ಟು ಸ್ವಲ್ಪ ಹೊತ್ತಿನ ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
        "Start Free": "ಉಚಿತವಾಗಿ ಪ್ರಾರಂಭಿಸಿ",
        "Start free, upgrade whenever your family is ready. Every feature below is compared side by side so nothing is hidden.": "ಮೊದಲು ಉಚಿತವಾಗಿ ಪ್ರಾರಂಭಿಸಿ, ನಿಮ್ಮ ಕುಟುಂಬ ಸಿದ್ಧವಾದಾಗ ಯಾವಾಗ ಬೇಕಾದರೂ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ. ಕೆಳಗಿನ ಪ್ರತಿಯೊಂದು ಫೀಚರ್‌ನ್ನು ಪಕ್ಕಪಕ್ಕನೆ ಹೋಲಿಸಲಾಗಿದೆ, ಏನೂ ಮರೆಯಾಗಿಲ್ಲ.",
        "Swipe sideways on a phone — the feature column stays in place.": "ಮೊಬೈಲ್‌ನಲ್ಲಿ ಅಡ್ಡವಾಗಿ ಸ್ವೈಪ್ ಮಾಡಿ — ಫೀಚರ್ ಕಾಲಮ್ ಜಾಗದಲ್ಲೇ ಇರುತ್ತದೆ.",
        "more features": "ಇನ್ನಷ್ಟು ಫೀಚರ್‌ಗಳು",
        "Namaste": "ನಮಸ್ತೆ",
        "{sender} has added you to our family tree on Family Repository.": "{sender} ಅವರು ನಿಮ್ಮನ್ನು Family Repositoryಯಲ್ಲಿ ನಮ್ಮ ಕುಟುಂಬ ವಂಶವೃಕ್ಷಕ್ಕೆ ಸೇರಿಸಿದ್ದಾರೆ.",
        "Tap to join": "ಸೇರುವುದುಕ್ಕಾಗಿ ಟ್ಯಾಪ್ ಮಾಡಿ",
        "Your invite code": "ನಿಮ್ಮ ಆಹ್ವಾನ ಕೋಡ್",
        "Together we will preserve our family's stories, photos and voices for the next generations.": "ಒಟ್ಟಿಗೆ ನಾವು ನಮ್ಮ ಕುಟುಂಬದ ಕಥೆಗಳು, ಫೋಟೋಗಳು ಮತ್ತು ಧ್ವನಿಗಳನ್ನು ಮುಂದಿನ ಪೀಳಿಗೆಗಳಿಗಾಗಿ ಸಂರಕ್ಷಿಸೋಣ.",
        "Your family": "ನಿಮ್ಮ ಕುಟುಂಬ",
        "Invite on WhatsApp": "WhatsApp ಮೂಲಕ ಆಹ್ವಾನಿಸಿ",
        "WhatsApp opened with the invite message.": "ಆಹ್ವಾನ ಸಂದೇಶದೊಂದಿಗೆ WhatsApp ತೆರೆಯಲಾಗಿದೆ.",
    },
    ml: {
        "Home": "ഹോം",
        "Family": "കുടുംബം",
        "Family Tree": "കുടുംബവൃക്ഷം",
        "Add a Member": "ഒരു അംഗത്തെ ചേർക്കുക",
        "Invite Family": "കുടുംബത്തെ ക്ഷണിക്കുക",
        "Family Hub · All": "കുടുംബ ഹബ് · എല്ലാം",
        "Family Timeline": "കുടുംബ ടൈംലൈൻ",
        "Family Calendar": "കുടുംബ കലണ്ടർ",
        "Services": "സേവനങ്ങൾ",
        "Photo Memories": "ഫോട്ടോ ഓർമ്മകൾ",
        "Audio Memories": "ഓഡിയോ ഓർമ്മകൾ",
        "AI Family Advisor": "AI കുടുംബ ഉപദേഷ്ടാവ്",
        "AI Story Generator": "AI കഥ സൃഷ്ടി ഉപകരണം",
        "Video Memories": "വീഡിയോ ഓർമ്മകൾ",
        "Digital Family Tree": "ഡിജിറ്റൽ കുടുംബവൃക്ഷം",
        "Family Hall of Fame": "കുടുംബ ഹാൾ ഓഫ് ഫെയിം",
        "Family Hub · All Services": "കുടുംബ ഹബ് · എല്ലാ സേവനങ്ങളും",
        "Records": "റെക്കോർഡുകൾ",
        "Blood Group Registry": "രക്തഗ്രൂപ്പ് രജിസ്ട്രി",
        "Health Repository": "ആരോഗ്യ റെപ്പോസിറ്ററി",
        "Health Score Compliance": "ആരോഗ്യ സ്കോർ അനുയോജ്യത",
        "Emergency Contacts": "അത്യാഹിത ബന്ധങ്ങൾ",
        "Business Directory": "ബിസിനസ് ഡയറക്ടറി",
        "Recipe Vault": "റസിപ്പി വോൾട്ട്",
        "Family Statistics": "കുടുംബ സ്ഥിതിവിവരക്കണക്കുകൾ",
        "Legacy": "വാഴ്‌വക്കുറിപ്പ്",
        "Legal Vault": "ലീഗൽ വോൾട്ട്",
        "Document Vault": "ഡോക്യുമെന്റ് വോൾട്ട്",
        "Story & Wisdom Vault": "കഥയും ജ്ഞാനവും സൂക്ഷിപ്പ്",
        "Family Constitution": "കുടുംബ ഭരണഘടന",
        "Futuristic Legacy Letter": "ഭാവി തലമുറയ്ക്കുള്ള വാഴ്‌വക്കത്ത്",
        "Digital Memorial": "ഡിജിറ്റൽ സ്മാരകം",
        "Account": "അക്കൗണ്ട്",
        "Packages & Plans": "പാക്കേജുകളും പ്ലാനുകളും",
        "Privacy & Settings": "സ്വകാര്യതയും ക്രമീകരണങ്ങളും",
        "Download & Export": "ഡൗൺലോഡ് & എക്‌സ്‌പോർട്ട്",
        "Profile": "പ്രൊഫൈൽ",
        "Search family…": "കുടുംബത്തെ തിരയുക…",
        "Dashboard": "ഡാഷ്‌ബോർഡ്",
        "Families": "കുടുംബങ്ങൾ",
        "Users": "ഉപയോക്താക്കൾ",
        "Subscriptions": "സബ്സ്ക്രിപ്ഷനുകൾ",
        "Packages": "പാക്കേജുകൾ",
        "Exports": "എക്‌സ്‌പോർട്ടുകൾ",
        "Content": "ഉള്ളടക്കം",
        "Landing Slides": "ലാൻഡിംഗ് സ്ലൈഡുകൾ",
        "Site Assets": "സൈറ്റ് ആസറ്റുകൾ",
        "Family Content": "കുടുംബ ഉള്ളടക്കം",
        "Translations": "വിവർത്തനങ്ങൾ",
        "User Page Editor": "ഉപയോക്തൃ പേജ് എഡിറ്റർ",
        "Analytics": "അനലിറ്റിക്സ്",
        "Support Tickets": "സപ്പോർട്ട് ടിക്കറ്റുകൾ",
        "Broadcasts": "ബ്രോഡ്കാസ്റ്റുകൾ",
        "Legacy CRM": "പഴയ CRM",
        "SMS Console": "SMS കൺസോൾ",
        "Security": "സുരക്ഷ",
        "Settings": "സെറ്റിംഗ്സ്",
        "UI/UX Audit": "UI/UX ഓഡിറ്റ്",
        "API Keys": "API കീകൾ",
        "Admin Team": "അഡ്മിൻ ടീം",
        "Content Managers": "കണ്ടന്റ് മാനേജർമാർ",
        "Overview": "അവലോകനം",
        "Members": "അംഗങ്ങൾ",
        "Billing": "ബില്ലിംഗ്",
        "Landing & Content": "ലാൻഡിംഗ് & കണ്ടന്റ്",
        "Insights": "ഇൻസൈറ്റുകൾ",
        "Support": "സപ്പോർട്ട്",
        "System": "സിസ്റ്റം",
        "Super Admin": "സൂപ്പർ അഡ്മിൻ",
        "Content Admin": "കണ്ടന്റ് അഡ്മിൻ",
        "Content Manager": "കണ്ടന്റ് മാനേജർ",
        "Finance Admin": "ഫൈനാൻസ് അഡ്മിൻ",
        "Support Admin": "സപ്പോർട്ട് അഡ്മിൻ",
        "Security Admin": "സെക്യൂരിറ്റി അഡ്മിൻ",
        "Admin": "അഡ്മിൻ",
        "Admin Panel": "അഡ്മിൻ പാനൽ",
        "Logout": "ലോഗ് ഔട്ട്",
        "Loading dashboard…": "ഡാഷ്‌ബോർഡ് ലോഡാകുന്നു…",
        "Platform overview at a glance.": "ഒരു നോട്ടത്തിൽ പ്ലാറ്റ്‌ഫോം അവലോകനം.",
        "Total Families": "ആകെ കുടുംബങ്ങൾ",
        "Total Members": "ആകെ അംഗങ്ങൾ",
        "Tree Persons": "വംശവൃക്ഷത്തിലുള്ള വ്യക്തികൾ",
        "Storage Used": "ഉപയോഗിച്ച സ്റ്റോറേജ്",
        "Marriages": "വിവാഹങ്ങൾ",
        "Memory Albums": "ഓർമ്മ ആൽബങ്ങൾ",
        "Wills (latest)": "വസിയത്തുകൾ (പുതിയത്)",
        "Audio Wills": "ഓഡിയോ വസിയത്തുകൾ",
        "With recorded audio": "റെക്കോർഡുചെയ്ത ഓഡിയോടെ",
        "Across all families": "എല്ലാ കുടുംബങ്ങളിലുമായി",
        "New signups — last 30 days": "പുതിയ സൈൻഅപ്പുകൾ — കഴിഞ്ഞ 30 ദിവസത്ത്",
        "Storage breakdown": "സ്റ്റോറേജ് വിശദാംശങ്ങൾ",
        "No stored files yet.": "ഇനിയും ഫയലുകൾ സൂക്ഷിച്ചിട്ടില്ല.",
        "Signups": "സൈൻഅപ്പുകൾ",
        "suspended": "താൽക്കാലികമായി നിർത്തിയിരിക്കുന്നു",
        "blocked": "തടഞ്ഞിരിക്കുന്നു",
        "paid": "പണം അടച്ചവർ",
        "open tickets": "തുറന്ന ടിക്കറ്റുകൾ",
        "Memory photos": "ഓർമ്മ ചിത്രങ്ങൾ",
        "Vault documents": "വോൾട്ട് ദസ്താവേസുകൾ",
        "Story audio": "കഥകളുടെ ഓഡിയോ",
        "Member profiles & photos": "അംഗങ്ങളുടെ പ്രൊഫൈലുകളും ഫോട്ടോകളും",
        "Profile details": "പ്രൊഫൈൽ വിശദാംശങ്ങൾ",
        "Story metadata": "കഥയുടെ മെറ്റഡാറ്റ",
        "Memory metadata": "ഓർമ്മയുടെ മെറ്റഡാറ്റ",
        "Document metadata": "ഡോക്യുമെന്റ് മെറ്റഡാറ്റ",
        "Admin (Head)": "അഡ്മിൻ (തലവൻ)",
        "added": "ചേർത്തു",
        "updated": "പുതുക്കി",
        "removed": "നീക്കി",
        "changed privacy of": "സ്വകാര്യത മാറ്റി",
        "updated profile of": "പ്രൊഫൈൽ പുതുക്കി",
        "viewed profile of": "പ്രൊഫൈൽ കണ്ടു",
        "recorded": "രേഖപ്പെടുത്തി",
        "played": "പ്ലേ ചെയ്തു",
        "deleted story": "കഥ ഡിലീറ്റ് ചെയ്തു",
        "uploaded": "അപ്‌ലോഡ് ചെയ്തു",
        "viewed": "കണ്ടു",
        "changed access of": "ആക്‌സസ് മാറ്റി",
        "deleted": "ഡിലീറ്റ് ചെയ്തു",
        "invited": "ക്ഷണിച്ചു",
        "revoked an invite": "ഒരു ക്ഷണം പിൻവലിച്ചു",
        "joined the family": "കുടുംബത്തിൽ ചേർന്നു",
        "changed role of": "പങ്ക്/റോൾ മാറ്റി",
        "downloaded their data": "സ്വന്തം ഡാറ്റ ഡൗൺലോഡ് ചെയ്തു",
        "completed privacy setup": "സ്വകാര്യത ക്രമീകരണം പൂർത്തിയാക്കി",
        "deleted account of": "അക്കൗണ്ട് ഇല്ലാതാക്കി",
        "Senior mode on — simpler privacy choices.": "സീനിയർ മോഡ് ഓൺ — എളുപ്പമുള്ള സ്വകാര്യതാ തിരഞ്ഞെടുപ്പുകൾ.",
        "Senior mode off.": "സീനിയർ മോഡ് ഓഫ്.",
        "Saved.": "സേവ് ചെയ്തു.",
        "Your data export has been downloaded.": "താങ്കളുടെ ഡാറ്റ എക്സ്പോർട്ട് ഡൗൺലോഡ് ചെയ്തുകഴിഞ്ഞു.",
        "Your account and data have been deleted.": "താങ്കളുടെ അക്കൗണ്ടും ഡാറ്റയും ഇല്ലാതാക്കി.",
        "Every family tree on the platform. Suspending blocks all its members from logging in.": "പ്ലാറ്റ്‌ഫോമിലുള്ള ഓരോ കുടുംബവംശവൃക്ഷവും. സസ്പെൻഡ് ചെയ്താൽ അതിലെ എല്ലാ അംഗങ്ങൾക്കും ലോഗിൻ ചെയ്യാൻ കഴിയില്ല.",
        "All registered members. Blocked users cannot log in or use the API.": "എല്ലാ രജിസ്റ്റർ ചെയ്ത അംഗങ്ങളും. ബ്ലോക്ക് ചെയ്ത ഉപയോക്താക്കൾക്ക് ലോഗിൻ ചെയ്യാനോ API ഉപയോഗിക്കാനോ കഴിയില്ല.",
        "Manual plan control until a payment gateway is connected in Settings.": "Settings-ൽ ഒരു പേയ്മെൻറ് ഗേറ്റ്‌വേ കണക്റ്റ് ചെയ്യുന്നത് വരെ പ്ലാൻ കൈകാര്യം ചെയ്യുന്നത് മാനുവൽ ആയിരിക്കും.",
        "Growth, engagement and audience mix.": "വളർച്ച, ഉപയോക്തൃ ചരുൾപ്പാട്, പ്രേക്ഷകസംഘത്തിന്റെ മിശ്രണം.",
        "Users raise tickets from Settings → Help in the app.": "ഉപയോക്താക്കൾ ആപ്പിലെ Settings → Help വഴി ടിക്കറ്റുകൾ സമർപ്പിക്കും.",
        "Branding, payment gateway and API keys. Secrets are stored server-side and shown masked.": "Branding, പേയ്മെൻറ് ഗേറ്റ്‌വേ, API keys എന്നിവ. രഹസ്യ വിവരങ്ങൾ സർവർ-സൈഡിൽ സൂക്ഷിക്കുകയും മറച്ചുതോന്നുന്ന രീതിയിൽ മാത്രം കാണിക്കുകയും ചെയ്യും.",
        "Packages — Feature Matrix (Demo)": "പാക്കേജുകൾ — ഫീച്ചർ മാട്രിക്സ് (Demo)",
        "Export Center": "എക്സ്പോർട്ട് സെന്റർ",
        "Download authoritative reports in CSV, Excel or PDF. Schedule auto-email exports below.": "CSV, Excel അല്ലെങ്കിൽ PDF രൂപത്തിൽ വിശ്വസനീയമായ റിപ്പോർട്ടുകൾ ഡൗൺലോഡ് ചെയ്യുക. താഴെ auto-email എക്സ്പോർട്ടുകൾ ഷെഡ്യൂൾ ചെയ്യാം.",
        "Send SMS or WhatsApp announcements to your users.": "നിങ്ങളുടെ ഉപയോക്താക്കൾക്ക് SMS അല്ലെങ്കിൽ WhatsApp വഴി അറിയിപ്പുകൾ അയയ്ക്കുക.",
        "Content Management": "കണ്ടന്റ് മാനേജ്മെന്റ്",
        "Poster templates, landing banners and testimonials curated by the super-admin.": "സൂപ്പർ-അഡ്മിൻ തയ്യാറാക്കുകയും തിരഞ്ഞെടുത്തും വച്ചിരിക്കുന്ന പോസ്റ്റർ ടെംപ്ലേറ്റുകൾ, ലാൻഡിംഗ് ബാനറുകൾ, ടെസ്റ്റിമോണിയലുകൾ.",
        "Platform-wide audit trail, failed logins, DPDP compliance requests, and your MFA credentials.": "മുഴുവൻ പ്ലാറ്റ്‌ഫോമിനുമുള്ള ഓഡിറ്റ് ട്രെയിൽ, പരാജയപ്പെട്ട ലോഗിൻ ശ്രമങ്ങൾ, DPDP അനുസരണ അഭ്യർത്ഥനകൾ, നിങ്ങളുടെ MFA ക്രെഡൻഷ്യലുകൾ എന്നിവ.",
        "Manage who can sign into the admin panel and what they can access.": "ആരും admin panel-ിൽ സൈൻ ഇൻ ചെയ്യണമെന്നതും അവർക്ക് എന്തൊക്കെ ആക്‌സസ് ചെയ്യാം എന്നതും നിയന്ത്രിക്കുക.",
        "Family Content Moderation": "കുടുംബ ഉള്ളടക്ക മേൽനോട്ടം",
        "Listen": "കേൾക്കുക",
        "Stop": "നിർത്തുക",
        "Pause": "താൽക്കാലികമായി നിർത്തുക",
        "Resume": "വീണ്ടും ആരംഭിക്കുക",
        "Generating…": "സൃഷ്ടിക്കുന്നു…",
        "Signup trend — last 90 days": "സൈൻഅപ്പ് പ്രവണതി — കഴിഞ്ഞ 90 ദിവസങ്ങൾ",
        "(or user) is expected to add all their family relationships on the": "(അഥവാ ഉപയോക്താവ്) സ്വന്തമായുള്ള എല്ലാ കുടുംബബന്ധങ്ങളും ചേർക്കേണ്ടതുണ്ടായിരിക്കുന്നത് ഈ",
        ", which can only be opened by your password.": ", ഇത് നിങ്ങളുടെ പാസ്‌വേഡ് ഉപയോഗിച്ചാണ് മാത്രമേ തുറക്കാനാകൂ.",
        ". Any member added there is automatically reflected here. For convenience, a few extra fields for": ". അവിടെ ചേർക്കുന്ന അംഗങ്ങൾ സ്വയം ഇവിടെ പ്രതിഫലിക്കും. ഉപയോഗ സൗകര്യത്തിന്, കുറച്ചു അധിക ഫീൽഡുകൾ കൂടി",
        "A family together": "ഒരുമിച്ച് ഒരു കുടുംബം",
        "A premium feature for your family's future": "നിങ്ങളുടെ കുടുംബത്തിന്റെ ഭാവിക്കായി ഒരു പ്രീമിയം സൗകര്യം",
        "Add": "ചേർക്കുക",
        "Add Event": "ഇവന്റ് ചേർക്കുക",
        "Add custom field": "കസ്റ്റം ഫീൽഡ് ചേർക്കുക",
        "All checks": "എല്ലാ പരിശോധനകളും",
        "Avg age": "ശരാശരി വയസ്സ്",
        "Back": "തിരികെ",
        "Back to Dashboard": "ഡാഷ്ബോർഡിലേക്കു് മടങ്ങുക",
        "Change photo": "ഫോട്ടോ മാറ്റുക",
        "Choose the package that fits your family": "നിങ്ങളുടെ കുടുംബത്തിന് അനുയോജ്യമായ പാക്കേജ് തെരഞ്ഞെടുക്കുക",
        "Classic, Premium and Elite": "ക്ലാസിക്, പ്രീമിയം, എലിറ്റ്",
        "Countries": "രാജ്യങ്ങൾ",
        "Current": "നിലവിലെ",
        "Current Location": "നിലവിലെ സ്ഥലം",
        "Current city": "നിലവിലെ നഗരം",
        "Current locations": "നിലവിലെ സ്ഥലങ്ങൾ",
        "Data is encrypted in transit and at rest; every add/edit/delete is captured in the audit log.": "ഡാറ്റ യാത്രയ്ക്കിടെയും സൂക്ഷിക്കുന്നിടത്തും എൻക്രിപ്റ്റ് ചെയ്‌തിരിക്കുന്നതാണ്; ഓരോ ചേർക്കലും/തിരുത്തലും/ഇല്ലാതാക്കലും ഓഡിറ്റ് ലോഗിൽ രേഖപ്പെടുത്തപ്പെടുന്നു.",
        "Date": "തീയതി",
        "Dear customer,": "പ്രിയ ഉപഭോക്താവേ,",
        "Delete": "ഇല്ലാതാക്കുക",
        "Distinct Cities": "വ്യത്യസ്ത നഗരങ്ങൾ",
        "Family (₹999/yr)": "കുടുംബം (₹999/വർഷം)",
        "Family Head": "കുടുംബ മേധാവി",
        "Family Health": "കുടുംബാരോഗ്യം",
        "Family Members": "കുടുംബാംഗങ്ങൾ",
        "Family Relationships": "കുടുംബബന്ധങ്ങൾ",
        "Favourite mithai": "ഇഷ്ടപ്പെട്ട മിഠായി",
        "Field name": "ഫീൽഡിന്റെ പേര്",
        "Fill with AI": "AI ഉപയോഗിച്ച് പൂരിപ്പിക്കുക",
        "GPT-5.2 fills 40+ fields across all 6 modules from your surname + region · you edit before saving.": "GPT-5.2 നിങ്ങളുടെ വീട്ടുപേറും പ്രദേശവും അടിസ്ഥാനമാക്കി എല്ലാ 6 മോഡ്യൂളുകളിലുമുള്ള 40-ത്തിലധികം ഫീൽഡുകൾ പൂരിപ്പിക്കും · നിങ്ങൾക്ക് സേവ് ചെയ്യുന്നതിനുമുമ്പ് തിരുത്താൻ കഴിയും.",
        "Gaon ka temple": "ഗ്രാമത്തിലെ ക്ഷേത്രം",
        "Generations": "തലമുറകൾ",
        "Health & Medical Repository": "ആരോഗ്യവും മെഡിക്കൽ വിവരശേഖരവും",
        "Health Score Compliance Report": "ഹെൽത്ത് സ്കോർ അനുസരണ റിപ്പോർട്ട്",
        "Health information is stored with explicit consent, only for members whose data you are authorised to record.": "നിങ്ങൾക്ക് രേഖപ്പെടുത്താൻ അധികാരമുള്ള അംഗങ്ങളുടെ ആരോഗ്യവിവരങ്ങൾ മാത്രമേ അവരുടെ വ്യക്തമായ സമ്മതത്തോടുകൂടി സൂക്ഷിക്കപ്പെടുകയുള്ളു.",
        "Help": "സഹాయం",
        "Hide details": "വിശദാംശങ്ങൾ മറയ്ക്കുക",
        "How complete is your family tree?": "നിങ്ങളുടെ കുടുംബവൃക്ഷം എത്ര പൂർണ്ണമാണ്?",
        "Informed consent — one time, per family": "അറിയിച്ച സമ്മതം — ഓരോ കുടുംബത്തിനും ഒരിക്കൽ മാത്രം",
        "Kind": "തരം",
        "Legacy (₹2999/yr)": "ലെഗസി (₹2999/വർഷം)",
        "Linked live from your family tree.": "നിങ്ങളുടെ കുടുംബവൃക്ഷത്തിൽ നിന്ന് തത്സമയമായി ബന്ധിപ്പിച്ചിരിക്കുന്നു.",
        "Living Cities": "ജീവിക്കുന്ന നഗരങ്ങൾ",
        "Loading events…": "ഇവന്റുകൾ ലോഡ് ചെയ്യുന്നു…",
        "Loading packages…": "പാക്കേജുകൾ ലോഡ് ചെയ്യുന്നു…",
        "Loading world map…": "ലോകമാപ്പ് ലോഡ് ചെയ്യുന്നു…",
        "Loading…": "ലോഡ് ചെയ്യുന്നു…",
        "Lucky number": "ഭാഗ്യനമ്പർ",
        "Member Profile": "അംഗത്തിന്റെ പ്രൊഫൈൽ",
        "Most Popular": "ഏറ്റവും ജനപ്രിയം",
        "Native": "സ്വദേശം",
        "Native Place": "സ്വദേശം",
        "Native Places": "സ്വദേശങ്ങൾ",
        "Native places": "സ്വദേശങ്ങൾ",
        "None of your family members have a mapped location yet.": "നിങ്ങളുടെ കുടുംബാംഗങ്ങളിൽ ഒരാളും ഇതുവരെ മാപ്പ് ചെയ്ത ലൊക്കേഷൻ ഇല്ല.",
        "Not a medical diagnosis platform.": "ഇത് ആരോഗ്യം നിർണയിക്കുന്ന മെഡിക്കൽ പ്ലാറ്റ്ഫോം അല്ല.",
        "Not added yet": "ഇനിയും ചേർത്തിട്ടില്ല",
        "Notes (optional)": "കുറിപ്പുകൾ (ഐച്ഛികം)",
        "Place of birth": "ജനനസ്ഥലം",
        "Preserve. Understand. Inform.": "സംരക്ഷിക്കുക. മനസ്സിലാക്കുക. അറിയിക്കുക.",
        "Privacy by design:": "സ്വതവേ സ്വകാര്യത:",
        "Records are visible to your family circle only; the Family Head controls who can add or edit.": "രേഖകൾ നിങ്ങളുടെ കുടുംബവൃത്തത്തിനുള്ളവർക്ക് മാത്രം കാണാനാകും; ആരെല്ലാം ചേർക്കാമെന്ന്‌ അല്ലെങ്കിൽ തിരുത്താമെന്ന് കുടുംബമുഖ്യൻ നിയന്ത്രിക്കും.",
        "Remove": "നീക്കുക",
        "Reset": "പുനഃസജ്ജമാക്കുക",
        "Save &amp; Continue": "സേവ് ചെയ്ത് തുടരുക",
        "Saved ✓": "സേവ് ചെയ്തു ✓",
        "Saving…": "സേവ് ചെയ്യുന്നു…",
        "Sensitive details are hidden by default.": "സെൻസിറ്റീവ് വിവരങ്ങൾ സ്വതവേ മറച്ചിരിക്കും.",
        "Skip the blank page — let AI suggest your family&apos;s heritage": "വെറും പേജ് ഒഴിവാക്കൂ — നിങ്ങളുടെ കുടുംബപാരമ്പര്യം AI നിർദ്ദേശിക്കട്ടെ",
        "Tap to view": "കാണാൻ ടാപ്പ് ചെയ്യുക",
        "This is a record-keeping repository — not a diagnosis, treatment or medical-advice tool.": "ഇത് റെക്കോർഡുകൾ സൂക്ഷിക്കുന്നതിനുള്ള ശേഖരമാണ് — രോഗനിർണയത്തിനോ ചികിത്സയ്ക്കോ മെഡിക്കൽ ഉപദേശത്തിനോ ഉള്ള ഉപകരണമല്ല.",
        "This repository is for private family record-keeping and health-history awareness only — it does not provide diagnosis, treatment, risk prediction or medical advice. Always consult a qualified healthcare provider.": "ഈ ശേഖരം സ്വകാര്യ കുടുംബരേഖകൾ സൂക്ഷിക്കാനും ആരോഗ്യചരിത്രത്തെക്കുറിച്ച് ബോധവൽക്കരണത്തിനുമായി മാത്രമാണ് — ഇത് രോഗനിർണ്ണയവും ചികിൽസയും അപകടസാധ്യത നിർണ്ണയവും അല്ലെങ്കിൽ മെഡിക്കൽ ഉപദേശവും നൽകുന്നില്ല. എപ്പോഴും യോഗ്യനായ ഒരു ആരോഗ്യപ്രവർത്തകനെ സമീപിക്കുക.",
        "This section is private": "ഈ വിഭാഗം സ്വകാര്യമാണ്",
        "Timezones spread": "സമയംമേഖലകളിലെ വ്യാപ്തി",
        "Tip": "സൂചന",
        "Title": "തലക്കെട്ട്",
        "Tree completeness": "വംശവൃക്ഷത്തിന്റെ പൂര്‍ത്തിത്വം",
        "Update": "അപ്‌ഡേറ്റ്",
        "Update their": "അവരുടെത് അപ്‌ഡേറ്റ് ചെയ്യുക",
        "Value (type or tap 🎤)": "വില (ടൈപ്പ് ചെയ്യുക അല്ലെങ്കില്‍ 🎤 തട്ടുക)",
        "Visual Family Tree": "ദൃശ്യവല്‍ക്കരിച്ച കുടുംബവൃക്ഷം",
        "Voice language": "ശബ്ദത്തിന്റെ ഭാഷ",
        "What's missing": "എന്താണ് കുറവ്",
        "Where Your Family Lives — Across the World": "നിങ്ങളുടെ കുടുംബം എവിടെയെല്ലാം ആണ് താമസിക്കുന്നത് — ലോകമൊട്ടാകെ",
        "are provided in the section below —": "താഴെ കൊടുത്തിരിക്കുന്ന വിഭാഗത്തില്‍ നല്‍കിയിരിക്കുന്നു —",
        "bank locker": "ബാങ്ക് ലോക്കര്‍",
        "can be preserved in this section. The documents associated with these important information are required to be preserved at a different location, which is a special privilege of our": "ഈ വിഭാഗത്തില്‍ സൂക്ഷിച്ചു വെക്കാം. ഈ പ്രധാന വിവരങ്ങളുമായി ബന്ധമുള്ള രേഖകള്‍ വേറെ ഒരു സ്ഥലത്ത് സൂക്ഷിക്കേണ്ടതാണ്, അത് ഞങ്ങളുടെ",
        "complete. Tick off the items below to grow it further.": "പൂർത്തിയായി. വൃക്ഷം ഇനിയും വളരാന്‍ താഴെയുള്ള ഇനങ്ങള്‍ ടിക്ക് ചെയ്യുക.",
        "customers.": "ഉപഭോക്താക്കളുടെ പ്രത്യേക സൗകര്യമാണ്.",
        "descriptive information": "വിവരണാത്മക വിവരം",
        "e.g. Dadu's Birthday": "ഉദാ. ദാദുവിന്റെ ജന്മദിനം",
        "family-only visibility · Family Head controls writing · explicit informed consent · encrypted storage · full audit trail of every change · DPDP Act 2023 aligned. Coming next: disease timeline, maternal/paternal branch views & emergency health card.": "കുടുംബാംഗങ്ങള്‍ക്കു മാത്രം കാണാന്‍ കഴിയുന്നു · എഴുത്ത് നിയന്ത്രിക്കുന്നത് കുടുംബ മേധാവിയാണ് · വ്യക്തമായ വിശദീകരണത്തോടെയുള്ള സമ്മതം · എന്‍ക്രിപ്റ്റ് ചെയ്ത സംഭരണം · ഓരോ മാറ്റത്തിന്റെയും പൂര്‍ണമായ ഓഡിറ്റ് ട്രെയില്‍ · DPDP Act 2023 അനുസൃതം. അടുത്തതായി വരുന്നത്: രോഗങ്ങളുടെ ടൈംലൈന്‍, മാതൃ/പിതൃ വംശ ശാഖകളുടെ പ്രത്യേക കാഴ്ചകള്‍, അടിയന്തര ഹെല്‍ത്ത് കാര്‍ഡ്.",
        "on the profile page, and they'll appear on the map instantly.": "പ്രൊഫൈല്‍ പേജില്‍ ചേര്‍ക്കൂ, ഉടന്‍ തന്നെ അത് മാപില്‍ കാണാം.",
        "or": "അല്ലെങ്കില്‍",
        "plans — preserve multi-generation medical history, hereditary conditions, allergies, vaccinations and more.": "പ്ലാനുകള്‍ — പല തലമുറകളിലേയും ചികില്‍സാ ചരിത്രം, പാരമ്പര്യ രോഗങ്ങള്‍, അലര്‍ജികള്‍, വാക്സിനേഷന്‍ എന്നിവയും കൂടുതല്‍ വിവരങ്ങളും സൂക്ഷിക്കാം.",
        "please note that you are preserving very important and vital information. Please make sure you save important information only if you want to preserve it on this platform in a highly secured manner by using a proper password. All the documents here are preserved as if they are kept in a": "ഇവിടെ നിങ്ങള്‍ വളരെ പ്രധാനപ്പെട്ടയും അത്യാവശ്യവുമായ വിവരങ്ങളാണ് സൂക്ഷിക്കുന്നത് എന്ന് ദയവായി ശ്രദ്ധിക്കുക. ഈ പ്ലാറ്റ്ഫോമില്‍ നിങ്ങള്‍ക്ക് അതീവ സുരക്ഷിതമായി, ഒരു ശരിയായ പാസ്‌വേര്‍ഡ് ഉപയോഗിച്ച് സൂക്ഷിച്ച് വെക്കാന്‍ ആഗ്രഹിക്കുന്നുവെന്നുറപ്പുള്ള വിവരങ്ങള്‍ മാത്രമേ ഇവിടെ സേവ് ചെയ്യാവൂ. ഇവിടെ ഉള്ള എല്ലാ രേഖകളും നിങ്ങള്‍ ഒരു",
        "step relations, adopted relations, close relatives and extended relatives": "ഡെഡ്‌റിലേഷൻസ്, ദത്തെടുത്ത ബന്ധങ്ങൾ, അടുത്ത ബന്ധുക്കൾ, ദൂരെ ബന്ധുക്കൾ",
        "these will not appear on your pictorial family tree view.": "ഇവ നിങ്ങളുടെ ചിത്ര രൂപത്തിലുള്ള കുടുംബവൃക്ഷ ദൃശ്യമിൽ കാണിക്കപ്പെടില്ല.",
        "© 2026 Digital Family Tree. All rights reserved.": "© 2026 Digital Family Tree. എല്ലാ അവകാശങ്ങളും സംരക്ഷിതമാണ്.",
        "21 sections of guided wisdom — the values, lessons and stories you want to pass down.": "നിങ്ങൾ അടുത്ത തലമുറയിലേക്ക് പകർന്നു നൽകാൻ ആഗ്രഹിക്കുന്ന മൂല്യങ്ങൾ, ജീവിതപാഠങ്ങൾ, കഥകൾ എന്നിവയ്ക്കായുള്ള 21 ഭാഗങ്ങളിലായുള്ള മാർഗനിർദ്ദേശിത ജ്ഞാനം.",
        "AI-POWERED": "AI-POWERED",
        "Aadhaar, property papers, wills and certificates — stored privately and shared only with the people you choose.": "ആധാർ, സ്വത്ത് രേഖകൾ, വസിയത്തുകൾ, സർട്ടിഫിക്കറ്റുകൾ — സ്വകാര്യമായി സൂക്ഷിച്ച്, നിങ്ങൾ തിരഞ്ഞെടുക്കുന്ന ആളുകളോടു മാത്രം പങ്കിടുക.",
        "Achievements Wall": "വിജയങ്ങളുടെ ഭിത്തി",
        "Ask anything about your family — heritage, relationships, memories — and get instant AI answers.": "നിങ്ങളുടെ കുടുംബത്തെക്കുറിച്ച് — പാരമ്പര്യം, ബന്ധങ്ങൾ, ഓർമ്മകൾ — എന്തും ചോദിക്കൂ, ഉടൻ തന്നെ AI മറുപടികൾ നേടൂ.",
        "Audio Memories (Voice Stories)": "ഓഡിയോ ഓർമ്മകൾ (ശബ്ദകഥകൾ)",
        "Begin your family tree journey": "നിങ്ങളുടെ കുടുംബവൃക്ഷ യാത്ര ആരംഭിക്കൂ",
        "Birthdays, anniversaries and festivals happening for your family today — one tap to wish.": "ഇന്ന് നിങ്ങളുടെ കുടുംബത്തിൽ നടക്കുന്ന പിറന്നാളുകൾ, വാർഷികങ്ങൾ, ഉത്സവങ്ങൾ — ഒറ്റ തട്ടലിൽ ആശംസിക്കൂ.",
        "Blood groups, allergies, chronic conditions and emergency contacts — accessible when it matters most.": "രക്തഗ്രൂപ്പ്, അലർജികൾ, ദീർഘകാല അസുഖങ്ങൾ, അടിയന്തര ബന്ധപ്പെടേണ്ടവർ — ഏറ്റവും ആവശ്യമായ സമയത്ത് എളുപ്പത്തിൽ ലഭ്യമാക്കാം.",
        "Bring parents, siblings and cousins into your private family space — everyone adds their memories, and the tree grows together.": "നിങ്ങളുടെ സ്വകാര്യ കുടുംബസ്ഥലത്ത് മാതാപിതാക്കൾ, സഹോദരങ്ങൾ, സഹോദരപ്പുത്രൻമാർ എന്നിവരെ ക്ഷണിക്കൂ — എല്ലാവരും തങ്ങളുടെ ഓർമ്മകൾ ചേർക്കുമ്പോൾ, കുടുംബവൃക്ഷം ഒരുമിച്ച് വളരും.",
        "CULTURE & TRADITIONS": "സാംസ്കാരവും പാരമ്പര്യങ്ങളും",
        "Capture a memory in your own voice. We'll transcribe, translate and preserve it for future generations.": "ഒരു ഓർമ്മയെ നിങ്ങളുടെ സ്വന്തം ശബ്ദത്തിൽ രേഖപ്പെടുത്തി വയ്ക്കൂ. അതിനെ ഞങ്ങൾ എഴുത്താക്കി, ഭാഷാന്തരം ചെയ്ത്, വരും തലമുറകൾക്കായി സംരക്ഷിക്കും.",
        "Celebrate doctors, engineers, artists and every achiever in your family — a wall of pride for generations to see.": "നിങ്ങളുടെ കുടുംബത്തിലെ ഡോക്ടർമാർ, എഞ്ചിനിയർമാർ, കലാകാരൻമാർ, എല്ലാ വിജയികളെയും ചേർത്ത് ആഘോഷിക്കൂ — വരും തലമുറകൾക്ക് അഭിമാനത്തോടെ കാണാനാകുന്ന ഒരു സ്മാരകഭിത്തി.",
        "Choose the package that fits your family — upgrade anytime, and unlock more features as your legacy grows.": "നിങ്ങളുടെ കുടുംബത്തിന് ഏറ്റവും ചേരുന്ന പാക്കേജ് തിരഞ്ഞെടുക്കൂ — ഏത് സമയത്തും അപ്ഗ്രേഡ് ചെയ്ത്, നിങ്ങളുടെ പാരമ്പര്യം വളരുന്തോറും കൂടുതൽ സൗകര്യങ്ങൾ തുറക്കാം.",
        "Complete legacy suite with AI tools": "AI ഉപകരണങ്ങളോടുകൂടിയ സമ്പൂർണ്ണ പാരമ്പര്യ സ്യൂട്ട്",
        "Connections": "ബന്ധങ്ങൾ",
        "Culture & Rituals Archive": "സാംസ്കാരികവും ആചാരപരവും ആയ ശേഖരം",
        "Demo Coming Soon": "ഡെമോ ഉടൻ വരുന്നു",
        "Demo pricing — final packages will be announced soon. Selection is saved to your account.": "ഡെമോ വിലകൾ — അന്തിമ പാക്കേജുകൾ ഉടൻ പ്രഖ്യാപിക്കും. നിങ്ങൾ ചെയ്ത തിരഞ്ഞെടുപ്പ് നിങ്ങളുടെ അക്കൗണ്ടിൽ സേവ് ചെയ്യപ്പെടും.",
        "Digital Family Tree (Print-ready)": "ഡിജിറ്റൽ കുടുംബവൃക്ഷം (പ്രിന്റ് ചെയ്യാൻ തയ്യാറായ രൂപത്തിൽ)",
        "EMERGENCY INFO": "അപത്കാല വിവരങ്ങൾ",
        "EVENTS & DATES": "ഇവന്റുകളും തീയതികളും",
        "Events & Reminders": "ഇവന്റുകളും ഓർമ്മപ്പെടുത്തലുകളും",
        "Every family member at a glance — search, filter and open any profile in one tap.": "ഓരോ കുടുംബാംഗത്തെയും ഒറ്റ നോട്ടത്തിൽ — തിരയുക, ഫിൽറ്റർ ചെയ്യുക, ഒരു തപ്പിലൂടെ തന്നെ പ്രൊഫൈൽ തുറക്കുക.",
        "Every milestone across generations — arranged as one continuous, beautiful story.": "തലമുറകൾക്കപ്പുറം ഉള്ള എല്ലാ പ്രധാന നിമിഷങ്ങളും — ഒറ്റ തുടർച്ചയായ മനോഹരമായ കഥയായി ക്രമീകരിച്ചിരിക്കുന്നു.",
        "Every new member, photo, story and record — see everything happening in your family, as it happens.": "ഓരോ പുതിയ അംഗവും, ഫോട്ടോയും, കഥയും, രേഖയും — നിങ്ങളുടെ കുടുംബത്തിൽ നടക്കുന്നതെല്ലാം നടക്കുന്ന സമയത്ത് തന്നെ കാണുക.",
        "Every photo, voice note and story preserved forever — safely inside your family vault.": "ഓരോ ഫോട്ടോയും, ശബ്ദകുറിപ്പും, കഥയും എന്നെന്നേക്കുമായി സംരക്ഷിച്ചിരിക്കുന്നു — സുരക്ഷിതമായി നിങ്ങളുടെ കുടുംബ വോൾട്ടിനുള്ളിൽ.",
        "Everything, forever — one payment": "എല്ലാം, എന്നെന്നും — ഒരു തവണയുടെ പേയ്മെന്റ്",
        "Expert Biography Writing": "വിദഗ്ധരായ ജീവിതകഥ രചന",
        "Export everything you've saved — members, stories, memories, records — in the format that suits you. Your data is always yours.": "നിങ്ങൾ സേവ് ചെയ്തിട്ടുള്ള അംഗങ്ങൾ, കഥകൾ, ഓർമ്മകൾ, രേഖകൾ എന്നിവ എല്ലാം — നിങ്ങള്ക്ക് അനുയോജ്യമായ ഫോർമാറ്റിൽ എക്സ്പോർട്ട് ചെയ്യുക. നിങ്ങളുടെ ഡാറ്റ എല്ലായ്പ്പോഴും നിങ്ങളുടേതായിരിക്കും.",
        "FAMILY STATISTICS": "കുടുംബ സ്ഥിതിവിവരക്കണക്കുകൾ",
        "FAMILY TIMELINE": "കുടുംബ ടൈംലൈൻ",
        "FAMILY WORLD MAP": "കുടുംബ ലോകമാപ്പ്",
        "Family Activity": "കുടുംബ പ്രവർത്തനങ്ങൾ",
        "Family Calendar & Celebrations": "കുടുംബ കലണ്ടറും ആഘോഷങ്ങളും",
        "Family Pride": "കുടുംബ അഭിമാനം",
        "Family Records": "കുടുംബ രേഖകൾ",
        "Family Tree Builder (6 generations)": "കുടുംബ വംശവൃക്ഷ നിർമ്മാണം (6 തലമുറകൾ)",
        "Family World Map": "കുടുംബ ലോകമാപ്പ്",
        "Gold": "ഗോൾഡ്",
        "HEALTH & EMERGENCY": "ആരോഗ്യവും അടിയന്തരസാഹചര്യങ്ങളും",
        "HEALTH REPOSITORY": "ആരോഗ്യ സംഭരണശാല",
        "Health & Medical Repository (10 registers)": "ആരോഗ്യവും മെഡിക്കൽ രേഖകളും (10 രജിസ്റ്ററുകൾ)",
        "How large is your family across generations? Longevity, geography, professions and more.": "തലമുറകൾക്ക് അകത്ത് നിങ്ങളുടെ കുടുംബം എത്ര വലിയതാണ്? ആയുസ്, ഭൂപ്രദേശം, തൊഴിലുകൾ തുടങ്ങിയവ എല്ലാം ഒരുമിച്ച് നോക്കാം.",
        "Keep every family member's blood group in one secure place. In an emergency, every second counts — this registry helps you instantly find the right donor within your family.": "ഓരോ കുടുംബാംഗത്തിന്റെയും രക്തഗ്രൂപ്പ് ഒരു സുരക്ഷിതമായ ഇടത്ത് സൂക്ഷിക്കുക. അടിയന്തരസാഹചര്യങ്ങളിൽ ഓരോ നിമിഷവും വിലപ്പെട്ടതാണ് — ശരിയായ രക്തദാതാവിനെ നിങ്ങളുടെ കുടുംബത്തിനുള്ളിൽ തന്നെ ഉടൻ കണ്ടെത്താൻ ഈ രജിസ്റ്റർ സഹായിക്കും.",
        "LEGACY & MEMORIAL": "പാരമ്പര്യവും സ്മരണകളും",
        "LEGAL & LEGACY": "നിയമപരവും പാരമ്പര്യവുമായി ബന്ധപ്പെട്ട രേഖകൾ",
        "Legacy Lifetime": "ആജീവനാന്ത പാരമ്പര്യ സംരക്ഷണം",
        "Legal Vault (Will & Nominee)": "നിയമ രേഖാ ശേഖരം (വസിയത്തും നോമിനിയും)",
        "Let AI compose a heartfelt narrative of your family's journey from the profiles you've filled.": "നിങ്ങൾ പൂരിപ്പിച്ച പ്രൊഫൈലുകൾ അടിസ്ഥാനമാക്കി, നിങ്ങളുടെ കുടുംബയാത്രയെ കുറിച്ചുള്ള ഹൃദയസ്പർശിയായ കഥ AI ഉപയോഗിച്ച് തയ്യാറാക്കാം.",
        "MEMORIES & STORIES": "ഓർമ്മകളും കഥകളും",
        "Marriage Records": "വിവാഹ രേഖകൾ",
        "Member Profiles & Photos": "അംഗങ്ങളുടെ പ്രൊഫൈലുകളും ഫോട്ടോകളും",
        "Memories & reminders for the whole family": "മുഴുവൻ കുടുംബത്തിനുമുള്ള ഓർമ്മകളും റിമൈൻഡറുകളും",
        "Multi-user Family Access (Invites)": "മൾട്ടി-യൂസർ കുടുംബ ആക്സസ് (ആഹ്വാനങ്ങളിലൂടെ)",
        "Never miss a birthday, anniversary or festival — smart reminders from your family tree, delivered by email, push and in-app.": "ഒരു പിറന്നാളും, വാർഷികവും, ഉത്സവവും നഷ്ടമാകാതെ നോക്കാം — നിങ്ങളുടെ ഫാമിലി ട്രീയിൽ നിന്നുള്ള സ്മാർ‍ട്ട് റിമൈൻഡറുകൾ ഇമെയിൽ, പുഷ്, ആപ്പിനുള്ളിൽ എന്നിവ വഴി ലഭിക്കും.",
        "One place for every birthday, anniversary, shraddha and cultural festival — with smart nudges.": "ഓരോ പിറന്നാളും, വിവാഹ വാർഷികവും, ശ്രാദ്ധവും, സാംസ്കാരിക ഉത്സവവും — എല്ലാം ഒരേയൊരു സ്ഥലത്ത്, സ്മാർട്ട് ഓർമ്മപ്പെടുത്തലുകളോടൊപ്പം.",
        "Personal Vault": "വ്യക്തിഗത രേഖാശേഖരം",
        "Prescriptions, reports and hospital records for every family member — organized and searchable.": "ഓരോ കുടുംബാംഗത്തിന്റെയും മരുന്ന് കുറിപ്പുകൾ, റിപ്പോർട്ടുകൾ, ആശുപത്രി രേഖകൾ എന്നിവ — ക്രമീകരിച്ച രൂപത്തിൽ, എളുപ്പത്തിൽ തിരയാൻ കഴിയുന്ന വിധത്തിൽ.",
        "Preserve wedding dates, venues and couple details — anniversaries flow automatically into your family calendar and timeline.": "വിവാഹ തീയതികളും വേദിയും ദമ്പതികളുടെ വിവരങ്ങളും സൂക്ഷിക്കുക — വാർഷികങ്ങൾ സ്വയം നിങ്ങളുടെ കുടുംബ കലണ്ടറിലും ടൈംലൈൻലും ചേർന്നു പോകും.",
        "Priority Support": "പ്രാധാന്യ സഹയം",
        "Rituals, recipes, dialects and heritage — everything that makes your family uniquely yours.": "ആചാരങ്ങൾ, വിഭവക്കുറിപ്പുകൾ, ഭാഷാശൈലികൾ, പാരമ്പര്യം — നിങ്ങളുടെ കുടുംബത്തെ അന്യംതീർന്ന നിങ്ങളുടെതാക്കുന്ന എല്ലാം.",
        "SHARE & CELEBRATE": "പങ്കിടൂ & ആഘോഷിക്കൂ",
        "Seal messages, photos and videos to open on future birthdays, anniversaries or a chosen date.": "സന്ദേശങ്ങൾ, ഫോട്ടോകൾ, വീഡിയോകൾ എന്നിവ ഭാവിയിലെ പിറന്നാളുകൾക്കും വാർഷികങ്ങൾക്കും അല്ലെങ്കിൽ നിങ്ങൾ തിരഞ്ഞെടുക്കുന്ന ദിവസത്തിനും വേണ്ടി മുദ്രകുത്തി സൂക്ഷിക്കാം.",
        "See every family member on a real world map. Each pin shows a current location (orange) and a native place (green), connected by a dotted line — a beautiful visual of your family's journey through geography.": "ഒരു യഥാർത്ഥ ലോകമാപ്പിൽ നിങ്ങളുടെ ഓരോ കുടുംബാംഗത്തെയും കാണാം. ഓരോ പിനും ഇപ്പോഴുള്ള സ്ഥലം (ഓറഞ്ച്) കൂടിയെയും സ്വദേശം (പച്ച) കൂടിയെയും, ചിതറിയ കളത്തിലൂടെ ബന്ധിപ്പിക്കപ്പെട്ട ഒരു വരയിലൂടെ കാണിക്കും — നിങ്ങളുടെ കുടുംബത്തിന്റെ ഭൂമിശാസ്ത്രയാത്രയുടെ മനോഹരമായ ഒരു ദൃശ്യം.",
        "Share the gift of legacy — invite friends to build their own private family tree, free to start.": "പാരമ്പര്യത്തിന്റെ ഈ സമ്മാനം പങ്കിടൂ — നിങ്ങളുടെ സുഹൃത്തുക്കളെ അവരുടെ സ്വന്തം സ്വകാര്യ കുടുംബവംശവൃക്ഷം നിർമ്മിക്കാൻ ക്ഷണിക്കുക; ആരംഭിക്കുന്നത് സൗജന്യം.",
        "Silver": "സിൽവർ",
        "Smart Reminders (Email + Push)": "സ്മാർട്ട് റിമൈൻഡറുകൾ (ഇമെയിൽ + പുഷ്)",
        "Starter": "സ്റ്റാർട്ടർ",
        "TIME CAPSULES": "ടൈം ക്യാപ്സൂളുകൾ",
        "TODAY'S CELEBRATIONS": "ഇന്നത്തെ ആഘോഷങ്ങൾ",
        "Turn your family tree into a beautiful shareable poster — perfect for wedding invites, festivals and print.": "നിങ്ങളുടെ കുടുംബവംശവൃക്ഷത്തെ മനോഹരമായ ഒരു പങ്കിടാവുന്ന പോസ്റ്ററാക്കി മാറ്റൂ — വിവാഹ ക്ഷണങ്ങൾക്കും, ഉത്സവങ്ങൾക്കും, പ്രിന്റിനും ഏറ്റവും അനുയോജ്യം.",
        "VOICE & STORIES": "ശബ്ദവും കഥകളും",
        "Watch Demo": "ഡെമോ കാണുക",
        "Wills, power-of-attorney, property papers and nominee details — locked and always accessible to the right people.": "വിൽ രേഖകൾ, പവർ-ഓഫ്-അറ്റോർണി, സ്വത്ത് രേഖകൾ, നോമിനിയുടെ വിവരങ്ങൾ എന്നിവ — സുരക്ഷിതമായി പൂട്ടി, ശരിയായ ആളുകൾക്ക് എപ്പോഴും ലഭ്യമാക്കാം.",
        "Your data, your rules — manage account preferences, visibility and every privacy declaration in one place.": "നിങ്ങളുടെ ഡാറ്റ, നിങ്ങളുടെ നിയമങ്ങൾ — അക്കൗണ്ട് ക്രമീകരണങ്ങൾ, കാണാവുന്ന പരിധി, എല്ലാ സ്വകാര്യതാ വിവരങ്ങളും ഒരേ സ്ഥലത്ത് നിന്ന് നിയന്ത്രിക്കാം.",
        "one-time · lifetime": "ഒരിക്കൽ മാത്രം · ആയുഷ്കാലം",
        "per month": "ഓരോ മാസം",
        "per year": "ഓരോ വർഷം",
        "January": "ജനുവരി",
        "February": "ഫെബ്രുവരി",
        "March": "മാർച്ച്",
        "April": "ഏപ്രിൽ",
        "May": "മെയ്",
        "June": "ജൂൺ",
        "July": "ജൂലൈ",
        "August": "ഓഗസ്റ്റ്",
        "September": "സെപ്റ്റംബർ",
        "October": "ഒക്ടോബർ",
        "November": "നവംബർ",
        "December": "ഡിസംബർ",
        "is locked": "പൂട്ടിയിരിക്കുന്നു",
        "Your current package": "താങ്കളുടെ നിലവിലുള്ള പാക്കേജ്",
        "doesn't include this feature.": "ഈ സൗകര്യം ഇതിൽ ഉള്‍പ്പെടുന്നില്ല.",
        "Included in": "ഉള്‍പ്പെടുന്നത്",
        "one-time": "ഒരിക്കല്‍ മാത്രം",
        "year": "വര്‍ഷം",
        "month": "മാസം",
        "lifetime": "ജീവിതകാലം",
        "Go Back": "തിരികെ പോകുക",
        "View Packages": "പാക്കേജുകള്‍ കാണുക",
        "This feature": "ഈ സൗകര്യം",
        "Family Legacy Dashboard": "കുടുംബ പാരമ്പര്യ ഡാഷ്‌ബോർഡ്",
        "Legacy Services": "പാരമ്പര്യ സേവനങ്ങൾ",
        "Life Story Vault": "ജീവിതകഥ ശേഖരം",
        "Video Testament Library": "വീഡിയോ വിലാപത്ര ലൈബ്രറി",
        "Family Wisdom Bank": "കുടുംബ ജ്ഞാന ബാങ്ക്",
        "Failure Stories Archive": "പരാജയകഥാ ശേഖരം",
        "Success Stories": "വിജയകഥകൾ",
        "Family Decision History": "കുടുംബ തീരുമാന ചരിത്രം",
        "Family Values Repository": "കുടുംബ മൂല്യ ശേഖരം",
        "Family Hero Gallery": "കുടുംബ ഹീറോ ഗാലറി",
        "Unsung Heroes": "അറിയപ്പെടാതെ പോയ വീരന്മാർ",
        "Gratitude Wall": "കൃതജ്ഞതാ ഭിത്തി",
        "Tribute Pages": "സ്മരണപ്പേജുകൾ",
        "Love Letters Archive": "സ്നേഹലേഖന ശേഖരം",
        "Childhood Stories Bank": "ബാല്യക്കഥാ ബാങ്ക്",
        "Language Preservation": "ഭാഷാസംരക്ഷണം",
        "Ancestral Village": "പൂർവ്വികരുടെ ഗ്രാമം",
        "Surname History": "കുടുംബപ്പേരിന്റെ ചരിത്രം",
        "Family Emblem": "കുടുംബ ചിഹ്നം",
        "Cultural Artifacts": "സാംസ്കാരിക അവശിഷ്ടങ്ങൾ",
        "Family Songs & Bhajans": "കുടുംബ ഗാനങ്ങളും ഭജനകളും",
        "Oral History Center": "മൗഖിക ചരിത്ര കേന്ദ്രം",
        "Biography Writing Platform": "ജീവചരിത്ര രചന പ്ലാറ്റ്ഫോം",
        "Memoir Writing Service": "സ്മൃതിഗ്രന്ഥ (മെമ്മോയർ) രചനാ സേവനം",
        "Personalised Gifting Service": "വ്യക്തിഗത സമ്മാനസേവനം",
        "Personal Digital Identity Platform": "വ്യക്തിഗത ഡിജിറ്റൽ ഐഡന്റിറ്റി പ്ലാറ്റ്ഫോം",
        "Add to": "ഇതിലേക്ക് ചേർക്കുക",
        "Choose": "തിരഞ്ഞെടുക്കുക",
        "Compare all packages": "എല്ലാ പാക്കേജുകളും താരതമ്യം ചെയ്യുക",
        "Demo pricing — packages, prices and the feature split are all editable from the admin panel.": "ഡെമോ പ്രൈസിംഗ് — പാക്കേജുകളും വിലകളും ഫീച്ചറുകളുടെ വിഭജനവും എല്ലാം അഡ്മിൻ പാനലിൽ നിന്ന് തിരുത്താവുന്നതാണ്.",
        "Feature": "ഫീച്ചർ",
        "Five packages, one family legacy": "അഞ്ച് പാക്കേജുകൾ, ഒരു കുടുംബ പൈതൃകം",
        "Free": "സൗജന്യം",
        "Life story, wisdom and biography now live in Family Legacy Dashboard": "ജീവിതകഥ, ജീവിതബുദ്ധി, ജീവചരിത്രം എന്നിവ ഇനി Family Legacy Dashboard-ൽ സജീവമാണ്",
        "Open Family Legacy Dashboard": "Family Legacy Dashboard തുറക്കുക",
        "Packages & Pricing": "പാക്കേജുകളും വിലയും",
        "Packages temporarily unavailable. Please try again shortly.": "ഇപ്പോൾ പാക്കേജുകൾ താത്കാലികമായി ലഭ്യമല്ല. ദയവായി കുറച്ച് സമയം കഴിഞ്ഞ് വീണ്ടും ശ്രമിക്കുക.",
        "Start Free": "സൗജന്യമായി ആരംഭിക്കുക",
        "Start free, upgrade whenever your family is ready. Every feature below is compared side by side so nothing is hidden.": "സൗജന്യമായി ആരംഭിച്ച്, നിങ്ങളുടെ കുടുംബം തയ്യാറാകുമ്പോൾ എപ്പോൾ വേണമെങ്കിലും അപ്ഗ്രേഡ് ചെയ്യാം. താഴെയുള്ള ഓരോ ഫീച്ചറും പുറംപുറമായി താരതമ്യം ചെയ്തിട്ടുള്ളതിനാൽ ഒന്നും മറച്ചുവെച്ചിട്ടില്ല.",
        "Swipe sideways on a phone — the feature column stays in place.": "ഫോണിൽ വലത്തോട്ടോ ഇടത്തോട്ടോ സ്വൈപ്പ് ചെയ്യുക — ഫീച്ചർ കോളം അവിടെ തന്നെയുണ്ടാകും.",
        "more features": "കൂടുതൽ ഫീച്ചറുകൾ",
        "Namaste": "നമസ്തേ",
        "{sender} has added you to our family tree on Family Repository.": "Family Repositoryയിലെ നമ്മുടെ കുടുംബവൃക്ഷത്തിൽ {sender} നിങ്ങളെ ചേർത്തിരിക്കുന്നു.",
        "Tap to join": "ചേരാൻ തൊടുക",
        "Your invite code": "നിങ്ങളുടെ ക്ഷണക്കോഡ്",
        "Together we will preserve our family's stories, photos and voices for the next generations.": "കൂടെയൊത്ത് നമ്മുടേ കുടുംബത്തിന്റെ കഥകളും ഫോട്ടോകളും ശബ്ദങ്ങളും അടുത്ത തലമുറകൾക്കായി സംരക്ഷിക്കാം.",
        "Your family": "നിങ്ങളുടെ കുടുംബം",
        "Invite on WhatsApp": "WhatsApp വഴി ക്ഷണിക്കുക",
        "WhatsApp opened with the invite message.": "ക്ഷണക്കുറിപ്പുള്ള സന്ദേശത്തോടെ WhatsApp തുറന്നിരിക്കുന്നു.",
    },
    pa: {
        "Home": "ਘਰ",
        "Family": "ਪਰਿਵਾਰ",
        "Family Tree": "ਪਰਿਵਾਰ ਵ੍ਰਿਕਸ਼",
        "Add a Member": "ਮੈਂਬਰ ਸ਼ਾਮਲ ਕਰੋ",
        "Invite Family": "ਪਰਿਵਾਰ ਨੂੰ ਨਿਊਤਾ ਭੇਜੋ",
        "Family Hub · All": "ਫੈਮਿਲੀ ਹੱਬ · ਸਭ",
        "Family Timeline": "ਪਰਿਵਾਰ ਸਮਾਂਰੇਖਾ",
        "Family Calendar": "ਪਰਿਵਾਰ ਕੈਲੈਂਡਰ",
        "Services": "ਸੇਵਾਵਾਂ",
        "Photo Memories": "ਫੋਟੋ ਯਾਦਾਂ",
        "Audio Memories": "ਆਡੀਓ ਯਾਦਾਂ",
        "AI Family Advisor": "AI ਪਰਿਵਾਰ ਸਲਾਹਕਾਰ",
        "AI Story Generator": "AI ਕਹਾਣੀ ਤਿਆਰ ਕਰਨ ਵਾਲਾ",
        "Video Memories": "ਵੀਡੀਓ ਯਾਦਾਂ",
        "Digital Family Tree": "ਡਿਜਿਟਲ ਪਰਿਵਾਰ ਵ੍ਰਿਕਸ਼",
        "Family Hall of Fame": "ਪਰਿਵਾਰ ਹਾਲ ਆਫ ਫੇਮ",
        "Family Hub · All Services": "ਫੈਮਿਲੀ ਹੱਬ · ਸਾਰੀਆਂ ਸੇਵਾਵਾਂ",
        "Records": "ਰਿਕਾਰਡ",
        "Blood Group Registry": "ਬਲੱਡ ਗਰੁੱਪ ਰਜਿਸਟਰੀ",
        "Health Repository": "ਹੈਲਥ ਰਿਪੋਜ਼ਟਰੀ",
        "Health Score Compliance": "ਹੈਲਥ ਸਕੋਰ ਕਮਪਲਾਇੰਸ",
        "Emergency Contacts": "ਐਮਰਜੈਂਸੀ ਸੰਪਰਕ",
        "Business Directory": "ਬਿਜ਼ਨੇਸ ਡਾਇਰੈਕਟਰੀ",
        "Recipe Vault": "ਰੈਸੀਪੀ ਵਾਲਟ",
        "Family Statistics": "ਪਰਿਵਾਰਕ ਅੰਕੜੇ",
        "Legacy": "ਵਿਰਾਸਤ",
        "Legal Vault": "ਕਾਨੂੰਨੀ ਵਾਲਟ",
        "Document Vault": "ਦਸਤਾਵੇਜ਼ ਵਾਲਟ",
        "Story & Wisdom Vault": "ਕਹਾਣੀਆਂ ਅਤੇ ਗਿਆਨ ਵਾਲਟ",
        "Family Constitution": "ਪਰਿਵਾਰਕ ਸੰਵਿਧਾਨ",
        "Futuristic Legacy Letter": "ਭਵਿੱਖੀ ਵਿਰਾਸਤੀ ਚਿੱਠੀ",
        "Digital Memorial": "ਡਿਜ਼ਿਟਲ ਸਮਾਰਕ",
        "Account": "ਅਕਾਊਂਟ",
        "Packages & Plans": "ਪੈਕੇਜ ਅਤੇ ਪਲੈਨ",
        "Privacy & Settings": "ਪ੍ਰਾਈਵੇਸੀ ਅਤੇ ਸੈਟਿੰਗਜ਼",
        "Download & Export": "ਡਾਊਨਲੋਡ ਅਤੇ ਐਕਸਪੋਰਟ",
        "Profile": "ਪ੍ਰੋਫ਼ਾਈਲ",
        "Search family…": "ਪਰਿਵਾਰ ਖੋਜੋ…",
        "Dashboard": "ਡੈਸ਼ਬੋਰਡ",
        "Families": "ਪਰਿਵਾਰ",
        "Users": "ਉਪਭੋਗਤਾ",
        "Subscriptions": "ਸਬਸਕ੍ਰਿਪਸ਼ਨ",
        "Packages": "ਪੈਕੇਜ",
        "Exports": "ਐਕਸਪੋਰਟ",
        "Content": "ਸਮੱਗਰੀ",
        "Landing Slides": "ਲੈਂਡਿੰਗ ਸਲਾਈਡਾਂ",
        "Site Assets": "ਸਾਈਟ ਐਸੈੱਟ",
        "Family Content": "ਪਰਿਵਾਰਕ ਸਮੱਗਰੀ",
        "Translations": "ਅਨੁਵਾਦ",
        "User Page Editor": "ਯੂਜ਼ਰ ਪੇਜ਼ ਐਡੀਟਰ",
        "Analytics": "ਐਨਾਲਿਟਿਕਸ",
        "Support Tickets": "ਸਹਾਇਤਾ ਟਿਕਟਾਂ",
        "Broadcasts": "ਬਰਾਡਕਾਸਟ",
        "Legacy CRM": "ਲੈਗੇਸੀ CRM",
        "SMS Console": "SMS ਕੌਂਸੋਲ",
        "Security": "ਸੁਰੱਖਿਆ",
        "Settings": "ਸੈਟਿੰਗਾਂ",
        "UI/UX Audit": "UI/UX ਆਡਿਟ",
        "API Keys": "API Keys",
        "Admin Team": "ਐਡਮਿਨ ਟੀਮ",
        "Content Managers": "ਸਮੱਗਰੀ ਮੈਨੇਜਰ",
        "Overview": "ਸੰਖੇਪ ਝਲਕ",
        "Members": "ਮੈਂਬਰ",
        "Billing": "ਬਿਲਿੰਗ",
        "Landing & Content": "ਲੈਂਡਿੰਗ ਅਤੇ ਸਮੱਗਰੀ",
        "Insights": "ਝਲਕਾਂ",
        "Support": "ਸਹਾਇਤਾ",
        "System": "ਸਿਸਟਮ",
        "Super Admin": "ਸੁਪਰ ਐਡਮਿਨ",
        "Content Admin": "ਸਮੱਗਰੀ ਐਡਮਿਨ",
        "Content Manager": "ਸਮੱਗਰੀ ਮੈਨੇਜਰ",
        "Finance Admin": "ਫਾਇਨੈਂਸ ਐਡਮਿਨ",
        "Support Admin": "ਸਹਾਇਤਾ ਐਡਮਿਨ",
        "Security Admin": "ਸੁਰੱਖਿਆ ਐਡਮਿਨ",
        "Admin": "ਐਡਮਿਨ",
        "Admin Panel": "ਐਡਮਿਨ ਪੈਨਲ",
        "Logout": "ਲਾਗ ਆਉਟ",
        "Loading dashboard…": "ਡੈਸ਼ਬੋਰਡ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ…",
        "Platform overview at a glance.": "ਪਲੇਟਫਾਰਮ ਦੀ ਝਲਕ ਇਕ ਨਜ਼ਰ ਵਿੱਚ।",
        "Total Families": "ਕੁੱਲ ਪਰਿਵਾਰ",
        "Total Members": "ਕੁੱਲ ਮੈਂਬਰ",
        "Tree Persons": "ਰੁੱਖ ਵਾਲੇ ਵਿਅਕਤੀ",
        "Storage Used": "ਵਰਤੀ ਸਟੋਰੇਜ",
        "Marriages": "ਵਿਆਹ",
        "Memory Albums": "ਯਾਦਾਂ ਦੇ ਐਲਬਮ",
        "Wills (latest)": "ਵਸੀਅਤਾਂ (ਤਾਜ਼ਾ)",
        "Audio Wills": "ਆਡੀਓ ਵਸੀਅਤਾਂ",
        "With recorded audio": "ਰਿਕਾਰਡ ਕੀਤੀ ਆਡੀਓ ਨਾਲ",
        "Across all families": "ਸਾਰਿਆਂ ਪਰਿਵਾਰਾਂ ਵਿੱਚ",
        "New signups — last 30 days": "ਨਵੀਆਂ ਸਾਈਨਅਪ — ਪਿਛਲੇ 30 ਦਿਨ",
        "Storage breakdown": "ਸਟੋਰੇਜ ਦਾ ਵੇਰਵਾ",
        "No stored files yet.": "ਹਾਲੇ ਕੋਈ ਫ਼ਾਇਲ ਨਹੀਂ ਸੰਭਾਲੀ ਗਈ।",
        "Signups": "ਸਾਈਨਅਪ",
        "suspended": "ਮੁਅੱਤਲ",
        "blocked": "ਬਲਾਕ ਕੀਤਾ",
        "paid": "ਭੁਗਤਾਨ ਕੀਤਾ",
        "open tickets": "ਖੁੱਲ੍ਹੇ ਟਿਕਟ",
        "Memory photos": "ਯਾਦਾਂ ਦੀਆਂ ਫੋਟੋਆਂ",
        "Vault documents": "ਤਿਜੋਰੀ ਦਸਤਾਵੇਜ਼",
        "Story audio": "ਕਹਾਣੀ ਆਡੀਓ",
        "Member profiles & photos": "ਮੈਂਬਰ ਪ੍ਰੋਫਾਈਲਾਂ ਅਤੇ ਫੋਟੋਆਂ",
        "Profile details": "ਪ੍ਰੋਫਾਈਲ ਵੇਰਵੇ",
        "Story metadata": "ਕਹਾਣੀ ਮੈਟਾਡੇਟਾ",
        "Memory metadata": "ਯਾਦ ਮੈਟਾਡੇਟਾ",
        "Document metadata": "ਦਸਤਾਵੇਜ਼ ਮੈਟਾਡੇਟਾ",
        "Admin (Head)": "ਐਡਮਿਨ (ਮੁੱਖ)",
        "added": "ਸ਼ਾਮਲ ਕੀਤਾ",
        "updated": "ਅਪਡੇਟ ਕੀਤਾ",
        "removed": "ਹਟਾਇਆ",
        "changed privacy of": "ਦੀ ਪਰਾਈਵੇਸੀ ਬਦਲੀ",
        "updated profile of": "ਦੀ ਪ੍ਰੋਫਾਈਲ ਅਪਡੇਟ ਕੀਤੀ",
        "viewed profile of": "ਦੀ ਪ੍ਰੋਫਾਈਲ ਵੇਖੀ",
        "recorded": "ਰੇਕਾਰਡ ਕੀਤਾ",
        "played": "ਚਲਾਇਆ",
        "deleted story": "ਕਹਾਣੀ ਮਿਟਾਈ",
        "uploaded": "ਅਪਲੋਡ ਕੀਤਾ",
        "viewed": "ਵੇਖਿਆ",
        "changed access of": "ਦਾ ਐਕਸੈੱਸ ਬਦਲਿਆ",
        "deleted": "ਮਿਟਾਇਆ",
        "invited": "ਨਿਯੋਤਾ ਭੇਜਿਆ",
        "revoked an invite": "ਨਿਯੋਤਾ ਰੱਦ ਕੀਤਾ",
        "joined the family": "ਪਰਿਵਾਰ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਏ",
        "changed role of": "ਦਾ ਰੋਲ ਬਦਲਿਆ",
        "downloaded their data": "ਉਨ੍ਹਾਂ ਨੇ ਆਪਣਾ ਡਾਟਾ ਡਾਊਨਲੋਡ ਕੀਤਾ",
        "completed privacy setup": "ਪਰਾਈਵੇਸੀ ਸੈਟਅੱਪ ਪੂਰਾ ਕੀਤਾ",
        "deleted account of": "ਦਾ ਖਾਤਾ ਮਿਟਾਇਆ",
        "Senior mode on — simpler privacy choices.": "ਸੀਨੀਅਰ ਮੋਡ ਚਾਲੂ — ਹੋਰ ਸਧਾਰਣ ਪਰਾਈਵੇਸੀ ਚੋਣਾਂ।",
        "Senior mode off.": "ਸੀਨੀਅਰ ਮੋਡ ਬੰਦ।",
        "Saved.": "ਸੇਵ ਕਰ ਦਿੱਤਾ।",
        "Your data export has been downloaded.": "ਤੁਹਾਡਾ ਡਾਟਾ ਐਕਸਪੋਰਟ ਡਾਊਨਲੋਡ ਹੋ ਗਿਆ ਹੈ।",
        "Your account and data have been deleted.": "ਤੁਹਾਡਾ ਖਾਤਾ ਅਤੇ ਡਾਟਾ ਮਿਟਾਇਆ ਜਾ ਚੁੱਕਾ ਹੈ।",
        "Every family tree on the platform. Suspending blocks all its members from logging in.": "ਪਲੇਟਫ਼ਾਰਮ ਉੱਤੇ ਹਰ ਪਰਿਵਾਰਕ ਟ੍ਰੀ। ਸਸਪੈਂਡ ਕਰਨ ਨਾਲ ਇਸ ਦੇ ਸਾਰੇ ਮੈਂਬਰਾਂ ਦਾ ਲੌਗਇਨ ਰੋਕ ਦਿੱਤਾ ਜਾਂਦਾ ਹੈ।",
        "All registered members. Blocked users cannot log in or use the API.": "ਸਾਰੇ ਰਜਿਸਟਰਡ ਮੈਂਬਰ। ਬਲੌਕ ਕੀਤੇ ਯੂਜ਼ਰ ਲੌਗਇਨ ਨਹੀਂ ਕਰ ਸਕਦੇ ਜਾਂ API ਇਸਤੇਮਾਲ ਨਹੀਂ ਕਰ ਸਕਦੇ।",
        "Manual plan control until a payment gateway is connected in Settings.": "ਜਦ ਤੱਕ Settings ਵਿੱਚ ਕੋਈ ਪੇਮੈਂਟ ਗੇਟਵੇ ਨਹੀਂ ਜੋੜਿਆ ਜਾਂਦਾ, ਤਦ ਤੱਕ ਪਲਾਨ ਦਾ ਹੱਥੋਂ ਕੰਟਰੋਲ।",
        "Growth, engagement and audience mix.": "ਵਿਕਾਸ, ਇਨਗੇਜਮੈਂਟ ਅਤੇ ਦਰਸ਼ਕਾਂ ਦੀ ਬਣਤਰ।",
        "Users raise tickets from Settings → Help in the app.": "ਯੂਜ਼ਰ ਐਪ ਵਿੱਚ Settings → Help ਤੋਂ ਟਿਕਟ ਦਾਖਲ ਕਰਦੇ ਹਨ।",
        "Branding, payment gateway and API keys. Secrets are stored server-side and shown masked.": "ਬ੍ਰਾਂਡਿੰਗ, ਪੇਮੈਂਟ ਗੇਟਵੇ ਅਤੇ API keys। ਰਾਜ਼ ਸਰਵਰ ਵਾਲੇ ਪਾਸੇ ਸੰਭਾਲੇ ਜਾਂਦੇ ਹਨ ਅਤੇ ਲੁਕਾਏ ਹੋਏ ਦਿਖਾਏ ਜਾਂਦੇ ਹਨ।",
        "Packages — Feature Matrix (Demo)": "ਪੈਕੇਜ — ਫੀਚਰ ਮੈਟਰਿਕਸ (ਡੈਮੋ)",
        "Export Center": "ਐਕਸਪੋਰਟ ਸੈਂਟਰ",
        "Download authoritative reports in CSV, Excel or PDF. Schedule auto-email exports below.": "CSV, Excel ਜਾਂ PDF ਵਿੱਚ ਅਧਿਕਾਰਿਕ ਰਿਪੋਰਟਾਂ ਡਾਊਨਲੋਡ ਕਰੋ। ਹੇਠਾਂ ਆਟੋ-ਈਮੇਲ ਐਕਸਪੋਰਟਾਂ ਦੀ ਸ਼ਡਿਊਲਿੰਗ ਕਰੋ।",
        "Send SMS or WhatsApp announcements to your users.": "ਆਪਣੇ ਯੂਜ਼ਰਾਂ ਨੂੰ SMS ਜਾਂ WhatsApp ਰਾਹੀਂ ਐਲਾਨ ਭੇਜੋ।",
        "Content Management": "ਕੰਟੈਂਟ ਮੈਨੇਜਮੈਂਟ",
        "Poster templates, landing banners and testimonials curated by the super-admin.": "ਸੁਪਰ-ਐਡਮਿਨ ਵੱਲੋਂ ਤਿਆਰ ਕੀਤੇ ਪੋਸਟਰ ਟੈਂਪਲੇਟ, ਲੈਂਡਿੰਗ ਬੈਨਰ ਅਤੇ ਟੈਸਟਿਮੋਨੀਅਲ।",
        "Platform-wide audit trail, failed logins, DPDP compliance requests, and your MFA credentials.": "ਪੂਰੇ ਪਲੇਟਫ਼ਾਰਮ ਦੀ ਆਡਿਟ ਟ੍ਰੇਲ, ਅਸਫਲ ਲੌਗਇਨ, DPDP ਕੰਪਲਾਇੰਸ ਬੇਨਤੀਆਂ ਅਤੇ ਤੁਹਾਡੇ MFA ਕ੍ਰੀਡੈਂਸ਼ਲ।",
        "Manage who can sign into the admin panel and what they can access.": "ਇਹ ਸੰਭਾਲੋ ਕਿ ਐਡਮਿਨ ਪੈਨਲ ਵਿੱਚ ਕੌਣ ਲੌਗਇਨ ਕਰ ਸਕਦਾ ਹੈ ਅਤੇ ਉਹ ਕੀ ਐਕਸੈੱਸ ਕਰ ਸਕਦਾ ਹੈ।",
        "Family Content Moderation": "ਪਰਿਵਾਰਕ ਕੰਟੈਂਟ ਮੋਡਰੇਸ਼ਨ",
        "Listen": "ਸੁਣੋ",
        "Stop": "ਰੋਕੋ",
        "Pause": "ਰੋਕੋ (ਥੋੜ੍ਹੀ ਦੇਰ ਲਈ)",
        "Resume": "ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ",
        "Generating…": "ਬਣਾ ਰਿਹਾ ਹੈ…",
        "Signup trend — last 90 days": "ਸਾਈਨਅੱਪ ਰੁਝਾਨ — ਪਿਛਲੇ 90 ਦਿਨ",
        "(or user) is expected to add all their family relationships on the": "(ਜਾਂ ਯੂਜ਼ਰ) ਤੋਂ ਉਮੀਦ ਕੀਤੀ ਜਾਂਦੀ ਹੈ ਕਿ ਉਹ ਆਪਣੇ ਸਾਰੇ ਪਰਿਵਾਰਕ ਰਿਸ਼ਤੇ ਇਸ ‘ਤੇ ਜੋੜਣ",
        ", which can only be opened by your password.": ", ਜਿਸ ਨੂੰ ਸਿਰਫ਼ ਤੁਹਾਡੇ ਪਾਸਵਰਡ ਨਾਲ ਹੀ ਖੋਲ੍ਹਿਆ ਜਾ ਸਕਦਾ ਹੈ।",
        ". Any member added there is automatically reflected here. For convenience, a few extra fields for": ". ਉੱਥੇ ਜੋੜਿਆ ਕੋਈ ਵੀ ਮੈਂਬਰ ਆਪਣੇ ਆਪ ਇੱਥੇ ਦਿਖਾਈ ਦੇਵੇਗਾ। ਸੁਵਿਧਾ ਲਈ, ਕੁਝ ਵਾਧੂ ਖੇਤਰ",
        "A family together": "ਇੱਕੱਠਾ ਪਰਿਵਾਰ",
        "A premium feature for your family's future": "ਤੁਹਾਡੇ ਪਰਿਵਾਰ ਦੇ ਭਵਿੱਖ ਲਈ ਪ੍ਰੀਮੀਅਮ ਸੁਵਿਧਾ",
        "Add": "ਜੋੜੋ",
        "Add Event": "ਇਵੈਂਟ ਜੋੜੋ",
        "Add custom field": "ਕਸਟਮ ਫੀਲਡ ਜੋੜੋ",
        "All checks": "ਸਾਰੇ ਜਾਂਚ",
        "Avg age": "ਔਸਤ ਉਮਰ",
        "Back": "ਵਾਪਸ",
        "Back to Dashboard": "ਡੈਸ਼ਬੋਰਡ ‘ਤੇ ਵਾਪਸ ਜਾਓ",
        "Change photo": "ਫੋਟੋ ਬਦਲੋ",
        "Choose the package that fits your family": "ਆਪਣੇ ਪਰਿਵਾਰ ਲਈ ਢੁੱਕਵਾਂ ਪੈਕੇਜ ਚੁਣੋ",
        "Classic, Premium and Elite": "ਕਲਾਸਿਕ, ਪ੍ਰੀਮੀਅਮ ਅਤੇ ਐਲੀਟ",
        "Countries": "ਦੇਸ਼",
        "Current": "ਮੌਜੂਦਾ",
        "Current Location": "ਮੌਜੂਦਾ ਸਥਿਤੀ",
        "Current city": "ਮੌਜੂਦਾ ਸ਼ਹਿਰ",
        "Current locations": "ਮੌਜੂਦਾ ਸਥਾਨ",
        "Data is encrypted in transit and at rest; every add/edit/delete is captured in the audit log.": "ਡਾਟਾ ਟ੍ਰਾਂਜ਼ਿਟ ਅਤੇ ਸਟੋਰੇਜ ਦੌਰਾਨ ਇਨਕ੍ਰਿਪਟ ਰਹਿੰਦਾ ਹੈ; ਹਰ ਇਕ add/edit/delete ਆਡਿਟ ਲਾਗ ਵਿੱਚ ਦਰਜ ਹੁੰਦਾ ਹੈ।",
        "Date": "ਤਾਰੀਖ",
        "Dear customer,": "ਸਨਮਾਨਿਤ ਗਾਹਕ ਜੀ,",
        "Delete": "ਮਿਟਾਓ",
        "Distinct Cities": "ਵੱਖ-ਵੱਖ ਸ਼ਹਿਰ",
        "Family (₹999/yr)": "ਪਰਿਵਾਰ (₹999/ਸਾਲ)",
        "Family Head": "ਪਰਿਵਾਰ ਮੁਖੀ",
        "Family Health": "ਪਰਿਵਾਰਕ ਸਿਹਤ",
        "Family Members": "ਪਰਿਵਾਰਕ ਮੈਂਬਰ",
        "Family Relationships": "ਪਰਿਵਾਰਕ ਸਬੰਧ",
        "Favourite mithai": "ਪਸੰਦੀਦਾ ਮਿਠਾਈ",
        "Field name": "ਫੀਲਡ ਦਾ ਨਾਮ",
        "Fill with AI": "AI ਨਾਲ ਭਰੋ",
        "GPT-5.2 fills 40+ fields across all 6 modules from your surname + region · you edit before saving.": "GPT-5.2 ਤੁਹਾਡੇ ਸਰਨੇਮ + ਇਲਾਕੇ ਤੋਂ 6ੋ ਮਾਡਿਊਲਾਂ ਵਿੱਚ 40 ਤੋਂ ਵੱਧ ਫ਼ੀਲਡ ਆਪ ਭਰਦਾ ਹੈ · ਤੁਸੀਂ ਸੇਵ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਸੋਧ ਕਰ ਸਕਦੇ ਹੋ।",
        "Gaon ka temple": "ਪਿੰਡ ਦਾ ਮੰਦਿਰ",
        "Generations": "ਪੀੜ੍ਹੀਆਂ",
        "Health & Medical Repository": "ਸਿਹਤ ਅਤੇ ਮੈਡੀਕਲ ਰਿਪੋਜ਼ਟਰੀ",
        "Health Score Compliance Report": "ਹੈਲਥ ਸਕੋਰ ਕੰਪਲਾਇਂਸ ਰਿਪੋਰਟ",
        "Health information is stored with explicit consent, only for members whose data you are authorised to record.": "ਸਿਹਤ ਸੰਬੰਧੀ ਜਾਣਕਾਰੀ ਸਿਰਫ਼ ਸਪਸ਼ਟ ਸਹਿਮਤੀ ਨਾਲ ਹੀ ਸੰਭਾਲੀ ਜਾਂਦੀ ਹੈ, ਅਤੇ ਕੇਵਲ ਉਨ੍ਹਾਂ ਮੈਂਬਰਾਂ ਲਈ ਜਿਨ੍ਹਾਂ ਦਾ ਡਾਟਾ ਦਰਜ ਕਰਨ ਲਈ ਤੁਹਾਨੂੰ ਅਧਿਕਾਰ ਹੈ।",
        "Help": "ਮਦਦ",
        "Hide details": "ਵੇਰਵੇ ਲੁਕਾਓ",
        "How complete is your family tree?": "ਤੁਹਾਡਾ ਵੰਸ਼–ਵ੍ਰੁੱਖ ਕਿੰਨਾ ਪੂਰਾ ਹੈ?",
        "Informed consent — one time, per family": "ਜਾਣਕਾਰੀ ਸਮੇਤ ਸਹਿਮਤੀ — ਹਰ ਪਰਿਵਾਰ ਲਈ ਸਿਰਫ ਇੱਕ ਵਾਰ",
        "Kind": "ਕਿਸਮ",
        "Legacy (₹2999/yr)": "Legacy (₹2999/ਸਾਲ)",
        "Linked live from your family tree.": "ਤੁਹਾਡੇ ਵੰਸ਼–ਵ੍ਰੁੱਖ ਨਾਲ ਲਾਈਵ ਜੁੜਿਆ ਹੋਇਆ ਹੈ।",
        "Living Cities": "ਰਿਹਾਇਸ਼ ਵਾਲੇ ਸ਼ਹਿਰ",
        "Loading events…": "ਇਵੈਂਟ ਲੋਡ ਹੋ ਰਹੇ ਹਨ…",
        "Loading packages…": "ਪੈਕੇਜ ਲੋਡ ਹੋ ਰਹੇ ਹਨ…",
        "Loading world map…": "ਵਿਸ਼ਵ ਨਕਸ਼ਾ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ…",
        "Loading…": "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ…",
        "Lucky number": "ਲੱਕੀ ਨੰਬਰ",
        "Member Profile": "ਮੈਂਬਰ ਪ੍ਰੋਫ਼ਾਈਲ",
        "Most Popular": "ਸਭ ਤੋਂ ਲੋਕਪ੍ਰਿਯ",
        "Native": "ਮੂਲ ਸਥਾਨ ਵਾਲਾ",
        "Native Place": "ਮੂਲ ਸਥਾਨ",
        "Native Places": "ਮੂਲ ਸਥਾਨ",
        "Native places": "ਮੂਲ ਸਥਾਨ",
        "None of your family members have a mapped location yet.": "ਤੁਹਾਡੇ ਕਿਸੇ ਵੀ ਪਰਿਵਾਰਕ ਮੈਂਬਰ ਲਈ ਹੁਣ ਤੱਕ ਸਥਾਨ ਮੈਪ ਨਹੀਂ ਕੀਤਾ ਗਿਆ।",
        "Not a medical diagnosis platform.": "ਇਹ ਕੋਈ ਮੈਡੀਕਲ ਨਿਡਾਣ ਪਲੇਟਫਾਰਮ ਨਹੀਂ ਹੈ।",
        "Not added yet": "ਹਾਲੇ ਨਹੀਂ ਜੋੜਿਆ ਗਿਆ",
        "Notes (optional)": "ਨੋਟ (ਇੱਛਿਕ)",
        "Place of birth": "ਜਨਮ ਸਥਾਨ",
        "Preserve. Understand. Inform.": "ਸੰਭਾਲੋ। ਸਮਝੋ। ਜਾਣਕਾਰੀ ਦਿਓ।",
        "Privacy by design:": "ਰਹੱਸਨੀਯਤਾ ਡਿਜ਼ਾਈਨ ਰਾਹੀਂ:",
        "Records are visible to your family circle only; the Family Head controls who can add or edit.": "ਰਿਕਾਰਡ ਸਿਰਫ਼ ਤੁਹਾਡੇ ਪਰਿਵਾਰਕ ਸਰਕਲ ਨੂੰ ਹੀ ਦਿਸਦੇ ਹਨ; ਪਰਿਵਾਰ ਮੁਖੀ ਇਹ ਨਿਰਧਾਰਤ ਕਰਦੇ ਹਨ ਕਿ ਕੌਣ ਜੋੜ ਸਕਦਾ ਜਾਂ ਸੋਧ ਸਕਦਾ ਹੈ।",
        "Remove": "ਹਟਾਓ",
        "Reset": "ਰੀਸੈਟ",
        "Save &amp; Continue": "ਸੇਵ ਕਰੋ ਅਤੇ ਜਾਰੀ ਰੱਖੋ",
        "Saved ✓": "ਸੰਭਾਲ ਲਿਆ ✓",
        "Saving…": "ਸੰਭਾਲਿਆ ਜਾ ਰਿਹਾ ਹੈ…",
        "Sensitive details are hidden by default.": "ਸੰਵੇਦਨਸ਼ੀਲ ਵੇਰਵੇ ਪਹਿਲੋਂ ਤੋਂ ਹੀ ਓਹਲੇ ਰੱਖੇ ਜਾਂਦੇ ਹਨ।",
        "Skip the blank page — let AI suggest your family&apos;s heritage": "ਖਾਲੀ ਸਫ਼ਾ ਛੱਡੋ — ਆਪਣੀ ਪਰਿਵਾਰਕ ਵਿਰਾਸਤ ਲਈ AI ਤੋਂ ਸੁਝਾਅ ਲਵੋ",
        "Tap to view": "ਵੇਖਣ ਲਈ ਟੈਪ ਕਰੋ",
        "This is a record-keeping repository — not a diagnosis, treatment or medical-advice tool.": "ਇਹ ਸਿਰਫ਼ ਰਿਕਾਰਡ ਸੰਭਾਲਣ ਲਈ ਭੰਡਾਰ ਹੈ — ਕੋਈ ਨਿਦਾਨ, ਇਲਾਜ ਜਾਂ ਮੈਡੀਕਲ ਸਲਾਹ ਦੇਣ ਵਾਲਾ ਸਾਧਨ ਨਹੀਂ।",
        "This repository is for private family record-keeping and health-history awareness only — it does not provide diagnosis, treatment, risk prediction or medical advice. Always consult a qualified healthcare provider.": "ਇਹ ਭੰਡਾਰ ਸਿਰਫ਼ ਨਿੱਜੀ ਪਰਿਵਾਰਕ ਰਿਕਾਰਡ ਸੰਭਾਲਣ ਅਤੇ ਸਿਹਤ ਇਤਿਹਾਸ ਬਾਰੇ ਜਾਣਕਾਰੀ ਲਈ ਹੈ — ਇਹ ਨਿਦਾਨ, ਇਲਾਜ, ਜੋਖ਼ਮ ਦਾ ਅੰਦਾਜ਼ਾ ਜਾਂ ਮੈਡੀਕਲ ਸਲਾਹ ਨਹੀਂ ਦਿੰਦਾ। ਹਮੇਸ਼ਾਂ ਯੋਗਤਾ ਵਾਲੇ ਸਿਹਤ ਸੇਵਾ ਪ੍ਰਦਾਤਾ ਨਾਲ ਸਲਾਹ ਕਰੋ।",
        "This section is private": "ਇਹ ਹਿੱਸਾ ਨਿੱਜੀ ਹੈ",
        "Timezones spread": "ਸਮਾਂ-ਖੇਤਰਾਂ ਦੀ ਫੈਲਾਵਟ",
        "Tip": "ਸੁਝਾਅ",
        "Title": "ਸਿਰਲੇਖ",
        "Tree completeness": "ਪਰਿਵਾਰਕ ਰੁੱਖ ਦੀ ਪੂਰੇਪਣ ਦੀ ਸਥਿਤੀ",
        "Update": "ਅੱਪਡੇਟ ਕਰੋ",
        "Update their": "ਉਹਨਾਂ ਦੀ ਅੱਪਡੇਟ ਕਰੋ",
        "Value (type or tap 🎤)": "ਮੁੱਲ (ਲਿਖੋ ਜਾਂ 🎤 ਦਬੋ)",
        "Visual Family Tree": "ਦ੍ਰਿਸ਼ਮਾਨ ਪਰਿਵਾਰਕ ਰੁੱਖ",
        "Voice language": "ਆਵਾਜ਼ ਦੀ ਭਾਸ਼ਾ",
        "What's missing": "ਕੀ ਘੱਟ ਹੈ",
        "Where Your Family Lives — Across the World": "ਤੁਹਾਡਾ ਪਰਿਵਾਰ ਕਿੱਥੇ ਰਹਿੰਦਾ ਹੈ — ਸਾਰੀ ਦੁਨੀਆ ਵਿੱਚ",
        "are provided in the section below —": "ਹੇਠਾਂ ਦਿੱਤੇ ਭਾਗ ਵਿੱਚ ਦਿੱਤੀਆਂ ਗਈਆਂ ਹਨ —",
        "bank locker": "ਬੈਂਕ ਲਾਕਰ",
        "can be preserved in this section. The documents associated with these important information are required to be preserved at a different location, which is a special privilege of our": "ਇਸ ਭਾਗ ਵਿੱਚ ਸੰਭਾਲ ਕੇ ਰੱਖੀਆਂ ਜਾ ਸਕਦੀਆਂ ਹਨ। ਇਹ ਮਹੱਤਵਪੂਰਨ ਜਾਣਕਾਰੀ ਨਾਲ ਜੁੜੇ ਦਸਤਾਵੇਜ਼ ਇੱਕ ਵੱਖਰੀ ਜਗ੍ਹਾ ਤੇ ਸੰਭਾਲ ਕੇ ਰੱਖਣੇ ਲਾਜ਼ਮੀ ਹਨ, ਜੋ ਸਾਡੇ",
        "complete. Tick off the items below to grow it further.": "ਪੂਰਾ ਹੈ। ਇਸਨੂੰ ਹੋਰ ਵਧਾਉਣ ਲਈ ਹੇਠਾਂ ਦਿੱਤੀਆਂ ਚੀਜ਼ਾਂ ਨੂੰ ਟਿੱਕ ਕਰੋ।",
        "customers.": "ਗਾਹਕਾਂ ਲਈ ਇੱਕ ਵਿਸ਼ੇਸ਼ ਸਹੂਲਤ ਹੈ।",
        "descriptive information": "ਵੇਰਵੇਦਾਰ ਜਾਣਕਾਰੀ",
        "e.g. Dadu's Birthday": "ਜਿਵੇਂ ਦਾਦੂ ਦਾ ਜਨਮਦਿਨ",
        "family-only visibility · Family Head controls writing · explicit informed consent · encrypted storage · full audit trail of every change · DPDP Act 2023 aligned. Coming next: disease timeline, maternal/paternal branch views & emergency health card.": "ਕੇਵਲ ਪਰਿਵਾਰ ਲਈ ਦ੍ਰਿਸ਼ਮਾਨ · ਲਿਖਣ ਦਾ ਅਧਿਕਾਰ ਪਰਿਵਾਰ ਮੁਖੀ ਕੋਲ · ਸਪਸ਼ਟ ਜਾਣਕਾਰੀ-ਅਧਾਰਿਤ ਸਹਿਮਤੀ · ਇਨਕ੍ਰਿਪਟ ਕੀਤੀ ਸਟੋਰੇਜ · ਹਰ ਤਬਦੀਲੀ ਦਾ ਪੂਰਾ ਆਡਿਟ ਰਿਕਾਰਡ · DPDP Act 2023 ਦੇ ਅਨੁਕੂਲ। ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ: ਬਿਮਾਰੀਆਂ ਦੀ ਟਾਈਮਲਾਈਨ, ਮਾਤ੍ਰਿਕ/ਪਿਤ੍ਰਿਕ ਸ਼ਾਖਾ ਦੇ ਦ੍ਰਿਸ਼ ਅਤੇ ਐਮਰਜੈਂਸੀ ਹੈਲਥ ਕਾਰਡ।",
        "on the profile page, and they'll appear on the map instantly.": "ਪ੍ਰੋਫ਼ਾਈਲ ਪੇਜ ਉੱਤੇ, ਅਤੇ ਉਹ ਤੁਰੰਤ ਨਕਸ਼ੇ ‘ਤੇ ਦਿਖਾਈ ਦਿਣਗੇ।",
        "or": "ਜਾਂ",
        "plans — preserve multi-generation medical history, hereditary conditions, allergies, vaccinations and more.": "ਪਲਾਨ — ਕਈ ਪੀੜੀਆਂ ਦੀ ਮੈਡੀਕਲ ਹਿਸਟਰੀ, ਵਿਰਾਸਤੀ ਬਿਮਾਰੀਆਂ, ਐਲਰਜੀਆਂ, ਟੀਕਾਕਰਨ ਅਤੇ ਹੋਰ ਬਹੁਤ ਕੁਝ ਸੰਭਾਲ ਕੇ ਰੱਖੋ।",
        "please note that you are preserving very important and vital information. Please make sure you save important information only if you want to preserve it on this platform in a highly secured manner by using a proper password. All the documents here are preserved as if they are kept in a": "ਕਿਰਪਾ ਕਰਕੇ ਧਿਆਨ ਨਾਲ ਸਮਝੋ ਕਿ ਤੁਸੀਂ ਬਹੁਤ ਹੀ ਮਹੱਤਵਪੂਰਨ ਅਤੇ ਜ਼ਰੂਰੀ ਜਾਣਕਾਰੀ ਸੰਭਾਲ ਕੇ ਰੱਖ ਰਹੇ ਹੋ। ਕਿਰਪਾ ਕਰਕੇ ਇਹ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਸੀਂ ਮਹੱਤਵਪੂਰਨ ਜਾਣਕਾਰੀ ਤਦ ਹੀ ਸੇਵ ਕਰੋ ਜੇ ਤੁਸੀਂ ਇਸਨੂੰ ਮਜ਼ਬੂਤ ਪਾਸਵਰਡ ਦੇ ਨਾਲ ਇਸ ਪਲੇਟਫਾਰਮ ‘ਤੇ ਬਹੁਤ ਹੀ ਸੁਰੱਖਿਅਤ ਢੰਗ ਨਾਲ ਸੰਭਾਲ ਕੇ ਰੱਖਣਾ ਚਾਹੁੰਦੇ ਹੋ। ਇੱਥੇ ਰੱਖੇ ਸਾਰੇ ਦਸਤਾਵੇਜ਼ ਇਸ ਤਰ੍ਹਾਂ ਸੰਭਾਲੇ ਜਾਂਦੇ ਹਨ ਜਿਵੇਂ ਉਹ",
        "step relations, adopted relations, close relatives and extended relatives": "ਸੌਤੇ ਸੰਬੰਧ, ਗੋਦ ਲਏ ਹੋਏ ਸੰਬੰਧ, ਨੇੜਲੇ ਰਿਸ਼ਤੇਦਾਰ ਅਤੇ ਵਿਆਪਕ ਰਿਸ਼ਤੇਦਾਰ",
        "these will not appear on your pictorial family tree view.": "ਇਹ ਤੁਹਾਡੇ ਪਰਿਵਾਰਕ ਰੁੱਖ ਦੇ ਚਿੱਤਰ ਵਾਲੇ ਨਜ਼ਾਰੇ ਵਿੱਚ ਨਹੀਂ ਵੇਖਾਏ ਜਾਣਗੇ।",
        "© 2026 Digital Family Tree. All rights reserved.": "© 2026 Digital Family Tree. ਸਭ ਹੱਕ ਰਾਖਵੇਂ ਹਨ।",
        "21 sections of guided wisdom — the values, lessons and stories you want to pass down.": "ਰਾਹ-ਦਿਖਾਉਂਦੀ ਸਿਆਣਪ ਦੇ 21 ਭਾਗ — ਉਹ ਮੁੱਲ, ਸਿੱਖਿਆ ਤੇ ਕਹਾਣੀਆਂ ਜੋ ਤੁਸੀਂ ਅਗਲੀ ਪੀੜ੍ਹੀਆਂ ਤੱਕ ਪਹੁੰਚਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ।",
        "AI-POWERED": "AI-POWERED",
        "Aadhaar, property papers, wills and certificates — stored privately and shared only with the people you choose.": "ਆਧਾਰ, ਜਾਇਦਾਦ ਦੇ ਕਾਗਜ਼, ਵਸੀਅਤਾਂ ਅਤੇ ਸਰਟੀਫਿਕੇਟ — ਨਿੱਜੀ ਤੌਰ ‘ਤੇ ਸੁਰੱਖਿਅਤ, ਅਤੇ ਸਿਰਫ਼ ਉਹਨਾਂ ਨਾਲ ਸਾਂਝੇ ਜੋ ਤੁਸੀਂ ਚੁਣੋ।",
        "Achievements Wall": "ਉਪਲਬਧੀਆਂ ਦੀ ਦੀਵਾਰ",
        "Ask anything about your family — heritage, relationships, memories — and get instant AI answers.": "ਆਪਣੇ ਪਰਿਵਾਰ ਬਾਰੇ ਕੁਝ ਵੀ ਪੁੱਛੋ — ਵਿਰਾਸਤ, ਰਿਸ਼ਤੇ, ਯਾਦਾਂ — ਅਤੇ ਤੁਰੰਤ AI ਜਵਾਬ ਪ੍ਰਾਪਤ ਕਰੋ।",
        "Audio Memories (Voice Stories)": "ਆਡੀਓ ਯਾਦਾਂ (ਆਵਾਜ਼ ਵਾਲੀਆਂ ਕਹਾਣੀਆਂ)",
        "Begin your family tree journey": "ਆਪਣੇ ਪਰਿਵਾਰਕ ਰੁੱਖ ਦੀ ਯਾਤਰਾ ਸ਼ੁਰੂ ਕਰੋ",
        "Birthdays, anniversaries and festivals happening for your family today — one tap to wish.": "ਅੱਜ ਤੁਹਾਡੇ ਪਰਿਵਾਰ ਵਿੱਚ ਹੋ ਰਹੇ ਜਨਮਦਿਨ, ਵਰ੍ਹੇਗੰਢ ਅਤੇ ਤਿਉਹਾਰ — ਇੱਕ ਟੈਪ ਨਾਲ ਸ਼ੁਭਕਾਮਨਾ ਭੇਜੋ।",
        "Blood groups, allergies, chronic conditions and emergency contacts — accessible when it matters most.": "ਖੂਨ ਦੇ ਸਮੂਹ, ਐਲਰਜੀਆਂ, ਪੁਰਾਣੀਆਂ ਬਿਮਾਰੀਆਂ ਅਤੇ ਐਮਰਜੈਂਸੀ ਸੰਪਰਕ — ਜਦੋਂ ਸਭ ਤੋਂ ਵੱਧ ਲੋੜ ਹੋਵੇ ਤਾਂ ਤੁਰੰਤ ਹਾਸਲ।",
        "Bring parents, siblings and cousins into your private family space — everyone adds their memories, and the tree grows together.": "ਮਾਤਾ-ਪਿਤਾ, ਭੈਣ-ਭਰਾ ਅਤੇ ਕਜ਼ਿਨਾਂ ਨੂੰ ਆਪਣੇ ਨਿੱਜੀ ਪਰਿਵਾਰਕ ਸਪੇਸ ਵਿੱਚ ਜੋੜੋ — ਹਰ ਕੋਈ ਆਪਣੀਆਂ ਯਾਦਾਂ ਜੋੜੇ, ਅਤੇ ਪਰਿਵਾਰਕ ਰੁੱਖ ਇਕੱਠੇ ਵਧੇ।",
        "CULTURE & TRADITIONS": "ਸੰਸਕਾਰ ਤੇ ਰਿਵਾਜ",
        "Capture a memory in your own voice. We'll transcribe, translate and preserve it for future generations.": "ਕੋਈ ਯਾਦ ਆਪਣੀ ਆਵਾਜ਼ ਵਿੱਚ ਦਰਜ ਕਰੋ। ਅਸੀਂ ਇਸ ਨੂੰ ਲਿਖਾਂਗੇ, ਅਨੁਵਾਦ ਕਰਾਂਗੇ ਅਤੇ ਆਉਣ ਵਾਲੀਆਂ ਪੀੜ੍ਹੀਆਂ ਲਈ ਸੰਭਾਲ ਕੇ ਰੱਖਾਂਗੇ।",
        "Celebrate doctors, engineers, artists and every achiever in your family — a wall of pride for generations to see.": "ਆਪਣੇ ਪਰਿਵਾਰ ਦੇ ਡਾਕਟਰਾਂ, ਇੰਜੀਨੀਅਰਾਂ, ਕਲਾਕਾਰਾਂ ਅਤੇ ਹਰ ਉਪਲਬਧੀ ਹਾਸਲ ਕਰਨ ਵਾਲੇ ਨੂੰ ਮਨਾਓ — ਪੀੜ੍ਹੀਆਂ ਲਈ ਮਾਣ ਦੀ ਇੱਕ ਦੀਵਾਰ।",
        "Choose the package that fits your family — upgrade anytime, and unlock more features as your legacy grows.": "ਆਪਣੇ ਪਰਿਵਾਰ ਲਈ ਸਭ ਤੋਂ ਸੁਹੀ ਪੈਕੇਜ ਚੁਣੋ — ਕਦੀ ਵੀ ਅਪਗ੍ਰੇਡ ਕਰੋ, ਅਤੇ ਜਿਵੇਂ-ਜਿਵੇਂ ਤੁਹਾਡੀ ਵਿਰਾਸਤ ਵਧੇ, ਹੋਰ ਫੀਚਰ ਖੋਲ੍ਹੋ।",
        "Complete legacy suite with AI tools": "AI ਟੂਲਾਂ ਸਮੇਤ ਪੂਰਾ ਵਿਰਾਸਤੀ ਸੁਈਟ",
        "Connections": "ਜੁੜਾਵ",
        "Culture & Rituals Archive": "ਸੰਸਕਾਰ ਅਤੇ ਰਸਮਾਂ ਦਾ ਅਰਕਾਈਵ",
        "Demo Coming Soon": "ਡੈਮੋ ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ",
        "Demo pricing — final packages will be announced soon. Selection is saved to your account.": "ਡੈਮੋ ਕੀਮਤਾਂ — ਆਖਰੀ ਪੈਕੇਜ ਜਲਦੀ ਹੀ ਘੋਸ਼ਿਤ ਕੀਤੇ ਜਾਣਗੇ। ਤੁਹਾਡੀ ਚੋਣ ਤੁਹਾਡੇ ਅਕਾਊਂਟ ਵਿੱਚ ਸੰਭਾਲ ਲਈ ਗਈ ਹੈ।",
        "Digital Family Tree (Print-ready)": "ਡਿਜ਼ਿਟਲ ਪਰਿਵਾਰਕ ਰੁੱਖ (ਛਪਾਈ ਲਈ ਤਿਆਰ)",
        "EMERGENCY INFO": "ਐਮਰਜੈਂਸੀ ਜਾਣਕਾਰੀ",
        "EVENTS & DATES": "ਇਵੈਂਟ ਅਤੇ ਤਰੀਕਾਂ",
        "Events & Reminders": "ਇਵੈਂਟ ਅਤੇ ਰਿਮਾਈਂਡਰ",
        "Every family member at a glance — search, filter and open any profile in one tap.": "ਹਰ ਪਰਿਵਾਰਕ ਮੈਂਬਰ ਨੂੰ ਇਕ ਝਲਕ ‘ਚ ਵੇਖੋ — ਖੋਜੋ, ਫਿਲਟਰ ਕਰੋ ਅਤੇ ਕਿਸੇ ਵੀ ਪ੍ਰੋਫ਼ਾਈਲ ਨੂੰ ਇਕ ਟੈਪ ਨਾਲ ਖੋਲ੍ਹੋ।",
        "Every milestone across generations — arranged as one continuous, beautiful story.": "ਪੀੜ੍ਹੀਆਂ ਭਰ ਦੇ ਹਰ ਮੋੜ ਨੂੰ — ਇਕ ਲਗਾਤਾਰ, ਸੋਹਣੀ ਕਹਾਣੀ ਵਾਂਗ ਸਜਾਇਆ ਗਿਆ ਹੈ।",
        "Every new member, photo, story and record — see everything happening in your family, as it happens.": "ਹਰ ਨਵਾਂ ਮੈਂਬਰ, ਫ਼ੋਟੋ, ਕਹਾਣੀ ਅਤੇ ਰਿਕਾਰਡ — ਆਪਣੇ ਪਰਿਵਾਰ ‘ਚ ਹੋ ਰਹੀ ਹਰ ਗੱਲ ਨੂੰ, ਜਿਵੇਂ ਜਿਵੇਂ ਹੋਵੇ, ਤੁਰੰਤ ਵੇਖੋ।",
        "Every photo, voice note and story preserved forever — safely inside your family vault.": "ਹਰ ਫ਼ੋਟੋ, ਆਵਾਜ਼ ਨੋਟ ਅਤੇ ਕਹਾਣੀ ਹਮੇਸ਼ਾਂ ਲਈ ਸੰਭਾਲੀ ਹੋਈ — ਤੁਹਾਡੇ ਪਰਿਵਾਰਕ ਸੇਫ਼ ਵਿੱਚ ਸੁਰੱਖਿਅਤ।",
        "Everything, forever — one payment": "ਸਭ ਕੁਝ, ਹਮੇਸ਼ਾਂ ਲਈ — ਸਿਰਫ਼ ਇਕ ਭੁਗਤਾਨ",
        "Expert Biography Writing": "ਮਾਹਰ ਜੀਵਨੀ ਲਿਖਵਾਉਣ ਦੀ ਸੇਵਾ",
        "Export everything you've saved — members, stories, memories, records — in the format that suits you. Your data is always yours.": "ਤੁਸੀਂ ਜੋ ਕੁਝ ਵੀ ਸੰਭਾਲਿਆ ਹੈ — ਮੈਂਬਰ, ਕਹਾਣੀਆਂ, ਯਾਦਾਂ, ਰਿਕਾਰਡ — ਸਭ ਕੁਝ ਆਪਣੇ ਮਨਪਸੰਦ ਫਾਰਮੈਟ ‘ਚ ਐਕਸਪੋਰਟ ਕਰੋ। ਤੁਹਾਡਾ ਡਾਟਾ ਹਮੇਸ਼ਾਂ ਸਿਰਫ਼ ਤੁਹਾਡਾ ਹੀ ਰਹੇਗਾ।",
        "FAMILY STATISTICS": "ਪਰਿਵਾਰਕ ਅੰਕੜੇ",
        "FAMILY TIMELINE": "ਪਰਿਵਾਰਕ ਟਾਈਮਲਾਈਨ",
        "FAMILY WORLD MAP": "ਪਰਿਵਾਰਕ ਵਿਸ਼ਵ ਨਕਸ਼ਾ",
        "Family Activity": "ਪਰਿਵਾਰਕ ਸਰਗਰਮੀਆਂ",
        "Family Calendar & Celebrations": "ਪਰਿਵਾਰਕ ਕੈਲੰਡਰ ਅਤੇ ਜਸ਼ਨ",
        "Family Pride": "ਪਰਿਵਾਰ ਦੀ ਸ਼ਾਨ",
        "Family Records": "ਪਰਿਵਾਰਕ ਰਿਕਾਰਡ",
        "Family Tree Builder (6 generations)": "ਫ਼ੈਮਿਲੀ ਟਰੀ ਬਿਲਡਰ (6 ਪੀੜ੍ਹੀਆਂ)",
        "Family World Map": "ਪਰਿਵਾਰਕ ਵਿਸ਼ਵ ਨਕਸ਼ਾ",
        "Gold": "ਗੋਲਡ",
        "HEALTH & EMERGENCY": "ਸਿਹਤ ਅਤੇ ਐਮਰਜੈਂਸੀ",
        "HEALTH REPOSITORY": "ਸਿਹਤ ਰਿਪੋਜ਼ਿਟਰੀ",
        "Health & Medical Repository (10 registers)": "ਸਿਹਤ ਅਤੇ ਮੈਡੀਕਲ ਰਿਪੋਜ਼ਿਟਰੀ (10 ਰਜਿਸਟਰ)",
        "How large is your family across generations? Longevity, geography, professions and more.": "ਪੀੜੀਆਂ ਦਰ ਪੀੜੀਆਂ ਤੁਹਾਡਾ ਪਰਿਵਾਰ ਕਿੰਨਾ ਵੱਡਾ ਹੈ? ਲੰਬੀ ਉਮਰ, ਭੂਗੋਲ, ਪੇਸ਼ੇ ਅਤੇ ਹੋਰ ਬਹੁਤ ਕੁਝ।",
        "Keep every family member's blood group in one secure place. In an emergency, every second counts — this registry helps you instantly find the right donor within your family.": "ਹਰ ਪਰਿਵਾਰਿਕ ਮੈਂਬਰ ਦਾ ਬਲੱਡ ਗਰੁੱਪ ਇੱਕ ਹੀ ਸੁਰੱਖਿਅਤ ਥਾਂ ਤੇ ਸੰਭਾਲ ਕੇ ਰੱਖੋ। ਐਮਰਜੈਂਸੀ ਵਿੱਚ ਹਰ ਸਕਿੰਟ ਕੀਮਤੀ ਹੁੰਦਾ ਹੈ — ਇਹ ਰਜਿਸਟਰੀ ਤੁਹਾਨੂੰ ਆਪਣੇ ਪਰਿਵਾਰ ਵਿੱਚੋਂ ਸਹੀ ਡੋਨਰ ਤੁਰੰਤ ਲੱਭਣ ਵਿੱਚ ਮਦਦ ਕਰਦੀ ਹੈ।",
        "LEGACY & MEMORIAL": "ਵਿਰਾਸਤ ਅਤੇ ਯਾਦਗਾਰ",
        "LEGAL & LEGACY": "ਕਾਨੂੰਨੀ ਅਤੇ ਵਿਰਾਸਤ",
        "Legacy Lifetime": "ਵਿਰਾਸਤ ਜੀਵਨਕਾਲ",
        "Legal Vault (Will & Nominee)": "ਲੀਗਲ ਵਾਲਟ (ਵਸੀਆਤ ਅਤੇ ਨਾਮਜ਼ਦ)",
        "Let AI compose a heartfelt narrative of your family's journey from the profiles you've filled.": "ਤੁਸੀਂ ਭਰੇ ਹੋਏ ਪ੍ਰੋਫ਼ਾਈਲਾਂ ਤੋਂ ਆਪਣੇ ਪਰਿਵਾਰ ਦੀ ਯਾਤਰਾ ਦੀ ਦਿਲ ਨੂੰ ਛੂਹਣ ਵਾਲੀ ਕਹਾਣੀ AI ਤੋਂ ਤਿਆਰ ਕਰਵਾਓ।",
        "MEMORIES & STORIES": "ਯਾਦਾਂ ਅਤੇ ਕਹਾਣੀਆਂ",
        "Marriage Records": "ਵਿਆਹ ਦੇ ਰਿਕਾਰਡ",
        "Member Profiles & Photos": "ਮੈਂਬਰ ਪ੍ਰੋਫ਼ਾਈਲ ਅਤੇ ਫੋਟੋਆਂ",
        "Memories & reminders for the whole family": "ਸਾਰੇ ਪਰਿਵਾਰ ਲਈ ਯਾਦਾਂ ਅਤੇ ਰਿਮਾਈਂਡਰ",
        "Multi-user Family Access (Invites)": "ਮਲਟੀ-ਯੂਜ਼ਰ ਪਰਿਵਾਰਿਕ ਪਹੁੰਚ (ਨਿਯੋਤੇ)",
        "Never miss a birthday, anniversary or festival — smart reminders from your family tree, delivered by email, push and in-app.": "ਕਦੇ ਵੀ ਕੋਈ ਜਨਮਦਿਨ, ਸਾਲਗਿਰਹ ਜਾਂ ਤਿਉਹਾਰ ਨਾ ਛੱਡੋ — ਤੁਹਾਡੇ ਪਰਿਵਾਰਕ ਦਰਖ਼ਤ ਤੋਂ ਸਮਾਰਟ ਰਿਮਾਈਂਡਰ, ਜੋ ਈਮੇਲ, ਪੁਸ਼ ਅਤੇ ਐਪ ਵਿੱਚ ਹੀ ਮਿਲਣਗੇ।",
        "One place for every birthday, anniversary, shraddha and cultural festival — with smart nudges.": "ਹਰ ਜਨਮਦਿਨ, ਸਾਲਗਿਰਹ, ਸ੍ਰਾਧ ਅਤੇ ਸੱਭਿਆਚਾਰਕ ਤਿਉਹਾਰ ਲਈ ਇੱਕ ਹੀ ਥਾਂ — ਸਮਾਰਟ ਯਾਦ ਦਿਹਾਣੀਆਂ ਦੇ ਨਾਲ।",
        "Personal Vault": "ਪ੍ਰਸਨਲ ਵਾਲਟ",
        "Prescriptions, reports and hospital records for every family member — organized and searchable.": "ਹਰ ਪਰਿਵਾਰਕ ਮੈਂਬਰ ਲਈ ਨੁਸਖੇ, ਰਿਪੋਰਟਾਂ ਅਤੇ ਹਸਪਤਾਲ ਦੇ ਰਿਕਾਰਡ — ਸਜੇ-ਸੰਭਾਲੇ ਅਤੇ ਆਸਾਨੀ ਨਾਲ ਖੋਜਯੋਗ।",
        "Preserve wedding dates, venues and couple details — anniversaries flow automatically into your family calendar and timeline.": "ਵਿਆਹ ਦੀਆਂ ਤਾਰੀਖਾਂ, ਸਥਾਨ ਅਤੇ ਜੋੜੇ ਦੇ ਵੇਰਵੇ ਸੰਭਾਲ ਕੇ ਰੱਖੋ — ਸਾਲਗਿਰਹਾਂ ਆਪਣੇ ਆਪ ਹੀ ਤੁਹਾਡੇ ਪਰਿਵਾਰਿਕ ਕੈਲੰਡਰ ਅਤੇ ਟਾਈਮਲਾਈਨ ਵਿੱਚ ਆ ਜਾਂਦੀਆਂ ਹਨ।",
        "Priority Support": "ਪ੍ਰਾਥਮਿਕਤਾ ਸਹਾਇਤਾ",
        "Rituals, recipes, dialects and heritage — everything that makes your family uniquely yours.": "ਰਸਮਾਂ, ਵਿਅੰਜਨ, ਬੋਲੀਆਂ ਅਤੇ ਵਿਰਾਸਤ — ਉਹ ਸਭ ਕੁਝ ਜੋ ਤੁਹਾਡੇ ਪਰਿਵਾਰ ਨੂੰ ਵੱਖਰਾ ਤੇ ਖ਼ਾਸ ਬਣਾਉਂਦਾ ਹੈ।",
        "SHARE & CELEBRATE": "ਸਾਂਝ ਪਾਓ ਅਤੇ ਜਸ਼ਨ ਮਨਾਓ",
        "Seal messages, photos and videos to open on future birthdays, anniversaries or a chosen date.": "ਸੁਨੇਹਿਆਂ, ਫੋਟੋਆਂ ਅਤੇ ਵੀਡੀਓਜ਼ ਨੂੰ ਮੁਹਰਬੰਦ ਕਰੋ ਤਾਂ ਜੋ ਉਹ ਭਵਿੱਖ ਦੇ ਜਨਮਦਿਨਾਂ, ਸਾਲਗਿਰ੍ਹਾਂ ਜਾਂ ਕਿਸੇ ਚੁਣੀ ਮਿਤੀ ‘ਤੇ ਖੋਲ੍ਹੇ ਜਾ ਸਕਣ।",
        "See every family member on a real world map. Each pin shows a current location (orange) and a native place (green), connected by a dotted line — a beautiful visual of your family's journey through geography.": "ਅਸਲੀ ਦੁਨੀਆ ਦੇ ਨਕਸ਼ੇ ‘ਤੇ ਹਰ ਪਰਿਵਾਰਕ ਮੈਂਬਰ ਨੂੰ ਵੇਖੋ। ਹਰ ਪਿਨ ਮੌਜੂਦਾ ਸਥਿਤੀ (ਸੰਤਰੀ) ਅਤੇ ਮੂਲ ਥਾਂ (ਹਰਾ) ਦਿਖਾਉਂਦਾ ਹੈ, ਜੋ ਟੁੱਟੀ ਲਾਈਨ ਨਾਲ ਜੋੜੇ ਹੁੰਦੇ ਹਨ — ਭੂਗੋਲ ਰਾਹੀਂ ਤੁਹਾਡੇ ਪਰਿਵਾਰ ਦੇ ਸਫ਼ਰ ਦੀ ਇੱਕ ਸੋਹਣੀ ਤਸਵੀਰ।",
        "Share the gift of legacy — invite friends to build their own private family tree, free to start.": "ਵਿਰਾਸਤ ਦਾ ਤੋਹਫ਼ਾ ਸਾਂਝਾ ਕਰੋ — ਦੋਸਤਾਂ ਨੂੰ ਆਪਣਾ ਨਿੱਜੀ ਪਰਿਵਾਰਕ ਦਰੱਖਤ ਬਣਾਉਣ ਲਈ ਸੱਦਾ ਦਿਓ, ਸ਼ੁਰੂਆਤ ਮੁਫ਼ਤ ਹੈ।",
        "Silver": "ਸਿਲਵਰ",
        "Smart Reminders (Email + Push)": "ਸਮਾਰਟ ਯਾਦ ਦਿਹਾਣੀਆਂ (Email + Push)",
        "Starter": "ਸਟਾਰਟਰ",
        "TIME CAPSULES": "ਟਾਈਮ ਕੈਪਸੂਲ",
        "TODAY'S CELEBRATIONS": "ਅੱਜ ਦੇ ਜਸ਼ਨ",
        "Turn your family tree into a beautiful shareable poster — perfect for wedding invites, festivals and print.": "ਆਪਣੇ ਪਰਿਵਾਰਕ ਦਰੱਖਤ ਨੂੰ ਇੱਕ ਖੂਬਸੂਰਤ, ਸਾਂਝਾ ਕਰਨ ਯੋਗ ਪੋਸਟਰ ਵਿੱਚ ਬਦਲੋ — ਵਿਆਹ ਦੇ ਸੱਦੇ, ਤਿਉਹਾਰਾਂ ਅਤੇ ਪ੍ਰਿੰਟ ਲਈ ਬਿਲਕੁਲ ਉਤਮ।",
        "VOICE & STORIES": "ਆਵਾਜ਼ ਅਤੇ ਕਹਾਣੀਆਂ",
        "Watch Demo": "ਡੈਮੋ ਵੇਖੋ",
        "Wills, power-of-attorney, property papers and nominee details — locked and always accessible to the right people.": "ਵਸੀਅਤਾਂ, ਪਾਵਰ-ਆਫ਼-ਅਟਾਰਨੀ, ਜਾਇਦਾਦ ਦੇ ਕਾਗਜ਼ ਅਤੇ ਨਾਮਜ਼ਦ ਵਿਅਕਤੀਆਂ ਦੀ ਜਾਣਕਾਰੀ — ਤਾਲਾਬੰਦ ਅਤੇ ਹਮੇਸ਼ਾ ਸਹੀ ਲੋਕਾਂ ਲਈ ਹੀ ਉਪਲਬਧ।",
        "Your data, your rules — manage account preferences, visibility and every privacy declaration in one place.": "ਤੁਹਾਡੇ ਡੇਟਾ ‘ਤੇ ਤੁਹਾਡਾ ਹੀ ਹੱਕ — ਖਾਤੇ ਦੀਆਂ ਪਸੰਦਾਂ, ਦਿੱਖ ਅਤੇ ਹਰ privacy ਘੋਸ਼ਣਾ ਨੂੰ ਇੱਕ ਹੀ ਥਾਂ ‘ਤੇ ਸੰਭਾਲੋ।",
        "one-time · lifetime": "ਇੱਕ ਵਾਰ · ਉਮਰ ਭਰ ਲਈ",
        "per month": "ਮਹੀਨੇ ਦੇ ਹਿਸਾਬ ਨਾਲ",
        "per year": "ਸਾਲ ਦੇ ਹਿਸਾਬ ਨਾਲ",
        "January": "ਜਨਵਰੀ",
        "February": "ਫ਼ਰਵਰੀ",
        "March": "ਮਾਰਚ",
        "April": "ਅਪ੍ਰੈਲ",
        "May": "ਮਈ",
        "June": "ਜੂਨ",
        "July": "ਜੁਲਾਈ",
        "August": "ਅਗਸਤ",
        "September": "ਸਤੰਬਰ",
        "October": "ਅਕਤੂਬਰ",
        "November": "ਨਵੰਬਰ",
        "December": "ਦਸੰਬਰ",
        "is locked": "ਲੌਕ ਹੈ",
        "Your current package": "ਤੁਹਾਡਾ ਮੌਜੂਦਾ ਪੈਕੇਜ",
        "doesn't include this feature.": "ਇਸ ਫੀਚਰ ਨੂੰ ਸ਼ਾਮਲ ਨਹੀਂ ਕਰਦਾ।",
        "Included in": "ਇਸ ਵਿੱਚ ਸ਼ਾਮਲ",
        "one-time": "ਇੱਕ ਵਾਰ",
        "year": "ਸਾਲ",
        "month": "ਮਹੀਨਾ",
        "lifetime": "ਜੀਵਨ ਭਰ",
        "Go Back": "ਪਿੱਛੇ ਜਾਓ",
        "View Packages": "ਪੈਕੇਜ ਵੇਖੋ",
        "This feature": "ਇਹ ਫੀਚਰ",
        "Family Legacy Dashboard": "ਪਰੀਵਾਰਿਕ ਵਿਰਾਸਤ ਡੈਸ਼ਬੋਰਡ",
        "Legacy Services": "ਵਿਰਾਸਤੀ ਸੇਵਾਵਾਂ",
        "Life Story Vault": "ਜ਼ਿੰਦਗੀ ਕਹਾਣੀ ਤਿਜੋਰੀ",
        "Video Testament Library": "ਵੀਡੀਓ ਵਿਲ ਲਾਇਬ੍ਰੇਰੀ",
        "Family Wisdom Bank": "ਪਰੀਵਾਰਿਕ ਜੀਵਨ-ਗਿਆਨ ਬੈਂਕ",
        "Failure Stories Archive": "ਅਸਫਲਤਾ ਕਹਾਣੀਆਂ ਅਰਕਾਈਵ",
        "Success Stories": "ਸਫਲਤਾ ਕਹਾਣੀਆਂ",
        "Family Decision History": "ਪਰੀਵਾਰਿਕ ਫੈਸਲਿਆਂ ਦਾ ਇਤਿਹਾਸ",
        "Family Values Repository": "ਪਰੀਵਾਰਿਕ ਮੁੱਲਾਂ ਦਾ ਖਜ਼ਾਨਾ",
        "Family Hero Gallery": "ਪਰੀਵਾਰਿਕ ਹੀਰੋ ਗੈਲਰੀ",
        "Unsung Heroes": "ਗੁਮਨਾਮ ਹੀਰੋ",
        "Gratitude Wall": "ਸ਼ੁਕਰਾਨਾ ਦੀ ਕੰਧ",
        "Tribute Pages": "ਸ਼ਰਧਾਂਜਲੀ ਸਫ਼ੇ",
        "Love Letters Archive": "ਪਿਆਰ ਭਰੇ ਖ਼ਤਾਂ ਦਾ ਅਰਕਾਈਵ",
        "Childhood Stories Bank": "ਬਚਪਨ ਦੀਆਂ ਕਹਾਣੀਆਂ ਬੈਂਕ",
        "Language Preservation": "ਭਾਸ਼ਾ ਸੰਭਾਲ",
        "Ancestral Village": "ਪੁਰਖਿਆਂ ਦਾ ਪਿੰਡ",
        "Surname History": "ਖ਼ਾਨਦਾਨੀ ਨਾਂ ਦਾ ਇਤਿਹਾਸ",
        "Family Emblem": "ਪਰੀਵਾਰਿਕ ਨਿਸ਼ਾਨ",
        "Cultural Artifacts": "ਸੱਭਿਆਚਾਰਕ ਵਿਰਾਸਤੀ ਚੀਜ਼ਾਂ",
        "Family Songs & Bhajans": "ਪਰਿਵਾਰਕ ਗੀਤ ਅਤੇ ਭਜਨ",
        "Oral History Center": "ਮੌਖਿਕ ਇਤਿਹਾਸ ਕੇਂਦਰ",
        "Biography Writing Platform": "ਜੀਵਨੀਆਂ ਲਿਖਣ ਦਾ ਪਲੇਟਫਾਰਮ",
        "Memoir Writing Service": "ਸਮਰਥ ਲਿਖਣ ਦੀ ਸੇਵਾ",
        "Personalised Gifting Service": "ਵਿਅਕਤੀਗਤ ਤੋਹਫ਼ੇ ਦੀ ਸੇਵਾ",
        "Personal Digital Identity Platform": "ਵਿਅਕਤੀਗਤ ਡਿਜ਼ਿਟਲ ਪਹਿਚਾਣ ਪਲੇਟਫਾਰਮ",
        "Add to": "ਵਿੱਚ ਜੋੜੋ",
        "Choose": "ਚੁਣੋ",
        "Compare all packages": "ਸਾਰੇ ਪੈਕੇਜਾਂ ਦੀ ਤੁਲਨਾ ਕਰੋ",
        "Demo pricing — packages, prices and the feature split are all editable from the admin panel.": "ਡੈਮੋ ਪ੍ਰਾਈਸਿੰਗ — ਪੈਕੇਜ, ਕੀਮਤਾਂ ਅਤੇ ਫੀਚਰ ਵੰਡ ਸਾਰਾ ਕੁਝ ਐਡਮਿਨ ਪੈਨਲ ਤੋਂ ਸੋਧਿਆ ਜਾ ਸਕਦਾ ਹੈ।",
        "Feature": "ਫੀਚਰ",
        "Five packages, one family legacy": "ਪੰਜ ਪੈਕੇਜ, ਇਕ ਪਰਿਵਾਰਕ ਵਿਰਾਸਤ",
        "Free": "ਮੁਫ਼ਤ",
        "Life story, wisdom and biography now live in Family Legacy Dashboard": "ਜ਼ਿੰਦਗੀ ਦੀ ਕਹਾਣੀ, ਤਜਰਬਾ ਤੇ ਜੀਵਨੀ ਹੁਣ Family Legacy Dashboard ਵਿੱਚ ਸੁਰੱਖਿਅਤ ਹਨ",
        "Open Family Legacy Dashboard": "Family Legacy Dashboard ਖੋਲ੍ਹੋ",
        "Packages & Pricing": "ਪੈਕੇਜ ਅਤੇ ਕੀਮਤਾਂ",
        "Packages temporarily unavailable. Please try again shortly.": "ਪੈਕੇਜ ਅਸਥਾਈ ਤੌਰ ‘ਤੇ ਉਪਲਬਧ ਨਹੀਂ ਹਨ। ਕਿਰਪਾ ਕਰਕੇ ਕੁਝ ਸਮੇਂ ਬਾਅਦ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
        "Start Free": "ਮੁਫ਼ਤ ਸ਼ੁਰੂ ਕਰੋ",
        "Start free, upgrade whenever your family is ready. Every feature below is compared side by side so nothing is hidden.": "ਮੁਫ਼ਤ ਸ਼ੁਰੂ ਕਰੋ, ਅਤੇ ਜਦੋਂ ਤੁਹਾਡਾ ਪਰਿਵਾਰ ਤਿਆਰ ਹੋਵੇ ਤਾਂ ਅੱਪਗਰੇਡ ਕਰੋ। ਹੇਠਾਂ ਹਰ ਫੀਚਰ ਨੂੰ ਇਕ ਦੂਜੇ ਦੇ ਨਾਲ-ਨਾਲ ਦਿਖਾਇਆ ਗਿਆ ਹੈ ਤਾਂ ਜੋ ਕੁਝ ਵੀ ਲੁਕਿਆ ਨਾ ਰਹੇ।",
        "Swipe sideways on a phone — the feature column stays in place.": "ਫੋਨ ‘ਤੇ ਸਾਈਡ ਵੱਲ ਸਵਾਈਪ ਕਰੋ — ਫੀਚਰ ਵਾਲਾ ਕਾਲਮ ਆਪਣੀ ਜਗ੍ਹਾ ‘ਤੇ ਹੀ ਰਹੇਗਾ।",
        "more features": "ਹੋਰ ਫੀਚਰ",
        "Namaste": "ਨਮਸਤੇ",
        "{sender} has added you to our family tree on Family Repository.": "{sender} ਨੇ ਤੁਹਾਨੂੰ Family Repository ‘ਤੇ ਸਾਡੇ ਪਰਿਵਾਰਕ ਵਿਰਖ਼ ਵਿੱਚ ਸ਼ਾਮਲ ਕੀਤਾ ਹੈ।",
        "Tap to join": "ਸ਼ਾਮਲ ਹੋਣ ਲਈ ਟੈਪ ਕਰੋ",
        "Your invite code": "ਤੁਹਾਡਾ ਨਿਯੋਤਾ ਕੋਡ",
        "Together we will preserve our family's stories, photos and voices for the next generations.": "ਅਸੀਂ ਇਕੱਠੇ ਮਿਲ ਕੇ ਆਪਣੇ ਪਰਿਵਾਰ ਦੀਆਂ ਕਹਾਣੀਆਂ, ਤਸਵੀਰਾਂ ਅਤੇ ਆਵਾਜ਼ਾਂ ਅਗਲੀ ਪੀੜੀਆਂ ਲਈ ਸੰਭਾਲ ਕੇ ਰੱਖਾਂਗੇ।",
        "Your family": "ਤੁਹਾਡਾ ਪਰਿਵਾਰ",
        "Invite on WhatsApp": "WhatsApp ਰਾਹੀਂ ਨਿਯੋਤਾ ਭੇਜੋ",
        "WhatsApp opened with the invite message.": "ਨਿਯੋਤਾ ਸੁਨੇਹੇ ਨਾਲ WhatsApp ਖੁੱਲ ਗਿਆ ਹੈ।",
    },
};

export function usePhraseT() {
    const { lang } = useLang();
    return (s) => (PHRASES[lang] && PHRASES[lang][s]) || s;
}

export const tOr = (t, key, fb) => {
    const v = t(key);
    return v === key ? fb : v;
};
